import { d as R, u as ir, t as rr, i as _, r as gn, a as V, b as z, h as g, H as mn, g as vn, R as It, I as ea } from "./index-6e735f92.js";
import { R as yn } from "./register-component-083eb961-763c87e9.js";
import { T as Ot } from "./constants-3d8016e3-3c080f00.js";
import { c as ta } from "./customParseFormat-129be926-36eabae2.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
var St, S, sr, ke, me, Kn, ar, lr, ct = {}, or = [], na = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function le(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}
function cr(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function p(t, e, n) {
  var i, r, s, a = {};
  for (s in e)
    s == "key" ? i = e[s] : s == "ref" ? r = e[s] : a[s] = e[s];
  if (arguments.length > 2 && (a.children = arguments.length > 3 ? St.call(arguments, 2) : n), typeof t == "function" && t.defaultProps != null)
    for (s in t.defaultProps)
      a[s] === void 0 && (a[s] = t.defaultProps[s]);
  return rt(t, a, i, r, null);
}
function rt(t, e, n, i, r) {
  var s = { type: t, props: e, key: n, ref: i, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: r ?? ++sr };
  return r == null && S.vnode != null && S.vnode(s), s;
}
function j() {
  return { current: null };
}
function H(t) {
  return t.children;
}
function ia(t, e, n, i, r) {
  var s;
  for (s in n)
    s === "children" || s === "key" || s in e || dt(t, s, null, n[s], i);
  for (s in e)
    r && typeof e[s] != "function" || s === "children" || s === "key" || s === "value" || s === "checked" || n[s] === e[s] || dt(t, s, e[s], n[s], i);
}
function ei(t, e, n) {
  e[0] === "-" ? t.setProperty(e, n ?? "") : t[e] = n == null ? "" : typeof n != "number" || na.test(e) ? n : n + "px";
}
function dt(t, e, n, i, r) {
  var s;
  e:
    if (e === "style")
      if (typeof n == "string")
        t.style.cssText = n;
      else {
        if (typeof i == "string" && (t.style.cssText = i = ""), i)
          for (e in i)
            n && e in n || ei(t.style, e, "");
        if (n)
          for (e in n)
            i && n[e] === i[e] || ei(t.style, e, n[e]);
      }
    else if (e[0] === "o" && e[1] === "n")
      s = e !== (e = e.replace(/Capture$/, "")), e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + s] = n, n ? i || t.addEventListener(e, s ? ni : ti, s) : t.removeEventListener(e, s ? ni : ti, s);
    else if (e !== "dangerouslySetInnerHTML") {
      if (r)
        e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (e !== "width" && e !== "height" && e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e in t)
        try {
          t[e] = n ?? "";
          break e;
        } catch {
        }
      typeof n == "function" || (n == null || n === !1 && e.indexOf("-") == -1 ? t.removeAttribute(e) : t.setAttribute(e, n));
    }
}
function ti(t) {
  ke = !0;
  try {
    return this.l[t.type + !1](S.event ? S.event(t) : t);
  } finally {
    ke = !1;
  }
}
function ni(t) {
  ke = !0;
  try {
    return this.l[t.type + !0](S.event ? S.event(t) : t);
  } finally {
    ke = !1;
  }
}
function G(t, e) {
  this.props = t, this.context = e;
}
function ze(t, e) {
  if (e == null)
    return t.__ ? ze(t.__, t.__.__k.indexOf(t) + 1) : null;
  for (var n; e < t.__k.length; e++)
    if ((n = t.__k[e]) != null && n.__e != null)
      return n.__e;
  return typeof t.type == "function" ? ze(t) : null;
}
function dr(t) {
  var e, n;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++)
      if ((n = t.__k[e]) != null && n.__e != null) {
        t.__e = t.__c.base = n.__e;
        break;
      }
    return dr(t);
  }
}
function ra(t) {
  ke ? setTimeout(t) : ar(t);
}
function Kt(t) {
  (!t.__d && (t.__d = !0) && me.push(t) && !ut.__r++ || Kn !== S.debounceRendering) && ((Kn = S.debounceRendering) || ra)(ut);
}
function ut() {
  var t, e, n, i, r, s, a, l;
  for (me.sort(function(o, d) {
    return o.__v.__b - d.__v.__b;
  }); t = me.shift(); )
    t.__d && (e = me.length, i = void 0, r = void 0, a = (s = (n = t).__v).__e, (l = n.__P) && (i = [], (r = le({}, s)).__v = s.__v + 1, bn(l, s, r, n.__n, l.ownerSVGElement !== void 0, s.__h != null ? [a] : null, i, a ?? ze(s), s.__h), gr(i, s), s.__e != a && dr(s)), me.length > e && me.sort(function(o, d) {
      return o.__v.__b - d.__v.__b;
    }));
  ut.__r = 0;
}
function ur(t, e, n, i, r, s, a, l, o, d) {
  var c, h, f, u, v, y, b, E = i && i.__k || or, C = E.length;
  for (n.__k = [], c = 0; c < e.length; c++)
    if ((u = n.__k[c] = (u = e[c]) == null || typeof u == "boolean" ? null : typeof u == "string" || typeof u == "number" || typeof u == "bigint" ? rt(null, u, null, null, u) : Array.isArray(u) ? rt(H, { children: u }, null, null, null) : u.__b > 0 ? rt(u.type, u.props, u.key, u.ref ? u.ref : null, u.__v) : u) != null) {
      if (u.__ = n, u.__b = n.__b + 1, (f = E[c]) === null || f && u.key == f.key && u.type === f.type)
        E[c] = void 0;
      else
        for (h = 0; h < C; h++) {
          if ((f = E[h]) && u.key == f.key && u.type === f.type) {
            E[h] = void 0;
            break;
          }
          f = null;
        }
      bn(t, u, f = f || ct, r, s, a, l, o, d), v = u.__e, (h = u.ref) && f.ref != h && (b || (b = []), f.ref && b.push(f.ref, null, u), b.push(h, u.__c || v, u)), v != null ? (y == null && (y = v), typeof u.type == "function" && u.__k === f.__k ? u.__d = o = fr(u, o, t) : o = hr(t, u, f, E, v, o), typeof n.type == "function" && (n.__d = o)) : o && f.__e == o && o.parentNode != t && (o = ze(f));
    }
  for (n.__e = y, c = C; c--; )
    E[c] != null && (typeof n.type == "function" && E[c].__e != null && E[c].__e == n.__d && (n.__d = pr(i).nextSibling), vr(E[c], E[c]));
  if (b)
    for (c = 0; c < b.length; c++)
      mr(b[c], b[++c], b[++c]);
}
function fr(t, e, n) {
  for (var i, r = t.__k, s = 0; r && s < r.length; s++)
    (i = r[s]) && (i.__ = t, e = typeof i.type == "function" ? fr(i, e, n) : hr(n, i, i, r, i.__e, e));
  return e;
}
function ft(t, e) {
  return e = e || [], t == null || typeof t == "boolean" || (Array.isArray(t) ? t.some(function(n) {
    ft(n, e);
  }) : e.push(t)), e;
}
function hr(t, e, n, i, r, s) {
  var a, l, o;
  if (e.__d !== void 0)
    a = e.__d, e.__d = void 0;
  else if (n == null || r != s || r.parentNode == null)
    e:
      if (s == null || s.parentNode !== t)
        t.appendChild(r), a = null;
      else {
        for (l = s, o = 0; (l = l.nextSibling) && o < i.length; o += 1)
          if (l == r)
            break e;
        t.insertBefore(r, s), a = s;
      }
  return a !== void 0 ? a : r.nextSibling;
}
function pr(t) {
  var e, n, i;
  if (t.type == null || typeof t.type == "string")
    return t.__e;
  if (t.__k) {
    for (e = t.__k.length - 1; e >= 0; e--)
      if ((n = t.__k[e]) && (i = pr(n)))
        return i;
  }
  return null;
}
function bn(t, e, n, i, r, s, a, l, o) {
  var d, c, h, f, u, v, y, b, E, C, T, A, O, M, N, x = e.type;
  if (e.constructor !== void 0)
    return null;
  n.__h != null && (o = n.__h, l = e.__e = n.__e, e.__h = null, s = [l]), (d = S.__b) && d(e);
  try {
    e:
      if (typeof x == "function") {
        if (b = e.props, E = (d = x.contextType) && i[d.__c], C = d ? E ? E.props.value : d.__ : i, n.__c ? y = (c = e.__c = n.__c).__ = c.__E : ("prototype" in x && x.prototype.render ? e.__c = c = new x(b, C) : (e.__c = c = new G(b, C), c.constructor = x, c.render = aa), E && E.sub(c), c.props = b, c.state || (c.state = {}), c.context = C, c.__n = i, h = c.__d = !0, c.__h = [], c._sb = []), c.__s == null && (c.__s = c.state), x.getDerivedStateFromProps != null && (c.__s == c.state && (c.__s = le({}, c.__s)), le(c.__s, x.getDerivedStateFromProps(b, c.__s))), f = c.props, u = c.state, c.__v = e, h)
          x.getDerivedStateFromProps == null && c.componentWillMount != null && c.componentWillMount(), c.componentDidMount != null && c.__h.push(c.componentDidMount);
        else {
          if (x.getDerivedStateFromProps == null && b !== f && c.componentWillReceiveProps != null && c.componentWillReceiveProps(b, C), !c.__e && c.shouldComponentUpdate != null && c.shouldComponentUpdate(b, c.__s, C) === !1 || e.__v === n.__v) {
            for (e.__v !== n.__v && (c.props = b, c.state = c.__s, c.__d = !1), e.__e = n.__e, e.__k = n.__k, e.__k.forEach(function(Q) {
              Q && (Q.__ = e);
            }), T = 0; T < c._sb.length; T++)
              c.__h.push(c._sb[T]);
            c._sb = [], c.__h.length && a.push(c);
            break e;
          }
          c.componentWillUpdate != null && c.componentWillUpdate(b, c.__s, C), c.componentDidUpdate != null && c.__h.push(function() {
            c.componentDidUpdate(f, u, v);
          });
        }
        if (c.context = C, c.props = b, c.__P = t, A = S.__r, O = 0, "prototype" in x && x.prototype.render) {
          for (c.state = c.__s, c.__d = !1, A && A(e), d = c.render(c.props, c.state, c.context), M = 0; M < c._sb.length; M++)
            c.__h.push(c._sb[M]);
          c._sb = [];
        } else
          do
            c.__d = !1, A && A(e), d = c.render(c.props, c.state, c.context), c.state = c.__s;
          while (c.__d && ++O < 25);
        c.state = c.__s, c.getChildContext != null && (i = le(le({}, i), c.getChildContext())), h || c.getSnapshotBeforeUpdate == null || (v = c.getSnapshotBeforeUpdate(f, u)), N = d != null && d.type === H && d.key == null ? d.props.children : d, ur(t, Array.isArray(N) ? N : [N], e, n, i, r, s, a, l, o), c.base = e.__e, e.__h = null, c.__h.length && a.push(c), y && (c.__E = c.__ = null), c.__e = !1;
      } else
        s == null && e.__v === n.__v ? (e.__k = n.__k, e.__e = n.__e) : e.__e = sa(n.__e, e, n, i, r, s, a, o);
    (d = S.diffed) && d(e);
  } catch (Q) {
    e.__v = null, (o || s != null) && (e.__e = l, e.__h = !!o, s[s.indexOf(l)] = null), S.__e(Q, e, n);
  }
}
function gr(t, e) {
  S.__c && S.__c(e, t), t.some(function(n) {
    try {
      t = n.__h, n.__h = [], t.some(function(i) {
        i.call(n);
      });
    } catch (i) {
      S.__e(i, n.__v);
    }
  });
}
function sa(t, e, n, i, r, s, a, l) {
  var o, d, c, h = n.props, f = e.props, u = e.type, v = 0;
  if (u === "svg" && (r = !0), s != null) {
    for (; v < s.length; v++)
      if ((o = s[v]) && "setAttribute" in o == !!u && (u ? o.localName === u : o.nodeType === 3)) {
        t = o, s[v] = null;
        break;
      }
  }
  if (t == null) {
    if (u === null)
      return document.createTextNode(f);
    t = r ? document.createElementNS("http://www.w3.org/2000/svg", u) : document.createElement(u, f.is && f), s = null, l = !1;
  }
  if (u === null)
    h === f || l && t.data === f || (t.data = f);
  else {
    if (s = s && St.call(t.childNodes), d = (h = n.props || ct).dangerouslySetInnerHTML, c = f.dangerouslySetInnerHTML, !l) {
      if (s != null)
        for (h = {}, v = 0; v < t.attributes.length; v++)
          h[t.attributes[v].name] = t.attributes[v].value;
      (c || d) && (c && (d && c.__html == d.__html || c.__html === t.innerHTML) || (t.innerHTML = c && c.__html || ""));
    }
    if (ia(t, f, h, r, l), c)
      e.__k = [];
    else if (v = e.props.children, ur(t, Array.isArray(v) ? v : [v], e, n, i, r && u !== "foreignObject", s, a, s ? s[0] : n.__k && ze(n, 0), l), s != null)
      for (v = s.length; v--; )
        s[v] != null && cr(s[v]);
    l || ("value" in f && (v = f.value) !== void 0 && (v !== t.value || u === "progress" && !v || u === "option" && v !== h.value) && dt(t, "value", v, h.value, !1), "checked" in f && (v = f.checked) !== void 0 && v !== t.checked && dt(t, "checked", v, h.checked, !1));
  }
  return t;
}
function mr(t, e, n) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (i) {
    S.__e(i, n);
  }
}
function vr(t, e, n) {
  var i, r;
  if (S.unmount && S.unmount(t), (i = t.ref) && (i.current && i.current !== t.__e || mr(i, null, e)), (i = t.__c) != null) {
    if (i.componentWillUnmount)
      try {
        i.componentWillUnmount();
      } catch (s) {
        S.__e(s, e);
      }
    i.base = i.__P = null, t.__c = void 0;
  }
  if (i = t.__k)
    for (r = 0; r < i.length; r++)
      i[r] && vr(i[r], e, n || typeof t.type != "function");
  n || t.__e == null || cr(t.__e), t.__ = t.__e = t.__d = void 0;
}
function aa(t, e, n) {
  return this.constructor(t, n);
}
function Ue(t, e, n) {
  var i, r, s;
  S.__ && S.__(t, e), r = (i = typeof n == "function") ? null : n && n.__k || e.__k, s = [], bn(e, t = (!i && n || e).__k = p(H, null, [t]), r || ct, ct, e.ownerSVGElement !== void 0, !i && n ? [n] : r ? null : e.firstChild ? St.call(e.childNodes) : null, s, !i && n ? n : r ? r.__e : e.firstChild, i), gr(s, t);
}
function la(t, e) {
  var n = { __c: e = "__cC" + lr++, __: t, Consumer: function(i, r) {
    return i.children(r);
  }, Provider: function(i) {
    var r, s;
    return this.getChildContext || (r = [], (s = {})[e] = this, this.getChildContext = function() {
      return s;
    }, this.shouldComponentUpdate = function(a) {
      this.props.value !== a.value && r.some(function(l) {
        l.__e = !0, Kt(l);
      });
    }, this.sub = function(a) {
      r.push(a);
      var l = a.componentWillUnmount;
      a.componentWillUnmount = function() {
        r.splice(r.indexOf(a), 1), l && l.call(a);
      };
    }), i.children;
  } };
  return n.Provider.__ = n.Consumer.contextType = n;
}
St = or.slice, S = { __e: function(t, e, n, i) {
  for (var r, s, a; e = e.__; )
    if ((r = e.__c) && !r.__)
      try {
        if ((s = r.constructor) && s.getDerivedStateFromError != null && (r.setState(s.getDerivedStateFromError(t)), a = r.__d), r.componentDidCatch != null && (r.componentDidCatch(t, i || {}), a = r.__d), a)
          return r.__E = r;
      } catch (l) {
        t = l;
      }
  throw t;
} }, sr = 0, ke = !1, G.prototype.setState = function(t, e) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = le({}, this.state), typeof t == "function" && (t = t(le({}, n), this.props)), t && le(n, t), t != null && this.__v && (e && this._sb.push(e), Kt(this));
}, G.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), Kt(this));
}, G.prototype.render = H, me = [], ar = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, ut.__r = 0, lr = 0;
var X, Nt, ii, yr = [], Pt = [], ri = S.__b, si = S.__r, ai = S.diffed, li = S.__c, oi = S.unmount;
function oa() {
  for (var t; t = yr.shift(); )
    if (t.__P && t.__H)
      try {
        t.__H.__h.forEach(st), t.__H.__h.forEach(en), t.__H.__h = [];
      } catch (e) {
        t.__H.__h = [], S.__e(e, t.__v);
      }
}
S.__b = function(t) {
  X = null, ri && ri(t);
}, S.__r = function(t) {
  si && si(t);
  var e = (X = t.__c).__H;
  e && (Nt === X ? (e.__h = [], X.__h = [], e.__.forEach(function(n) {
    n.__N && (n.__ = n.__N), n.__V = Pt, n.__N = n.i = void 0;
  })) : (e.__h.forEach(st), e.__h.forEach(en), e.__h = [])), Nt = X;
}, S.diffed = function(t) {
  ai && ai(t);
  var e = t.__c;
  e && e.__H && (e.__H.__h.length && (yr.push(e) !== 1 && ii === S.requestAnimationFrame || ((ii = S.requestAnimationFrame) || ca)(oa)), e.__H.__.forEach(function(n) {
    n.i && (n.__H = n.i), n.__V !== Pt && (n.__ = n.__V), n.i = void 0, n.__V = Pt;
  })), Nt = X = null;
}, S.__c = function(t, e) {
  e.some(function(n) {
    try {
      n.__h.forEach(st), n.__h = n.__h.filter(function(i) {
        return !i.__ || en(i);
      });
    } catch (i) {
      e.some(function(r) {
        r.__h && (r.__h = []);
      }), e = [], S.__e(i, n.__v);
    }
  }), li && li(t, e);
}, S.unmount = function(t) {
  oi && oi(t);
  var e, n = t.__c;
  n && n.__H && (n.__H.__.forEach(function(i) {
    try {
      st(i);
    } catch (r) {
      e = r;
    }
  }), n.__H = void 0, e && S.__e(e, n.__v));
};
var ci = typeof requestAnimationFrame == "function";
function ca(t) {
  var e, n = function() {
    clearTimeout(i), ci && cancelAnimationFrame(e), setTimeout(t);
  }, i = setTimeout(n, 100);
  ci && (e = requestAnimationFrame(n));
}
function st(t) {
  var e = X, n = t.__c;
  typeof n == "function" && (t.__c = void 0, n()), X = e;
}
function en(t) {
  var e = X;
  t.__c = t.__(), X = e;
}
function da(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}
function di(t, e) {
  for (var n in t)
    if (n !== "__source" && !(n in e))
      return !0;
  for (var i in e)
    if (i !== "__source" && t[i] !== e[i])
      return !0;
  return !1;
}
function ui(t) {
  this.props = t;
}
(ui.prototype = new G()).isPureReactComponent = !0, ui.prototype.shouldComponentUpdate = function(t, e) {
  return di(this.props, t) || di(this.state, e);
};
var fi = S.__b;
S.__b = function(t) {
  t.type && t.type.__f && t.ref && (t.props.ref = t.ref, t.ref = null), fi && fi(t);
};
var ua = S.__e;
S.__e = function(t, e, n, i) {
  if (t.then) {
    for (var r, s = e; s = s.__; )
      if ((r = s.__c) && r.__c)
        return e.__e == null && (e.__e = n.__e, e.__k = n.__k), r.__c(t, e);
  }
  ua(t, e, n, i);
};
var hi = S.unmount;
function br(t, e, n) {
  return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function(i) {
    typeof i.__c == "function" && i.__c();
  }), t.__c.__H = null), (t = da({}, t)).__c != null && (t.__c.__P === n && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function(i) {
    return br(i, e, n);
  })), t;
}
function Er(t, e, n) {
  return t && (t.__v = null, t.__k = t.__k && t.__k.map(function(i) {
    return Er(i, e, n);
  }), t.__c && t.__c.__P === e && (t.__e && n.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = n)), t;
}
function Ht() {
  this.__u = 0, this.t = null, this.__b = null;
}
function _r(t) {
  var e = t.__.__c;
  return e && e.__a && e.__a(t);
}
function $e() {
  this.u = null, this.o = null;
}
S.unmount = function(t) {
  var e = t.__c;
  e && e.__R && e.__R(), e && t.__h === !0 && (t.type = null), hi && hi(t);
}, (Ht.prototype = new G()).__c = function(t, e) {
  var n = e.__c, i = this;
  i.t == null && (i.t = []), i.t.push(n);
  var r = _r(i.__v), s = !1, a = function() {
    s || (s = !0, n.__R = null, r ? r(l) : l());
  };
  n.__R = a;
  var l = function() {
    if (!--i.__u) {
      if (i.state.__a) {
        var d = i.state.__a;
        i.__v.__k[0] = Er(d, d.__c.__P, d.__c.__O);
      }
      var c;
      for (i.setState({ __a: i.__b = null }); c = i.t.pop(); )
        c.forceUpdate();
    }
  }, o = e.__h === !0;
  i.__u++ || o || i.setState({ __a: i.__b = i.__v.__k[0] }), t.then(a, a);
}, Ht.prototype.componentWillUnmount = function() {
  this.t = [];
}, Ht.prototype.render = function(t, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var n = document.createElement("div"), i = this.__v.__k[0].__c;
      this.__v.__k[0] = br(this.__b, n, i.__O = i.__P);
    }
    this.__b = null;
  }
  var r = e.__a && p(H, null, t.fallback);
  return r && (r.__h = null), [p(H, null, e.__a ? null : t.children), r];
};
var pi = function(t, e, n) {
  if (++n[1] === n[0] && t.o.delete(e), t.props.revealOrder && (t.props.revealOrder[0] !== "t" || !t.o.size))
    for (n = t.u; n; ) {
      for (; n.length > 3; )
        n.pop()();
      if (n[1] < n[0])
        break;
      t.u = n = n[2];
    }
};
function fa(t) {
  return this.getChildContext = function() {
    return t.context;
  }, t.children;
}
function ha(t) {
  var e = this, n = t.i;
  e.componentWillUnmount = function() {
    Ue(null, e.l), e.l = null, e.i = null;
  }, e.i && e.i !== n && e.componentWillUnmount(), t.__v ? (e.l || (e.i = n, e.l = { nodeType: 1, parentNode: n, childNodes: [], appendChild: function(i) {
    this.childNodes.push(i), e.i.appendChild(i);
  }, insertBefore: function(i, r) {
    this.childNodes.push(i), e.i.appendChild(i);
  }, removeChild: function(i) {
    this.childNodes.splice(this.childNodes.indexOf(i) >>> 1, 1), e.i.removeChild(i);
  } }), Ue(p(fa, { context: e.context }, t.__v), e.l)) : e.l && e.componentWillUnmount();
}
function pa(t, e) {
  var n = p(ha, { __v: t, i: e });
  return n.containerInfo = e, n;
}
($e.prototype = new G()).__a = function(t) {
  var e = this, n = _r(e.__v), i = e.o.get(t);
  return i[0]++, function(r) {
    var s = function() {
      e.props.revealOrder ? (i.push(r), pi(e, t, i)) : r();
    };
    n ? n(s) : s();
  };
}, $e.prototype.render = function(t) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var e = ft(t.children);
  t.revealOrder && t.revealOrder[0] === "b" && e.reverse();
  for (var n = e.length; n--; )
    this.o.set(e[n], this.u = [1, 0, this.u]);
  return t.children;
}, $e.prototype.componentDidUpdate = $e.prototype.componentDidMount = function() {
  var t = this;
  this.o.forEach(function(e, n) {
    pi(t, n, e);
  });
};
var ga = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, ma = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, va = typeof document < "u", ya = function(t) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(t);
};
G.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t) {
  Object.defineProperty(G.prototype, t, { configurable: !0, get: function() {
    return this["UNSAFE_" + t];
  }, set: function(e) {
    Object.defineProperty(this, t, { configurable: !0, writable: !0, value: e });
  } });
});
var gi = S.event;
function ba() {
}
function Ea() {
  return this.cancelBubble;
}
function _a() {
  return this.defaultPrevented;
}
S.event = function(t) {
  return gi && (t = gi(t)), t.persist = ba, t.isPropagationStopped = Ea, t.isDefaultPrevented = _a, t.nativeEvent = t;
};
var mi = { configurable: !0, get: function() {
  return this.class;
} }, vi = S.vnode;
S.vnode = function(t) {
  var e = t.type, n = t.props, i = n;
  if (typeof e == "string") {
    var r = e.indexOf("-") === -1;
    for (var s in i = {}, n) {
      var a = n[s];
      va && s === "children" && e === "noscript" || s === "value" && "defaultValue" in n && a == null || (s === "defaultValue" && "value" in n && n.value == null ? s = "value" : s === "download" && a === !0 ? a = "" : /ondoubleclick/i.test(s) ? s = "ondblclick" : /^onchange(textarea|input)/i.test(s + e) && !ya(n.type) ? s = "oninput" : /^onfocus$/i.test(s) ? s = "onfocusin" : /^onblur$/i.test(s) ? s = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(s) ? s = s.toLowerCase() : r && ma.test(s) ? s = s.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : a === null && (a = void 0), /^oninput$/i.test(s) && (s = s.toLowerCase(), i[s] && (s = "oninputCapture")), i[s] = a);
    }
    e == "select" && i.multiple && Array.isArray(i.value) && (i.value = ft(n.children).forEach(function(l) {
      l.props.selected = i.value.indexOf(l.props.value) != -1;
    })), e == "select" && i.defaultValue != null && (i.value = ft(n.children).forEach(function(l) {
      l.props.selected = i.multiple ? i.defaultValue.indexOf(l.props.value) != -1 : i.defaultValue == l.props.value;
    })), t.props = i, n.class != n.className && (mi.enumerable = "className" in n, n.className != null && (i.class = n.className), Object.defineProperty(i, "className", mi));
  }
  t.$$typeof = ga, vi && vi(t);
};
var yi = S.__r;
S.__r = function(t) {
  yi && yi(t);
};
const wr = [], tn = /* @__PURE__ */ new Map();
function En(t) {
  wr.push(t), tn.forEach((e) => {
    Sr(e, t);
  });
}
function wa(t) {
  t.isConnected && Cr(t.getRootNode());
}
function Cr(t) {
  let e = tn.get(t);
  if (!e || !e.isConnected) {
    if (e = t.querySelector("style[data-fullcalendar]"), !e) {
      e = document.createElement("style"), e.setAttribute("data-fullcalendar", "");
      const n = Sa();
      n && (e.nonce = n);
      const i = t === document ? document.head : t, r = t === document ? i.querySelector("script,link[rel=stylesheet],link[as=style],style") : i.firstChild;
      i.insertBefore(e, r);
    }
    tn.set(t, e), Ca(e);
  }
}
function Ca(t) {
  for (const e of wr)
    Sr(t, e);
}
function Sr(t, e) {
  const { sheet: n } = t, i = n.cssRules.length;
  e.split("}").forEach((r, s) => {
    r = r.trim(), r && n.insertRule(r + "}", i + s);
  });
}
let Lt;
function Sa() {
  return Lt === void 0 && (Lt = Da()), Lt;
}
function Da() {
  const t = document.querySelector('meta[name="csp-nonce"]');
  if (t && t.hasAttribute("content"))
    return t.getAttribute("content");
  const e = document.querySelector("script[nonce]");
  return e && e.nonce || "";
}
typeof document < "u" && Cr(document);
var Aa = ':root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:"\\e900"}.fc-icon-chevron-right:before{content:"\\e901"}.fc-icon-chevrons-left:before{content:"\\e902"}.fc-icon-chevrons-right:before{content:"\\e903"}.fc-icon-minus-square:before{content:"\\e904"}.fc-icon-plus-square:before{content:"\\e905"}.fc-icon-x:before{content:"\\e906"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:"";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:"";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}';
En(Aa);
function _n(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function U(t, e) {
  if (t.closest)
    return t.closest(e);
  if (!document.documentElement.contains(t))
    return null;
  do {
    if (Ta(t, e))
      return t;
    t = t.parentElement || t.parentNode;
  } while (t !== null && t.nodeType === 1);
  return null;
}
function Ta(t, e) {
  return (t.matches || t.matchesSelector || t.msMatchesSelector).call(t, e);
}
function Ra(t, e) {
  let n = t instanceof HTMLElement ? [t] : t, i = [];
  for (let r = 0; r < n.length; r += 1) {
    let s = n[r].querySelectorAll(e);
    for (let a = 0; a < s.length; a += 1)
      i.push(s[a]);
  }
  return i;
}
const xa = /(top|left|right|bottom|width|height)$/i;
function He(t, e) {
  for (let n in e)
    Dr(t, n, e[n]);
}
function Dr(t, e, n) {
  n == null ? t.style[e] = "" : typeof n == "number" && xa.test(e) ? t.style[e] = `${n}px` : t.style[e] = n;
}
function Ar(t) {
  var e, n;
  return (n = (e = t.composedPath) === null || e === void 0 ? void 0 : e.call(t)[0]) !== null && n !== void 0 ? n : t.target;
}
let bi = 0;
function Dt() {
  return bi += 1, "fc-dom-" + bi;
}
function At(t) {
  t.preventDefault();
}
function ka(t, e) {
  return (n) => {
    let i = U(n.target, t);
    i && e.call(i, n, i);
  };
}
function Tr(t, e, n, i) {
  let r = ka(n, i);
  return t.addEventListener(e, r), () => {
    t.removeEventListener(e, r);
  };
}
function Ma(t, e, n, i) {
  let r;
  return Tr(t, "mouseover", e, (s, a) => {
    if (a !== r) {
      r = a, n(s, a);
      let l = (o) => {
        r = null, i(o, a), a.removeEventListener("mouseleave", l);
      };
      a.addEventListener("mouseleave", l);
    }
  });
}
const Ei = [
  "webkitTransitionEnd",
  "otransitionend",
  "oTransitionEnd",
  "msTransitionEnd",
  "transitionend"
];
function Ia(t, e) {
  let n = (i) => {
    e(i), Ei.forEach((r) => {
      t.removeEventListener(r, n);
    });
  };
  Ei.forEach((i) => {
    t.addEventListener(i, n);
  });
}
function Rr(t) {
  return Object.assign({ onClick: t }, xr(t));
}
function xr(t) {
  return {
    tabIndex: 0,
    onKeyDown(e) {
      (e.key === "Enter" || e.key === " ") && (t(e), e.preventDefault());
    }
  };
}
let _i = 0;
function we() {
  return _i += 1, String(_i);
}
function wn() {
  document.body.classList.add("fc-not-allowed");
}
function Cn() {
  document.body.classList.remove("fc-not-allowed");
}
function Oa(t) {
  t.style.userSelect = "none", t.addEventListener("selectstart", At);
}
function Na(t) {
  t.style.userSelect = "", t.removeEventListener("selectstart", At);
}
function Pa(t) {
  t.addEventListener("contextmenu", At);
}
function Ha(t) {
  t.removeEventListener("contextmenu", At);
}
function La(t) {
  let e = [], n = [], i, r;
  for (typeof t == "string" ? n = t.split(/\s*,\s*/) : typeof t == "function" ? n = [t] : Array.isArray(t) && (n = t), i = 0; i < n.length; i += 1)
    r = n[i], typeof r == "string" ? e.push(r.charAt(0) === "-" ? { field: r.substring(1), order: -1 } : { field: r, order: 1 }) : typeof r == "function" && e.push({ func: r });
  return e;
}
function Ba(t, e, n) {
  let i, r;
  for (i = 0; i < n.length; i += 1)
    if (r = za(t, e, n[i]), r)
      return r;
  return 0;
}
function za(t, e, n) {
  return n.func ? n.func(t, e) : Ua(t[n.field], e[n.field]) * (n.order || 1);
}
function Ua(t, e) {
  return !t && !e ? 0 : e == null ? -1 : t == null ? 1 : typeof t == "string" || typeof e == "string" ? String(t).localeCompare(String(e)) : t - e;
}
function Te(t, e) {
  let n = String(t);
  return "000".substr(0, e - n.length) + n;
}
function Le(t, e, n) {
  return typeof t == "function" ? t(...e) : typeof t == "string" ? e.reduce((i, r, s) => i.replace("$" + s, r || ""), t) : n;
}
function Fa(t, e) {
  return t - e;
}
function at(t) {
  return t % 1 === 0;
}
function ja(t) {
  let e = t.querySelector(".fc-scrollgrid-shrink-frame"), n = t.querySelector(".fc-scrollgrid-shrink-cushion");
  if (!e)
    throw new Error("needs fc-scrollgrid-shrink-frame className");
  if (!n)
    throw new Error("needs fc-scrollgrid-shrink-cushion className");
  return t.getBoundingClientRect().width - e.getBoundingClientRect().width + // the cell padding+border
  n.getBoundingClientRect().width;
}
const wi = ["years", "months", "days", "milliseconds"], Wa = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
function k(t, e) {
  return typeof t == "string" ? Va(t) : typeof t == "object" && t ? Ci(t) : typeof t == "number" ? Ci({ [e || "milliseconds"]: t }) : null;
}
function Va(t) {
  let e = Wa.exec(t);
  if (e) {
    let n = e[1] ? -1 : 1;
    return {
      years: 0,
      months: 0,
      days: n * (e[2] ? parseInt(e[2], 10) : 0),
      milliseconds: n * ((e[3] ? parseInt(e[3], 10) : 0) * 60 * 60 * 1e3 + // hours
      (e[4] ? parseInt(e[4], 10) : 0) * 60 * 1e3 + // minutes
      (e[5] ? parseInt(e[5], 10) : 0) * 1e3 + // seconds
      (e[6] ? parseInt(e[6], 10) : 0))
    };
  }
  return null;
}
function Ci(t) {
  let e = {
    years: t.years || t.year || 0,
    months: t.months || t.month || 0,
    days: t.days || t.day || 0,
    milliseconds: (t.hours || t.hour || 0) * 60 * 60 * 1e3 + // hours
    (t.minutes || t.minute || 0) * 60 * 1e3 + // minutes
    (t.seconds || t.second || 0) * 1e3 + // seconds
    (t.milliseconds || t.millisecond || t.ms || 0)
    // ms
  }, n = t.weeks || t.week;
  return n && (e.days += n * 7, e.specifiedWeeks = !0), e;
}
function Ga(t, e) {
  return t.years === e.years && t.months === e.months && t.days === e.days && t.milliseconds === e.milliseconds;
}
function nn(t, e) {
  return {
    years: t.years + e.years,
    months: t.months + e.months,
    days: t.days + e.days,
    milliseconds: t.milliseconds + e.milliseconds
  };
}
function Ya(t, e) {
  return {
    years: t.years - e.years,
    months: t.months - e.months,
    days: t.days - e.days,
    milliseconds: t.milliseconds - e.milliseconds
  };
}
function qa(t, e) {
  return {
    years: t.years * e,
    months: t.months * e,
    days: t.days * e,
    milliseconds: t.milliseconds * e
  };
}
function Qa(t) {
  return Re(t) / 365;
}
function $a(t) {
  return Re(t) / 30;
}
function Re(t) {
  return Z(t) / 864e5;
}
function Z(t) {
  return t.years * (365 * 864e5) + t.months * (30 * 864e5) + t.days * 864e5 + t.milliseconds;
}
function Sn(t, e) {
  let n = null;
  for (let i = 0; i < wi.length; i += 1) {
    let r = wi[i];
    if (e[r]) {
      let s = t[r] / e[r];
      if (!at(s) || n !== null && n !== s)
        return null;
      n = s;
    } else if (t[r])
      return null;
  }
  return n;
}
function rn(t) {
  let e = t.milliseconds;
  if (e) {
    if (e % 1e3 !== 0)
      return { unit: "millisecond", value: e };
    if (e % (1e3 * 60) !== 0)
      return { unit: "second", value: e / 1e3 };
    if (e % (1e3 * 60 * 60) !== 0)
      return { unit: "minute", value: e / (1e3 * 60) };
    if (e)
      return { unit: "hour", value: e / (1e3 * 60 * 60) };
  }
  return t.days ? t.specifiedWeeks && t.days % 7 === 0 ? { unit: "week", value: t.days / 7 } : { unit: "day", value: t.days } : t.months ? { unit: "month", value: t.months } : t.years ? { unit: "year", value: t.years } : { unit: "millisecond", value: 0 };
}
const { hasOwnProperty: ht } = Object.prototype;
function Dn(t, e) {
  let n = {};
  if (e) {
    for (let i in e)
      if (e[i] === ge) {
        let r = [];
        for (let s = t.length - 1; s >= 0; s -= 1) {
          let a = t[s][i];
          if (typeof a == "object" && a)
            r.unshift(a);
          else if (a !== void 0) {
            n[i] = a;
            break;
          }
        }
        r.length && (n[i] = Dn(r));
      }
  }
  for (let i = t.length - 1; i >= 0; i -= 1) {
    let r = t[i];
    for (let s in r)
      s in n || (n[s] = r[s]);
  }
  return n;
}
function be(t, e) {
  let n = {};
  for (let i in t)
    e(t[i], i) && (n[i] = t[i]);
  return n;
}
function ne(t, e) {
  let n = {};
  for (let i in t)
    n[i] = e(t[i], i);
  return n;
}
function kr(t) {
  let e = {};
  for (let n of t)
    e[n] = !0;
  return e;
}
function An(t) {
  let e = [];
  for (let n in t)
    e.push(t[n]);
  return e;
}
function J(t, e) {
  if (t === e)
    return !0;
  for (let n in t)
    if (ht.call(t, n) && !(n in e))
      return !1;
  for (let n in e)
    if (ht.call(e, n) && t[n] !== e[n])
      return !1;
  return !0;
}
const Za = /^on[A-Z]/;
function Xa(t, e) {
  const n = sn(t, e);
  for (let i of n)
    if (!Za.test(i))
      return !1;
  return !0;
}
function sn(t, e) {
  let n = [];
  for (let i in t)
    ht.call(t, i) && (i in e || n.push(i));
  for (let i in e)
    ht.call(e, i) && t[i] !== e[i] && n.push(i);
  return n;
}
function Bt(t, e, n = {}) {
  if (t === e)
    return !0;
  for (let i in e)
    if (!(i in t && Ja(t[i], e[i], n[i])))
      return !1;
  for (let i in t)
    if (!(i in e))
      return !1;
  return !0;
}
function Ja(t, e, n) {
  return t === e || n === !0 ? !0 : n ? n(t, e) : !1;
}
function Ka(t, e = 0, n, i = 1) {
  let r = [];
  n == null && (n = Object.keys(t).length);
  for (let s = e; s < n; s += i) {
    let a = t[s];
    a !== void 0 && r.push(a);
  }
  return r;
}
function ue(t, e, n) {
  if (t === e)
    return !0;
  let i = t.length, r;
  if (i !== e.length)
    return !1;
  for (r = 0; r < i; r += 1)
    if (!(n ? n(t[r], e[r]) : t[r] === e[r]))
      return !1;
  return !0;
}
const el = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
function Si(t, e) {
  let n = oe(t);
  return n[2] += e * 7, W(n);
}
function F(t, e) {
  let n = oe(t);
  return n[2] += e, W(n);
}
function fe(t, e) {
  let n = oe(t);
  return n[6] += e, W(n);
}
function tl(t, e) {
  return Ce(t, e) / 7;
}
function Ce(t, e) {
  return (e.valueOf() - t.valueOf()) / (1e3 * 60 * 60 * 24);
}
function nl(t, e) {
  return (e.valueOf() - t.valueOf()) / (1e3 * 60 * 60);
}
function il(t, e) {
  return (e.valueOf() - t.valueOf()) / (1e3 * 60);
}
function rl(t, e) {
  return (e.valueOf() - t.valueOf()) / 1e3;
}
function sl(t, e) {
  let n = P(t), i = P(e);
  return {
    years: 0,
    months: 0,
    days: Math.round(Ce(n, i)),
    milliseconds: e.valueOf() - i.valueOf() - (t.valueOf() - n.valueOf())
  };
}
function al(t, e) {
  let n = pt(t, e);
  return n !== null && n % 7 === 0 ? n / 7 : null;
}
function pt(t, e) {
  return ce(t) === ce(e) ? Math.round(Ce(t, e)) : null;
}
function P(t) {
  return W([
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ]);
}
function ll(t) {
  return W([
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours()
  ]);
}
function ol(t) {
  return W([
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes()
  ]);
}
function cl(t) {
  return W([
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  ]);
}
function dl(t, e, n) {
  let i = t.getUTCFullYear(), r = zt(t, i, e, n);
  if (r < 1)
    return zt(t, i - 1, e, n);
  let s = zt(t, i + 1, e, n);
  return s >= 1 ? Math.min(r, s) : r;
}
function zt(t, e, n, i) {
  let r = W([e, 0, 1 + ul(e, n, i)]), s = P(t), a = Math.round(Ce(r, s));
  return Math.floor(a / 7) + 1;
}
function ul(t, e, n) {
  let i = 7 + e - n;
  return -((7 + W([t, 0, i]).getUTCDay() - e) % 7) + i - 1;
}
function Di(t) {
  return [
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ];
}
function Ai(t) {
  return new Date(
    t[0],
    t[1] || 0,
    t[2] == null ? 1 : t[2],
    // day of month
    t[3] || 0,
    t[4] || 0,
    t[5] || 0
  );
}
function oe(t) {
  return [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds(),
    t.getUTCMilliseconds()
  ];
}
function W(t) {
  return t.length === 1 && (t = t.concat([0])), new Date(Date.UTC(...t));
}
function Mr(t) {
  return !isNaN(t.valueOf());
}
function ce(t) {
  return t.getUTCHours() * 1e3 * 60 * 60 + t.getUTCMinutes() * 1e3 * 60 + t.getUTCSeconds() * 1e3 + t.getUTCMilliseconds();
}
function Ir(t, e, n = !1) {
  let i = t.toISOString();
  return i = i.replace(".000", ""), n && (i = i.replace("T00:00:00Z", "")), i.length > 10 && (e == null ? i = i.replace("Z", "") : e !== 0 && (i = i.replace("Z", Rn(e, !0)))), i;
}
function Tn(t) {
  return t.toISOString().replace(/T.*$/, "");
}
function fl(t) {
  return t.toISOString().match(/^\d{4}-\d{2}/)[0];
}
function hl(t) {
  return Te(t.getUTCHours(), 2) + ":" + Te(t.getUTCMinutes(), 2) + ":" + Te(t.getUTCSeconds(), 2);
}
function Rn(t, e = !1) {
  let n = t < 0 ? "-" : "+", i = Math.abs(t), r = Math.floor(i / 60), s = Math.round(i % 60);
  return e ? `${n + Te(r, 2)}:${Te(s, 2)}` : `GMT${n}${r}${s ? `:${Te(s, 2)}` : ""}`;
}
function D(t, e, n) {
  let i, r;
  return function(...s) {
    if (!i)
      r = t.apply(this, s);
    else if (!ue(i, s)) {
      n && n(r);
      let a = t.apply(this, s);
      (!e || !e(a, r)) && (r = a);
    }
    return i = s, r;
  };
}
function lt(t, e, n) {
  let i, r;
  return (s) => {
    if (!i)
      r = t.call(this, s);
    else if (!J(i, s)) {
      n && n(r);
      let a = t.call(this, s);
      (!e || !e(a, r)) && (r = a);
    }
    return i = s, r;
  };
}
const Ti = {
  week: 3,
  separator: 0,
  omitZeroMinute: 0,
  meridiem: 0,
  omitCommas: 0
}, gt = {
  timeZoneName: 7,
  era: 6,
  year: 5,
  month: 4,
  day: 2,
  weekday: 2,
  hour: 1,
  minute: 1,
  second: 1
}, Ze = /\s*([ap])\.?m\.?/i, pl = /,/g, gl = /\s+/g, ml = /\u200e/g, vl = /UTC|GMT/;
class yl {
  constructor(e) {
    let n = {}, i = {}, r = 0;
    for (let s in e)
      s in Ti ? (i[s] = e[s], r = Math.max(Ti[s], r)) : (n[s] = e[s], s in gt && (r = Math.max(gt[s], r)));
    this.standardDateProps = n, this.extendedSettings = i, this.severity = r, this.buildFormattingFunc = D(Ri);
  }
  format(e, n) {
    return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, n)(e);
  }
  formatRange(e, n, i, r) {
    let { standardDateProps: s, extendedSettings: a } = this, l = Sl(e.marker, n.marker, i.calendarSystem);
    if (!l)
      return this.format(e, i);
    let o = l;
    o > 1 && // the two dates are different in a way that's larger scale than time
    (s.year === "numeric" || s.year === "2-digit") && (s.month === "numeric" || s.month === "2-digit") && (s.day === "numeric" || s.day === "2-digit") && (o = 1);
    let d = this.format(e, i), c = this.format(n, i);
    if (d === c)
      return d;
    let h = Dl(s, o), f = Ri(h, a, i), u = f(e), v = f(n), y = Al(d, u, c, v), b = a.separator || r || i.defaultSeparator || "";
    return y ? y.before + u + b + v + y.after : d + b + c;
  }
  getLargestUnit() {
    switch (this.severity) {
      case 7:
      case 6:
      case 5:
        return "year";
      case 4:
        return "month";
      case 3:
        return "week";
      case 2:
        return "day";
      default:
        return "time";
    }
  }
}
function Ri(t, e, n) {
  let i = Object.keys(t).length;
  return i === 1 && t.timeZoneName === "short" ? (r) => Rn(r.timeZoneOffset) : i === 0 && e.week ? (r) => Cl(n.computeWeekNumber(r.marker), n.weekText, n.weekTextLong, n.locale, e.week) : bl(t, e, n);
}
function bl(t, e, n) {
  t = Object.assign({}, t), e = Object.assign({}, e), El(t, e), t.timeZone = "UTC";
  let i = new Intl.DateTimeFormat(n.locale.codes, t), r;
  if (e.omitZeroMinute) {
    let s = Object.assign({}, t);
    delete s.minute, r = new Intl.DateTimeFormat(n.locale.codes, s);
  }
  return (s) => {
    let { marker: a } = s, l;
    r && !a.getUTCMinutes() ? l = r : l = i;
    let o = l.format(a);
    return _l(o, s, t, e, n);
  };
}
function El(t, e) {
  t.timeZoneName && (t.hour || (t.hour = "2-digit"), t.minute || (t.minute = "2-digit")), t.timeZoneName === "long" && (t.timeZoneName = "short"), e.omitZeroMinute && (t.second || t.millisecond) && delete e.omitZeroMinute;
}
function _l(t, e, n, i, r) {
  return t = t.replace(ml, ""), n.timeZoneName === "short" && (t = wl(t, r.timeZone === "UTC" || e.timeZoneOffset == null ? "UTC" : (
    // important to normalize for IE, which does "GMT"
    Rn(e.timeZoneOffset)
  ))), i.omitCommas && (t = t.replace(pl, "").trim()), i.omitZeroMinute && (t = t.replace(":00", "")), i.meridiem === !1 ? t = t.replace(Ze, "").trim() : i.meridiem === "narrow" ? t = t.replace(Ze, (s, a) => a.toLocaleLowerCase()) : i.meridiem === "short" ? t = t.replace(Ze, (s, a) => `${a.toLocaleLowerCase()}m`) : i.meridiem === "lowercase" && (t = t.replace(Ze, (s) => s.toLocaleLowerCase())), t = t.replace(gl, " "), t = t.trim(), t;
}
function wl(t, e) {
  let n = !1;
  return t = t.replace(vl, () => (n = !0, e)), n || (t += ` ${e}`), t;
}
function Cl(t, e, n, i, r) {
  let s = [];
  return r === "long" ? s.push(n) : (r === "short" || r === "narrow") && s.push(e), (r === "long" || r === "short") && s.push(" "), s.push(i.simpleNumberFormat.format(t)), i.options.direction === "rtl" && s.reverse(), s.join("");
}
function Sl(t, e, n) {
  return n.getMarkerYear(t) !== n.getMarkerYear(e) ? 5 : n.getMarkerMonth(t) !== n.getMarkerMonth(e) ? 4 : n.getMarkerDay(t) !== n.getMarkerDay(e) ? 2 : ce(t) !== ce(e) ? 1 : 0;
}
function Dl(t, e) {
  let n = {};
  for (let i in t)
    (!(i in gt) || // not a date part prop (like timeZone)
    gt[i] <= e) && (n[i] = t[i]);
  return n;
}
function Al(t, e, n, i) {
  let r = 0;
  for (; r < t.length; ) {
    let s = t.indexOf(e, r);
    if (s === -1)
      break;
    let a = t.substr(0, s);
    r = s + e.length;
    let l = t.substr(r), o = 0;
    for (; o < n.length; ) {
      let d = n.indexOf(i, o);
      if (d === -1)
        break;
      let c = n.substr(0, d);
      o = d + i.length;
      let h = n.substr(o);
      if (a === c && l === h)
        return {
          before: a,
          after: l
        };
    }
  }
  return null;
}
function xi(t, e) {
  let n = e.markerToArray(t.marker);
  return {
    marker: t.marker,
    timeZoneOffset: t.timeZoneOffset,
    array: n,
    year: n[0],
    month: n[1],
    day: n[2],
    hour: n[3],
    minute: n[4],
    second: n[5],
    millisecond: n[6]
  };
}
function mt(t, e, n, i) {
  let r = xi(t, n.calendarSystem), s = e ? xi(e, n.calendarSystem) : null;
  return {
    date: r,
    start: r,
    end: s,
    timeZone: n.timeZone,
    localeCodes: n.locale.codes,
    defaultSeparator: i || n.defaultSeparator
  };
}
class Tl {
  constructor(e) {
    this.cmdStr = e;
  }
  format(e, n, i) {
    return n.cmdFormatter(this.cmdStr, mt(e, null, n, i));
  }
  formatRange(e, n, i, r) {
    return i.cmdFormatter(this.cmdStr, mt(e, n, i, r));
  }
}
class Rl {
  constructor(e) {
    this.func = e;
  }
  format(e, n, i) {
    return this.func(mt(e, null, n, i));
  }
  formatRange(e, n, i, r) {
    return this.func(mt(e, n, i, r));
  }
}
function B(t) {
  return typeof t == "object" && t ? new yl(t) : typeof t == "string" ? new Tl(t) : typeof t == "function" ? new Rl(t) : null;
}
const ki = {
  navLinkDayClick: m,
  navLinkWeekClick: m,
  duration: k,
  bootstrapFontAwesome: m,
  buttonIcons: m,
  customButtons: m,
  defaultAllDayEventDuration: k,
  defaultTimedEventDuration: k,
  nextDayThreshold: k,
  scrollTime: k,
  scrollTimeReset: Boolean,
  slotMinTime: k,
  slotMaxTime: k,
  dayPopoverFormat: B,
  slotDuration: k,
  snapDuration: k,
  headerToolbar: m,
  footerToolbar: m,
  defaultRangeSeparator: String,
  titleRangeSeparator: String,
  forceEventDuration: Boolean,
  dayHeaders: Boolean,
  dayHeaderFormat: B,
  dayHeaderClassNames: m,
  dayHeaderContent: m,
  dayHeaderDidMount: m,
  dayHeaderWillUnmount: m,
  dayCellClassNames: m,
  dayCellContent: m,
  dayCellDidMount: m,
  dayCellWillUnmount: m,
  initialView: String,
  aspectRatio: Number,
  weekends: Boolean,
  weekNumberCalculation: m,
  weekNumbers: Boolean,
  weekNumberClassNames: m,
  weekNumberContent: m,
  weekNumberDidMount: m,
  weekNumberWillUnmount: m,
  editable: Boolean,
  viewClassNames: m,
  viewDidMount: m,
  viewWillUnmount: m,
  nowIndicator: Boolean,
  nowIndicatorClassNames: m,
  nowIndicatorContent: m,
  nowIndicatorDidMount: m,
  nowIndicatorWillUnmount: m,
  showNonCurrentDates: Boolean,
  lazyFetching: Boolean,
  startParam: String,
  endParam: String,
  timeZoneParam: String,
  timeZone: String,
  locales: m,
  locale: m,
  themeSystem: String,
  dragRevertDuration: Number,
  dragScroll: Boolean,
  allDayMaintainDuration: Boolean,
  unselectAuto: Boolean,
  dropAccept: m,
  eventOrder: La,
  eventOrderStrict: Boolean,
  handleWindowResize: Boolean,
  windowResizeDelay: Number,
  longPressDelay: Number,
  eventDragMinDistance: Number,
  expandRows: Boolean,
  height: m,
  contentHeight: m,
  direction: String,
  weekNumberFormat: B,
  eventResizableFromStart: Boolean,
  displayEventTime: Boolean,
  displayEventEnd: Boolean,
  weekText: String,
  weekTextLong: String,
  progressiveEventRendering: Boolean,
  businessHours: m,
  initialDate: m,
  now: m,
  eventDataTransform: m,
  stickyHeaderDates: m,
  stickyFooterScrollbar: m,
  viewHeight: m,
  defaultAllDay: Boolean,
  eventSourceFailure: m,
  eventSourceSuccess: m,
  eventDisplay: String,
  eventStartEditable: Boolean,
  eventDurationEditable: Boolean,
  eventOverlap: m,
  eventConstraint: m,
  eventAllow: m,
  eventBackgroundColor: String,
  eventBorderColor: String,
  eventTextColor: String,
  eventColor: String,
  eventClassNames: m,
  eventContent: m,
  eventDidMount: m,
  eventWillUnmount: m,
  selectConstraint: m,
  selectOverlap: m,
  selectAllow: m,
  droppable: Boolean,
  unselectCancel: String,
  slotLabelFormat: m,
  slotLaneClassNames: m,
  slotLaneContent: m,
  slotLaneDidMount: m,
  slotLaneWillUnmount: m,
  slotLabelClassNames: m,
  slotLabelContent: m,
  slotLabelDidMount: m,
  slotLabelWillUnmount: m,
  dayMaxEvents: m,
  dayMaxEventRows: m,
  dayMinWidth: Number,
  slotLabelInterval: k,
  allDayText: String,
  allDayClassNames: m,
  allDayContent: m,
  allDayDidMount: m,
  allDayWillUnmount: m,
  slotMinWidth: Number,
  navLinks: Boolean,
  eventTimeFormat: B,
  rerenderDelay: Number,
  moreLinkText: m,
  moreLinkHint: m,
  selectMinDistance: Number,
  selectable: Boolean,
  selectLongPressDelay: Number,
  eventLongPressDelay: Number,
  selectMirror: Boolean,
  eventMaxStack: Number,
  eventMinHeight: Number,
  eventMinWidth: Number,
  eventShortHeight: Number,
  slotEventOverlap: Boolean,
  plugins: m,
  firstDay: Number,
  dayCount: Number,
  dateAlignment: String,
  dateIncrement: k,
  hiddenDays: m,
  fixedWeekCount: Boolean,
  validRange: m,
  visibleRange: m,
  titleFormat: m,
  eventInteractive: Boolean,
  // only used by list-view, but languages define the value, so we need it in base options
  noEventsText: String,
  viewHint: m,
  navLinkHint: m,
  closeHint: String,
  timeHint: String,
  eventHint: String,
  moreLinkClick: m,
  moreLinkClassNames: m,
  moreLinkContent: m,
  moreLinkDidMount: m,
  moreLinkWillUnmount: m,
  monthStartFormat: B,
  // for connectors
  // (can't be part of plugin system b/c must be provided at runtime)
  handleCustomRendering: m,
  customRenderingMetaMap: m,
  customRenderingReplacesEl: Boolean
}, Be = {
  eventDisplay: "auto",
  defaultRangeSeparator: " - ",
  titleRangeSeparator: " – ",
  defaultTimedEventDuration: "01:00:00",
  defaultAllDayEventDuration: { day: 1 },
  forceEventDuration: !1,
  nextDayThreshold: "00:00:00",
  dayHeaders: !0,
  initialView: "",
  aspectRatio: 1.35,
  headerToolbar: {
    start: "title",
    center: "",
    end: "today prev,next"
  },
  weekends: !0,
  weekNumbers: !1,
  weekNumberCalculation: "local",
  editable: !1,
  nowIndicator: !1,
  scrollTime: "06:00:00",
  scrollTimeReset: !0,
  slotMinTime: "00:00:00",
  slotMaxTime: "24:00:00",
  showNonCurrentDates: !0,
  lazyFetching: !0,
  startParam: "start",
  endParam: "end",
  timeZoneParam: "timeZone",
  timeZone: "local",
  locales: [],
  locale: "",
  themeSystem: "standard",
  dragRevertDuration: 500,
  dragScroll: !0,
  allDayMaintainDuration: !1,
  unselectAuto: !0,
  dropAccept: "*",
  eventOrder: "start,-duration,allDay,title",
  dayPopoverFormat: { month: "long", day: "numeric", year: "numeric" },
  handleWindowResize: !0,
  windowResizeDelay: 100,
  longPressDelay: 1e3,
  eventDragMinDistance: 5,
  expandRows: !1,
  navLinks: !1,
  selectable: !1,
  eventMinHeight: 15,
  eventMinWidth: 30,
  eventShortHeight: 30,
  monthStartFormat: { month: "long", day: "numeric" }
}, Mi = {
  datesSet: m,
  eventsSet: m,
  eventAdd: m,
  eventChange: m,
  eventRemove: m,
  windowResize: m,
  eventClick: m,
  eventMouseEnter: m,
  eventMouseLeave: m,
  select: m,
  unselect: m,
  loading: m,
  // internal
  _unmount: m,
  _beforeprint: m,
  _afterprint: m,
  _noEventDrop: m,
  _noEventResize: m,
  _resize: m,
  _scrollRequest: m
}, Ii = {
  buttonText: m,
  buttonHints: m,
  views: m,
  plugins: m,
  initialEvents: m,
  events: m,
  eventSources: m
}, pe = {
  headerToolbar: ge,
  footerToolbar: ge,
  buttonText: ge,
  buttonHints: ge,
  buttonIcons: ge,
  dateIncrement: ge,
  plugins: Xe,
  events: Xe,
  eventSources: Xe,
  resources: Xe
};
function ge(t, e) {
  return typeof t == "object" && typeof e == "object" && t && e ? J(t, e) : t === e;
}
function Xe(t, e) {
  return Array.isArray(t) && Array.isArray(e) ? ue(t, e) : t === e;
}
const xl = {
  type: String,
  component: m,
  buttonText: String,
  buttonTextKey: String,
  dateProfileGeneratorClass: m,
  usesMinMaxTime: Boolean,
  classNames: m,
  content: m,
  didMount: m,
  willUnmount: m
};
function Ut(t) {
  return Dn(t, pe);
}
function xn(t, e) {
  let n = {}, i = {};
  for (let r in e)
    r in t && (n[r] = e[r](t[r]));
  for (let r in t)
    r in e || (i[r] = t[r]);
  return { refined: n, extra: i };
}
function m(t) {
  return t;
}
function kn(t, e, n, i) {
  return {
    instanceId: we(),
    defId: t,
    range: e,
    forcedStartTzo: n ?? null,
    forcedEndTzo: i ?? null
  };
}
function kl(t, e, n, i) {
  for (let r = 0; r < i.length; r += 1) {
    let s = i[r].parse(t, n);
    if (s) {
      let { allDay: a } = t;
      return a == null && (a = e, a == null && (a = s.allDayGuess, a == null && (a = !1))), {
        allDay: a,
        duration: s.duration,
        typeData: s.typeData,
        typeId: r
      };
    }
  }
  return null;
}
function Ee(t, e, n) {
  let { dateEnv: i, pluginHooks: r, options: s } = n, { defs: a, instances: l } = t;
  l = be(l, (o) => !a[o.defId].recurringDef);
  for (let o in a) {
    let d = a[o];
    if (d.recurringDef) {
      let { duration: c } = d.recurringDef;
      c || (c = d.allDay ? s.defaultAllDayEventDuration : s.defaultTimedEventDuration);
      let h = Ml(d, c, e, i, r.recurringTypes);
      for (let f of h) {
        let u = kn(o, {
          start: f,
          end: i.add(f, c)
        });
        l[u.instanceId] = u;
      }
    }
  }
  return { defs: a, instances: l };
}
function Ml(t, e, n, i, r) {
  let a = r[t.recurringDef.typeId].expand(t.recurringDef.typeData, {
    start: i.subtract(n.start, e),
    end: n.end
  }, i);
  return t.allDay && (a = a.map(P)), a;
}
function Fe(t, e, n, i, r, s) {
  let a = Y(), l = On(n);
  for (let o of t) {
    let d = Pr(o, e, n, i, l, r, s);
    d && an(d, a);
  }
  return a;
}
function an(t, e = Y()) {
  return e.defs[t.def.defId] = t.def, t.instance && (e.instances[t.instance.instanceId] = t.instance), e;
}
function Mn(t, e) {
  let n = t.instances[e];
  if (n) {
    let i = t.defs[n.defId], r = Tt(t, (s) => Il(i, s));
    return r.defs[i.defId] = i, r.instances[n.instanceId] = n, r;
  }
  return Y();
}
function Il(t, e) {
  return !!(t.groupId && t.groupId === e.groupId);
}
function Y() {
  return { defs: {}, instances: {} };
}
function In(t, e) {
  return {
    defs: Object.assign(Object.assign({}, t.defs), e.defs),
    instances: Object.assign(Object.assign({}, t.instances), e.instances)
  };
}
function Tt(t, e) {
  let n = be(t.defs, e), i = be(t.instances, (r) => n[r.defId]);
  return { defs: n, instances: i };
}
function Ol(t, e) {
  let { defs: n, instances: i } = t, r = {}, s = {};
  for (let a in n)
    e.defs[a] || (r[a] = n[a]);
  for (let a in i)
    !e.instances[a] && // not explicitly excluded
    r[i[a].defId] && (s[a] = i[a]);
  return {
    defs: r,
    instances: s
  };
}
function Nl(t, e) {
  return Array.isArray(t) ? Fe(t, null, e, !0) : typeof t == "object" && t ? Fe([t], null, e, !0) : t != null ? String(t) : null;
}
function Oi(t) {
  return Array.isArray(t) ? t : typeof t == "string" ? t.split(/\s+/) : [];
}
const vt = {
  display: String,
  editable: Boolean,
  startEditable: Boolean,
  durationEditable: Boolean,
  constraint: m,
  overlap: m,
  allow: m,
  className: Oi,
  classNames: Oi,
  color: String,
  backgroundColor: String,
  borderColor: String,
  textColor: String
}, Pl = {
  display: null,
  startEditable: null,
  durationEditable: null,
  constraints: [],
  overlap: null,
  allows: [],
  backgroundColor: "",
  borderColor: "",
  textColor: "",
  classNames: []
};
function yt(t, e) {
  let n = Nl(t.constraint, e);
  return {
    display: t.display || null,
    startEditable: t.startEditable != null ? t.startEditable : t.editable,
    durationEditable: t.durationEditable != null ? t.durationEditable : t.editable,
    constraints: n != null ? [n] : [],
    overlap: t.overlap != null ? t.overlap : null,
    allows: t.allow != null ? [t.allow] : [],
    backgroundColor: t.backgroundColor || t.color || "",
    borderColor: t.borderColor || t.color || "",
    textColor: t.textColor || "",
    classNames: (t.className || []).concat(t.classNames || [])
    // join singular and plural
  };
}
function Or(t) {
  return t.reduce(Hl, Pl);
}
function Hl(t, e) {
  return {
    display: e.display != null ? e.display : t.display,
    startEditable: e.startEditable != null ? e.startEditable : t.startEditable,
    durationEditable: e.durationEditable != null ? e.durationEditable : t.durationEditable,
    constraints: t.constraints.concat(e.constraints),
    overlap: typeof e.overlap == "boolean" ? e.overlap : t.overlap,
    allows: t.allows.concat(e.allows),
    backgroundColor: e.backgroundColor || t.backgroundColor,
    borderColor: e.borderColor || t.borderColor,
    textColor: e.textColor || t.textColor,
    classNames: t.classNames.concat(e.classNames)
  };
}
const ot = {
  id: String,
  groupId: String,
  title: String,
  url: String,
  interactive: Boolean
}, Nr = {
  start: m,
  end: m,
  date: m,
  allDay: Boolean
}, Ll = Object.assign(Object.assign(Object.assign({}, ot), Nr), { extendedProps: m });
function Pr(t, e, n, i, r = On(n), s, a) {
  let { refined: l, extra: o } = Hr(t, n, r), d = zl(e, n), c = kl(l, d, n.dateEnv, n.pluginHooks.recurringTypes);
  if (c) {
    let f = ln(l, o, e ? e.sourceId : "", c.allDay, !!c.duration, n, s);
    return f.recurringDef = {
      typeId: c.typeId,
      typeData: c.typeData,
      duration: c.duration
    }, { def: f, instance: null };
  }
  let h = Bl(l, d, n, i);
  if (h) {
    let f = ln(l, o, e ? e.sourceId : "", h.allDay, h.hasEnd, n, s), u = kn(f.defId, h.range, h.forcedStartTzo, h.forcedEndTzo);
    return a && f.publicId && a[f.publicId] && (u.instanceId = a[f.publicId]), { def: f, instance: u };
  }
  return null;
}
function Hr(t, e, n = On(e)) {
  return xn(t, n);
}
function On(t) {
  return Object.assign(Object.assign(Object.assign({}, vt), Ll), t.pluginHooks.eventRefiners);
}
function ln(t, e, n, i, r, s, a) {
  let l = {
    title: t.title || "",
    groupId: t.groupId || "",
    publicId: t.id || "",
    url: t.url || "",
    recurringDef: null,
    defId: (a && t.id ? a[t.id] : "") || we(),
    sourceId: n,
    allDay: i,
    hasEnd: r,
    interactive: t.interactive,
    ui: yt(t, s),
    extendedProps: Object.assign(Object.assign({}, t.extendedProps || {}), e)
  };
  for (let o of s.pluginHooks.eventDefMemberAdders)
    Object.assign(l, o(t));
  return Object.freeze(l.ui.classNames), Object.freeze(l.extendedProps), l;
}
function Bl(t, e, n, i) {
  let { allDay: r } = t, s, a = null, l = !1, o, d = null, c = t.start != null ? t.start : t.date;
  if (s = n.dateEnv.createMarkerMeta(c), s)
    a = s.marker;
  else if (!i)
    return null;
  return t.end != null && (o = n.dateEnv.createMarkerMeta(t.end)), r == null && (e != null ? r = e : r = (!s || s.isTimeUnspecified) && (!o || o.isTimeUnspecified)), r && a && (a = P(a)), o && (d = o.marker, r && (d = P(d)), a && d <= a && (d = null)), d ? l = !0 : i || (l = n.options.forceEventDuration || !1, d = n.dateEnv.add(a, r ? n.options.defaultAllDayEventDuration : n.options.defaultTimedEventDuration)), {
    allDay: r,
    hasEnd: l,
    range: { start: a, end: d },
    forcedStartTzo: s ? s.forcedTzo : null,
    forcedEndTzo: o ? o.forcedTzo : null
  };
}
function zl(t, e) {
  let n = null;
  return t && (n = t.defaultAllDay), n == null && (n = e.options.defaultAllDay), n;
}
const Ul = {
  startTime: "09:00",
  endTime: "17:00",
  daysOfWeek: [1, 2, 3, 4, 5],
  display: "inverse-background",
  classNames: "fc-non-business",
  groupId: "_businessHours"
  // so multiple defs get grouped
};
function Fl(t, e) {
  return Fe(jl(t), null, e);
}
function jl(t) {
  let e;
  return t === !0 ? e = [{}] : Array.isArray(t) ? e = t.filter((n) => n.daysOfWeek) : typeof t == "object" && t ? e = [t] : e = [], e = e.map((n) => Object.assign(Object.assign({}, Ul), n)), e;
}
function Lr(t) {
  let e = Math.floor(Ce(t.start, t.end)) || 1, n = P(t.start), i = F(n, e);
  return { start: n, end: i };
}
function Br(t, e = k(0)) {
  let n = null, i = null;
  if (t.end) {
    i = P(t.end);
    let r = t.end.valueOf() - i.valueOf();
    r && r >= Z(e) && (i = F(i, 1));
  }
  return t.start && (n = P(t.start), i && i <= n && (i = F(n, 1))), { start: n, end: i };
}
function Ae(t, e, n, i) {
  return i === "year" ? k(n.diffWholeYears(t, e), "year") : i === "month" ? k(n.diffWholeMonths(t, e), "month") : sl(t, e);
}
function Wl(t, e) {
  return t.left >= e.left && t.left < e.right && t.top >= e.top && t.top < e.bottom;
}
function zr(t, e) {
  let n = {
    left: Math.max(t.left, e.left),
    right: Math.min(t.right, e.right),
    top: Math.max(t.top, e.top),
    bottom: Math.min(t.bottom, e.bottom)
  };
  return n.left < n.right && n.top < n.bottom ? n : !1;
}
function Vl(t, e) {
  return {
    left: Math.min(Math.max(t.left, e.left), e.right),
    top: Math.min(Math.max(t.top, e.top), e.bottom)
  };
}
function Gl(t) {
  return {
    left: (t.left + t.right) / 2,
    top: (t.top + t.bottom) / 2
  };
}
function Yl(t, e) {
  return {
    left: t.left - e.left,
    top: t.top - e.top
  };
}
let Ft;
function Ur() {
  return Ft == null && (Ft = ql()), Ft;
}
function ql() {
  if (typeof document > "u")
    return !0;
  let t = document.createElement("div");
  t.style.position = "absolute", t.style.top = "0px", t.style.left = "0px", t.innerHTML = "<table><tr><td><div></div></td></tr></table>", t.querySelector("table").style.height = "100px", t.querySelector("div").style.height = "100%", document.body.appendChild(t);
  let n = t.querySelector("div").offsetHeight > 0;
  return document.body.removeChild(t), n;
}
const jt = Y();
class Ql {
  constructor() {
    this.getKeysForEventDefs = D(this._getKeysForEventDefs), this.splitDateSelection = D(this._splitDateSpan), this.splitEventStore = D(this._splitEventStore), this.splitIndividualUi = D(this._splitIndividualUi), this.splitEventDrag = D(this._splitInteraction), this.splitEventResize = D(this._splitInteraction), this.eventUiBuilders = {};
  }
  splitProps(e) {
    let n = this.getKeyInfo(e), i = this.getKeysForEventDefs(e.eventStore), r = this.splitDateSelection(e.dateSelection), s = this.splitIndividualUi(e.eventUiBases, i), a = this.splitEventStore(e.eventStore, i), l = this.splitEventDrag(e.eventDrag), o = this.splitEventResize(e.eventResize), d = {};
    this.eventUiBuilders = ne(n, (c, h) => this.eventUiBuilders[h] || D($l));
    for (let c in n) {
      let h = n[c], f = a[c] || jt, u = this.eventUiBuilders[c];
      d[c] = {
        businessHours: h.businessHours || e.businessHours,
        dateSelection: r[c] || null,
        eventStore: f,
        eventUiBases: u(e.eventUiBases[""], h.ui, s[c]),
        eventSelection: f.instances[e.eventSelection] ? e.eventSelection : "",
        eventDrag: l[c] || null,
        eventResize: o[c] || null
      };
    }
    return d;
  }
  _splitDateSpan(e) {
    let n = {};
    if (e) {
      let i = this.getKeysForDateSpan(e);
      for (let r of i)
        n[r] = e;
    }
    return n;
  }
  _getKeysForEventDefs(e) {
    return ne(e.defs, (n) => this.getKeysForEventDef(n));
  }
  _splitEventStore(e, n) {
    let { defs: i, instances: r } = e, s = {};
    for (let a in i)
      for (let l of n[a])
        s[l] || (s[l] = Y()), s[l].defs[a] = i[a];
    for (let a in r) {
      let l = r[a];
      for (let o of n[l.defId])
        s[o] && (s[o].instances[a] = l);
    }
    return s;
  }
  _splitIndividualUi(e, n) {
    let i = {};
    for (let r in e)
      if (r)
        for (let s of n[r])
          i[s] || (i[s] = {}), i[s][r] = e[r];
    return i;
  }
  _splitInteraction(e) {
    let n = {};
    if (e) {
      let i = this._splitEventStore(e.affectedEvents, this._getKeysForEventDefs(e.affectedEvents)), r = this._getKeysForEventDefs(e.mutatedEvents), s = this._splitEventStore(e.mutatedEvents, r), a = (l) => {
        n[l] || (n[l] = {
          affectedEvents: i[l] || jt,
          mutatedEvents: s[l] || jt,
          isEvent: e.isEvent
        });
      };
      for (let l in i)
        a(l);
      for (let l in s)
        a(l);
    }
    return n;
  }
}
function $l(t, e, n) {
  let i = [];
  t && i.push(t), e && i.push(e);
  let r = {
    "": Or(i)
  };
  return n && Object.assign(r, n), r;
}
function Zl(t, e) {
  let n = null, i = null;
  return t.start && (n = e.createMarker(t.start)), t.end && (i = e.createMarker(t.end)), !n && !i || n && i && i < n ? null : { start: n, end: i };
}
function Ni(t, e) {
  let n = [], { start: i } = e, r, s;
  for (t.sort(Xl), r = 0; r < t.length; r += 1)
    s = t[r], s.start > i && n.push({ start: i, end: s.start }), s.end > i && (i = s.end);
  return i < e.end && n.push({ start: i, end: e.end }), n;
}
function Xl(t, e) {
  return t.start.valueOf() - e.start.valueOf();
}
function _e(t, e) {
  let { start: n, end: i } = t, r = null;
  return e.start !== null && (n === null ? n = e.start : n = new Date(Math.max(n.valueOf(), e.start.valueOf()))), e.end != null && (i === null ? i = e.end : i = new Date(Math.min(i.valueOf(), e.end.valueOf()))), (n === null || i === null || n < i) && (r = { start: n, end: i }), r;
}
function Jl(t, e) {
  return (t.start === null ? null : t.start.valueOf()) === (e.start === null ? null : e.start.valueOf()) && (t.end === null ? null : t.end.valueOf()) === (e.end === null ? null : e.end.valueOf());
}
function Nn(t, e) {
  return (t.end === null || e.start === null || t.end > e.start) && (t.start === null || e.end === null || t.start < e.end);
}
function Rt(t, e) {
  return (t.start === null || e.start !== null && e.start >= t.start) && (t.end === null || e.end !== null && e.end <= t.end);
}
function te(t, e) {
  return (t.start === null || e >= t.start) && (t.end === null || e < t.end);
}
function Kl(t, e) {
  return e.start != null && t < e.start ? e.start : e.end != null && t >= e.end ? new Date(e.end.valueOf() - 1) : t;
}
function Fr(t, e, n, i) {
  return {
    dow: t.getUTCDay(),
    isDisabled: !!(i && !te(i.activeRange, t)),
    isOther: !!(i && !te(i.currentRange, t)),
    isToday: !!(e && te(e, t)),
    isPast: !!(n ? t < n : e && t < e.start),
    isFuture: !!(n ? t > n : e && t >= e.end)
  };
}
function Pn(t, e) {
  let n = [
    "fc-day",
    `fc-day-${el[t.dow]}`
  ];
  return t.isDisabled ? n.push("fc-day-disabled") : (t.isToday && (n.push("fc-day-today"), n.push(e.getClass("today"))), t.isPast && n.push("fc-day-past"), t.isFuture && n.push("fc-day-future"), t.isOther && n.push("fc-day-other")), n;
}
const eo = B({ year: "numeric", month: "long", day: "numeric" }), to = B({ week: "long" });
function bt(t, e, n = "day", i = !0) {
  const { dateEnv: r, options: s, calendarApi: a } = t;
  let l = r.format(e, n === "week" ? to : eo);
  if (s.navLinks) {
    let o = r.toDate(e);
    const d = (c) => {
      let h = n === "day" ? s.navLinkDayClick : n === "week" ? s.navLinkWeekClick : null;
      typeof h == "function" ? h.call(a, r.toDate(e), c) : (typeof h == "string" && (n = h), a.zoomTo(e, n));
    };
    return Object.assign({ title: Le(s.navLinkHint, [l, o], l), "data-navlink": "" }, i ? Rr(d) : { onClick: d });
  }
  return { "aria-label": l };
}
let Wt = null;
function no() {
  return Wt === null && (Wt = io()), Wt;
}
function io() {
  let t = document.createElement("div");
  He(t, {
    position: "absolute",
    top: -1e3,
    left: 0,
    border: 0,
    padding: 0,
    overflow: "scroll",
    direction: "rtl"
  }), t.innerHTML = "<div></div>", document.body.appendChild(t);
  let n = t.firstChild.getBoundingClientRect().left > t.getBoundingClientRect().left;
  return _n(t), n;
}
let Vt;
function ro() {
  return Vt || (Vt = so()), Vt;
}
function so() {
  let t = document.createElement("div");
  t.style.overflow = "scroll", t.style.position = "absolute", t.style.top = "-9999px", t.style.left = "-9999px", document.body.appendChild(t);
  let e = jr(t);
  return document.body.removeChild(t), e;
}
function jr(t) {
  return {
    x: t.offsetHeight - t.clientHeight,
    y: t.offsetWidth - t.clientWidth
  };
}
function ao(t, e = !1) {
  let n = window.getComputedStyle(t), i = parseInt(n.borderLeftWidth, 10) || 0, r = parseInt(n.borderRightWidth, 10) || 0, s = parseInt(n.borderTopWidth, 10) || 0, a = parseInt(n.borderBottomWidth, 10) || 0, l = jr(t), o = l.y - i - r, d = l.x - s - a, c = {
    borderLeft: i,
    borderRight: r,
    borderTop: s,
    borderBottom: a,
    scrollbarBottom: d,
    scrollbarLeft: 0,
    scrollbarRight: 0
  };
  return no() && n.direction === "rtl" ? c.scrollbarLeft = o : c.scrollbarRight = o, e && (c.paddingLeft = parseInt(n.paddingLeft, 10) || 0, c.paddingRight = parseInt(n.paddingRight, 10) || 0, c.paddingTop = parseInt(n.paddingTop, 10) || 0, c.paddingBottom = parseInt(n.paddingBottom, 10) || 0), c;
}
function lo(t, e = !1, n) {
  let i = n ? t.getBoundingClientRect() : Hn(t), r = ao(t, e), s = {
    left: i.left + r.borderLeft + r.scrollbarLeft,
    right: i.right - r.borderRight - r.scrollbarRight,
    top: i.top + r.borderTop,
    bottom: i.bottom - r.borderBottom - r.scrollbarBottom
  };
  return e && (s.left += r.paddingLeft, s.right -= r.paddingRight, s.top += r.paddingTop, s.bottom -= r.paddingBottom), s;
}
function Hn(t) {
  let e = t.getBoundingClientRect();
  return {
    left: e.left + window.pageXOffset,
    top: e.top + window.pageYOffset,
    right: e.right + window.pageXOffset,
    bottom: e.bottom + window.pageYOffset
  };
}
function oo(t) {
  let e = Wr(t), n = t.getBoundingClientRect();
  for (let i of e) {
    let r = zr(n, i.getBoundingClientRect());
    if (r)
      n = r;
    else
      return null;
  }
  return n;
}
function Wr(t) {
  let e = [];
  for (; t instanceof HTMLElement; ) {
    let n = window.getComputedStyle(t);
    if (n.position === "fixed")
      break;
    /(auto|scroll)/.test(n.overflow + n.overflowY + n.overflowX) && e.push(t), t = t.parentNode;
  }
  return e;
}
function co(t, e, n) {
  let i = !1, r = function(l) {
    i || (i = !0, e(l));
  }, s = function(l) {
    i || (i = !0, n(l));
  }, a = t(r, s);
  a && typeof a.then == "function" && a.then(r, s);
}
class xt {
  constructor() {
    this.handlers = {}, this.thisContext = null;
  }
  setThisContext(e) {
    this.thisContext = e;
  }
  setOptions(e) {
    this.options = e;
  }
  on(e, n) {
    uo(this.handlers, e, n);
  }
  off(e, n) {
    fo(this.handlers, e, n);
  }
  trigger(e, ...n) {
    let i = this.handlers[e] || [], r = this.options && this.options[e], s = [].concat(r || [], i);
    for (let a of s)
      a.apply(this.thisContext, n);
  }
  hasHandlers(e) {
    return !!(this.handlers[e] && this.handlers[e].length || this.options && this.options[e]);
  }
}
function uo(t, e, n) {
  (t[e] || (t[e] = [])).push(n);
}
function fo(t, e, n) {
  n ? t[e] && (t[e] = t[e].filter((i) => i !== n)) : delete t[e];
}
class Me {
  constructor(e, n, i, r) {
    this.els = n;
    let s = this.originClientRect = e.getBoundingClientRect();
    i && this.buildElHorizontals(s.left), r && this.buildElVerticals(s.top);
  }
  // Populates the left/right internal coordinate arrays
  buildElHorizontals(e) {
    let n = [], i = [];
    for (let r of this.els) {
      let s = r.getBoundingClientRect();
      n.push(s.left - e), i.push(s.right - e);
    }
    this.lefts = n, this.rights = i;
  }
  // Populates the top/bottom internal coordinate arrays
  buildElVerticals(e) {
    let n = [], i = [];
    for (let r of this.els) {
      let s = r.getBoundingClientRect();
      n.push(s.top - e), i.push(s.bottom - e);
    }
    this.tops = n, this.bottoms = i;
  }
  // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
  // If no intersection is made, returns undefined.
  leftToIndex(e) {
    let { lefts: n, rights: i } = this, r = n.length, s;
    for (s = 0; s < r; s += 1)
      if (e >= n[s] && e < i[s])
        return s;
  }
  // Given a top offset (from document top), returns the index of the el that it vertically intersects.
  // If no intersection is made, returns undefined.
  topToIndex(e) {
    let { tops: n, bottoms: i } = this, r = n.length, s;
    for (s = 0; s < r; s += 1)
      if (e >= n[s] && e < i[s])
        return s;
  }
  // Gets the width of the element at the given index
  getWidth(e) {
    return this.rights[e] - this.lefts[e];
  }
  // Gets the height of the element at the given index
  getHeight(e) {
    return this.bottoms[e] - this.tops[e];
  }
  similarTo(e) {
    return Je(this.tops || [], e.tops || []) && Je(this.bottoms || [], e.bottoms || []) && Je(this.lefts || [], e.lefts || []) && Je(this.rights || [], e.rights || []);
  }
}
function Je(t, e) {
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let i = 0; i < n; i++)
    if (Math.round(t[i]) !== Math.round(e[i]))
      return !1;
  return !0;
}
class Ln {
  getMaxScrollTop() {
    return this.getScrollHeight() - this.getClientHeight();
  }
  getMaxScrollLeft() {
    return this.getScrollWidth() - this.getClientWidth();
  }
  canScrollVertically() {
    return this.getMaxScrollTop() > 0;
  }
  canScrollHorizontally() {
    return this.getMaxScrollLeft() > 0;
  }
  canScrollUp() {
    return this.getScrollTop() > 0;
  }
  canScrollDown() {
    return this.getScrollTop() < this.getMaxScrollTop();
  }
  canScrollLeft() {
    return this.getScrollLeft() > 0;
  }
  canScrollRight() {
    return this.getScrollLeft() < this.getMaxScrollLeft();
  }
}
class ho extends Ln {
  constructor(e) {
    super(), this.el = e;
  }
  getScrollTop() {
    return this.el.scrollTop;
  }
  getScrollLeft() {
    return this.el.scrollLeft;
  }
  setScrollTop(e) {
    this.el.scrollTop = e;
  }
  setScrollLeft(e) {
    this.el.scrollLeft = e;
  }
  getScrollWidth() {
    return this.el.scrollWidth;
  }
  getScrollHeight() {
    return this.el.scrollHeight;
  }
  getClientHeight() {
    return this.el.clientHeight;
  }
  getClientWidth() {
    return this.el.clientWidth;
  }
}
class po extends Ln {
  getScrollTop() {
    return window.pageYOffset;
  }
  getScrollLeft() {
    return window.pageXOffset;
  }
  setScrollTop(e) {
    window.scroll(window.pageXOffset, e);
  }
  setScrollLeft(e) {
    window.scroll(e, window.pageYOffset);
  }
  getScrollWidth() {
    return document.documentElement.scrollWidth;
  }
  getScrollHeight() {
    return document.documentElement.scrollHeight;
  }
  getClientHeight() {
    return document.documentElement.clientHeight;
  }
  getClientWidth() {
    return document.documentElement.clientWidth;
  }
}
class je {
  constructor(e) {
    this.iconOverrideOption && this.setIconOverride(e[this.iconOverrideOption]);
  }
  setIconOverride(e) {
    let n, i;
    if (typeof e == "object" && e) {
      n = Object.assign({}, this.iconClasses);
      for (i in e)
        n[i] = this.applyIconOverridePrefix(e[i]);
      this.iconClasses = n;
    } else
      e === !1 && (this.iconClasses = {});
  }
  applyIconOverridePrefix(e) {
    let n = this.iconOverridePrefix;
    return n && e.indexOf(n) !== 0 && (e = n + e), e;
  }
  getClass(e) {
    return this.classes[e] || "";
  }
  getIconClass(e, n) {
    let i;
    return n && this.rtlIconClasses ? i = this.rtlIconClasses[e] || this.iconClasses[e] : i = this.iconClasses[e], i ? `${this.baseIconClass} ${i}` : "";
  }
  getCustomButtonIconClass(e) {
    let n;
    return this.iconOverrideCustomButtonOption && (n = e[this.iconOverrideCustomButtonOption], n) ? `${this.baseIconClass} ${this.applyIconOverridePrefix(n)}` : "";
  }
}
je.prototype.classes = {};
je.prototype.iconClasses = {};
je.prototype.baseIconClass = "";
je.prototype.iconOverridePrefix = "";
function Pi(t) {
  t();
  let e = S.debounceRendering, n = [];
  function i(r) {
    n.push(r);
  }
  for (S.debounceRendering = i, Ue(p(go, {}), document.createElement("div")); n.length; )
    n.shift()();
  S.debounceRendering = e;
}
class go extends G {
  render() {
    return p("div", {});
  }
  componentDidMount() {
    this.setState({});
  }
}
function Vr(t) {
  let e = la(t), n = e.Provider;
  return e.Provider = function() {
    let i = !this.getChildContext, r = n.apply(this, arguments);
    if (i) {
      let s = [];
      this.shouldComponentUpdate = (a) => {
        this.props.value !== a.value && s.forEach((l) => {
          l.context = a.value, l.forceUpdate();
        });
      }, this.sub = (a) => {
        s.push(a);
        let l = a.componentWillUnmount;
        a.componentWillUnmount = () => {
          s.splice(s.indexOf(a), 1), l && l.call(a);
        };
      };
    }
    return r;
  }, e;
}
class mo {
  constructor(e, n, i, r) {
    this.execFunc = e, this.emitter = n, this.scrollTime = i, this.scrollTimeReset = r, this.handleScrollRequest = (s) => {
      this.queuedRequest = Object.assign({}, this.queuedRequest || {}, s), this.drain();
    }, n.on("_scrollRequest", this.handleScrollRequest), this.fireInitialScroll();
  }
  detach() {
    this.emitter.off("_scrollRequest", this.handleScrollRequest);
  }
  update(e) {
    e && this.scrollTimeReset ? this.fireInitialScroll() : this.drain();
  }
  fireInitialScroll() {
    this.handleScrollRequest({
      time: this.scrollTime
    });
  }
  drain() {
    this.queuedRequest && this.execFunc(this.queuedRequest) && (this.queuedRequest = null);
  }
}
const re = Vr({});
function vo(t, e, n, i, r, s, a, l, o, d, c, h, f) {
  return {
    dateEnv: r,
    options: n,
    pluginHooks: a,
    emitter: d,
    dispatch: l,
    getCurrentData: o,
    calendarApi: c,
    viewSpec: t,
    viewApi: e,
    dateProfileGenerator: i,
    theme: s,
    isRtl: n.direction === "rtl",
    addResizeHandler(u) {
      d.on("_resize", u);
    },
    removeResizeHandler(u) {
      d.off("_resize", u);
    },
    createScrollResponder(u) {
      return new mo(u, d, k(n.scrollTime), n.scrollTimeReset);
    },
    registerInteractiveComponent: h,
    unregisterInteractiveComponent: f
  };
}
class Se extends G {
  shouldComponentUpdate(e, n) {
    return this.debug && console.log(sn(e, this.props), sn(n, this.state)), !Bt(this.props, e, this.propEquality) || !Bt(this.state, n, this.stateEquality);
  }
  // HACK for freakin' React StrictMode
  safeSetState(e) {
    Bt(this.state, Object.assign(Object.assign({}, this.state), e), this.stateEquality) || this.setState(e);
  }
}
Se.addPropsEquality = yo;
Se.addStateEquality = bo;
Se.contextType = re;
Se.prototype.propEquality = {};
Se.prototype.stateEquality = {};
class I extends Se {
}
I.contextType = re;
function yo(t) {
  let e = Object.create(this.prototype.propEquality);
  Object.assign(e, t), this.prototype.propEquality = e;
}
function bo(t) {
  let e = Object.create(this.prototype.stateEquality);
  Object.assign(e, t), this.prototype.stateEquality = e;
}
function ie(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
class K extends I {
  constructor() {
    super(...arguments), this.uid = we();
  }
  // Hit System
  // -----------------------------------------------------------------------------------------------------------------
  prepareHits() {
  }
  queryHit(e, n, i, r) {
    return null;
  }
  // Pointer Interaction Utils
  // -----------------------------------------------------------------------------------------------------------------
  isValidSegDownEl(e) {
    return !this.props.eventDrag && // HACK
    !this.props.eventResize && // HACK
    !U(e, ".fc-event-mirror");
  }
  isValidDateDownEl(e) {
    return !U(e, ".fc-event:not(.fc-bg-event)") && !U(e, ".fc-more-link") && // a "more.." link
    !U(e, "a[data-navlink]") && // a clickable nav link
    !U(e, ".fc-popover");
  }
}
function Eo(t, e) {
  switch (e.type) {
    case "CHANGE_DATE":
      return e.dateMarker;
    default:
      return t;
  }
}
function _o(t, e) {
  let n = t.initialDate;
  return n != null ? e.createMarker(n) : We(t.now, e);
}
function We(t, e) {
  return typeof t == "function" && (t = t()), t == null ? e.createNowMarker() : e.createMarker(t);
}
class Gr {
  constructor(e) {
    this.props = e, this.nowDate = We(e.nowInput, e.dateEnv), this.initHiddenDays();
  }
  /* Date Range Computation
  ------------------------------------------------------------------------------------------------------------------*/
  // Builds a structure with info about what the dates/ranges will be for the "prev" view.
  buildPrev(e, n, i) {
    let { dateEnv: r } = this.props, s = r.subtract(
      r.startOf(n, e.currentRangeUnit),
      // important for start-of-month
      e.dateIncrement
    );
    return this.build(s, -1, i);
  }
  // Builds a structure with info about what the dates/ranges will be for the "next" view.
  buildNext(e, n, i) {
    let { dateEnv: r } = this.props, s = r.add(
      r.startOf(n, e.currentRangeUnit),
      // important for start-of-month
      e.dateIncrement
    );
    return this.build(s, 1, i);
  }
  // Builds a structure holding dates/ranges for rendering around the given date.
  // Optional direction param indicates whether the date is being incremented/decremented
  // from its previous value. decremented = -1, incremented = 1 (default).
  build(e, n, i = !0) {
    let { props: r } = this, s, a, l, o, d, c;
    return s = this.buildValidRange(), s = this.trimHiddenDays(s), i && (e = Kl(e, s)), a = this.buildCurrentRangeInfo(e, n), l = /^(year|month|week|day)$/.test(a.unit), o = this.buildRenderRange(this.trimHiddenDays(a.range), a.unit, l), o = this.trimHiddenDays(o), d = o, r.showNonCurrentDates || (d = _e(d, a.range)), d = this.adjustActiveRange(d), d = _e(d, s), c = Nn(a.range, s), te(o, e) || (e = o.start), {
      currentDate: e,
      // constraint for where prev/next operations can go and where events can be dragged/resized to.
      // an object with optional start and end properties.
      validRange: s,
      // range the view is formally responsible for.
      // for example, a month view might have 1st-31st, excluding padded dates
      currentRange: a.range,
      // name of largest unit being displayed, like "month" or "week"
      currentRangeUnit: a.unit,
      isRangeAllDay: l,
      // dates that display events and accept drag-n-drop
      // will be `null` if no dates accept events
      activeRange: d,
      // date range with a rendered skeleton
      // includes not-active days that need some sort of DOM
      renderRange: o,
      // Duration object that denotes the first visible time of any given day
      slotMinTime: r.slotMinTime,
      // Duration object that denotes the exclusive visible end time of any given day
      slotMaxTime: r.slotMaxTime,
      isValid: c,
      // how far the current date will move for a prev/next operation
      dateIncrement: this.buildDateIncrement(a.duration)
      // pass a fallback (might be null) ^
    };
  }
  // Builds an object with optional start/end properties.
  // Indicates the minimum/maximum dates to display.
  // not responsible for trimming hidden days.
  buildValidRange() {
    let e = this.props.validRangeInput, n = typeof e == "function" ? e.call(this.props.calendarApi, this.nowDate) : e;
    return this.refineRange(n) || { start: null, end: null };
  }
  // Builds a structure with info about the "current" range, the range that is
  // highlighted as being the current month for example.
  // See build() for a description of `direction`.
  // Guaranteed to have `range` and `unit` properties. `duration` is optional.
  buildCurrentRangeInfo(e, n) {
    let { props: i } = this, r = null, s = null, a = null, l;
    return i.duration ? (r = i.duration, s = i.durationUnit, a = this.buildRangeFromDuration(e, n, r, s)) : (l = this.props.dayCount) ? (s = "day", a = this.buildRangeFromDayCount(e, n, l)) : (a = this.buildCustomVisibleRange(e)) ? s = i.dateEnv.greatestWholeUnit(a.start, a.end).unit : (r = this.getFallbackDuration(), s = rn(r).unit, a = this.buildRangeFromDuration(e, n, r, s)), { duration: r, unit: s, range: a };
  }
  getFallbackDuration() {
    return k({ day: 1 });
  }
  // Returns a new activeRange to have time values (un-ambiguate)
  // slotMinTime or slotMaxTime causes the range to expand.
  adjustActiveRange(e) {
    let { dateEnv: n, usesMinMaxTime: i, slotMinTime: r, slotMaxTime: s } = this.props, { start: a, end: l } = e;
    return i && (Re(r) < 0 && (a = P(a), a = n.add(a, r)), Re(s) > 1 && (l = P(l), l = F(l, -1), l = n.add(l, s))), { start: a, end: l };
  }
  // Builds the "current" range when it is specified as an explicit duration.
  // `unit` is the already-computed greatestDurationDenominator unit of duration.
  buildRangeFromDuration(e, n, i, r) {
    let { dateEnv: s, dateAlignment: a } = this.props, l, o, d;
    if (!a) {
      let { dateIncrement: h } = this.props;
      h && Z(h) < Z(i) ? a = rn(h).unit : a = r;
    }
    Re(i) <= 1 && this.isHiddenDay(l) && (l = this.skipHiddenDays(l, n), l = P(l));
    function c() {
      l = s.startOf(e, a), o = s.add(l, i), d = { start: l, end: o };
    }
    return c(), this.trimHiddenDays(d) || (e = this.skipHiddenDays(e, n), c()), d;
  }
  // Builds the "current" range when a dayCount is specified.
  buildRangeFromDayCount(e, n, i) {
    let { dateEnv: r, dateAlignment: s } = this.props, a = 0, l = e, o;
    s && (l = r.startOf(l, s)), l = P(l), l = this.skipHiddenDays(l, n), o = l;
    do
      o = F(o, 1), this.isHiddenDay(o) || (a += 1);
    while (a < i);
    return { start: l, end: o };
  }
  // Builds a normalized range object for the "visible" range,
  // which is a way to define the currentRange and activeRange at the same time.
  buildCustomVisibleRange(e) {
    let { props: n } = this, i = n.visibleRangeInput, r = typeof i == "function" ? i.call(n.calendarApi, n.dateEnv.toDate(e)) : i, s = this.refineRange(r);
    return s && (s.start == null || s.end == null) ? null : s;
  }
  // Computes the range that will represent the element/cells for *rendering*,
  // but which may have voided days/times.
  // not responsible for trimming hidden days.
  buildRenderRange(e, n, i) {
    return e;
  }
  // Compute the duration value that should be added/substracted to the current date
  // when a prev/next operation happens.
  buildDateIncrement(e) {
    let { dateIncrement: n } = this.props, i;
    return n || ((i = this.props.dateAlignment) ? k(1, i) : e || k({ days: 1 }));
  }
  refineRange(e) {
    if (e) {
      let n = Zl(e, this.props.dateEnv);
      return n && (n = Br(n)), n;
    }
    return null;
  }
  /* Hidden Days
  ------------------------------------------------------------------------------------------------------------------*/
  // Initializes internal variables related to calculating hidden days-of-week
  initHiddenDays() {
    let e = this.props.hiddenDays || [], n = [], i = 0, r;
    for (this.props.weekends === !1 && e.push(0, 6), r = 0; r < 7; r += 1)
      (n[r] = e.indexOf(r) !== -1) || (i += 1);
    if (!i)
      throw new Error("invalid hiddenDays");
    this.isHiddenDayHash = n;
  }
  // Remove days from the beginning and end of the range that are computed as hidden.
  // If the whole range is trimmed off, returns null
  trimHiddenDays(e) {
    let { start: n, end: i } = e;
    return n && (n = this.skipHiddenDays(n)), i && (i = this.skipHiddenDays(i, -1, !0)), n == null || i == null || n < i ? { start: n, end: i } : null;
  }
  // Is the current day hidden?
  // `day` is a day-of-week index (0-6), or a Date (used for UTC)
  isHiddenDay(e) {
    return e instanceof Date && (e = e.getUTCDay()), this.isHiddenDayHash[e];
  }
  // Incrementing the current day until it is no longer a hidden day, returning a copy.
  // DOES NOT CONSIDER validRange!
  // If the initial value of `date` is not a hidden day, don't do anything.
  // Pass `isExclusive` as `true` if you are dealing with an end date.
  // `inc` defaults to `1` (increment one day forward each time)
  skipHiddenDays(e, n = 1, i = !1) {
    for (; this.isHiddenDayHash[(e.getUTCDay() + (i ? n : 0) + 7) % 7]; )
      e = F(e, n);
    return e;
  }
}
function Yr(t, e, n) {
  n.emitter.trigger("select", Object.assign(Object.assign({}, Bn(t, n)), { jsEvent: e ? e.origEvent : null, view: n.viewApi || n.calendarApi.view }));
}
function wo(t, e) {
  e.emitter.trigger("unselect", {
    jsEvent: t ? t.origEvent : null,
    view: e.viewApi || e.calendarApi.view
  });
}
function Bn(t, e) {
  let n = {};
  for (let i of e.pluginHooks.dateSpanTransforms)
    Object.assign(n, i(t, e));
  return Object.assign(n, Ho(t, e.dateEnv)), n;
}
function Hi(t, e, n) {
  let { dateEnv: i, options: r } = n, s = e;
  return t ? (s = P(s), s = i.add(s, r.defaultAllDayEventDuration)) : s = i.add(s, r.defaultTimedEventDuration), s;
}
function zn(t, e, n, i) {
  let r = Et(t.defs, e), s = Y();
  for (let a in t.defs) {
    let l = t.defs[a];
    s.defs[a] = Co(l, r[a], n, i);
  }
  for (let a in t.instances) {
    let l = t.instances[a], o = s.defs[l.defId];
    s.instances[a] = So(l, o, r[l.defId], n, i);
  }
  return s;
}
function Co(t, e, n, i) {
  let r = n.standardProps || {};
  r.hasEnd == null && e.durationEditable && (n.startDelta || n.endDelta) && (r.hasEnd = !0);
  let s = Object.assign(Object.assign(Object.assign({}, t), r), { ui: Object.assign(Object.assign({}, t.ui), r.ui) });
  n.extendedProps && (s.extendedProps = Object.assign(Object.assign({}, s.extendedProps), n.extendedProps));
  for (let a of i.pluginHooks.eventDefMutationAppliers)
    a(s, n, i);
  return !s.hasEnd && i.options.forceEventDuration && (s.hasEnd = !0), s;
}
function So(t, e, n, i, r) {
  let { dateEnv: s } = r, a = i.standardProps && i.standardProps.allDay === !0, l = i.standardProps && i.standardProps.hasEnd === !1, o = Object.assign({}, t);
  return a && (o.range = Lr(o.range)), i.datesDelta && n.startEditable && (o.range = {
    start: s.add(o.range.start, i.datesDelta),
    end: s.add(o.range.end, i.datesDelta)
  }), i.startDelta && n.durationEditable && (o.range = {
    start: s.add(o.range.start, i.startDelta),
    end: o.range.end
  }), i.endDelta && n.durationEditable && (o.range = {
    start: o.range.start,
    end: s.add(o.range.end, i.endDelta)
  }), l && (o.range = {
    start: o.range.start,
    end: Hi(e.allDay, o.range.start, r)
  }), e.allDay && (o.range = {
    start: P(o.range.start),
    end: P(o.range.end)
  }), o.range.end < o.range.start && (o.range.end = Hi(e.allDay, o.range.start, r)), o;
}
class De {
  constructor(e, n) {
    this.context = e, this.internalEventSource = n;
  }
  remove() {
    this.context.dispatch({
      type: "REMOVE_EVENT_SOURCE",
      sourceId: this.internalEventSource.sourceId
    });
  }
  refetch() {
    this.context.dispatch({
      type: "FETCH_EVENT_SOURCES",
      sourceIds: [this.internalEventSource.sourceId],
      isRefetch: !0
    });
  }
  get id() {
    return this.internalEventSource.publicId;
  }
  get url() {
    return this.internalEventSource.meta.url;
  }
  get format() {
    return this.internalEventSource.meta.format;
  }
}
class L {
  // instance will be null if expressing a recurring event that has no current instances,
  // OR if trying to validate an incoming external event that has no dates assigned
  constructor(e, n, i) {
    this._context = e, this._def = n, this._instance = i || null;
  }
  /*
  TODO: make event struct more responsible for this
  */
  setProp(e, n) {
    if (e in Nr)
      console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
    else if (e === "id")
      n = ot[e](n), this.mutate({
        standardProps: { publicId: n }
        // hardcoded internal name
      });
    else if (e in ot)
      n = ot[e](n), this.mutate({
        standardProps: { [e]: n }
      });
    else if (e in vt) {
      let i = vt[e](n);
      e === "color" ? i = { backgroundColor: n, borderColor: n } : e === "editable" ? i = { startEditable: n, durationEditable: n } : i = { [e]: n }, this.mutate({
        standardProps: { ui: i }
      });
    } else
      console.warn(`Could not set prop '${e}'. Use setExtendedProp instead.`);
  }
  setExtendedProp(e, n) {
    this.mutate({
      extendedProps: { [e]: n }
    });
  }
  setStart(e, n = {}) {
    let { dateEnv: i } = this._context, r = i.createMarker(e);
    if (r && this._instance) {
      let s = this._instance.range, a = Ae(s.start, r, i, n.granularity);
      n.maintainDuration ? this.mutate({ datesDelta: a }) : this.mutate({ startDelta: a });
    }
  }
  setEnd(e, n = {}) {
    let { dateEnv: i } = this._context, r;
    if (!(e != null && (r = i.createMarker(e), !r)) && this._instance)
      if (r) {
        let s = Ae(this._instance.range.end, r, i, n.granularity);
        this.mutate({ endDelta: s });
      } else
        this.mutate({ standardProps: { hasEnd: !1 } });
  }
  setDates(e, n, i = {}) {
    let { dateEnv: r } = this._context, s = { allDay: i.allDay }, a = r.createMarker(e), l;
    if (a && !(n != null && (l = r.createMarker(n), !l)) && this._instance) {
      let o = this._instance.range;
      i.allDay === !0 && (o = Lr(o));
      let d = Ae(o.start, a, r, i.granularity);
      if (l) {
        let c = Ae(o.end, l, r, i.granularity);
        Ga(d, c) ? this.mutate({ datesDelta: d, standardProps: s }) : this.mutate({ startDelta: d, endDelta: c, standardProps: s });
      } else
        s.hasEnd = !1, this.mutate({ datesDelta: d, standardProps: s });
    }
  }
  moveStart(e) {
    let n = k(e);
    n && this.mutate({ startDelta: n });
  }
  moveEnd(e) {
    let n = k(e);
    n && this.mutate({ endDelta: n });
  }
  moveDates(e) {
    let n = k(e);
    n && this.mutate({ datesDelta: n });
  }
  setAllDay(e, n = {}) {
    let i = { allDay: e }, { maintainDuration: r } = n;
    r == null && (r = this._context.options.allDayMaintainDuration), this._def.allDay !== e && (i.hasEnd = r), this.mutate({ standardProps: i });
  }
  formatRange(e) {
    let { dateEnv: n } = this._context, i = this._instance, r = B(e);
    return this._def.hasEnd ? n.formatRange(i.range.start, i.range.end, r, {
      forcedStartTzo: i.forcedStartTzo,
      forcedEndTzo: i.forcedEndTzo
    }) : n.format(i.range.start, r, {
      forcedTzo: i.forcedStartTzo
    });
  }
  mutate(e) {
    let n = this._instance;
    if (n) {
      let i = this._def, r = this._context, { eventStore: s } = r.getCurrentData(), a = Mn(s, n.instanceId);
      a = zn(a, {
        "": {
          display: "",
          startEditable: !0,
          durationEditable: !0,
          constraints: [],
          overlap: null,
          allows: [],
          backgroundColor: "",
          borderColor: "",
          textColor: "",
          classNames: []
        }
      }, e, r);
      let o = new L(r, i, n);
      this._def = a.defs[i.defId], this._instance = a.instances[n.instanceId], r.dispatch({
        type: "MERGE_EVENTS",
        eventStore: a
      }), r.emitter.trigger("eventChange", {
        oldEvent: o,
        event: this,
        relatedEvents: ve(a, r, n),
        revert() {
          r.dispatch({
            type: "RESET_EVENTS",
            eventStore: s
            // the ORIGINAL store
          });
        }
      });
    }
  }
  remove() {
    let e = this._context, n = qr(this);
    e.dispatch({
      type: "REMOVE_EVENTS",
      eventStore: n
    }), e.emitter.trigger("eventRemove", {
      event: this,
      relatedEvents: [],
      revert() {
        e.dispatch({
          type: "MERGE_EVENTS",
          eventStore: n
        });
      }
    });
  }
  get source() {
    let { sourceId: e } = this._def;
    return e ? new De(this._context, this._context.getCurrentData().eventSources[e]) : null;
  }
  get start() {
    return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
  }
  get end() {
    return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
  }
  get startStr() {
    let e = this._instance;
    return e ? this._context.dateEnv.formatIso(e.range.start, {
      omitTime: this._def.allDay,
      forcedTzo: e.forcedStartTzo
    }) : "";
  }
  get endStr() {
    let e = this._instance;
    return e && this._def.hasEnd ? this._context.dateEnv.formatIso(e.range.end, {
      omitTime: this._def.allDay,
      forcedTzo: e.forcedEndTzo
    }) : "";
  }
  // computable props that all access the def
  // TODO: find a TypeScript-compatible way to do this at scale
  get id() {
    return this._def.publicId;
  }
  get groupId() {
    return this._def.groupId;
  }
  get allDay() {
    return this._def.allDay;
  }
  get title() {
    return this._def.title;
  }
  get url() {
    return this._def.url;
  }
  get display() {
    return this._def.ui.display || "auto";
  }
  // bad. just normalize the type earlier
  get startEditable() {
    return this._def.ui.startEditable;
  }
  get durationEditable() {
    return this._def.ui.durationEditable;
  }
  get constraint() {
    return this._def.ui.constraints[0] || null;
  }
  get overlap() {
    return this._def.ui.overlap;
  }
  get allow() {
    return this._def.ui.allows[0] || null;
  }
  get backgroundColor() {
    return this._def.ui.backgroundColor;
  }
  get borderColor() {
    return this._def.ui.borderColor;
  }
  get textColor() {
    return this._def.ui.textColor;
  }
  // NOTE: user can't modify these because Object.freeze was called in event-def parsing
  get classNames() {
    return this._def.ui.classNames;
  }
  get extendedProps() {
    return this._def.extendedProps;
  }
  toPlainObject(e = {}) {
    let n = this._def, { ui: i } = n, { startStr: r, endStr: s } = this, a = {
      allDay: n.allDay
    };
    return n.title && (a.title = n.title), r && (a.start = r), s && (a.end = s), n.publicId && (a.id = n.publicId), n.groupId && (a.groupId = n.groupId), n.url && (a.url = n.url), i.display && i.display !== "auto" && (a.display = i.display), e.collapseColor && i.backgroundColor && i.backgroundColor === i.borderColor ? a.color = i.backgroundColor : (i.backgroundColor && (a.backgroundColor = i.backgroundColor), i.borderColor && (a.borderColor = i.borderColor)), i.textColor && (a.textColor = i.textColor), i.classNames.length && (a.classNames = i.classNames), Object.keys(n.extendedProps).length && (e.collapseExtendedProps ? Object.assign(a, n.extendedProps) : a.extendedProps = n.extendedProps), a;
  }
  toJSON() {
    return this.toPlainObject();
  }
}
function qr(t) {
  let e = t._def, n = t._instance;
  return {
    defs: { [e.defId]: e },
    instances: n ? { [n.instanceId]: n } : {}
  };
}
function ve(t, e, n) {
  let { defs: i, instances: r } = t, s = [], a = n ? n.instanceId : "";
  for (let l in r) {
    let o = r[l], d = i[o.defId];
    o.instanceId !== a && s.push(new L(e, d, o));
  }
  return s;
}
function Li(t, e, n, i) {
  let r = {}, s = {}, a = {}, l = [], o = [], d = Et(t.defs, e);
  for (let c in t.defs) {
    let h = t.defs[c];
    d[h.defId].display === "inverse-background" && (h.groupId ? (r[h.groupId] = [], a[h.groupId] || (a[h.groupId] = h)) : s[c] = []);
  }
  for (let c in t.instances) {
    let h = t.instances[c], f = t.defs[h.defId], u = d[f.defId], v = h.range, y = !f.allDay && i ? Br(v, i) : v, b = _e(y, n);
    b && (u.display === "inverse-background" ? f.groupId ? r[f.groupId].push(b) : s[h.defId].push(b) : u.display !== "none" && (u.display === "background" ? l : o).push({
      def: f,
      ui: u,
      instance: h,
      range: b,
      isStart: y.start && y.start.valueOf() === b.start.valueOf(),
      isEnd: y.end && y.end.valueOf() === b.end.valueOf()
    }));
  }
  for (let c in r) {
    let h = r[c], f = Ni(h, n);
    for (let u of f) {
      let v = a[c], y = d[v.defId];
      l.push({
        def: v,
        ui: y,
        instance: null,
        range: u,
        isStart: !1,
        isEnd: !1
      });
    }
  }
  for (let c in s) {
    let h = s[c], f = Ni(h, n);
    for (let u of f)
      l.push({
        def: t.defs[c],
        ui: d[c],
        instance: null,
        range: u,
        isStart: !1,
        isEnd: !1
      });
  }
  return { bg: l, fg: o };
}
function Do(t) {
  return t.ui.display === "background" || t.ui.display === "inverse-background";
}
function Bi(t, e) {
  t.fcSeg = e;
}
function Ie(t) {
  return t.fcSeg || t.parentNode.fcSeg || // for the harness
  null;
}
function Et(t, e) {
  return ne(t, (n) => Qr(n, e));
}
function Qr(t, e) {
  let n = [];
  return e[""] && n.push(e[""]), e[t.defId] && n.push(e[t.defId]), n.push(t.ui), Or(n);
}
function $r(t, e) {
  let n = t.map(Ao);
  return n.sort((i, r) => Ba(i, r, e)), n.map((i) => i._seg);
}
function Ao(t) {
  let { eventRange: e } = t, n = e.def, i = e.instance ? e.instance.range : e.range, r = i.start ? i.start.valueOf() : 0, s = i.end ? i.end.valueOf() : 0;
  return Object.assign(Object.assign(Object.assign({}, n.extendedProps), n), {
    id: n.publicId,
    start: r,
    end: s,
    duration: s - r,
    allDay: Number(n.allDay),
    _seg: t
  });
}
function To(t, e) {
  let { pluginHooks: n } = e, i = n.isDraggableTransformers, { def: r, ui: s } = t.eventRange, a = s.startEditable;
  for (let l of i)
    a = l(a, r, s, e);
  return a;
}
function Ro(t, e) {
  return t.isStart && t.eventRange.ui.durationEditable && e.options.eventResizableFromStart;
}
function xo(t, e) {
  return t.isEnd && t.eventRange.ui.durationEditable;
}
function Zr(t, e, n, i, r, s, a) {
  let { dateEnv: l, options: o } = n, { displayEventTime: d, displayEventEnd: c } = o, h = t.eventRange.def, f = t.eventRange.instance;
  d == null && (d = i !== !1), c == null && (c = r !== !1);
  let u = f.range.start, v = f.range.end, y = s || t.start || t.eventRange.range.start, b = a || t.end || t.eventRange.range.end, E = P(u).valueOf() === P(y).valueOf(), C = P(fe(v, -1)).valueOf() === P(fe(b, -1)).valueOf();
  return d && !h.allDay && (E || C) ? (y = E ? u : y, b = C ? v : b, c && h.hasEnd ? l.formatRange(y, b, e, {
    forcedStartTzo: s ? null : f.forcedStartTzo,
    forcedEndTzo: a ? null : f.forcedEndTzo
  }) : l.format(y, e, {
    forcedTzo: s ? null : f.forcedStartTzo
    // nooooo, same
  })) : "";
}
function de(t, e, n) {
  let i = t.eventRange.range;
  return {
    isPast: i.end < (n || e.start),
    isFuture: i.start >= (n || e.end),
    isToday: e && te(e, i.start)
  };
}
function ko(t) {
  let e = ["fc-event"];
  return t.isMirror && e.push("fc-event-mirror"), t.isDraggable && e.push("fc-event-draggable"), (t.isStartResizable || t.isEndResizable) && e.push("fc-event-resizable"), t.isDragging && e.push("fc-event-dragging"), t.isResizing && e.push("fc-event-resizing"), t.isSelected && e.push("fc-event-selected"), t.isStart && e.push("fc-event-start"), t.isEnd && e.push("fc-event-end"), t.isPast && e.push("fc-event-past"), t.isToday && e.push("fc-event-today"), t.isFuture && e.push("fc-event-future"), e;
}
function Xr(t) {
  return t.instance ? t.instance.instanceId : `${t.def.defId}:${t.range.start.toISOString()}`;
}
function Jr(t, e) {
  let { def: n, instance: i } = t.eventRange, { url: r } = n;
  if (r)
    return { href: r };
  let { emitter: s, options: a } = e, { eventInteractive: l } = a;
  return l == null && (l = n.interactive, l == null && (l = !!s.hasHandlers("eventClick"))), l ? xr((o) => {
    s.trigger("eventClick", {
      el: o.target,
      event: new L(e, n, i),
      jsEvent: o,
      view: e.viewApi
    });
  }) : {};
}
const Mo = {
  start: m,
  end: m,
  allDay: Boolean
};
function Io(t, e, n) {
  let i = Oo(t, e), { range: r } = i;
  if (!r.start)
    return null;
  if (!r.end) {
    if (n == null)
      return null;
    r.end = e.add(r.start, n);
  }
  return i;
}
function Oo(t, e) {
  let { refined: n, extra: i } = xn(t, Mo), r = n.start ? e.createMarkerMeta(n.start) : null, s = n.end ? e.createMarkerMeta(n.end) : null, { allDay: a } = n;
  return a == null && (a = r && r.isTimeUnspecified && (!s || s.isTimeUnspecified)), Object.assign({ range: {
    start: r ? r.marker : null,
    end: s ? s.marker : null
  }, allDay: a }, i);
}
function No(t, e) {
  return Jl(t.range, e.range) && t.allDay === e.allDay && Po(t, e);
}
function Po(t, e) {
  for (let n in e)
    if (n !== "range" && n !== "allDay" && t[n] !== e[n])
      return !1;
  for (let n in t)
    if (!(n in e))
      return !1;
  return !0;
}
function Ho(t, e) {
  return Object.assign(Object.assign({}, es(t.range, e, t.allDay)), { allDay: t.allDay });
}
function Kr(t, e, n) {
  return Object.assign(Object.assign({}, es(t, e, n)), { timeZone: e.timeZone });
}
function es(t, e, n) {
  return {
    start: e.toDate(t.start),
    end: e.toDate(t.end),
    startStr: e.formatIso(t.start, { omitTime: n }),
    endStr: e.formatIso(t.end, { omitTime: n })
  };
}
function Lo(t, e, n) {
  let i = Hr({ editable: !1 }, n), r = ln(
    i.refined,
    i.extra,
    "",
    // sourceId
    t.allDay,
    !0,
    // hasEnd
    n
  );
  return {
    def: r,
    ui: Qr(r, e),
    instance: kn(r.defId, t.range),
    range: t.range,
    isStart: !0,
    isEnd: !0
  };
}
let ts = {};
function Bo(t, e) {
  ts[t] = e;
}
function zo(t) {
  return new ts[t]();
}
class Uo {
  getMarkerYear(e) {
    return e.getUTCFullYear();
  }
  getMarkerMonth(e) {
    return e.getUTCMonth();
  }
  getMarkerDay(e) {
    return e.getUTCDate();
  }
  arrayToMarker(e) {
    return W(e);
  }
  markerToArray(e) {
    return oe(e);
  }
}
Bo("gregory", Uo);
const Fo = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function jo(t) {
  let e = Fo.exec(t);
  if (e) {
    let n = new Date(Date.UTC(Number(e[1]), e[3] ? Number(e[3]) - 1 : 0, Number(e[5] || 1), Number(e[7] || 0), Number(e[8] || 0), Number(e[10] || 0), e[12] ? +`0.${e[12]}` * 1e3 : 0));
    if (Mr(n)) {
      let i = null;
      return e[13] && (i = (e[15] === "-" ? -1 : 1) * (Number(e[16] || 0) * 60 + Number(e[18] || 0))), {
        marker: n,
        isTimeUnspecified: !e[6],
        timeZoneOffset: i
      };
    }
  }
  return null;
}
class Wo {
  constructor(e) {
    let n = this.timeZone = e.timeZone, i = n !== "local" && n !== "UTC";
    e.namedTimeZoneImpl && i && (this.namedTimeZoneImpl = new e.namedTimeZoneImpl(n)), this.canComputeOffset = !!(!i || this.namedTimeZoneImpl), this.calendarSystem = zo(e.calendarSystem), this.locale = e.locale, this.weekDow = e.locale.week.dow, this.weekDoy = e.locale.week.doy, e.weekNumberCalculation === "ISO" && (this.weekDow = 1, this.weekDoy = 4), typeof e.firstDay == "number" && (this.weekDow = e.firstDay), typeof e.weekNumberCalculation == "function" && (this.weekNumberFunc = e.weekNumberCalculation), this.weekText = e.weekText != null ? e.weekText : e.locale.options.weekText, this.weekTextLong = (e.weekTextLong != null ? e.weekTextLong : e.locale.options.weekTextLong) || this.weekText, this.cmdFormatter = e.cmdFormatter, this.defaultSeparator = e.defaultSeparator;
  }
  // Creating / Parsing
  createMarker(e) {
    let n = this.createMarkerMeta(e);
    return n === null ? null : n.marker;
  }
  createNowMarker() {
    return this.canComputeOffset ? this.timestampToMarker((/* @__PURE__ */ new Date()).valueOf()) : W(Di(/* @__PURE__ */ new Date()));
  }
  createMarkerMeta(e) {
    if (typeof e == "string")
      return this.parse(e);
    let n = null;
    return typeof e == "number" ? n = this.timestampToMarker(e) : e instanceof Date ? (e = e.valueOf(), isNaN(e) || (n = this.timestampToMarker(e))) : Array.isArray(e) && (n = W(e)), n === null || !Mr(n) ? null : { marker: n, isTimeUnspecified: !1, forcedTzo: null };
  }
  parse(e) {
    let n = jo(e);
    if (n === null)
      return null;
    let { marker: i } = n, r = null;
    return n.timeZoneOffset !== null && (this.canComputeOffset ? i = this.timestampToMarker(i.valueOf() - n.timeZoneOffset * 60 * 1e3) : r = n.timeZoneOffset), { marker: i, isTimeUnspecified: n.isTimeUnspecified, forcedTzo: r };
  }
  // Accessors
  getYear(e) {
    return this.calendarSystem.getMarkerYear(e);
  }
  getMonth(e) {
    return this.calendarSystem.getMarkerMonth(e);
  }
  getDay(e) {
    return this.calendarSystem.getMarkerDay(e);
  }
  // Adding / Subtracting
  add(e, n) {
    let i = this.calendarSystem.markerToArray(e);
    return i[0] += n.years, i[1] += n.months, i[2] += n.days, i[6] += n.milliseconds, this.calendarSystem.arrayToMarker(i);
  }
  subtract(e, n) {
    let i = this.calendarSystem.markerToArray(e);
    return i[0] -= n.years, i[1] -= n.months, i[2] -= n.days, i[6] -= n.milliseconds, this.calendarSystem.arrayToMarker(i);
  }
  addYears(e, n) {
    let i = this.calendarSystem.markerToArray(e);
    return i[0] += n, this.calendarSystem.arrayToMarker(i);
  }
  addMonths(e, n) {
    let i = this.calendarSystem.markerToArray(e);
    return i[1] += n, this.calendarSystem.arrayToMarker(i);
  }
  // Diffing Whole Units
  diffWholeYears(e, n) {
    let { calendarSystem: i } = this;
    return ce(e) === ce(n) && i.getMarkerDay(e) === i.getMarkerDay(n) && i.getMarkerMonth(e) === i.getMarkerMonth(n) ? i.getMarkerYear(n) - i.getMarkerYear(e) : null;
  }
  diffWholeMonths(e, n) {
    let { calendarSystem: i } = this;
    return ce(e) === ce(n) && i.getMarkerDay(e) === i.getMarkerDay(n) ? i.getMarkerMonth(n) - i.getMarkerMonth(e) + (i.getMarkerYear(n) - i.getMarkerYear(e)) * 12 : null;
  }
  // Range / Duration
  greatestWholeUnit(e, n) {
    let i = this.diffWholeYears(e, n);
    return i !== null ? { unit: "year", value: i } : (i = this.diffWholeMonths(e, n), i !== null ? { unit: "month", value: i } : (i = al(e, n), i !== null ? { unit: "week", value: i } : (i = pt(e, n), i !== null ? { unit: "day", value: i } : (i = nl(e, n), at(i) ? { unit: "hour", value: i } : (i = il(e, n), at(i) ? { unit: "minute", value: i } : (i = rl(e, n), at(i) ? { unit: "second", value: i } : { unit: "millisecond", value: n.valueOf() - e.valueOf() }))))));
  }
  countDurationsBetween(e, n, i) {
    let r;
    return i.years && (r = this.diffWholeYears(e, n), r !== null) ? r / Qa(i) : i.months && (r = this.diffWholeMonths(e, n), r !== null) ? r / $a(i) : i.days && (r = pt(e, n), r !== null) ? r / Re(i) : (n.valueOf() - e.valueOf()) / Z(i);
  }
  // Start-Of
  // these DON'T return zoned-dates. only UTC start-of dates
  startOf(e, n) {
    return n === "year" ? this.startOfYear(e) : n === "month" ? this.startOfMonth(e) : n === "week" ? this.startOfWeek(e) : n === "day" ? P(e) : n === "hour" ? ll(e) : n === "minute" ? ol(e) : n === "second" ? cl(e) : null;
  }
  startOfYear(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e)
    ]);
  }
  startOfMonth(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e),
      this.calendarSystem.getMarkerMonth(e)
    ]);
  }
  startOfWeek(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e),
      this.calendarSystem.getMarkerMonth(e),
      e.getUTCDate() - (e.getUTCDay() - this.weekDow + 7) % 7
    ]);
  }
  // Week Number
  computeWeekNumber(e) {
    return this.weekNumberFunc ? this.weekNumberFunc(this.toDate(e)) : dl(e, this.weekDow, this.weekDoy);
  }
  // TODO: choke on timeZoneName: long
  format(e, n, i = {}) {
    return n.format({
      marker: e,
      timeZoneOffset: i.forcedTzo != null ? i.forcedTzo : this.offsetForMarker(e)
    }, this);
  }
  formatRange(e, n, i, r = {}) {
    return r.isEndExclusive && (n = fe(n, -1)), i.formatRange({
      marker: e,
      timeZoneOffset: r.forcedStartTzo != null ? r.forcedStartTzo : this.offsetForMarker(e)
    }, {
      marker: n,
      timeZoneOffset: r.forcedEndTzo != null ? r.forcedEndTzo : this.offsetForMarker(n)
    }, this, r.defaultSeparator);
  }
  /*
  DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
  might as well use buildIsoString or some other util directly
  */
  formatIso(e, n = {}) {
    let i = null;
    return n.omitTimeZoneOffset || (n.forcedTzo != null ? i = n.forcedTzo : i = this.offsetForMarker(e)), Ir(e, i, n.omitTime);
  }
  // TimeZone
  timestampToMarker(e) {
    return this.timeZone === "local" ? W(Di(new Date(e))) : this.timeZone === "UTC" || !this.namedTimeZoneImpl ? new Date(e) : W(this.namedTimeZoneImpl.timestampToArray(e));
  }
  offsetForMarker(e) {
    return this.timeZone === "local" ? -Ai(oe(e)).getTimezoneOffset() : this.timeZone === "UTC" ? 0 : this.namedTimeZoneImpl ? this.namedTimeZoneImpl.offsetForArray(oe(e)) : null;
  }
  // Conversion
  toDate(e, n) {
    return this.timeZone === "local" ? Ai(oe(e)) : this.timeZone === "UTC" ? new Date(e.valueOf()) : this.namedTimeZoneImpl ? new Date(e.valueOf() - this.namedTimeZoneImpl.offsetForArray(oe(e)) * 1e3 * 60) : new Date(e.valueOf() - (n || 0));
  }
}
class ns {
  constructor() {
    this.strictOrder = !1, this.allowReslicing = !1, this.maxCoord = -1, this.maxStackCnt = -1, this.levelCoords = [], this.entriesByLevel = [], this.stackCnts = {};
  }
  addSegs(e) {
    let n = [];
    for (let i of e)
      this.insertEntry(i, n);
    return n;
  }
  insertEntry(e, n) {
    let i = this.findInsertion(e);
    return this.isInsertionValid(i, e) ? (this.insertEntryAt(e, i), 1) : this.handleInvalidInsertion(i, e, n);
  }
  isInsertionValid(e, n) {
    return (this.maxCoord === -1 || e.levelCoord + n.thickness <= this.maxCoord) && (this.maxStackCnt === -1 || e.stackCnt < this.maxStackCnt);
  }
  // returns number of new entries inserted
  handleInvalidInsertion(e, n, i) {
    return this.allowReslicing && e.touchingEntry ? this.splitEntry(n, e.touchingEntry, i) : (i.push(n), 0);
  }
  splitEntry(e, n, i) {
    let r = 0, s = [], a = e.span, l = n.span;
    return a.start < l.start && (r += this.insertEntry({
      index: e.index,
      thickness: e.thickness,
      span: { start: a.start, end: l.start }
    }, s)), a.end > l.end && (r += this.insertEntry({
      index: e.index,
      thickness: e.thickness,
      span: { start: l.end, end: a.end }
    }, s)), r ? (i.push({
      index: e.index,
      thickness: e.thickness,
      span: Un(l, a)
      // guaranteed to intersect
    }, ...s), r) : (i.push(e), 0);
  }
  insertEntryAt(e, n) {
    let { entriesByLevel: i, levelCoords: r } = this;
    n.lateral === -1 ? (Gt(r, n.level, n.levelCoord), Gt(i, n.level, [e])) : Gt(i[n.level], n.lateral, e), this.stackCnts[ye(e)] = n.stackCnt;
  }
  findInsertion(e) {
    let { levelCoords: n, entriesByLevel: i, strictOrder: r, stackCnts: s } = this, a = n.length, l = 0, o = -1, d = -1, c = null, h = 0;
    for (let v = 0; v < a; v += 1) {
      let y = n[v];
      if (!r && y >= l + e.thickness)
        break;
      let b = i[v], E, C = cn(b, e.span.start, on), T = C[0] + C[1];
      for (
        ;
        // loop through entries that horizontally intersect
        (E = b[T]) && // but not past the whole entry list
        E.span.start < e.span.end;
      ) {
        let A = y + E.thickness;
        A > l && (l = A, c = E, o = v, d = T), A === l && (h = Math.max(h, s[ye(E)] + 1)), T += 1;
      }
    }
    let f = 0;
    if (c)
      for (f = o + 1; f < a && n[f] < l; )
        f += 1;
    let u = -1;
    return f < a && n[f] === l && (u = cn(i[f], e.span.end, on)[0]), {
      touchingLevel: o,
      touchingLateral: d,
      touchingEntry: c,
      stackCnt: h,
      levelCoord: l,
      level: f,
      lateral: u
    };
  }
  // sorted by levelCoord (lowest to highest)
  toRects() {
    let { entriesByLevel: e, levelCoords: n } = this, i = e.length, r = [];
    for (let s = 0; s < i; s += 1) {
      let a = e[s], l = n[s];
      for (let o of a)
        r.push(Object.assign(Object.assign({}, o), { levelCoord: l }));
    }
    return r;
  }
}
function on(t) {
  return t.span.end;
}
function ye(t) {
  return t.index + ":" + t.span.start;
}
function Vo(t) {
  let e = [];
  for (let n of t) {
    let i = [], r = {
      span: n.span,
      entries: [n]
    };
    for (let s of e)
      Un(s.span, r.span) ? r = {
        entries: s.entries.concat(r.entries),
        span: Go(s.span, r.span)
      } : i.push(s);
    i.push(r), e = i;
  }
  return e;
}
function Go(t, e) {
  return {
    start: Math.min(t.start, e.start),
    end: Math.max(t.end, e.end)
  };
}
function Un(t, e) {
  let n = Math.max(t.start, e.start), i = Math.min(t.end, e.end);
  return n < i ? { start: n, end: i } : null;
}
function Gt(t, e, n) {
  t.splice(e, 0, n);
}
function cn(t, e, n) {
  let i = 0, r = t.length;
  if (!r || e < n(t[i]))
    return [0, 0];
  if (e > n(t[r - 1]))
    return [r, 0];
  for (; i < r; ) {
    let s = Math.floor(i + (r - i) / 2), a = n(t[s]);
    if (e < a)
      r = s;
    else if (e > a)
      i = s + 1;
    else
      return [s, 1];
  }
  return [i, 0];
}
class Oe {
  constructor(e) {
    this.component = e.component, this.isHitComboAllowed = e.isHitComboAllowed || null;
  }
  destroy() {
  }
}
function Yo(t, e) {
  return {
    component: t,
    el: e.el,
    useEventCenter: e.useEventCenter != null ? e.useEventCenter : !0,
    isHitComboAllowed: e.isHitComboAllowed || null
  };
}
function Fn(t) {
  return {
    [t.component.uid]: t
  };
}
const dn = {};
class qo {
  constructor(e, n) {
    this.emitter = new xt();
  }
  destroy() {
  }
  setMirrorIsVisible(e) {
  }
  setMirrorNeedsRevert(e) {
  }
  setAutoScrollEnabled(e) {
  }
}
const jn = {};
class Qo extends I {
  constructor() {
    super(...arguments), this.state = {
      forPrint: !1
    }, this.handleBeforePrint = () => {
      this.setState({ forPrint: !0 });
    }, this.handleAfterPrint = () => {
      this.setState({ forPrint: !1 });
    };
  }
  render() {
    let { props: e } = this, { options: n } = e, { forPrint: i } = this.state, r = i || n.height === "auto" || n.contentHeight === "auto", s = !r && n.height != null ? n.height : "", a = [
      "fc",
      i ? "fc-media-print" : "fc-media-screen",
      `fc-direction-${n.direction}`,
      e.theme.getClass("root")
    ];
    return Ur() || a.push("fc-liquid-hack"), e.children(a, s, r, i);
  }
  componentDidMount() {
    let { emitter: e } = this.props;
    e.on("_beforeprint", this.handleBeforePrint), e.on("_afterprint", this.handleAfterPrint);
  }
  componentWillUnmount() {
    let { emitter: e } = this.props;
    e.off("_beforeprint", this.handleBeforePrint), e.off("_afterprint", this.handleAfterPrint);
  }
}
function $o(t, e) {
  return !t || e > 10 ? B({ weekday: "short" }) : e > 1 ? B({ weekday: "short", month: "numeric", day: "numeric", omitCommas: !0 }) : B({ weekday: "long" });
}
const is = "fc-col-header-cell";
function rs(t) {
  return t.text;
}
class Wn extends I {
  constructor() {
    super(...arguments), this.id = we(), this.queuedDomNodes = [], this.currentDomNodes = [], this.handleEl = (e) => {
      this.props.elRef && ie(this.props.elRef, e);
    };
  }
  render() {
    const { props: e, context: n } = this, { options: i } = n, { customGenerator: r, defaultGenerator: s, renderProps: a } = e, l = as(e);
    let o = !1, d, c = [], h;
    if (r != null) {
      const f = typeof r == "function" ? r(a, p) : r;
      if (f === !0)
        o = !0;
      else {
        const u = f && typeof f == "object";
        u && "html" in f ? l.dangerouslySetInnerHTML = { __html: f.html } : u && "domNodes" in f ? c = Array.prototype.slice.call(f.domNodes) : !u && typeof f != "function" ? d = f : h = f;
      }
    } else
      o = !ss(e.generatorName, i);
    return o && s && (d = s(a)), this.queuedDomNodes = c, this.currentGeneratorMeta = h, p(e.elTag, l, d);
  }
  componentDidMount() {
    this.applyQueueudDomNodes(), this.triggerCustomRendering(!0);
  }
  componentDidUpdate() {
    this.applyQueueudDomNodes(), this.triggerCustomRendering(!0);
  }
  componentWillUnmount() {
    this.triggerCustomRendering(!1);
  }
  triggerCustomRendering(e) {
    var n;
    const { props: i, context: r } = this, { handleCustomRendering: s, customRenderingMetaMap: a } = r.options;
    if (s) {
      const l = (n = this.currentGeneratorMeta) !== null && n !== void 0 ? n : a == null ? void 0 : a[i.generatorName];
      l && s(Object.assign(Object.assign({
        id: this.id,
        isActive: e,
        containerEl: this.base,
        reportNewContainerEl: this.handleEl,
        // for customRenderingReplacesEl
        generatorMeta: l
      }, i), { elClasses: (i.elClasses || []).filter(Zo) }));
    }
  }
  applyQueueudDomNodes() {
    const { queuedDomNodes: e, currentDomNodes: n } = this, i = this.base;
    if (!ue(e, n)) {
      n.forEach(_n);
      for (let r of e)
        i.appendChild(r);
      this.currentDomNodes = e;
    }
  }
}
Wn.addPropsEquality({
  elClasses: ue,
  elStyle: J,
  elAttrs: Xa,
  renderProps: J
});
function ss(t, e) {
  var n;
  return !!(e.handleCustomRendering && t && (!((n = e.customRenderingMetaMap) === null || n === void 0) && n[t]));
}
function as(t, e) {
  const n = Object.assign(Object.assign({}, t.elAttrs), { ref: t.elRef });
  return (t.elClasses || e) && (n.className = (t.elClasses || []).concat(e || []).concat(n.className || []).filter(Boolean).join(" ")), t.elStyle && (n.style = t.elStyle), n;
}
function Zo(t) {
  return !!t;
}
const ls = Vr(0);
class q extends G {
  constructor() {
    super(...arguments), this.InnerContent = Xo.bind(void 0, this), this.handleRootEl = (e) => {
      this.rootEl = e, this.props.elRef && ie(this.props.elRef, e);
    };
  }
  render() {
    const { props: e } = this, n = Jo(e.classNameGenerator, e.renderProps);
    if (e.children) {
      const i = as(e, n), r = e.children(this.InnerContent, e.renderProps, i);
      return e.elTag ? p(e.elTag, i, r) : r;
    } else
      return p(Wn, Object.assign(Object.assign({}, e), { elRef: this.handleRootEl, elTag: e.elTag || "div", elClasses: (e.elClasses || []).concat(n), renderId: this.context }));
  }
  componentDidMount() {
    var e, n;
    (n = (e = this.props).didMount) === null || n === void 0 || n.call(e, Object.assign(Object.assign({}, this.props.renderProps), { el: this.rootEl || this.base }));
  }
  componentWillUnmount() {
    var e, n;
    (n = (e = this.props).willUnmount) === null || n === void 0 || n.call(e, Object.assign(Object.assign({}, this.props.renderProps), { el: this.rootEl || this.base }));
  }
}
q.contextType = ls;
function Xo(t, e) {
  const n = t.props;
  return p(Wn, Object.assign({ renderProps: n.renderProps, generatorName: n.generatorName, customGenerator: n.customGenerator, defaultGenerator: n.defaultGenerator, renderId: t.context }, e));
}
function Jo(t, e) {
  const n = typeof t == "function" ? t(e) : t || [];
  return typeof n == "string" ? [n] : n;
}
class Ko extends I {
  render() {
    let { dateEnv: e, options: n, theme: i, viewApi: r } = this.context, { props: s } = this, { date: a, dateProfile: l } = s, o = Fr(a, s.todayRange, null, l), d = [is].concat(Pn(o, i)), c = e.format(a, s.dayHeaderFormat), h = !o.isDisabled && s.colCnt > 1 ? bt(this.context, a) : {}, f = Object.assign(Object.assign(Object.assign({ date: e.toDate(a), view: r }, s.extraRenderProps), { text: c }), o);
    return p(q, { elTag: "th", elClasses: d, elAttrs: Object.assign({ role: "columnheader", colSpan: s.colSpan, "data-date": o.isDisabled ? void 0 : Tn(a) }, s.extraDataAttrs), renderProps: f, generatorName: "dayHeaderContent", customGenerator: n.dayHeaderContent, defaultGenerator: rs, classNameGenerator: n.dayHeaderClassNames, didMount: n.dayHeaderDidMount, willUnmount: n.dayHeaderWillUnmount }, (u) => p("div", { className: "fc-scrollgrid-sync-inner" }, !o.isDisabled && p(u, { elTag: "a", elAttrs: h, elClasses: [
      "fc-col-header-cell-cushion",
      s.isSticky && "fc-sticky"
    ] })));
  }
}
const ec = B({ weekday: "long" });
class tc extends I {
  render() {
    let { props: e } = this, { dateEnv: n, theme: i, viewApi: r, options: s } = this.context, a = F(/* @__PURE__ */ new Date(2592e5), e.dow), l = {
      dow: e.dow,
      isDisabled: !1,
      isFuture: !1,
      isPast: !1,
      isToday: !1,
      isOther: !1
    }, o = n.format(a, e.dayHeaderFormat), d = Object.assign(Object.assign(Object.assign(Object.assign({
      // TODO: make this public?
      date: a
    }, l), { view: r }), e.extraRenderProps), { text: o });
    return p(q, { elTag: "th", elClasses: [
      is,
      ...Pn(l, i),
      ...e.extraClassNames || []
    ], elAttrs: Object.assign({ role: "columnheader", colSpan: e.colSpan }, e.extraDataAttrs), renderProps: d, generatorName: "dayHeaderContent", customGenerator: s.dayHeaderContent, defaultGenerator: rs, classNameGenerator: s.dayHeaderClassNames, didMount: s.dayHeaderDidMount, willUnmount: s.dayHeaderWillUnmount }, (c) => p(
      "div",
      { className: "fc-scrollgrid-sync-inner" },
      p(c, { elTag: "a", elClasses: [
        "fc-col-header-cell-cushion",
        e.isSticky && "fc-sticky"
      ], elAttrs: {
        "aria-label": n.format(a, ec)
      } })
    ));
  }
}
class Ve extends G {
  constructor(e, n) {
    super(e, n), this.initialNowDate = We(n.options.now, n.dateEnv), this.initialNowQueriedMs = (/* @__PURE__ */ new Date()).valueOf(), this.state = this.computeTiming().currentState;
  }
  render() {
    let { props: e, state: n } = this;
    return e.children(n.nowDate, n.todayRange);
  }
  componentDidMount() {
    this.setTimeout();
  }
  componentDidUpdate(e) {
    e.unit !== this.props.unit && (this.clearTimeout(), this.setTimeout());
  }
  componentWillUnmount() {
    this.clearTimeout();
  }
  computeTiming() {
    let { props: e, context: n } = this, i = fe(this.initialNowDate, (/* @__PURE__ */ new Date()).valueOf() - this.initialNowQueriedMs), r = n.dateEnv.startOf(i, e.unit), s = n.dateEnv.add(r, k(1, e.unit)), a = s.valueOf() - i.valueOf();
    return a = Math.min(1e3 * 60 * 60 * 24, a), {
      currentState: { nowDate: r, todayRange: zi(r) },
      nextState: { nowDate: s, todayRange: zi(s) },
      waitMs: a
    };
  }
  setTimeout() {
    let { nextState: e, waitMs: n } = this.computeTiming();
    this.timeoutId = setTimeout(() => {
      this.setState(e, () => {
        this.setTimeout();
      });
    }, n);
  }
  clearTimeout() {
    this.timeoutId && clearTimeout(this.timeoutId);
  }
}
Ve.contextType = re;
function zi(t) {
  let e = P(t), n = F(e, 1);
  return { start: e, end: n };
}
class os extends I {
  constructor() {
    super(...arguments), this.createDayHeaderFormatter = D(nc);
  }
  render() {
    let { context: e } = this, { dates: n, dateProfile: i, datesRepDistinctDays: r, renderIntro: s } = this.props, a = this.createDayHeaderFormatter(e.options.dayHeaderFormat, r, n.length);
    return p(Ve, { unit: "day" }, (l, o) => p(
      "tr",
      { role: "row" },
      s && s("day"),
      n.map((d) => r ? p(Ko, { key: d.toISOString(), date: d, dateProfile: i, todayRange: o, colCnt: n.length, dayHeaderFormat: a }) : p(tc, { key: d.getUTCDay(), dow: d.getUTCDay(), dayHeaderFormat: a }))
    ));
  }
}
function nc(t, e, n) {
  return t || $o(e, n);
}
class cs {
  constructor(e, n) {
    let i = e.start, { end: r } = e, s = [], a = [], l = -1;
    for (; i < r; )
      n.isHiddenDay(i) ? s.push(l + 0.5) : (l += 1, s.push(l), a.push(i)), i = F(i, 1);
    this.dates = a, this.indices = s, this.cnt = a.length;
  }
  sliceRange(e) {
    let n = this.getDateDayIndex(e.start), i = this.getDateDayIndex(F(e.end, -1)), r = Math.max(0, n), s = Math.min(this.cnt - 1, i);
    return r = Math.ceil(r), s = Math.floor(s), r <= s ? {
      firstIndex: r,
      lastIndex: s,
      isStart: n === r,
      isEnd: i === s
    } : null;
  }
  // Given a date, returns its chronolocial cell-index from the first cell of the grid.
  // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
  // If before the first offset, returns a negative number.
  // If after the last offset, returns an offset past the last cell offset.
  // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
  getDateDayIndex(e) {
    let { indices: n } = this, i = Math.floor(Ce(this.dates[0], e));
    return i < 0 ? n[0] - 1 : i >= n.length ? n[n.length - 1] + 1 : n[i];
  }
}
class ds {
  constructor(e, n) {
    let { dates: i } = e, r, s, a;
    if (n) {
      for (s = i[0].getUTCDay(), r = 1; r < i.length && i[r].getUTCDay() !== s; r += 1)
        ;
      a = Math.ceil(i.length / r);
    } else
      a = 1, r = i.length;
    this.rowCnt = a, this.colCnt = r, this.daySeries = e, this.cells = this.buildCells(), this.headerDates = this.buildHeaderDates();
  }
  buildCells() {
    let e = [];
    for (let n = 0; n < this.rowCnt; n += 1) {
      let i = [];
      for (let r = 0; r < this.colCnt; r += 1)
        i.push(this.buildCell(n, r));
      e.push(i);
    }
    return e;
  }
  buildCell(e, n) {
    let i = this.daySeries.dates[e * this.colCnt + n];
    return {
      key: i.toISOString(),
      date: i
    };
  }
  buildHeaderDates() {
    let e = [];
    for (let n = 0; n < this.colCnt; n += 1)
      e.push(this.cells[0][n].date);
    return e;
  }
  sliceRange(e) {
    let { colCnt: n } = this, i = this.daySeries.sliceRange(e), r = [];
    if (i) {
      let { firstIndex: s, lastIndex: a } = i, l = s;
      for (; l <= a; ) {
        let o = Math.floor(l / n), d = Math.min((o + 1) * n, a + 1);
        r.push({
          row: o,
          firstCol: l % n,
          lastCol: (d - 1) % n,
          isStart: i.isStart && l === s,
          isEnd: i.isEnd && d - 1 === a
        }), l = d;
      }
    }
    return r;
  }
}
class us {
  constructor() {
    this.sliceBusinessHours = D(this._sliceBusinessHours), this.sliceDateSelection = D(this._sliceDateSpan), this.sliceEventStore = D(this._sliceEventStore), this.sliceEventDrag = D(this._sliceInteraction), this.sliceEventResize = D(this._sliceInteraction), this.forceDayIfListItem = !1;
  }
  sliceProps(e, n, i, r, ...s) {
    let { eventUiBases: a } = e, l = this.sliceEventStore(e.eventStore, a, n, i, ...s);
    return {
      dateSelectionSegs: this.sliceDateSelection(e.dateSelection, n, i, a, r, ...s),
      businessHourSegs: this.sliceBusinessHours(e.businessHours, n, i, r, ...s),
      fgEventSegs: l.fg,
      bgEventSegs: l.bg,
      eventDrag: this.sliceEventDrag(e.eventDrag, a, n, i, ...s),
      eventResize: this.sliceEventResize(e.eventResize, a, n, i, ...s),
      eventSelection: e.eventSelection
    };
  }
  sliceNowDate(e, n, i, r, ...s) {
    return this._sliceDateSpan(
      { range: { start: e, end: fe(e, 1) }, allDay: !1 },
      // add 1 ms, protect against null range
      n,
      i,
      {},
      r,
      ...s
    );
  }
  _sliceBusinessHours(e, n, i, r, ...s) {
    return e ? this._sliceEventStore(Ee(e, Ke(n, !!i), r), {}, n, i, ...s).bg : [];
  }
  _sliceEventStore(e, n, i, r, ...s) {
    if (e) {
      let a = Li(e, n, Ke(i, !!r), r);
      return {
        bg: this.sliceEventRanges(a.bg, s),
        fg: this.sliceEventRanges(a.fg, s)
      };
    }
    return { bg: [], fg: [] };
  }
  _sliceInteraction(e, n, i, r, ...s) {
    if (!e)
      return null;
    let a = Li(e.mutatedEvents, n, Ke(i, !!r), r);
    return {
      segs: this.sliceEventRanges(a.fg, s),
      affectedInstances: e.affectedEvents.instances,
      isEvent: e.isEvent
    };
  }
  _sliceDateSpan(e, n, i, r, s, ...a) {
    if (!e)
      return [];
    let l = Ke(n, !!i), o = _e(e.range, l);
    if (o) {
      e = Object.assign(Object.assign({}, e), { range: o });
      let d = Lo(e, r, s), c = this.sliceRange(e.range, ...a);
      for (let h of c)
        h.eventRange = d;
      return c;
    }
    return [];
  }
  /*
  "complete" seg means it has component and eventRange
  */
  sliceEventRanges(e, n) {
    let i = [];
    for (let r of e)
      i.push(...this.sliceEventRange(r, n));
    return i;
  }
  /*
  "complete" seg means it has component and eventRange
  */
  sliceEventRange(e, n) {
    let i = e.range;
    this.forceDayIfListItem && e.ui.display === "list-item" && (i = {
      start: i.start,
      end: F(i.start, 1)
    });
    let r = this.sliceRange(i, ...n);
    for (let s of r)
      s.eventRange = e, s.isStart = e.isStart && s.isStart, s.isEnd = e.isEnd && s.isEnd;
    return r;
  }
}
function Ke(t, e) {
  let n = t.activeRange;
  return e ? n : {
    start: fe(n.start, t.slotMinTime.milliseconds),
    end: fe(n.end, t.slotMaxTime.milliseconds - 864e5)
    // 864e5 = ms in a day
  };
}
function ic(t, e, n, i, r) {
  switch (e.type) {
    case "RECEIVE_EVENTS":
      return rc(t, n[e.sourceId], e.fetchId, e.fetchRange, e.rawEvents, r);
    case "RESET_RAW_EVENTS":
      return sc(t, n[e.sourceId], e.rawEvents, i.activeRange, r);
    case "ADD_EVENTS":
      return ac(
        t,
        e.eventStore,
        // new ones
        i ? i.activeRange : null,
        r
      );
    case "RESET_EVENTS":
      return e.eventStore;
    case "MERGE_EVENTS":
      return In(t, e.eventStore);
    case "PREV":
    case "NEXT":
    case "CHANGE_DATE":
    case "CHANGE_VIEW_TYPE":
      return i ? Ee(t, i.activeRange, r) : t;
    case "REMOVE_EVENTS":
      return Ol(t, e.eventStore);
    case "REMOVE_EVENT_SOURCE":
      return hs(t, e.sourceId);
    case "REMOVE_ALL_EVENT_SOURCES":
      return Tt(t, (s) => !s.sourceId);
    case "REMOVE_ALL_EVENTS":
      return Y();
    default:
      return t;
  }
}
function rc(t, e, n, i, r, s) {
  if (e && // not already removed
  n === e.latestFetchId) {
    let a = Fe(fs(r, e, s), e, s);
    return i && (a = Ee(a, i, s)), In(hs(t, e.sourceId), a);
  }
  return t;
}
function sc(t, e, n, i, r) {
  const { defIdMap: s, instanceIdMap: a } = oc(t);
  let l = Fe(fs(n, e, r), e, r, !1, s, a);
  return Ee(l, i, r);
}
function fs(t, e, n) {
  let i = n.options.eventDataTransform, r = e ? e.eventDataTransform : null;
  return r && (t = Ui(t, r)), i && (t = Ui(t, i)), t;
}
function Ui(t, e) {
  let n;
  if (!e)
    n = t;
  else {
    n = [];
    for (let i of t) {
      let r = e(i);
      r ? n.push(r) : r == null && n.push(i);
    }
  }
  return n;
}
function ac(t, e, n, i) {
  return n && (e = Ee(e, n, i)), In(t, e);
}
function Fi(t, e, n) {
  let { defs: i } = t, r = ne(t.instances, (s) => i[s.defId].allDay ? s : Object.assign(Object.assign({}, s), { range: {
    start: n.createMarker(e.toDate(s.range.start, s.forcedStartTzo)),
    end: n.createMarker(e.toDate(s.range.end, s.forcedEndTzo))
  }, forcedStartTzo: n.canComputeOffset ? null : s.forcedStartTzo, forcedEndTzo: n.canComputeOffset ? null : s.forcedEndTzo }));
  return { defs: i, instances: r };
}
function hs(t, e) {
  return Tt(t, (n) => n.sourceId !== e);
}
function lc(t, e) {
  return {
    defs: t.defs,
    instances: be(t.instances, (n) => !e[n.instanceId])
  };
}
function oc(t) {
  const { defs: e, instances: n } = t, i = {}, r = {};
  for (let s in e) {
    const a = e[s], { publicId: l } = a;
    l && (i[l] = s);
  }
  for (let s in n) {
    const a = n[s], l = e[a.defId], { publicId: o } = l;
    o && (r[o] = s);
  }
  return { defIdMap: i, instanceIdMap: r };
}
function ps(t, e, n) {
  let { instances: i } = t.mutatedEvents;
  for (let r in i)
    if (!Rt(e.validRange, i[r].range))
      return !1;
  return gs({ eventDrag: t }, n);
}
function cc(t, e, n) {
  return Rt(e.validRange, t.range) ? gs({ dateSelection: t }, n) : !1;
}
function gs(t, e) {
  let n = e.getCurrentData(), i = Object.assign({ businessHours: n.businessHours, dateSelection: "", eventStore: n.eventStore, eventUiBases: n.eventUiBases, eventSelection: "", eventDrag: null, eventResize: null }, t);
  return (e.pluginHooks.isPropsValid || dc)(i, e);
}
function dc(t, e, n = {}, i) {
  return !(t.eventDrag && !uc(t, e, n, i) || t.dateSelection && !fc(t, e, n, i));
}
function uc(t, e, n, i) {
  let r = e.getCurrentData(), s = t.eventDrag, a = s.mutatedEvents, l = a.defs, o = a.instances, d = Et(l, s.isEvent ? t.eventUiBases : { "": r.selectionConfig });
  i && (d = ne(d, i));
  let c = lc(t.eventStore, s.affectedEvents.instances), h = c.defs, f = c.instances, u = Et(h, t.eventUiBases);
  for (let v in o) {
    let y = o[v], b = y.range, E = d[y.defId], C = l[y.defId];
    if (!ms(E.constraints, b, c, t.businessHours, e))
      return !1;
    let { eventOverlap: T } = e.options, A = typeof T == "function" ? T : null;
    for (let M in f) {
      let N = f[M];
      if (Nn(b, N.range) && (u[N.defId].overlap === !1 && s.isEvent || E.overlap === !1 || A && !A(
        new L(e, h[N.defId], N),
        // still event
        new L(e, C, y)
      )))
        return !1;
    }
    let O = r.eventStore;
    for (let M of E.allows) {
      let N = Object.assign(Object.assign({}, n), { range: y.range, allDay: C.allDay }), x = O.defs[C.defId], Q = O.instances[v], ae;
      if (x ? ae = new L(e, x, Q) : ae = new L(e, C), !M(Bn(N, e), ae))
        return !1;
    }
  }
  return !0;
}
function fc(t, e, n, i) {
  let r = t.eventStore, s = r.defs, a = r.instances, l = t.dateSelection, o = l.range, { selectionConfig: d } = e.getCurrentData();
  if (i && (d = i(d)), !ms(d.constraints, o, r, t.businessHours, e))
    return !1;
  let { selectOverlap: c } = e.options, h = typeof c == "function" ? c : null;
  for (let f in a) {
    let u = a[f];
    if (Nn(o, u.range) && (d.overlap === !1 || h && !h(new L(e, s[u.defId], u), null)))
      return !1;
  }
  for (let f of d.allows) {
    let u = Object.assign(Object.assign({}, n), l);
    if (!f(Bn(u, e), null))
      return !1;
  }
  return !0;
}
function ms(t, e, n, i, r) {
  for (let s of t)
    if (!pc(hc(s, e, n, i, r), e))
      return !1;
  return !0;
}
function hc(t, e, n, i, r) {
  return t === "businessHours" ? Yt(Ee(i, e, r)) : typeof t == "string" ? Yt(Tt(n, (s) => s.groupId === t)) : typeof t == "object" && t ? Yt(Ee(t, e, r)) : [];
}
function Yt(t) {
  let { instances: e } = t, n = [];
  for (let i in e)
    n.push(e[i].range);
  return n;
}
function pc(t, e) {
  for (let n of t)
    if (Rt(n, e))
      return !0;
  return !1;
}
class ji extends Error {
  constructor(e, n) {
    super(e), this.response = n;
  }
}
function gc(t, e, n) {
  t = t.toUpperCase();
  const i = {
    method: t
  };
  return t === "GET" ? e += (e.indexOf("?") === -1 ? "?" : "&") + new URLSearchParams(n) : (i.body = new URLSearchParams(n), i.headers = {
    "Content-Type": "application/x-www-form-urlencoded"
  }), fetch(e, i).then((r) => {
    if (r.ok)
      return r.json().then((s) => [s, r], () => {
        throw new ji("Failure parsing JSON", r);
      });
    throw new ji("Request failed", r);
  });
}
class Vn {
  constructor(e) {
    this.drainedOption = e, this.isRunning = !1, this.isDirty = !1, this.pauseDepths = {}, this.timeoutId = 0;
  }
  request(e) {
    this.isDirty = !0, this.isPaused() || (this.clearTimeout(), e == null ? this.tryDrain() : this.timeoutId = setTimeout(
      // NOT OPTIMAL! TODO: look at debounce
      this.tryDrain.bind(this),
      e
    ));
  }
  pause(e = "") {
    let { pauseDepths: n } = this;
    n[e] = (n[e] || 0) + 1, this.clearTimeout();
  }
  resume(e = "", n) {
    let { pauseDepths: i } = this;
    e in i && (n ? delete i[e] : (i[e] -= 1, i[e] <= 0 && delete i[e]), this.tryDrain());
  }
  isPaused() {
    return Object.keys(this.pauseDepths).length;
  }
  tryDrain() {
    if (!this.isRunning && !this.isPaused()) {
      for (this.isRunning = !0; this.isDirty; )
        this.isDirty = !1, this.drained();
      this.isRunning = !1;
    }
  }
  clear() {
    this.clearTimeout(), this.isDirty = !1, this.pauseDepths = {};
  }
  clearTimeout() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = 0);
  }
  drained() {
    this.drainedOption && this.drainedOption();
  }
}
const et = /^(visible|hidden)$/;
class mc extends I {
  constructor() {
    super(...arguments), this.handleEl = (e) => {
      this.el = e, ie(this.props.elRef, e);
    };
  }
  render() {
    let { props: e } = this, { liquid: n, liquidIsAbsolute: i } = e, r = n && i, s = ["fc-scroller"];
    return n && (i ? s.push("fc-scroller-liquid-absolute") : s.push("fc-scroller-liquid")), p("div", { ref: this.handleEl, className: s.join(" "), style: {
      overflowX: e.overflowX,
      overflowY: e.overflowY,
      left: r && -(e.overcomeLeft || 0) || "",
      right: r && -(e.overcomeRight || 0) || "",
      bottom: r && -(e.overcomeBottom || 0) || "",
      marginLeft: !r && -(e.overcomeLeft || 0) || "",
      marginRight: !r && -(e.overcomeRight || 0) || "",
      marginBottom: !r && -(e.overcomeBottom || 0) || "",
      maxHeight: e.maxHeight || ""
    } }, e.children);
  }
  needsXScrolling() {
    if (et.test(this.props.overflowX))
      return !1;
    let { el: e } = this, n = this.el.getBoundingClientRect().width - this.getYScrollbarWidth(), { children: i } = e;
    for (let r = 0; r < i.length; r += 1)
      if (i[r].getBoundingClientRect().width > n)
        return !0;
    return !1;
  }
  needsYScrolling() {
    if (et.test(this.props.overflowY))
      return !1;
    let { el: e } = this, n = this.el.getBoundingClientRect().height - this.getXScrollbarWidth(), { children: i } = e;
    for (let r = 0; r < i.length; r += 1)
      if (i[r].getBoundingClientRect().height > n)
        return !0;
    return !1;
  }
  getXScrollbarWidth() {
    return et.test(this.props.overflowX) ? 0 : this.el.offsetHeight - this.el.clientHeight;
  }
  getYScrollbarWidth() {
    return et.test(this.props.overflowY) ? 0 : this.el.offsetWidth - this.el.clientWidth;
  }
}
class ee {
  constructor(e) {
    this.masterCallback = e, this.currentMap = {}, this.depths = {}, this.callbackMap = {}, this.handleValue = (n, i) => {
      let { depths: r, currentMap: s } = this, a = !1, l = !1;
      n !== null ? (a = i in s, s[i] = n, r[i] = (r[i] || 0) + 1, l = !0) : (r[i] -= 1, r[i] || (delete s[i], delete this.callbackMap[i], a = !0)), this.masterCallback && (a && this.masterCallback(null, String(i)), l && this.masterCallback(n, String(i)));
    };
  }
  createRef(e) {
    let n = this.callbackMap[e];
    return n || (n = this.callbackMap[e] = (i) => {
      this.handleValue(i, String(e));
    }), n;
  }
  // TODO: check callers that don't care about order. should use getAll instead
  // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
  // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
  collect(e, n, i) {
    return Ka(this.currentMap, e, n, i);
  }
  getAll() {
    return An(this.currentMap);
  }
}
function vc(t) {
  let e = Ra(t, ".fc-scrollgrid-shrink"), n = 0;
  for (let i of e)
    n = Math.max(n, ja(i));
  return Math.ceil(n);
}
function vs(t, e) {
  return t.liquid && e.liquid;
}
function yc(t, e) {
  return e.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
  vs(t, e);
}
function bc(t, e, n, i) {
  let { expandRows: r } = n;
  return typeof e.content == "function" ? e.content(n) : p("table", {
    role: "presentation",
    className: [
      e.tableClassName,
      t.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
    ].join(" "),
    style: {
      minWidth: n.tableMinWidth,
      width: n.clientWidth,
      height: r ? n.clientHeight : ""
      // css `height` on a <table> serves as a min-height
    }
  }, n.tableColGroupNode, p(i ? "thead" : "tbody", {
    role: "presentation"
  }, typeof e.rowContent == "function" ? e.rowContent(n) : e.rowContent));
}
function Ec(t, e) {
  return ue(t, e, J);
}
function _c(t, e) {
  let n = [];
  for (let i of t) {
    let r = i.span || 1;
    for (let s = 0; s < r; s += 1)
      n.push(p("col", { style: {
        width: i.width === "shrink" ? wc(e) : i.width || "",
        minWidth: i.minWidth || ""
      } }));
  }
  return p("colgroup", {}, ...n);
}
function wc(t) {
  return t ?? 4;
}
function Cc(t) {
  for (let e of t)
    if (e.width === "shrink")
      return !0;
  return !1;
}
function Sc(t, e) {
  let n = [
    "fc-scrollgrid",
    e.theme.getClass("table")
  ];
  return t && n.push("fc-scrollgrid-liquid"), n;
}
function Dc(t, e) {
  let n = [
    "fc-scrollgrid-section",
    `fc-scrollgrid-section-${t.type}`,
    t.className
    // used?
  ];
  return e && t.liquid && t.maxHeight == null && n.push("fc-scrollgrid-section-liquid"), t.isSticky && n.push("fc-scrollgrid-section-sticky"), n;
}
function un(t) {
  return p("div", { className: "fc-scrollgrid-sticky-shim", style: {
    width: t.clientWidth,
    minWidth: t.tableMinWidth
  } });
}
function _t(t) {
  let { stickyHeaderDates: e } = t;
  return (e == null || e === "auto") && (e = t.height === "auto" || t.viewHeight === "auto"), e;
}
function ys(t) {
  let { stickyFooterScrollbar: e } = t;
  return (e == null || e === "auto") && (e = t.height === "auto" || t.viewHeight === "auto"), e;
}
class Gn extends I {
  constructor() {
    super(...arguments), this.processCols = D((e) => e, Ec), this.renderMicroColGroup = D(_c), this.scrollerRefs = new ee(), this.scrollerElRefs = new ee(this._handleScrollerEl.bind(this)), this.state = {
      shrinkWidth: null,
      forceYScrollbars: !1,
      scrollerClientWidths: {},
      scrollerClientHeights: {}
    }, this.handleSizing = () => {
      this.safeSetState(Object.assign({ shrinkWidth: this.computeShrinkWidth() }, this.computeScrollerDims()));
    };
  }
  render() {
    let { props: e, state: n, context: i } = this, r = e.sections || [], s = this.processCols(e.cols), a = this.renderMicroColGroup(s, n.shrinkWidth), l = Sc(e.liquid, i);
    e.collapsibleWidth && l.push("fc-scrollgrid-collapsible");
    let o = r.length, d = 0, c, h = [], f = [], u = [];
    for (; d < o && (c = r[d]).type === "header"; )
      h.push(this.renderSection(c, a, !0)), d += 1;
    for (; d < o && (c = r[d]).type === "body"; )
      f.push(this.renderSection(c, a, !1)), d += 1;
    for (; d < o && (c = r[d]).type === "footer"; )
      u.push(this.renderSection(c, a, !0)), d += 1;
    let v = !Ur();
    const y = { role: "rowgroup" };
    return p("table", {
      role: "grid",
      className: l.join(" "),
      style: { height: e.height }
    }, !!(!v && h.length) && p("thead", y, ...h), !!(!v && f.length) && p("tbody", y, ...f), !!(!v && u.length) && p("tfoot", y, ...u), v && p("tbody", y, ...h, ...f, ...u));
  }
  renderSection(e, n, i) {
    return "outerContent" in e ? p(H, { key: e.key }, e.outerContent) : p("tr", { key: e.key, role: "presentation", className: Dc(e, this.props.liquid).join(" ") }, this.renderChunkTd(e, n, e.chunk, i));
  }
  renderChunkTd(e, n, i, r) {
    if ("outerContent" in i)
      return i.outerContent;
    let { props: s } = this, { forceYScrollbars: a, scrollerClientWidths: l, scrollerClientHeights: o } = this.state, d = yc(s, e), c = vs(s, e), h = s.liquid ? a ? "scroll" : d ? "auto" : "hidden" : "visible", f = e.key, u = bc(e, i, {
      tableColGroupNode: n,
      tableMinWidth: "",
      clientWidth: !s.collapsibleWidth && l[f] !== void 0 ? l[f] : null,
      clientHeight: o[f] !== void 0 ? o[f] : null,
      expandRows: e.expandRows,
      syncRowHeights: !1,
      rowSyncHeights: [],
      reportRowHeightChange: () => {
      }
    }, r);
    return p(r ? "th" : "td", {
      ref: i.elRef,
      role: "presentation"
    }, p(
      "div",
      { className: `fc-scroller-harness${c ? " fc-scroller-harness-liquid" : ""}` },
      p(mc, { ref: this.scrollerRefs.createRef(f), elRef: this.scrollerElRefs.createRef(f), overflowY: h, overflowX: s.liquid ? "hidden" : "visible", maxHeight: e.maxHeight, liquid: c, liquidIsAbsolute: !0 }, u)
    ));
  }
  _handleScrollerEl(e, n) {
    let i = Ac(this.props.sections, n);
    i && ie(i.chunk.scrollerElRef, e);
  }
  componentDidMount() {
    this.handleSizing(), this.context.addResizeHandler(this.handleSizing);
  }
  componentDidUpdate() {
    this.handleSizing();
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleSizing);
  }
  computeShrinkWidth() {
    return Cc(this.props.cols) ? vc(this.scrollerElRefs.getAll()) : 0;
  }
  computeScrollerDims() {
    let e = ro(), { scrollerRefs: n, scrollerElRefs: i } = this, r = !1, s = {}, a = {};
    for (let l in n.currentMap) {
      let o = n.currentMap[l];
      if (o && o.needsYScrolling()) {
        r = !0;
        break;
      }
    }
    for (let l of this.props.sections) {
      let o = l.key, d = i.currentMap[o];
      if (d) {
        let c = d.parentNode;
        s[o] = Math.floor(c.getBoundingClientRect().width - (r ? e.y : 0)), a[o] = Math.floor(c.getBoundingClientRect().height);
      }
    }
    return { forceYScrollbars: r, scrollerClientWidths: s, scrollerClientHeights: a };
  }
}
Gn.addStateEquality({
  scrollerClientWidths: J,
  scrollerClientHeights: J
});
function Ac(t, e) {
  for (let n of t)
    if (n.key === e)
      return n;
  return null;
}
class Yn extends I {
  constructor() {
    super(...arguments), this.handleEl = (e) => {
      this.el = e, e && Bi(e, this.props.seg);
    };
  }
  render() {
    const { props: e, context: n } = this, { options: i } = n, { seg: r } = e, { eventRange: s } = r, { ui: a } = s, l = {
      event: new L(n, s.def, s.instance),
      view: n.viewApi,
      timeText: e.timeText,
      textColor: a.textColor,
      backgroundColor: a.backgroundColor,
      borderColor: a.borderColor,
      isDraggable: !e.disableDragging && To(r, n),
      isStartResizable: !e.disableResizing && Ro(r, n),
      isEndResizable: !e.disableResizing && xo(r),
      isMirror: !!(e.isDragging || e.isResizing || e.isDateSelecting),
      isStart: !!r.isStart,
      isEnd: !!r.isEnd,
      isPast: !!e.isPast,
      isFuture: !!e.isFuture,
      isToday: !!e.isToday,
      isSelected: !!e.isSelected,
      isDragging: !!e.isDragging,
      isResizing: !!e.isResizing
    };
    return p(q, Object.assign({}, e, { elRef: this.handleEl, elClasses: [
      ...ko(l),
      ...r.eventRange.ui.classNames,
      ...e.elClasses || []
    ], renderProps: l, generatorName: "eventContent", customGenerator: i.eventContent, defaultGenerator: e.defaultGenerator, classNameGenerator: i.eventClassNames, didMount: i.eventDidMount, willUnmount: i.eventWillUnmount }));
  }
  componentDidUpdate(e) {
    this.el && this.props.seg !== e.seg && Bi(this.el, this.props.seg);
  }
}
class bs extends I {
  render() {
    let { props: e, context: n } = this, { options: i } = n, { seg: r } = e, { ui: s } = r.eventRange, a = i.eventTimeFormat || e.defaultTimeFormat, l = Zr(r, a, n, e.defaultDisplayEventTime, e.defaultDisplayEventEnd);
    return p(Yn, Object.assign({}, e, { elTag: "a", elStyle: {
      borderColor: s.borderColor,
      backgroundColor: s.backgroundColor
    }, elAttrs: Jr(r, n), defaultGenerator: Tc, timeText: l }), (o, d) => p(
      H,
      null,
      p(o, { elTag: "div", elClasses: ["fc-event-main"], elStyle: { color: d.textColor } }),
      !!d.isStartResizable && p("div", { className: "fc-event-resizer fc-event-resizer-start" }),
      !!d.isEndResizable && p("div", { className: "fc-event-resizer fc-event-resizer-end" })
    ));
  }
}
function Tc(t) {
  return p(
    "div",
    { className: "fc-event-main-frame" },
    t.timeText && p("div", { className: "fc-event-time" }, t.timeText),
    p(
      "div",
      { className: "fc-event-title-container" },
      p("div", { className: "fc-event-title fc-sticky" }, t.event.title || p(H, null, " "))
    )
  );
}
const qn = (t) => p(re.Consumer, null, (e) => {
  let { options: n } = e, i = {
    isAxis: t.isAxis,
    date: e.dateEnv.toDate(t.date),
    view: e.viewApi
  };
  return p(q, Object.assign({}, t, { elTag: t.elTag || "div", renderProps: i, generatorName: "nowIndicatorContent", customGenerator: n.nowIndicatorContent, classNameGenerator: n.nowIndicatorClassNames, didMount: n.nowIndicatorDidMount, willUnmount: n.nowIndicatorWillUnmount }));
}), Rc = B({ day: "numeric" });
class Qn extends I {
  constructor() {
    super(...arguments), this.refineRenderProps = lt(xc);
  }
  render() {
    let { props: e, context: n } = this, { options: i } = n, r = this.refineRenderProps({
      date: e.date,
      dateProfile: e.dateProfile,
      todayRange: e.todayRange,
      isMonthStart: e.isMonthStart || !1,
      showDayNumber: e.showDayNumber,
      extraRenderProps: e.extraRenderProps,
      viewApi: n.viewApi,
      dateEnv: n.dateEnv,
      monthStartFormat: i.monthStartFormat
    });
    return p(q, Object.assign({}, e, { elClasses: [
      ...Pn(r, n.theme),
      ...e.elClasses || []
    ], elAttrs: Object.assign(Object.assign({}, e.elAttrs), r.isDisabled ? {} : { "data-date": Tn(e.date) }), renderProps: r, generatorName: "dayCellContent", customGenerator: i.dayCellContent, defaultGenerator: e.defaultGenerator, classNameGenerator: (
      // don't use custom classNames if disabled
      r.isDisabled ? void 0 : i.dayCellClassNames
    ), didMount: i.dayCellDidMount, willUnmount: i.dayCellWillUnmount }));
  }
}
function $n(t) {
  return !!(t.dayCellContent || ss("dayCellContent", t));
}
function xc(t) {
  let { date: e, dateEnv: n, dateProfile: i, isMonthStart: r } = t, s = Fr(e, t.todayRange, null, i), a = t.showDayNumber ? n.format(e, r ? t.monthStartFormat : Rc) : "";
  return Object.assign(Object.assign(Object.assign({ date: n.toDate(e), view: t.viewApi }, s), {
    isMonthStart: r,
    dayNumberText: a
  }), t.extraRenderProps);
}
class Es extends I {
  render() {
    let { props: e } = this, { seg: n } = e;
    return p(Yn, { elTag: "div", elClasses: ["fc-bg-event"], elStyle: { backgroundColor: n.eventRange.ui.backgroundColor }, defaultGenerator: kc, seg: n, timeText: "", isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: !1, isPast: e.isPast, isFuture: e.isFuture, isToday: e.isToday, disableDragging: !0, disableResizing: !0 });
  }
}
function kc(t) {
  let { title: e } = t.event;
  return e && p("div", { className: "fc-event-title" }, t.event.title);
}
function _s(t) {
  return p("div", { className: `fc-${t}` });
}
const ws = (t) => p(re.Consumer, null, (e) => {
  let { dateEnv: n, options: i } = e, { date: r } = t, s = i.weekNumberFormat || t.defaultFormat, a = n.computeWeekNumber(r), l = n.format(r, s);
  return p(
    q,
    Object.assign({}, t, { renderProps: { num: a, text: l, date: r }, generatorName: "weekNumberContent", customGenerator: i.weekNumberContent, defaultGenerator: Mc, classNameGenerator: i.weekNumberClassNames, didMount: i.weekNumberDidMount, willUnmount: i.weekNumberWillUnmount })
  );
});
function Mc(t) {
  return t.text;
}
const qt = 10;
class Ic extends I {
  constructor() {
    super(...arguments), this.state = {
      titleId: Dt()
    }, this.handleRootEl = (e) => {
      this.rootEl = e, this.props.elRef && ie(this.props.elRef, e);
    }, this.handleDocumentMouseDown = (e) => {
      const n = Ar(e);
      this.rootEl.contains(n) || this.handleCloseClick();
    }, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && this.handleCloseClick();
    }, this.handleCloseClick = () => {
      let { onClose: e } = this.props;
      e && e();
    };
  }
  render() {
    let { theme: e, options: n } = this.context, { props: i, state: r } = this, s = [
      "fc-popover",
      e.getClass("popover")
    ].concat(i.extraClassNames || []);
    return pa(p(
      "div",
      Object.assign({}, i.extraAttrs, { id: i.id, className: s.join(" "), "aria-labelledby": r.titleId, ref: this.handleRootEl }),
      p(
        "div",
        { className: "fc-popover-header " + e.getClass("popoverHeader") },
        p("span", { className: "fc-popover-title", id: r.titleId }, i.title),
        p("span", { className: "fc-popover-close " + e.getIconClass("close"), title: n.closeHint, onClick: this.handleCloseClick })
      ),
      p("div", { className: "fc-popover-body " + e.getClass("popoverContent") }, i.children)
    ), i.parentEl);
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleDocumentMouseDown), document.addEventListener("keydown", this.handleDocumentKeyDown), this.updateSize();
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDocumentMouseDown), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  updateSize() {
    let { isRtl: e } = this.context, { alignmentEl: n, alignGridTop: i } = this.props, { rootEl: r } = this, s = oo(n);
    if (s) {
      let a = r.getBoundingClientRect(), l = i ? U(n, ".fc-scrollgrid").getBoundingClientRect().top : s.top, o = e ? s.right - a.width : s.left;
      l = Math.max(l, qt), o = Math.min(o, document.documentElement.clientWidth - qt - a.width), o = Math.max(o, qt);
      let d = r.offsetParent.getBoundingClientRect();
      He(r, {
        top: l - d.top,
        left: o - d.left
      });
    }
  }
}
class Oc extends K {
  constructor() {
    super(...arguments), this.handleRootEl = (e) => {
      this.rootEl = e, e ? this.context.registerInteractiveComponent(this, {
        el: e,
        useEventCenter: !1
      }) : this.context.unregisterInteractiveComponent(this);
    };
  }
  render() {
    let { options: e, dateEnv: n } = this.context, { props: i } = this, { startDate: r, todayRange: s, dateProfile: a } = i, l = n.format(r, e.dayPopoverFormat);
    return p(Qn, { elRef: this.handleRootEl, date: r, dateProfile: a, todayRange: s }, (o, d, c) => p(
      Ic,
      { elRef: c.ref, id: i.id, title: l, extraClassNames: ["fc-more-popover"].concat(c.className || []), extraAttrs: c, parentEl: i.parentEl, alignmentEl: i.alignmentEl, alignGridTop: i.alignGridTop, onClose: i.onClose },
      $n(e) && p(o, { elTag: "div", elClasses: ["fc-more-popover-misc"] }),
      i.children
    ));
  }
  queryHit(e, n, i, r) {
    let { rootEl: s, props: a } = this;
    return e >= 0 && e < i && n >= 0 && n < r ? {
      dateProfile: a.dateProfile,
      dateSpan: Object.assign({ allDay: !a.forceTimed, range: {
        start: a.startDate,
        end: a.endDate
      } }, a.extraDateSpan),
      dayEl: s,
      rect: {
        left: 0,
        top: 0,
        right: i,
        bottom: r
      },
      layer: 1
      // important when comparing with hits from other components
    } : null;
  }
}
class Cs extends I {
  constructor() {
    super(...arguments), this.state = {
      isPopoverOpen: !1,
      popoverId: Dt()
    }, this.handleLinkEl = (e) => {
      this.linkEl = e, this.props.elRef && ie(this.props.elRef, e);
    }, this.handleClick = (e) => {
      let { props: n, context: i } = this, { moreLinkClick: r } = i.options, s = Wi(n).start;
      function a(l) {
        let { def: o, instance: d, range: c } = l.eventRange;
        return {
          event: new L(i, o, d),
          start: i.dateEnv.toDate(c.start),
          end: i.dateEnv.toDate(c.end),
          isStart: l.isStart,
          isEnd: l.isEnd
        };
      }
      typeof r == "function" && (r = r({
        date: s,
        allDay: !!n.allDayDate,
        allSegs: n.allSegs.map(a),
        hiddenSegs: n.hiddenSegs.map(a),
        jsEvent: e,
        view: i.viewApi
      })), !r || r === "popover" ? this.setState({ isPopoverOpen: !0 }) : typeof r == "string" && i.calendarApi.zoomTo(s, r);
    }, this.handlePopoverClose = () => {
      this.setState({ isPopoverOpen: !1 });
    };
  }
  render() {
    let { props: e, state: n } = this;
    return p(re.Consumer, null, (i) => {
      let { viewApi: r, options: s, calendarApi: a } = i, { moreLinkText: l } = s, { moreCnt: o } = e, d = Wi(e), c = typeof l == "function" ? l.call(a, o) : `+${o} ${l}`, h = Le(s.moreLinkHint, [o], c), f = {
        num: o,
        shortText: `+${o}`,
        text: c,
        view: r
      };
      return p(
        H,
        null,
        !!e.moreCnt && p(q, { elTag: e.elTag || "a", elRef: this.handleLinkEl, elClasses: [
          ...e.elClasses || [],
          "fc-more-link"
        ], elStyle: e.elStyle, elAttrs: Object.assign(Object.assign(Object.assign({}, e.elAttrs), Rr(this.handleClick)), { title: h, "aria-expanded": n.isPopoverOpen, "aria-controls": n.isPopoverOpen ? n.popoverId : "" }), renderProps: f, generatorName: "moreLinkContent", customGenerator: s.moreLinkContent, defaultGenerator: e.defaultGenerator || Nc, classNameGenerator: s.moreLinkClassNames, didMount: s.moreLinkDidMount, willUnmount: s.moreLinkWillUnmount }, e.children),
        n.isPopoverOpen && p(Oc, { id: n.popoverId, startDate: d.start, endDate: d.end, dateProfile: e.dateProfile, todayRange: e.todayRange, extraDateSpan: e.extraDateSpan, parentEl: this.parentEl, alignmentEl: e.alignmentElRef ? e.alignmentElRef.current : this.linkEl, alignGridTop: e.alignGridTop, forceTimed: e.forceTimed, onClose: this.handlePopoverClose }, e.popoverContent())
      );
    });
  }
  componentDidMount() {
    this.updateParentEl();
  }
  componentDidUpdate() {
    this.updateParentEl();
  }
  updateParentEl() {
    this.linkEl && (this.parentEl = U(this.linkEl, ".fc-view-harness"));
  }
}
function Nc(t) {
  return t.text;
}
function Wi(t) {
  if (t.allDayDate)
    return {
      start: t.allDayDate,
      end: F(t.allDayDate, 1)
    };
  let { hiddenSegs: e } = t;
  return {
    start: Ss(e),
    end: Hc(e)
  };
}
function Ss(t) {
  return t.reduce(Pc).eventRange.range.start;
}
function Pc(t, e) {
  return t.eventRange.range.start < e.eventRange.range.start ? t : e;
}
function Hc(t) {
  return t.reduce(Lc).eventRange.range.end;
}
function Lc(t, e) {
  return t.eventRange.range.end > e.eventRange.range.end ? t : e;
}
class wt extends I {
  render() {
    let { props: e, context: n } = this, { options: i } = n, r = { view: n.viewApi };
    return p(q, Object.assign({}, e, { elTag: e.elTag || "div", elClasses: [
      ...Ds(e.viewSpec),
      ...e.elClasses || []
    ], renderProps: r, classNameGenerator: i.viewClassNames, generatorName: void 0, didMount: i.viewDidMount, willUnmount: i.viewWillUnmount }), () => e.children);
  }
}
function Ds(t) {
  return [
    `fc-${t.type}-view`,
    "fc-view"
  ];
}
const Bc = {
  id: String,
  defaultAllDay: Boolean,
  url: String,
  format: String,
  events: m,
  eventDataTransform: m,
  // for any network-related sources
  success: m,
  failure: m
};
function As(t, e, n = Ts(e)) {
  let i;
  if (typeof t == "string" ? i = { url: t } : typeof t == "function" || Array.isArray(t) ? i = { events: t } : typeof t == "object" && t && (i = t), i) {
    let { refined: r, extra: s } = xn(i, n), a = zc(r, e);
    if (a)
      return {
        _raw: t,
        isFetching: !1,
        latestFetchId: "",
        fetchRange: null,
        defaultAllDay: r.defaultAllDay,
        eventDataTransform: r.eventDataTransform,
        success: r.success,
        failure: r.failure,
        publicId: r.id || "",
        sourceId: we(),
        sourceDefId: a.sourceDefId,
        meta: a.meta,
        ui: yt(r, e),
        extendedProps: s
      };
  }
  return null;
}
function Ts(t) {
  return Object.assign(Object.assign(Object.assign({}, vt), Bc), t.pluginHooks.eventSourceRefiners);
}
function zc(t, e) {
  let n = e.pluginHooks.eventSourceDefs;
  for (let i = n.length - 1; i >= 0; i -= 1) {
    let s = n[i].parseMeta(t);
    if (s)
      return { sourceDefId: i, meta: s };
  }
  return null;
}
class Uc {
  getCurrentData() {
    return this.currentDataManager.getCurrentData();
  }
  dispatch(e) {
    this.currentDataManager.dispatch(e);
  }
  get view() {
    return this.getCurrentData().viewApi;
  }
  batchRendering(e) {
    e();
  }
  updateSize() {
    this.trigger("_resize", !0);
  }
  // Options
  // -----------------------------------------------------------------------------------------------------------------
  setOption(e, n) {
    this.dispatch({
      type: "SET_OPTION",
      optionName: e,
      rawOptionValue: n
    });
  }
  getOption(e) {
    return this.currentDataManager.currentCalendarOptionsInput[e];
  }
  getAvailableLocaleCodes() {
    return Object.keys(this.getCurrentData().availableRawLocales);
  }
  // Trigger
  // -----------------------------------------------------------------------------------------------------------------
  on(e, n) {
    let { currentDataManager: i } = this;
    i.currentCalendarOptionsRefiners[e] ? i.emitter.on(e, n) : console.warn(`Unknown listener name '${e}'`);
  }
  off(e, n) {
    this.currentDataManager.emitter.off(e, n);
  }
  // not meant for public use
  trigger(e, ...n) {
    this.currentDataManager.emitter.trigger(e, ...n);
  }
  // View
  // -----------------------------------------------------------------------------------------------------------------
  changeView(e, n) {
    this.batchRendering(() => {
      if (this.unselect(), n)
        if (n.start && n.end)
          this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: e
          }), this.dispatch({
            type: "SET_OPTION",
            optionName: "visibleRange",
            rawOptionValue: n
          });
        else {
          let { dateEnv: i } = this.getCurrentData();
          this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: e,
            dateMarker: i.createMarker(n)
          });
        }
      else
        this.dispatch({
          type: "CHANGE_VIEW_TYPE",
          viewType: e
        });
    });
  }
  // Forces navigation to a view for the given date.
  // `viewType` can be a specific view name or a generic one like "week" or "day".
  // needs to change
  zoomTo(e, n) {
    let i = this.getCurrentData(), r;
    n = n || "day", r = i.viewSpecs[n] || this.getUnitViewSpec(n), this.unselect(), r ? this.dispatch({
      type: "CHANGE_VIEW_TYPE",
      viewType: r.type,
      dateMarker: e
    }) : this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e
    });
  }
  // Given a duration singular unit, like "week" or "day", finds a matching view spec.
  // Preference is given to views that have corresponding buttons.
  getUnitViewSpec(e) {
    let { viewSpecs: n, toolbarConfig: i } = this.getCurrentData(), r = [].concat(i.header ? i.header.viewsWithButtons : [], i.footer ? i.footer.viewsWithButtons : []), s, a;
    for (let l in n)
      r.push(l);
    for (s = 0; s < r.length; s += 1)
      if (a = n[r[s]], a && a.singleUnit === e)
        return a;
    return null;
  }
  // Current Date
  // -----------------------------------------------------------------------------------------------------------------
  prev() {
    this.unselect(), this.dispatch({ type: "PREV" });
  }
  next() {
    this.unselect(), this.dispatch({ type: "NEXT" });
  }
  prevYear() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.dateEnv.addYears(e.currentDate, -1)
    });
  }
  nextYear() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.dateEnv.addYears(e.currentDate, 1)
    });
  }
  today() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: We(e.calendarOptions.now, e.dateEnv)
    });
  }
  gotoDate(e) {
    let n = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: n.dateEnv.createMarker(e)
    });
  }
  incrementDate(e) {
    let n = this.getCurrentData(), i = k(e);
    i && (this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: n.dateEnv.add(n.currentDate, i)
    }));
  }
  getDate() {
    let e = this.getCurrentData();
    return e.dateEnv.toDate(e.currentDate);
  }
  // Date Formatting Utils
  // -----------------------------------------------------------------------------------------------------------------
  formatDate(e, n) {
    let { dateEnv: i } = this.getCurrentData();
    return i.format(i.createMarker(e), B(n));
  }
  // `settings` is for formatter AND isEndExclusive
  formatRange(e, n, i) {
    let { dateEnv: r } = this.getCurrentData();
    return r.formatRange(r.createMarker(e), r.createMarker(n), B(i), i);
  }
  formatIso(e, n) {
    let { dateEnv: i } = this.getCurrentData();
    return i.formatIso(i.createMarker(e), { omitTime: n });
  }
  // Date Selection / Event Selection / DayClick
  // -----------------------------------------------------------------------------------------------------------------
  select(e, n) {
    let i;
    n == null ? e.start != null ? i = e : i = {
      start: e,
      end: null
    } : i = {
      start: e,
      end: n
    };
    let r = this.getCurrentData(), s = Io(i, r.dateEnv, k({ days: 1 }));
    s && (this.dispatch({ type: "SELECT_DATES", selection: s }), Yr(s, null, r));
  }
  unselect(e) {
    let n = this.getCurrentData();
    n.dateSelection && (this.dispatch({ type: "UNSELECT_DATES" }), wo(e, n));
  }
  // Public Events API
  // -----------------------------------------------------------------------------------------------------------------
  addEvent(e, n) {
    if (e instanceof L) {
      let a = e._def, l = e._instance;
      return this.getCurrentData().eventStore.defs[a.defId] || (this.dispatch({
        type: "ADD_EVENTS",
        eventStore: an({ def: a, instance: l })
        // TODO: better util for two args?
      }), this.triggerEventAdd(e)), e;
    }
    let i = this.getCurrentData(), r;
    if (n instanceof De)
      r = n.internalEventSource;
    else if (typeof n == "boolean")
      n && ([r] = An(i.eventSources));
    else if (n != null) {
      let a = this.getEventSourceById(n);
      if (!a)
        return console.warn(`Could not find an event source with ID "${n}"`), null;
      r = a.internalEventSource;
    }
    let s = Pr(e, r, i, !1);
    if (s) {
      let a = new L(i, s.def, s.def.recurringDef ? null : s.instance);
      return this.dispatch({
        type: "ADD_EVENTS",
        eventStore: an(s)
      }), this.triggerEventAdd(a), a;
    }
    return null;
  }
  triggerEventAdd(e) {
    let { emitter: n } = this.getCurrentData();
    n.trigger("eventAdd", {
      event: e,
      relatedEvents: [],
      revert: () => {
        this.dispatch({
          type: "REMOVE_EVENTS",
          eventStore: qr(e)
        });
      }
    });
  }
  // TODO: optimize
  getEventById(e) {
    let n = this.getCurrentData(), { defs: i, instances: r } = n.eventStore;
    e = String(e);
    for (let s in i) {
      let a = i[s];
      if (a.publicId === e) {
        if (a.recurringDef)
          return new L(n, a, null);
        for (let l in r) {
          let o = r[l];
          if (o.defId === a.defId)
            return new L(n, a, o);
        }
      }
    }
    return null;
  }
  getEvents() {
    let e = this.getCurrentData();
    return ve(e.eventStore, e);
  }
  removeAllEvents() {
    this.dispatch({ type: "REMOVE_ALL_EVENTS" });
  }
  // Public Event Sources API
  // -----------------------------------------------------------------------------------------------------------------
  getEventSources() {
    let e = this.getCurrentData(), n = e.eventSources, i = [];
    for (let r in n)
      i.push(new De(e, n[r]));
    return i;
  }
  getEventSourceById(e) {
    let n = this.getCurrentData(), i = n.eventSources;
    e = String(e);
    for (let r in i)
      if (i[r].publicId === e)
        return new De(n, i[r]);
    return null;
  }
  addEventSource(e) {
    let n = this.getCurrentData();
    if (e instanceof De)
      return n.eventSources[e.internalEventSource.sourceId] || this.dispatch({
        type: "ADD_EVENT_SOURCES",
        sources: [e.internalEventSource]
      }), e;
    let i = As(e, n);
    return i ? (this.dispatch({ type: "ADD_EVENT_SOURCES", sources: [i] }), new De(n, i)) : null;
  }
  removeAllEventSources() {
    this.dispatch({ type: "REMOVE_ALL_EVENT_SOURCES" });
  }
  refetchEvents() {
    this.dispatch({ type: "FETCH_EVENT_SOURCES", isRefetch: !0 });
  }
  // Scroll
  // -----------------------------------------------------------------------------------------------------------------
  scrollToTime(e) {
    let n = k(e);
    n && this.trigger("_scrollRequest", { time: n });
  }
}
const Fc = [], Rs = {
  code: "en",
  week: {
    dow: 0,
    doy: 4
    // 4 days need to be within the year to be considered the first week
  },
  direction: "ltr",
  buttonText: {
    prev: "prev",
    next: "next",
    prevYear: "prev year",
    nextYear: "next year",
    year: "year",
    today: "today",
    month: "month",
    week: "week",
    day: "day",
    list: "list"
  },
  weekText: "W",
  weekTextLong: "Week",
  closeHint: "Close",
  timeHint: "Time",
  eventHint: "Event",
  allDayText: "all-day",
  moreLinkText: "more",
  noEventsText: "No events to display"
}, xs = Object.assign(Object.assign({}, Rs), {
  // Includes things we don't want other locales to inherit,
  // things that derive from other translatable strings.
  buttonHints: {
    prev: "Previous $0",
    next: "Next $0",
    today(t, e) {
      return e === "day" ? "Today" : `This ${t}`;
    }
  },
  viewHint: "$0 view",
  navLinkHint: "Go to $0",
  moreLinkHint(t) {
    return `Show ${t} more event${t === 1 ? "" : "s"}`;
  }
});
function jc(t) {
  let e = t.length > 0 ? t[0].code : "en", n = Fc.concat(t), i = {
    en: xs
  };
  for (let r of n)
    i[r.code] = r;
  return {
    map: i,
    defaultCode: e
  };
}
function ks(t, e) {
  return typeof t == "object" && !Array.isArray(t) ? Ms(t.code, [t.code], t) : Wc(t, e);
}
function Wc(t, e) {
  let n = [].concat(t || []), i = Vc(n, e) || xs;
  return Ms(t, n, i);
}
function Vc(t, e) {
  for (let n = 0; n < t.length; n += 1) {
    let i = t[n].toLocaleLowerCase().split("-");
    for (let r = i.length; r > 0; r -= 1) {
      let s = i.slice(0, r).join("-");
      if (e[s])
        return e[s];
    }
  }
  return null;
}
function Ms(t, e, n) {
  let i = Dn([Rs, n], ["buttonText"]);
  delete i.code;
  let { week: r } = i;
  return delete i.week, {
    codeArg: t,
    codes: e,
    week: r,
    simpleNumberFormat: new Intl.NumberFormat(t),
    options: i
  };
}
function se(t) {
  return {
    id: we(),
    name: t.name,
    premiumReleaseDate: t.premiumReleaseDate ? new Date(t.premiumReleaseDate) : void 0,
    deps: t.deps || [],
    reducers: t.reducers || [],
    isLoadingFuncs: t.isLoadingFuncs || [],
    contextInit: [].concat(t.contextInit || []),
    eventRefiners: t.eventRefiners || {},
    eventDefMemberAdders: t.eventDefMemberAdders || [],
    eventSourceRefiners: t.eventSourceRefiners || {},
    isDraggableTransformers: t.isDraggableTransformers || [],
    eventDragMutationMassagers: t.eventDragMutationMassagers || [],
    eventDefMutationAppliers: t.eventDefMutationAppliers || [],
    dateSelectionTransformers: t.dateSelectionTransformers || [],
    datePointTransforms: t.datePointTransforms || [],
    dateSpanTransforms: t.dateSpanTransforms || [],
    views: t.views || {},
    viewPropsTransformers: t.viewPropsTransformers || [],
    isPropsValid: t.isPropsValid || null,
    externalDefTransforms: t.externalDefTransforms || [],
    viewContainerAppends: t.viewContainerAppends || [],
    eventDropTransformers: t.eventDropTransformers || [],
    componentInteractions: t.componentInteractions || [],
    calendarInteractions: t.calendarInteractions || [],
    themeClasses: t.themeClasses || {},
    eventSourceDefs: t.eventSourceDefs || [],
    cmdFormatter: t.cmdFormatter,
    recurringTypes: t.recurringTypes || [],
    namedTimeZonedImpl: t.namedTimeZonedImpl,
    initialView: t.initialView || "",
    elementDraggingImpl: t.elementDraggingImpl,
    optionChangeHandlers: t.optionChangeHandlers || {},
    scrollGridImpl: t.scrollGridImpl || null,
    listenerRefiners: t.listenerRefiners || {},
    optionRefiners: t.optionRefiners || {},
    propSetHandlers: t.propSetHandlers || {}
  };
}
function Gc(t, e) {
  let n = {}, i = {
    premiumReleaseDate: void 0,
    reducers: [],
    isLoadingFuncs: [],
    contextInit: [],
    eventRefiners: {},
    eventDefMemberAdders: [],
    eventSourceRefiners: {},
    isDraggableTransformers: [],
    eventDragMutationMassagers: [],
    eventDefMutationAppliers: [],
    dateSelectionTransformers: [],
    datePointTransforms: [],
    dateSpanTransforms: [],
    views: {},
    viewPropsTransformers: [],
    isPropsValid: null,
    externalDefTransforms: [],
    viewContainerAppends: [],
    eventDropTransformers: [],
    componentInteractions: [],
    calendarInteractions: [],
    themeClasses: {},
    eventSourceDefs: [],
    cmdFormatter: null,
    recurringTypes: [],
    namedTimeZonedImpl: null,
    initialView: "",
    elementDraggingImpl: null,
    optionChangeHandlers: {},
    scrollGridImpl: null,
    listenerRefiners: {},
    optionRefiners: {},
    propSetHandlers: {}
  };
  function r(s) {
    for (let a of s) {
      const l = a.name, o = n[l];
      o === void 0 ? (n[l] = a.id, r(a.deps), i = qc(i, a)) : o !== a.id && console.warn(`Duplicate plugin '${l}'`);
    }
  }
  return t && r(t), r(e), i;
}
function Yc() {
  let t = [], e = [], n;
  return (i, r) => ((!n || !ue(i, t) || !ue(r, e)) && (n = Gc(i, r)), t = i, e = r, n);
}
function qc(t, e) {
  return {
    premiumReleaseDate: Qc(t.premiumReleaseDate, e.premiumReleaseDate),
    reducers: t.reducers.concat(e.reducers),
    isLoadingFuncs: t.isLoadingFuncs.concat(e.isLoadingFuncs),
    contextInit: t.contextInit.concat(e.contextInit),
    eventRefiners: Object.assign(Object.assign({}, t.eventRefiners), e.eventRefiners),
    eventDefMemberAdders: t.eventDefMemberAdders.concat(e.eventDefMemberAdders),
    eventSourceRefiners: Object.assign(Object.assign({}, t.eventSourceRefiners), e.eventSourceRefiners),
    isDraggableTransformers: t.isDraggableTransformers.concat(e.isDraggableTransformers),
    eventDragMutationMassagers: t.eventDragMutationMassagers.concat(e.eventDragMutationMassagers),
    eventDefMutationAppliers: t.eventDefMutationAppliers.concat(e.eventDefMutationAppliers),
    dateSelectionTransformers: t.dateSelectionTransformers.concat(e.dateSelectionTransformers),
    datePointTransforms: t.datePointTransforms.concat(e.datePointTransforms),
    dateSpanTransforms: t.dateSpanTransforms.concat(e.dateSpanTransforms),
    views: Object.assign(Object.assign({}, t.views), e.views),
    viewPropsTransformers: t.viewPropsTransformers.concat(e.viewPropsTransformers),
    isPropsValid: e.isPropsValid || t.isPropsValid,
    externalDefTransforms: t.externalDefTransforms.concat(e.externalDefTransforms),
    viewContainerAppends: t.viewContainerAppends.concat(e.viewContainerAppends),
    eventDropTransformers: t.eventDropTransformers.concat(e.eventDropTransformers),
    calendarInteractions: t.calendarInteractions.concat(e.calendarInteractions),
    componentInteractions: t.componentInteractions.concat(e.componentInteractions),
    themeClasses: Object.assign(Object.assign({}, t.themeClasses), e.themeClasses),
    eventSourceDefs: t.eventSourceDefs.concat(e.eventSourceDefs),
    cmdFormatter: e.cmdFormatter || t.cmdFormatter,
    recurringTypes: t.recurringTypes.concat(e.recurringTypes),
    namedTimeZonedImpl: e.namedTimeZonedImpl || t.namedTimeZonedImpl,
    initialView: t.initialView || e.initialView,
    elementDraggingImpl: t.elementDraggingImpl || e.elementDraggingImpl,
    optionChangeHandlers: Object.assign(Object.assign({}, t.optionChangeHandlers), e.optionChangeHandlers),
    scrollGridImpl: e.scrollGridImpl || t.scrollGridImpl,
    listenerRefiners: Object.assign(Object.assign({}, t.listenerRefiners), e.listenerRefiners),
    optionRefiners: Object.assign(Object.assign({}, t.optionRefiners), e.optionRefiners),
    propSetHandlers: Object.assign(Object.assign({}, t.propSetHandlers), e.propSetHandlers)
  };
}
function Qc(t, e) {
  return t === void 0 ? e : e === void 0 ? t : new Date(Math.max(t.valueOf(), e.valueOf()));
}
class he extends je {
}
he.prototype.classes = {
  root: "fc-theme-standard",
  tableCellShaded: "fc-cell-shaded",
  buttonGroup: "fc-button-group",
  button: "fc-button fc-button-primary",
  buttonActive: "fc-button-active"
};
he.prototype.baseIconClass = "fc-icon";
he.prototype.iconClasses = {
  close: "fc-icon-x",
  prev: "fc-icon-chevron-left",
  next: "fc-icon-chevron-right",
  prevYear: "fc-icon-chevrons-left",
  nextYear: "fc-icon-chevrons-right"
};
he.prototype.rtlIconClasses = {
  prev: "fc-icon-chevron-right",
  next: "fc-icon-chevron-left",
  prevYear: "fc-icon-chevrons-right",
  nextYear: "fc-icon-chevrons-left"
};
he.prototype.iconOverrideOption = "buttonIcons";
he.prototype.iconOverrideCustomButtonOption = "icon";
he.prototype.iconOverridePrefix = "fc-icon-";
function $c(t, e) {
  let n = {}, i;
  for (i in t)
    fn(i, n, t, e);
  for (i in e)
    fn(i, n, t, e);
  return n;
}
function fn(t, e, n, i) {
  if (e[t])
    return e[t];
  let r = Zc(t, e, n, i);
  return r && (e[t] = r), r;
}
function Zc(t, e, n, i) {
  let r = n[t], s = i[t], a = (c) => r && r[c] !== null ? r[c] : s && s[c] !== null ? s[c] : null, l = a("component"), o = a("superType"), d = null;
  if (o) {
    if (o === t)
      throw new Error("Can't have a custom view type that references itself");
    d = fn(o, e, n, i);
  }
  return !l && d && (l = d.component), l ? {
    type: t,
    component: l,
    defaults: Object.assign(Object.assign({}, d ? d.defaults : {}), r ? r.rawOptions : {}),
    overrides: Object.assign(Object.assign({}, d ? d.overrides : {}), s ? s.rawOptions : {})
  } : null;
}
function Vi(t) {
  return ne(t, Xc);
}
function Xc(t) {
  let e = typeof t == "function" ? { component: t } : t, { component: n } = e;
  return e.content ? n = Gi(e) : n && !(n.prototype instanceof I) && (n = Gi(Object.assign(Object.assign({}, e), { content: n }))), {
    superType: e.type,
    component: n,
    rawOptions: e
    // includes type and component too :(
  };
}
function Gi(t) {
  return (e) => p(re.Consumer, null, (n) => p(q, { elTag: "div", elClasses: Ds(n.viewSpec), renderProps: Object.assign(Object.assign({}, e), { nextDayThreshold: n.options.nextDayThreshold }), generatorName: void 0, customGenerator: t.content, classNameGenerator: t.classNames, didMount: t.didMount, willUnmount: t.willUnmount }));
}
function Jc(t, e, n, i) {
  let r = Vi(t), s = Vi(e.views), a = $c(r, s);
  return ne(a, (l) => Kc(l, s, e, n, i));
}
function Kc(t, e, n, i, r) {
  let s = t.overrides.duration || t.defaults.duration || i.duration || n.duration, a = null, l = "", o = "", d = {};
  if (s && (a = ed(s), a)) {
    let f = rn(a);
    l = f.unit, f.value === 1 && (o = l, d = e[l] ? e[l].rawOptions : {});
  }
  let c = (f) => {
    let u = f.buttonText || {}, v = t.defaults.buttonTextKey;
    return v != null && u[v] != null ? u[v] : u[t.type] != null ? u[t.type] : u[o] != null ? u[o] : null;
  }, h = (f) => {
    let u = f.buttonHints || {}, v = t.defaults.buttonTextKey;
    return v != null && u[v] != null ? u[v] : u[t.type] != null ? u[t.type] : u[o] != null ? u[o] : null;
  };
  return {
    type: t.type,
    component: t.component,
    duration: a,
    durationUnit: l,
    singleUnit: o,
    optionDefaults: t.defaults,
    optionOverrides: Object.assign(Object.assign({}, d), t.overrides),
    buttonTextOverride: c(i) || c(n) || // constructor-specified buttonText lookup hash takes precedence
    t.overrides.buttonText,
    buttonTextDefault: c(r) || t.defaults.buttonText || c(Be) || t.type,
    // not DRY
    buttonTitleOverride: h(i) || h(n) || t.overrides.buttonHint,
    buttonTitleDefault: h(r) || t.defaults.buttonHint || h(Be)
    // will eventually fall back to buttonText
  };
}
let Yi = {};
function ed(t) {
  let e = JSON.stringify(t), n = Yi[e];
  return n === void 0 && (n = k(t), Yi[e] = n), n;
}
function td(t, e) {
  switch (e.type) {
    case "CHANGE_VIEW_TYPE":
      t = e.viewType;
  }
  return t;
}
function nd(t, e) {
  switch (e.type) {
    case "SET_OPTION":
      return Object.assign(Object.assign({}, t), { [e.optionName]: e.rawOptionValue });
    default:
      return t;
  }
}
function id(t, e, n, i) {
  let r;
  switch (e.type) {
    case "CHANGE_VIEW_TYPE":
      return i.build(e.dateMarker || n);
    case "CHANGE_DATE":
      return i.build(e.dateMarker);
    case "PREV":
      if (r = i.buildPrev(t, n), r.isValid)
        return r;
      break;
    case "NEXT":
      if (r = i.buildNext(t, n), r.isValid)
        return r;
      break;
  }
  return t;
}
function rd(t, e, n) {
  let i = e ? e.activeRange : null;
  return Os({}, ud(t, n), i, n);
}
function sd(t, e, n, i) {
  let r = n ? n.activeRange : null;
  switch (e.type) {
    case "ADD_EVENT_SOURCES":
      return Os(t, e.sources, r, i);
    case "REMOVE_EVENT_SOURCE":
      return ld(t, e.sourceId);
    case "PREV":
    case "NEXT":
    case "CHANGE_DATE":
    case "CHANGE_VIEW_TYPE":
      return n ? Ns(t, r, i) : t;
    case "FETCH_EVENT_SOURCES":
      return Zn(t, e.sourceIds ? (
        // why no type?
        kr(e.sourceIds)
      ) : Ps(t, i), r, e.isRefetch || !1, i);
    case "RECEIVE_EVENTS":
    case "RECEIVE_EVENT_ERROR":
      return dd(t, e.sourceId, e.fetchId, e.fetchRange);
    case "REMOVE_ALL_EVENT_SOURCES":
      return {};
    default:
      return t;
  }
}
function ad(t, e, n) {
  let i = e ? e.activeRange : null;
  return Zn(t, Ps(t, n), i, !0, n);
}
function Is(t) {
  for (let e in t)
    if (t[e].isFetching)
      return !0;
  return !1;
}
function Os(t, e, n, i) {
  let r = {};
  for (let s of e)
    r[s.sourceId] = s;
  return n && (r = Ns(r, n, i)), Object.assign(Object.assign({}, t), r);
}
function ld(t, e) {
  return be(t, (n) => n.sourceId !== e);
}
function Ns(t, e, n) {
  return Zn(t, be(t, (i) => od(i, e, n)), e, !1, n);
}
function od(t, e, n) {
  return Hs(t, n) ? !n.options.lazyFetching || !t.fetchRange || t.isFetching || // always cancel outdated in-progress fetches
  e.start < t.fetchRange.start || e.end > t.fetchRange.end : !t.latestFetchId;
}
function Zn(t, e, n, i, r) {
  let s = {};
  for (let a in t) {
    let l = t[a];
    e[a] ? s[a] = cd(l, n, i, r) : s[a] = l;
  }
  return s;
}
function cd(t, e, n, i) {
  let { options: r, calendarApi: s } = i, a = i.pluginHooks.eventSourceDefs[t.sourceDefId], l = we();
  return a.fetch({
    eventSource: t,
    range: e,
    isRefetch: n,
    context: i
  }, (o) => {
    let { rawEvents: d } = o;
    r.eventSourceSuccess && (d = r.eventSourceSuccess.call(s, d, o.response) || d), t.success && (d = t.success.call(s, d, o.response) || d), i.dispatch({
      type: "RECEIVE_EVENTS",
      sourceId: t.sourceId,
      fetchId: l,
      fetchRange: e,
      rawEvents: d
    });
  }, (o) => {
    let d = !1;
    r.eventSourceFailure && (r.eventSourceFailure.call(s, o), d = !0), t.failure && (t.failure(o), d = !0), d || console.warn(o.message, o), i.dispatch({
      type: "RECEIVE_EVENT_ERROR",
      sourceId: t.sourceId,
      fetchId: l,
      fetchRange: e,
      error: o
    });
  }), Object.assign(Object.assign({}, t), { isFetching: !0, latestFetchId: l });
}
function dd(t, e, n, i) {
  let r = t[e];
  return r && // not already removed
  n === r.latestFetchId ? Object.assign(Object.assign({}, t), { [e]: Object.assign(Object.assign({}, r), { isFetching: !1, fetchRange: i }) }) : t;
}
function Ps(t, e) {
  return be(t, (n) => Hs(n, e));
}
function ud(t, e) {
  let n = Ts(e), i = [].concat(t.eventSources || []), r = [];
  t.initialEvents && i.unshift(t.initialEvents), t.events && i.unshift(t.events);
  for (let s of i) {
    let a = As(s, e, n);
    a && r.push(a);
  }
  return r;
}
function Hs(t, e) {
  return !e.pluginHooks.eventSourceDefs[t.sourceDefId].ignoreRange;
}
function fd(t, e) {
  switch (e.type) {
    case "UNSELECT_DATES":
      return null;
    case "SELECT_DATES":
      return e.selection;
    default:
      return t;
  }
}
function hd(t, e) {
  switch (e.type) {
    case "UNSELECT_EVENT":
      return "";
    case "SELECT_EVENT":
      return e.eventInstanceId;
    default:
      return t;
  }
}
function pd(t, e) {
  let n;
  switch (e.type) {
    case "UNSET_EVENT_DRAG":
      return null;
    case "SET_EVENT_DRAG":
      return n = e.state, {
        affectedEvents: n.affectedEvents,
        mutatedEvents: n.mutatedEvents,
        isEvent: n.isEvent
      };
    default:
      return t;
  }
}
function gd(t, e) {
  let n;
  switch (e.type) {
    case "UNSET_EVENT_RESIZE":
      return null;
    case "SET_EVENT_RESIZE":
      return n = e.state, {
        affectedEvents: n.affectedEvents,
        mutatedEvents: n.mutatedEvents,
        isEvent: n.isEvent
      };
    default:
      return t;
  }
}
function md(t, e, n, i, r) {
  let s = t.headerToolbar ? qi(t.headerToolbar, t, e, n, i, r) : null, a = t.footerToolbar ? qi(t.footerToolbar, t, e, n, i, r) : null;
  return { header: s, footer: a };
}
function qi(t, e, n, i, r, s) {
  let a = {}, l = [], o = !1;
  for (let d in t) {
    let c = t[d], h = vd(c, e, n, i, r, s);
    a[d] = h.widgets, l.push(...h.viewsWithButtons), o = o || h.hasTitle;
  }
  return { sectionWidgets: a, viewsWithButtons: l, hasTitle: o };
}
function vd(t, e, n, i, r, s) {
  let a = e.direction === "rtl", l = e.customButtons || {}, o = n.buttonText || {}, d = e.buttonText || {}, c = n.buttonHints || {}, h = e.buttonHints || {}, f = t ? t.split(" ") : [], u = [], v = !1;
  return { widgets: f.map((b) => b.split(",").map((E) => {
    if (E === "title")
      return v = !0, { buttonName: E };
    let C, T, A, O, M, N;
    if (C = l[E])
      A = (x) => {
        C.click && C.click.call(x.target, x, x.target);
      }, (O = i.getCustomButtonIconClass(C)) || (O = i.getIconClass(E, a)) || (M = C.text), N = C.hint || C.text;
    else if (T = r[E]) {
      u.push(E), A = () => {
        s.changeView(E);
      }, (M = T.buttonTextOverride) || (O = i.getIconClass(E, a)) || (M = T.buttonTextDefault);
      let x = T.buttonTextOverride || T.buttonTextDefault;
      N = Le(
        T.buttonTitleOverride || T.buttonTitleDefault || e.viewHint,
        [x, E],
        // view-name = buttonName
        x
      );
    } else if (s[E])
      if (A = () => {
        s[E]();
      }, (M = o[E]) || (O = i.getIconClass(E, a)) || (M = d[E]), E === "prevYear" || E === "nextYear") {
        let x = E === "prevYear" ? "prev" : "next";
        N = Le(c[x] || h[x], [
          d.year || "year",
          "year"
        ], d[E]);
      } else
        N = (x) => Le(c[E] || h[E], [
          d[x] || x,
          x
        ], d[E]);
    return { buttonName: E, buttonClick: A, buttonIcon: O, buttonText: M, buttonHint: N };
  })), viewsWithButtons: u, hasTitle: v };
}
class yd {
  constructor(e, n, i) {
    this.type = e, this.getCurrentData = n, this.dateEnv = i;
  }
  get calendar() {
    return this.getCurrentData().calendarApi;
  }
  get title() {
    return this.getCurrentData().viewTitle;
  }
  get activeStart() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
  }
  get activeEnd() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
  }
  get currentStart() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
  }
  get currentEnd() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
  }
  getOption(e) {
    return this.getCurrentData().options[e];
  }
}
let bd = {
  ignoreRange: !0,
  parseMeta(t) {
    return Array.isArray(t.events) ? t.events : null;
  },
  fetch(t, e) {
    e({
      rawEvents: t.eventSource.meta
    });
  }
};
const Ed = se({
  name: "array-event-source",
  eventSourceDefs: [bd]
});
let _d = {
  parseMeta(t) {
    return typeof t.events == "function" ? t.events : null;
  },
  fetch(t, e, n) {
    const { dateEnv: i } = t.context, r = t.eventSource.meta;
    co(r.bind(null, Kr(t.range, i)), (s) => e({ rawEvents: s }), n);
  }
};
const wd = se({
  name: "func-event-source",
  eventSourceDefs: [_d]
}), Cd = {
  method: String,
  extraParams: m,
  startParam: String,
  endParam: String,
  timeZoneParam: String
};
let Sd = {
  parseMeta(t) {
    return t.url && (t.format === "json" || !t.format) ? {
      url: t.url,
      format: "json",
      method: (t.method || "GET").toUpperCase(),
      extraParams: t.extraParams,
      startParam: t.startParam,
      endParam: t.endParam,
      timeZoneParam: t.timeZoneParam
    } : null;
  },
  fetch(t, e, n) {
    const { meta: i } = t.eventSource, r = Ad(i, t.range, t.context);
    gc(i.method, i.url, r).then(([s, a]) => {
      e({ rawEvents: s, response: a });
    }, n);
  }
};
const Dd = se({
  name: "json-event-source",
  eventSourceRefiners: Cd,
  eventSourceDefs: [Sd]
});
function Ad(t, e, n) {
  let { dateEnv: i, options: r } = n, s, a, l, o, d = {};
  return s = t.startParam, s == null && (s = r.startParam), a = t.endParam, a == null && (a = r.endParam), l = t.timeZoneParam, l == null && (l = r.timeZoneParam), typeof t.extraParams == "function" ? o = t.extraParams() : o = t.extraParams || {}, Object.assign(d, o), d[s] = i.formatIso(e.start), d[a] = i.formatIso(e.end), i.timeZone !== "local" && (d[l] = i.timeZone), d;
}
const Td = {
  daysOfWeek: m,
  startTime: k,
  endTime: k,
  duration: k,
  startRecur: m,
  endRecur: m
};
let Rd = {
  parse(t, e) {
    if (t.daysOfWeek || t.startTime || t.endTime || t.startRecur || t.endRecur) {
      let n = {
        daysOfWeek: t.daysOfWeek || null,
        startTime: t.startTime || null,
        endTime: t.endTime || null,
        startRecur: t.startRecur ? e.createMarker(t.startRecur) : null,
        endRecur: t.endRecur ? e.createMarker(t.endRecur) : null
      }, i;
      return t.duration && (i = t.duration), !i && t.startTime && t.endTime && (i = Ya(t.endTime, t.startTime)), {
        allDayGuess: !t.startTime && !t.endTime,
        duration: i,
        typeData: n
        // doesn't need endTime anymore but oh well
      };
    }
    return null;
  },
  expand(t, e, n) {
    let i = _e(e, { start: t.startRecur, end: t.endRecur });
    return i ? kd(t.daysOfWeek, t.startTime, i, n) : [];
  }
};
const xd = se({
  name: "simple-recurring-event",
  recurringTypes: [Rd],
  eventRefiners: Td
});
function kd(t, e, n, i) {
  let r = t ? kr(t) : null, s = P(n.start), a = n.end, l = [];
  for (; s < a; ) {
    let o;
    (!r || r[s.getUTCDay()]) && (e ? o = i.add(s, e) : o = s, l.push(o)), s = F(s, 1);
  }
  return l;
}
const Md = se({
  name: "change-handler",
  optionChangeHandlers: {
    events(t, e) {
      Qi([t], e);
    },
    eventSources: Qi
  }
});
function Qi(t, e) {
  let n = An(e.getCurrentData().eventSources);
  if (n.length === 1 && t.length === 1 && Array.isArray(n[0]._raw) && Array.isArray(t[0])) {
    e.dispatch({
      type: "RESET_RAW_EVENTS",
      sourceId: n[0].sourceId,
      rawEvents: t[0]
    });
    return;
  }
  let i = [];
  for (let r of t) {
    let s = !1;
    for (let a = 0; a < n.length; a += 1)
      if (n[a]._raw === r) {
        n.splice(a, 1), s = !0;
        break;
      }
    s || i.push(r);
  }
  for (let r of n)
    e.dispatch({
      type: "REMOVE_EVENT_SOURCE",
      sourceId: r.sourceId
    });
  for (let r of i)
    e.calendarApi.addEventSource(r);
}
function Id(t, e) {
  e.emitter.trigger("datesSet", Object.assign(Object.assign({}, Kr(t.activeRange, e.dateEnv)), { view: e.viewApi }));
}
function Od(t, e) {
  let { emitter: n } = e;
  n.hasHandlers("eventsSet") && n.trigger("eventsSet", ve(t, e));
}
const Nd = [
  Ed,
  wd,
  Dd,
  xd,
  Md,
  se({
    name: "misc",
    isLoadingFuncs: [
      (t) => Is(t.eventSources)
    ],
    propSetHandlers: {
      dateProfile: Id,
      eventStore: Od
    }
  })
];
class Pd {
  constructor(e, n) {
    this.runTaskOption = e, this.drainedOption = n, this.queue = [], this.delayedRunner = new Vn(this.drain.bind(this));
  }
  request(e, n) {
    this.queue.push(e), this.delayedRunner.request(n);
  }
  pause(e) {
    this.delayedRunner.pause(e);
  }
  resume(e, n) {
    this.delayedRunner.resume(e, n);
  }
  drain() {
    let { queue: e } = this;
    for (; e.length; ) {
      let n = [], i;
      for (; i = e.shift(); )
        this.runTask(i), n.push(i);
      this.drained(n);
    }
  }
  runTask(e) {
    this.runTaskOption && this.runTaskOption(e);
  }
  drained(e) {
    this.drainedOption && this.drainedOption(e);
  }
}
function Hd(t, e, n) {
  let i;
  return /^(year|month)$/.test(t.currentRangeUnit) ? i = t.currentRange : i = t.activeRange, n.formatRange(i.start, i.end, B(e.titleFormat || Ld(t)), {
    isEndExclusive: t.isRangeAllDay,
    defaultSeparator: e.titleRangeSeparator
  });
}
function Ld(t) {
  let { currentRangeUnit: e } = t;
  if (e === "year")
    return { year: "numeric" };
  if (e === "month")
    return { year: "numeric", month: "long" };
  let n = pt(t.currentRange.start, t.currentRange.end);
  return n !== null && n > 1 ? { year: "numeric", month: "short", day: "numeric" } : { year: "numeric", month: "long", day: "numeric" };
}
class Bd {
  constructor(e) {
    this.computeCurrentViewData = D(this._computeCurrentViewData), this.organizeRawLocales = D(jc), this.buildLocale = D(ks), this.buildPluginHooks = Yc(), this.buildDateEnv = D(zd), this.buildTheme = D(Ud), this.parseToolbars = D(md), this.buildViewSpecs = D(Jc), this.buildDateProfileGenerator = lt(Fd), this.buildViewApi = D(jd), this.buildViewUiProps = lt(Gd), this.buildEventUiBySource = D(Wd, J), this.buildEventUiBases = D(Vd), this.parseContextBusinessHours = lt(Yd), this.buildTitle = D(Hd), this.emitter = new xt(), this.actionRunner = new Pd(this._handleAction.bind(this), this.updateData.bind(this)), this.currentCalendarOptionsInput = {}, this.currentCalendarOptionsRefined = {}, this.currentViewOptionsInput = {}, this.currentViewOptionsRefined = {}, this.currentCalendarOptionsRefiners = {}, this.optionsForRefining = [], this.optionsForHandling = [], this.getCurrentData = () => this.data, this.dispatch = (f) => {
      this.actionRunner.request(f);
    }, this.props = e, this.actionRunner.pause();
    let n = {}, i = this.computeOptionsData(e.optionOverrides, n, e.calendarApi), r = i.calendarOptions.initialView || i.pluginHooks.initialView, s = this.computeCurrentViewData(r, i, e.optionOverrides, n);
    e.calendarApi.currentDataManager = this, this.emitter.setThisContext(e.calendarApi), this.emitter.setOptions(s.options);
    let a = _o(i.calendarOptions, i.dateEnv), l = s.dateProfileGenerator.build(a);
    te(l.activeRange, a) || (a = l.currentRange.start);
    let o = {
      dateEnv: i.dateEnv,
      options: i.calendarOptions,
      pluginHooks: i.pluginHooks,
      calendarApi: e.calendarApi,
      dispatch: this.dispatch,
      emitter: this.emitter,
      getCurrentData: this.getCurrentData
    };
    for (let f of i.pluginHooks.contextInit)
      f(o);
    let d = rd(i.calendarOptions, l, o), c = {
      dynamicOptionOverrides: n,
      currentViewType: r,
      currentDate: a,
      dateProfile: l,
      businessHours: this.parseContextBusinessHours(o),
      eventSources: d,
      eventUiBases: {},
      eventStore: Y(),
      renderableEventStore: Y(),
      dateSelection: null,
      eventSelection: "",
      eventDrag: null,
      eventResize: null,
      selectionConfig: this.buildViewUiProps(o).selectionConfig
    }, h = Object.assign(Object.assign({}, o), c);
    for (let f of i.pluginHooks.reducers)
      Object.assign(c, f(null, null, h));
    Qt(c, o) && this.emitter.trigger("loading", !0), this.state = c, this.updateData(), this.actionRunner.resume();
  }
  resetOptions(e, n) {
    let { props: i } = this;
    n === void 0 ? i.optionOverrides = e : (i.optionOverrides = Object.assign(Object.assign({}, i.optionOverrides || {}), e), this.optionsForRefining.push(...n)), (n === void 0 || n.length) && this.actionRunner.request({
      type: "NOTHING"
    });
  }
  _handleAction(e) {
    let { props: n, state: i, emitter: r } = this, s = nd(i.dynamicOptionOverrides, e), a = this.computeOptionsData(n.optionOverrides, s, n.calendarApi), l = td(i.currentViewType, e), o = this.computeCurrentViewData(l, a, n.optionOverrides, s);
    n.calendarApi.currentDataManager = this, r.setThisContext(n.calendarApi), r.setOptions(o.options);
    let d = {
      dateEnv: a.dateEnv,
      options: a.calendarOptions,
      pluginHooks: a.pluginHooks,
      calendarApi: n.calendarApi,
      dispatch: this.dispatch,
      emitter: r,
      getCurrentData: this.getCurrentData
    }, { currentDate: c, dateProfile: h } = i;
    this.data && this.data.dateProfileGenerator !== o.dateProfileGenerator && (h = o.dateProfileGenerator.build(c)), c = Eo(c, e), h = id(h, e, c, o.dateProfileGenerator), (e.type === "PREV" || // TODO: move this logic into DateProfileGenerator
    e.type === "NEXT" || // "
    !te(h.currentRange, c)) && (c = h.currentRange.start);
    let f = sd(i.eventSources, e, h, d), u = ic(i.eventStore, e, f, h, d), y = Is(f) && !o.options.progressiveEventRendering && i.renderableEventStore || u, { eventUiSingleBase: b, selectionConfig: E } = this.buildViewUiProps(d), C = this.buildEventUiBySource(f), T = this.buildEventUiBases(y.defs, b, C), A = {
      dynamicOptionOverrides: s,
      currentViewType: l,
      currentDate: c,
      dateProfile: h,
      eventSources: f,
      eventStore: u,
      renderableEventStore: y,
      selectionConfig: E,
      eventUiBases: T,
      businessHours: this.parseContextBusinessHours(d),
      dateSelection: fd(i.dateSelection, e),
      eventSelection: hd(i.eventSelection, e),
      eventDrag: pd(i.eventDrag, e),
      eventResize: gd(i.eventResize, e)
    }, O = Object.assign(Object.assign({}, d), A);
    for (let x of a.pluginHooks.reducers)
      Object.assign(A, x(i, e, O));
    let M = Qt(i, d), N = Qt(A, d);
    !M && N ? r.trigger("loading", !0) : M && !N && r.trigger("loading", !1), this.state = A, n.onAction && n.onAction(e);
  }
  updateData() {
    let { props: e, state: n } = this, i = this.data, r = this.computeOptionsData(e.optionOverrides, n.dynamicOptionOverrides, e.calendarApi), s = this.computeCurrentViewData(n.currentViewType, r, e.optionOverrides, n.dynamicOptionOverrides), a = this.data = Object.assign(Object.assign(Object.assign({ viewTitle: this.buildTitle(n.dateProfile, s.options, r.dateEnv), calendarApi: e.calendarApi, dispatch: this.dispatch, emitter: this.emitter, getCurrentData: this.getCurrentData }, r), s), n), l = r.pluginHooks.optionChangeHandlers, o = i && i.calendarOptions, d = r.calendarOptions;
    if (o && o !== d) {
      o.timeZone !== d.timeZone && (n.eventSources = a.eventSources = ad(a.eventSources, n.dateProfile, a), n.eventStore = a.eventStore = Fi(a.eventStore, i.dateEnv, a.dateEnv), n.renderableEventStore = a.renderableEventStore = Fi(a.renderableEventStore, i.dateEnv, a.dateEnv));
      for (let c in l)
        (this.optionsForHandling.indexOf(c) !== -1 || o[c] !== d[c]) && l[c](d[c], a);
    }
    this.optionsForHandling = [], e.onData && e.onData(a);
  }
  computeOptionsData(e, n, i) {
    if (!this.optionsForRefining.length && e === this.stableOptionOverrides && n === this.stableDynamicOptionOverrides)
      return this.stableCalendarOptionsData;
    let { refinedOptions: r, pluginHooks: s, localeDefaults: a, availableLocaleData: l, extra: o } = this.processRawCalendarOptions(e, n);
    $i(o);
    let d = this.buildDateEnv(r.timeZone, r.locale, r.weekNumberCalculation, r.firstDay, r.weekText, s, l, r.defaultRangeSeparator), c = this.buildViewSpecs(s.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, a), h = this.buildTheme(r, s), f = this.parseToolbars(r, this.stableOptionOverrides, h, c, i);
    return this.stableCalendarOptionsData = {
      calendarOptions: r,
      pluginHooks: s,
      dateEnv: d,
      viewSpecs: c,
      theme: h,
      toolbarConfig: f,
      localeDefaults: a,
      availableRawLocales: l.map
    };
  }
  // always called from behind a memoizer
  processRawCalendarOptions(e, n) {
    let { locales: i, locale: r } = Ut([
      Be,
      e,
      n
    ]), s = this.organizeRawLocales(i), a = s.map, l = this.buildLocale(r || s.defaultCode, a).options, o = this.buildPluginHooks(e.plugins || [], Nd), d = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ki), Mi), Ii), o.listenerRefiners), o.optionRefiners), c = {}, h = Ut([
      Be,
      l,
      e,
      n
    ]), f = {}, u = this.currentCalendarOptionsInput, v = this.currentCalendarOptionsRefined, y = !1;
    for (let b in h)
      this.optionsForRefining.indexOf(b) === -1 && (h[b] === u[b] || pe[b] && b in u && pe[b](u[b], h[b])) ? f[b] = v[b] : d[b] ? (f[b] = d[b](h[b]), y = !0) : c[b] = u[b];
    return y && (this.currentCalendarOptionsInput = h, this.currentCalendarOptionsRefined = f, this.stableOptionOverrides = e, this.stableDynamicOptionOverrides = n), this.optionsForHandling.push(...this.optionsForRefining), this.optionsForRefining = [], {
      rawOptions: this.currentCalendarOptionsInput,
      refinedOptions: this.currentCalendarOptionsRefined,
      pluginHooks: o,
      availableLocaleData: s,
      localeDefaults: l,
      extra: c
    };
  }
  _computeCurrentViewData(e, n, i, r) {
    let s = n.viewSpecs[e];
    if (!s)
      throw new Error(`viewType "${e}" is not available. Please make sure you've loaded all neccessary plugins`);
    let { refinedOptions: a, extra: l } = this.processRawViewOptions(s, n.pluginHooks, n.localeDefaults, i, r);
    $i(l);
    let o = this.buildDateProfileGenerator({
      dateProfileGeneratorClass: s.optionDefaults.dateProfileGeneratorClass,
      duration: s.duration,
      durationUnit: s.durationUnit,
      usesMinMaxTime: s.optionDefaults.usesMinMaxTime,
      dateEnv: n.dateEnv,
      calendarApi: this.props.calendarApi,
      slotMinTime: a.slotMinTime,
      slotMaxTime: a.slotMaxTime,
      showNonCurrentDates: a.showNonCurrentDates,
      dayCount: a.dayCount,
      dateAlignment: a.dateAlignment,
      dateIncrement: a.dateIncrement,
      hiddenDays: a.hiddenDays,
      weekends: a.weekends,
      nowInput: a.now,
      validRangeInput: a.validRange,
      visibleRangeInput: a.visibleRange,
      fixedWeekCount: a.fixedWeekCount
    }), d = this.buildViewApi(e, this.getCurrentData, n.dateEnv);
    return { viewSpec: s, options: a, dateProfileGenerator: o, viewApi: d };
  }
  processRawViewOptions(e, n, i, r, s) {
    let a = Ut([
      Be,
      e.optionDefaults,
      i,
      r,
      e.optionOverrides,
      s
    ]), l = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ki), Mi), Ii), xl), n.listenerRefiners), n.optionRefiners), o = {}, d = this.currentViewOptionsInput, c = this.currentViewOptionsRefined, h = !1, f = {};
    for (let u in a)
      a[u] === d[u] || pe[u] && pe[u](a[u], d[u]) ? o[u] = c[u] : (a[u] === this.currentCalendarOptionsInput[u] || pe[u] && pe[u](a[u], this.currentCalendarOptionsInput[u]) ? u in this.currentCalendarOptionsRefined && (o[u] = this.currentCalendarOptionsRefined[u]) : l[u] ? o[u] = l[u](a[u]) : f[u] = a[u], h = !0);
    return h && (this.currentViewOptionsInput = a, this.currentViewOptionsRefined = o), {
      rawOptions: this.currentViewOptionsInput,
      refinedOptions: this.currentViewOptionsRefined,
      extra: f
    };
  }
}
function zd(t, e, n, i, r, s, a, l) {
  let o = ks(e || a.defaultCode, a.map);
  return new Wo({
    calendarSystem: "gregory",
    timeZone: t,
    namedTimeZoneImpl: s.namedTimeZonedImpl,
    locale: o,
    weekNumberCalculation: n,
    firstDay: i,
    weekText: r,
    cmdFormatter: s.cmdFormatter,
    defaultSeparator: l
  });
}
function Ud(t, e) {
  let n = e.themeClasses[t.themeSystem] || he;
  return new n(t);
}
function Fd(t) {
  let e = t.dateProfileGeneratorClass || Gr;
  return new e(t);
}
function jd(t, e, n) {
  return new yd(t, e, n);
}
function Wd(t) {
  return ne(t, (e) => e.ui);
}
function Vd(t, e, n) {
  let i = { "": e };
  for (let r in t) {
    let s = t[r];
    s.sourceId && n[s.sourceId] && (i[r] = n[s.sourceId]);
  }
  return i;
}
function Gd(t) {
  let { options: e } = t;
  return {
    eventUiSingleBase: yt({
      display: e.eventDisplay,
      editable: e.editable,
      startEditable: e.eventStartEditable,
      durationEditable: e.eventDurationEditable,
      constraint: e.eventConstraint,
      overlap: typeof e.eventOverlap == "boolean" ? e.eventOverlap : void 0,
      allow: e.eventAllow,
      backgroundColor: e.eventBackgroundColor,
      borderColor: e.eventBorderColor,
      textColor: e.eventTextColor,
      color: e.eventColor
      // classNames: options.eventClassNames // render hook will handle this
    }, t),
    selectionConfig: yt({
      constraint: e.selectConstraint,
      overlap: typeof e.selectOverlap == "boolean" ? e.selectOverlap : void 0,
      allow: e.selectAllow
    }, t)
  };
}
function Qt(t, e) {
  for (let n of e.pluginHooks.isLoadingFuncs)
    if (n(t))
      return !0;
  return !1;
}
function Yd(t) {
  return Fl(t.options.businessHours, t);
}
function $i(t, e) {
  for (let n in t)
    console.warn(`Unknown option '${n}'` + (e ? ` for view '${e}'` : ""));
}
class qd extends I {
  render() {
    let e = this.props.widgetGroups.map((n) => this.renderWidgetGroup(n));
    return p("div", { className: "fc-toolbar-chunk" }, ...e);
  }
  renderWidgetGroup(e) {
    let { props: n } = this, { theme: i } = this.context, r = [], s = !0;
    for (let a of e) {
      let { buttonName: l, buttonClick: o, buttonText: d, buttonIcon: c, buttonHint: h } = a;
      if (l === "title")
        s = !1, r.push(p("h2", { className: "fc-toolbar-title", id: n.titleId }, n.title));
      else {
        let f = l === n.activeButton, u = !n.isTodayEnabled && l === "today" || !n.isPrevEnabled && l === "prev" || !n.isNextEnabled && l === "next", v = [`fc-${l}-button`, i.getClass("button")];
        f && v.push(i.getClass("buttonActive")), r.push(p("button", { type: "button", title: typeof h == "function" ? h(n.navUnit) : h, disabled: u, "aria-pressed": f, className: v.join(" "), onClick: o }, d || (c ? p("span", { className: c }) : "")));
      }
    }
    if (r.length > 1) {
      let a = s && i.getClass("buttonGroup") || "";
      return p("div", { className: a }, ...r);
    }
    return r[0];
  }
}
class Zi extends I {
  render() {
    let { model: e, extraClassName: n } = this.props, i = !1, r, s, a = e.sectionWidgets, l = a.center;
    return a.left ? (i = !0, r = a.left) : r = a.start, a.right ? (i = !0, s = a.right) : s = a.end, p(
      "div",
      { className: [
        n || "",
        "fc-toolbar",
        i ? "fc-toolbar-ltr" : ""
      ].join(" ") },
      this.renderSection("start", r || []),
      this.renderSection("center", l || []),
      this.renderSection("end", s || [])
    );
  }
  renderSection(e, n) {
    let { props: i } = this;
    return p(qd, { key: e, widgetGroups: n, title: i.title, navUnit: i.navUnit, activeButton: i.activeButton, isTodayEnabled: i.isTodayEnabled, isPrevEnabled: i.isPrevEnabled, isNextEnabled: i.isNextEnabled, titleId: i.titleId });
  }
}
class Qd extends I {
  constructor() {
    super(...arguments), this.state = {
      availableWidth: null
    }, this.handleEl = (e) => {
      this.el = e, ie(this.props.elRef, e), this.updateAvailableWidth();
    }, this.handleResize = () => {
      this.updateAvailableWidth();
    };
  }
  render() {
    let { props: e, state: n } = this, { aspectRatio: i } = e, r = [
      "fc-view-harness",
      i || e.liquid || e.height ? "fc-view-harness-active" : "fc-view-harness-passive"
      // let the view do the height
    ], s = "", a = "";
    return i ? n.availableWidth !== null ? s = n.availableWidth / i : a = `${1 / i * 100}%` : s = e.height || "", p("div", { "aria-labelledby": e.labeledById, ref: this.handleEl, className: r.join(" "), style: { height: s, paddingBottom: a } }, e.children);
  }
  componentDidMount() {
    this.context.addResizeHandler(this.handleResize);
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleResize);
  }
  updateAvailableWidth() {
    this.el && // needed. but why?
    this.props.aspectRatio && this.setState({ availableWidth: this.el.offsetWidth });
  }
}
class $d extends Oe {
  constructor(e) {
    super(e), this.handleSegClick = (n, i) => {
      let { component: r } = this, { context: s } = r, a = Ie(i);
      if (a && // might be the <div> surrounding the more link
      r.isValidSegDownEl(n.target)) {
        let l = U(n.target, ".fc-event-forced-url"), o = l ? l.querySelector("a[href]").href : "";
        s.emitter.trigger("eventClick", {
          el: i,
          event: new L(r.context, a.eventRange.def, a.eventRange.instance),
          jsEvent: n,
          view: s.viewApi
        }), o && !n.defaultPrevented && (window.location.href = o);
      }
    }, this.destroy = Tr(
      e.el,
      "click",
      ".fc-event",
      // on both fg and bg events
      this.handleSegClick
    );
  }
}
class Zd extends Oe {
  constructor(e) {
    super(e), this.handleEventElRemove = (n) => {
      n === this.currentSegEl && this.handleSegLeave(null, this.currentSegEl);
    }, this.handleSegEnter = (n, i) => {
      Ie(i) && (this.currentSegEl = i, this.triggerEvent("eventMouseEnter", n, i));
    }, this.handleSegLeave = (n, i) => {
      this.currentSegEl && (this.currentSegEl = null, this.triggerEvent("eventMouseLeave", n, i));
    }, this.removeHoverListeners = Ma(
      e.el,
      ".fc-event",
      // on both fg and bg events
      this.handleSegEnter,
      this.handleSegLeave
    );
  }
  destroy() {
    this.removeHoverListeners();
  }
  triggerEvent(e, n, i) {
    let { component: r } = this, { context: s } = r, a = Ie(i);
    (!n || r.isValidSegDownEl(n.target)) && s.emitter.trigger(e, {
      el: i,
      event: new L(s, a.eventRange.def, a.eventRange.instance),
      jsEvent: n,
      view: s.viewApi
    });
  }
}
class Xd extends Se {
  constructor() {
    super(...arguments), this.buildViewContext = D(vo), this.buildViewPropTransformers = D(Kd), this.buildToolbarProps = D(Jd), this.headerRef = j(), this.footerRef = j(), this.interactionsStore = {}, this.state = {
      viewLabelId: Dt()
    }, this.registerInteractiveComponent = (e, n) => {
      let i = Yo(e, n), a = [
        $d,
        Zd
      ].concat(this.props.pluginHooks.componentInteractions).map((l) => new l(i));
      this.interactionsStore[e.uid] = a, dn[e.uid] = i;
    }, this.unregisterInteractiveComponent = (e) => {
      let n = this.interactionsStore[e.uid];
      if (n) {
        for (let i of n)
          i.destroy();
        delete this.interactionsStore[e.uid];
      }
      delete dn[e.uid];
    }, this.resizeRunner = new Vn(() => {
      this.props.emitter.trigger("_resize", !0), this.props.emitter.trigger("windowResize", { view: this.props.viewApi });
    }), this.handleWindowResize = (e) => {
      let { options: n } = this.props;
      n.handleWindowResize && e.target === window && this.resizeRunner.request(n.windowResizeDelay);
    };
  }
  /*
  renders INSIDE of an outer div
  */
  render() {
    let { props: e } = this, { toolbarConfig: n, options: i } = e, r = this.buildToolbarProps(
      e.viewSpec,
      e.dateProfile,
      e.dateProfileGenerator,
      e.currentDate,
      We(e.options.now, e.dateEnv),
      // TODO: use NowTimer????
      e.viewTitle
    ), s = !1, a = "", l;
    e.isHeightAuto || e.forPrint ? a = "" : i.height != null ? s = !0 : i.contentHeight != null ? a = i.contentHeight : l = Math.max(i.aspectRatio, 0.5);
    let o = this.buildViewContext(e.viewSpec, e.viewApi, e.options, e.dateProfileGenerator, e.dateEnv, e.theme, e.pluginHooks, e.dispatch, e.getCurrentData, e.emitter, e.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent), d = n.header && n.header.hasTitle ? this.state.viewLabelId : "";
    return p(
      re.Provider,
      { value: o },
      n.header && p(Zi, Object.assign({ ref: this.headerRef, extraClassName: "fc-header-toolbar", model: n.header, titleId: d }, r)),
      p(
        Qd,
        { liquid: s, height: a, aspectRatio: l, labeledById: d },
        this.renderView(e),
        this.buildAppendContent()
      ),
      n.footer && p(Zi, Object.assign({ ref: this.footerRef, extraClassName: "fc-footer-toolbar", model: n.footer, titleId: "" }, r))
    );
  }
  componentDidMount() {
    let { props: e } = this;
    this.calendarInteractions = e.pluginHooks.calendarInteractions.map((i) => new i(e)), window.addEventListener("resize", this.handleWindowResize);
    let { propSetHandlers: n } = e.pluginHooks;
    for (let i in n)
      n[i](e[i], e);
  }
  componentDidUpdate(e) {
    let { props: n } = this, { propSetHandlers: i } = n.pluginHooks;
    for (let r in i)
      n[r] !== e[r] && i[r](n[r], n);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize), this.resizeRunner.clear();
    for (let e of this.calendarInteractions)
      e.destroy();
    this.props.emitter.trigger("_unmount");
  }
  buildAppendContent() {
    let { props: e } = this, n = e.pluginHooks.viewContainerAppends.map((i) => i(e));
    return p(H, {}, ...n);
  }
  renderView(e) {
    let { pluginHooks: n } = e, { viewSpec: i } = e, r = {
      dateProfile: e.dateProfile,
      businessHours: e.businessHours,
      eventStore: e.renderableEventStore,
      eventUiBases: e.eventUiBases,
      dateSelection: e.dateSelection,
      eventSelection: e.eventSelection,
      eventDrag: e.eventDrag,
      eventResize: e.eventResize,
      isHeightAuto: e.isHeightAuto,
      forPrint: e.forPrint
    }, s = this.buildViewPropTransformers(n.viewPropsTransformers);
    for (let l of s)
      Object.assign(r, l.transform(r, e));
    let a = i.component;
    return p(a, Object.assign({}, r));
  }
}
function Jd(t, e, n, i, r, s) {
  let a = n.build(r, void 0, !1), l = n.buildPrev(e, i, !1), o = n.buildNext(e, i, !1);
  return {
    title: s,
    activeButton: t.type,
    navUnit: t.singleUnit,
    isTodayEnabled: a.isValid && !te(e.currentRange, r),
    isPrevEnabled: l.isValid,
    isNextEnabled: o.isValid
  };
}
function Kd(t) {
  return t.map((e) => new e());
}
class eu extends Uc {
  constructor(e, n = {}) {
    super(), this.isRendering = !1, this.isRendered = !1, this.currentClassNames = [], this.customContentRenderId = 0, this.handleAction = (i) => {
      switch (i.type) {
        case "SET_EVENT_DRAG":
        case "SET_EVENT_RESIZE":
          this.renderRunner.tryDrain();
      }
    }, this.handleData = (i) => {
      this.currentData = i, this.renderRunner.request(i.calendarOptions.rerenderDelay);
    }, this.handleRenderRequest = () => {
      if (this.isRendering) {
        this.isRendered = !0;
        let { currentData: i } = this;
        Pi(() => {
          Ue(p(Qo, { options: i.calendarOptions, theme: i.theme, emitter: i.emitter }, (r, s, a, l) => (this.setClassNames(r), this.setHeight(s), p(
            ls.Provider,
            { value: this.customContentRenderId },
            p(Xd, Object.assign({ isHeightAuto: a, forPrint: l }, i))
          ))), this.el);
        });
      } else
        this.isRendered && (this.isRendered = !1, Ue(null, this.el), this.setClassNames([]), this.setHeight(""));
    }, wa(e), this.el = e, this.renderRunner = new Vn(this.handleRenderRequest), new Bd({
      optionOverrides: n,
      calendarApi: this,
      onAction: this.handleAction,
      onData: this.handleData
    });
  }
  render() {
    let e = this.isRendering;
    e ? this.customContentRenderId += 1 : this.isRendering = !0, this.renderRunner.request(), e && this.updateSize();
  }
  destroy() {
    this.isRendering && (this.isRendering = !1, this.renderRunner.request());
  }
  updateSize() {
    Pi(() => {
      super.updateSize();
    });
  }
  batchRendering(e) {
    this.renderRunner.pause("batchRendering"), e(), this.renderRunner.resume("batchRendering");
  }
  pauseRendering() {
    this.renderRunner.pause("pauseRendering");
  }
  resumeRendering() {
    this.renderRunner.resume("pauseRendering", !0);
  }
  resetOptions(e, n) {
    this.currentDataManager.resetOptions(e, n);
  }
  setClassNames(e) {
    if (!ue(e, this.currentClassNames)) {
      let { classList: n } = this.el;
      for (let i of this.currentClassNames)
        n.remove(i);
      for (let i of e)
        n.add(i);
      this.currentClassNames = e;
    }
  }
  setHeight(e) {
    Dr(this.el, "height", e);
  }
}
var tu = ':root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:"";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:"";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}';
En(tu);
function tt(t, e) {
  let n = [];
  for (let i = 0; i < e; i += 1)
    n[i] = [];
  for (let i of t)
    n[i.row].push(i);
  return n;
}
function nt(t, e) {
  let n = [];
  for (let i = 0; i < e; i += 1)
    n[i] = [];
  for (let i of t)
    n[i.firstCol].push(i);
  return n;
}
function Xi(t, e) {
  let n = [];
  if (t) {
    for (let i = 0; i < e; i += 1)
      n[i] = {
        affectedInstances: t.affectedInstances,
        isEvent: t.isEvent,
        segs: []
      };
    for (let i of t.segs)
      n[i.row].segs.push(i);
  } else
    for (let i = 0; i < e; i += 1)
      n[i] = null;
  return n;
}
const Ls = B({
  hour: "numeric",
  minute: "2-digit",
  omitZeroMinute: !0,
  meridiem: "narrow"
});
function Bs(t) {
  let { display: e } = t.eventRange.ui;
  return e === "list-item" || e === "auto" && !t.eventRange.def.allDay && t.firstCol === t.lastCol && // can't be multi-day
  t.isStart && // "
  t.isEnd;
}
class zs extends I {
  render() {
    let { props: e } = this;
    return p(bs, Object.assign({}, e, { elClasses: ["fc-daygrid-event", "fc-daygrid-block-event", "fc-h-event"], defaultTimeFormat: Ls, defaultDisplayEventEnd: e.defaultDisplayEventEnd, disableResizing: !e.seg.eventRange.def.allDay }));
  }
}
class Us extends I {
  render() {
    let { props: e, context: n } = this, { options: i } = n, { seg: r } = e, s = i.eventTimeFormat || Ls, a = Zr(r, s, n, !0, e.defaultDisplayEventEnd);
    return p(Yn, Object.assign({}, e, { elTag: "a", elClasses: ["fc-daygrid-event", "fc-daygrid-dot-event"], elAttrs: Jr(e.seg, n), defaultGenerator: nu, timeText: a, isResizing: !1, isDateSelecting: !1 }));
  }
}
function nu(t) {
  return p(
    H,
    null,
    p("div", { className: "fc-daygrid-event-dot", style: { borderColor: t.borderColor || t.backgroundColor } }),
    t.timeText && p("div", { className: "fc-event-time" }, t.timeText),
    p("div", { className: "fc-event-title" }, t.event.title || p(H, null, " "))
  );
}
class iu extends I {
  constructor() {
    super(...arguments), this.compileSegs = D(ru);
  }
  render() {
    let { props: e } = this, { allSegs: n, invisibleSegs: i } = this.compileSegs(e.singlePlacements);
    return p(Cs, { elClasses: ["fc-daygrid-more-link"], dateProfile: e.dateProfile, todayRange: e.todayRange, allDayDate: e.allDayDate, moreCnt: e.moreCnt, allSegs: n, hiddenSegs: i, alignmentElRef: e.alignmentElRef, alignGridTop: e.alignGridTop, extraDateSpan: e.extraDateSpan, popoverContent: () => {
      let r = (e.eventDrag ? e.eventDrag.affectedInstances : null) || (e.eventResize ? e.eventResize.affectedInstances : null) || {};
      return p(H, null, n.map((s) => {
        let a = s.eventRange.instance.instanceId;
        return p("div", { className: "fc-daygrid-event-harness", key: a, style: {
          visibility: r[a] ? "hidden" : ""
        } }, Bs(s) ? p(Us, Object.assign({ seg: s, isDragging: !1, isSelected: a === e.eventSelection, defaultDisplayEventEnd: !1 }, de(s, e.todayRange))) : p(zs, Object.assign({ seg: s, isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: a === e.eventSelection, defaultDisplayEventEnd: !1 }, de(s, e.todayRange))));
      }));
    } });
  }
}
function ru(t) {
  let e = [], n = [];
  for (let i of t)
    e.push(i.seg), i.isVisible || n.push(i.seg);
  return { allSegs: e, invisibleSegs: n };
}
const su = B({ week: "narrow" });
class au extends K {
  constructor() {
    super(...arguments), this.rootElRef = j(), this.state = {
      dayNumberId: Dt()
    }, this.handleRootEl = (e) => {
      ie(this.rootElRef, e), ie(this.props.elRef, e);
    };
  }
  render() {
    let { context: e, props: n, state: i, rootElRef: r } = this, { options: s, dateEnv: a } = e, { date: l, dateProfile: o } = n;
    const d = n.showDayNumber && ou(l, o.currentRange, a);
    return p(Qn, { elTag: "td", elRef: this.handleRootEl, elClasses: [
      "fc-daygrid-day",
      ...n.extraClassNames || []
    ], elAttrs: Object.assign(Object.assign(Object.assign({}, n.extraDataAttrs), n.showDayNumber ? { "aria-labelledby": i.dayNumberId } : {}), { role: "gridcell" }), defaultGenerator: lu, date: l, dateProfile: o, todayRange: n.todayRange, showDayNumber: n.showDayNumber, isMonthStart: d, extraRenderProps: n.extraRenderProps }, (c, h) => p(
      "div",
      { ref: n.innerElRef, className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner", style: { minHeight: n.minHeight } },
      n.showWeekNumber && p(ws, { elTag: "a", elClasses: ["fc-daygrid-week-number"], elAttrs: bt(e, l, "week"), date: l, defaultFormat: su }),
      !h.isDisabled && (n.showDayNumber || $n(s) || n.forceDayTop) ? p(
        "div",
        { className: "fc-daygrid-day-top" },
        p(c, { elTag: "a", elClasses: [
          "fc-daygrid-day-number",
          d && "fc-daygrid-month-start"
        ], elAttrs: Object.assign(Object.assign({}, bt(e, l)), { id: i.dayNumberId }) })
      ) : n.showDayNumber ? (
        // for creating correct amount of space (see issue #7162)
        p(
          "div",
          { className: "fc-daygrid-day-top", style: { visibility: "hidden" } },
          p("a", { className: "fc-daygrid-day-number" }, " ")
        )
      ) : void 0,
      p(
        "div",
        { className: "fc-daygrid-day-events", ref: n.fgContentElRef },
        n.fgContent,
        p(
          "div",
          { className: "fc-daygrid-day-bottom", style: { marginTop: n.moreMarginTop } },
          p(iu, { allDayDate: l, singlePlacements: n.singlePlacements, moreCnt: n.moreCnt, alignmentElRef: r, alignGridTop: !n.showDayNumber, extraDateSpan: n.extraDateSpan, dateProfile: n.dateProfile, eventSelection: n.eventSelection, eventDrag: n.eventDrag, eventResize: n.eventResize, todayRange: n.todayRange })
        )
      ),
      p("div", { className: "fc-daygrid-day-bg" }, n.bgContent)
    ));
  }
}
function lu(t) {
  return t.dayNumberText || p(H, null, " ");
}
function ou(t, e, n) {
  const { start: i, end: r } = e, s = fe(r, -1), a = n.getYear(i), l = n.getMonth(i), o = n.getYear(s), d = n.getMonth(s);
  return !(a === o && l === d) && // first date in current view?
  (t.valueOf() === i.valueOf() || // a month-start that's within the current range?
  n.getDay(t) === 1 && t.valueOf() < r.valueOf());
}
function cu(t, e, n, i, r, s, a) {
  let l = new fu();
  l.allowReslicing = !0, l.strictOrder = i, e === !0 || n === !0 ? (l.maxCoord = s, l.hiddenConsumes = !0) : typeof e == "number" ? l.maxStackCnt = e : typeof n == "number" && (l.maxStackCnt = n, l.hiddenConsumes = !0);
  let o = [], d = [];
  for (let E = 0; E < t.length; E += 1) {
    let C = t[E], { instanceId: T } = C.eventRange.instance, A = r[T];
    A != null ? o.push({
      index: E,
      thickness: A,
      span: {
        start: C.firstCol,
        end: C.lastCol + 1
      }
    }) : d.push(C);
  }
  let c = l.addSegs(o), h = l.toRects(), { singleColPlacements: f, multiColPlacements: u, leftoverMargins: v } = du(h, t, a), y = [], b = [];
  for (let E of d) {
    u[E.firstCol].push({
      seg: E,
      isVisible: !1,
      isAbsolute: !0,
      absoluteTop: 0,
      marginTop: 0
    });
    for (let C = E.firstCol; C <= E.lastCol; C += 1)
      f[C].push({
        seg: xe(E, C, C + 1, a),
        isVisible: !1,
        isAbsolute: !1,
        absoluteTop: 0,
        marginTop: 0
      });
  }
  for (let E = 0; E < a.length; E += 1)
    y.push(0);
  for (let E of c) {
    let C = t[E.index], T = E.span;
    u[T.start].push({
      seg: xe(C, T.start, T.end, a),
      isVisible: !1,
      isAbsolute: !0,
      absoluteTop: 0,
      marginTop: 0
    });
    for (let A = T.start; A < T.end; A += 1)
      y[A] += 1, f[A].push({
        seg: xe(C, A, A + 1, a),
        isVisible: !1,
        isAbsolute: !1,
        absoluteTop: 0,
        marginTop: 0
      });
  }
  for (let E = 0; E < a.length; E += 1)
    b.push(v[E]);
  return { singleColPlacements: f, multiColPlacements: u, moreCnts: y, moreMarginTops: b };
}
function du(t, e, n) {
  let i = uu(t, n.length), r = [], s = [], a = [];
  for (let l = 0; l < n.length; l += 1) {
    let o = i[l], d = [], c = 0, h = 0;
    for (let u of o) {
      let v = e[u.index];
      d.push({
        seg: xe(v, l, l + 1, n),
        isVisible: !0,
        isAbsolute: !1,
        absoluteTop: u.levelCoord,
        marginTop: u.levelCoord - c
      }), c = u.levelCoord + u.thickness;
    }
    let f = [];
    c = 0, h = 0;
    for (let u of o) {
      let v = e[u.index], y = u.span.end - u.span.start > 1, b = u.span.start === l;
      h += u.levelCoord - c, c = u.levelCoord + u.thickness, y ? (h += u.thickness, b && f.push({
        seg: xe(v, u.span.start, u.span.end, n),
        isVisible: !0,
        isAbsolute: !0,
        absoluteTop: u.levelCoord,
        marginTop: 0
      })) : b && (f.push({
        seg: xe(v, u.span.start, u.span.end, n),
        isVisible: !0,
        isAbsolute: !1,
        absoluteTop: u.levelCoord,
        marginTop: h
        // claim the margin
      }), h = 0);
    }
    r.push(d), s.push(f), a.push(h);
  }
  return { singleColPlacements: r, multiColPlacements: s, leftoverMargins: a };
}
function uu(t, e) {
  let n = [];
  for (let i = 0; i < e; i += 1)
    n.push([]);
  for (let i of t)
    for (let r = i.span.start; r < i.span.end; r += 1)
      n[r].push(i);
  return n;
}
function xe(t, e, n, i) {
  if (t.firstCol === e && t.lastCol === n - 1)
    return t;
  let r = t.eventRange, s = r.range, a = _e(s, {
    start: i[e].date,
    end: F(i[n - 1].date, 1)
  });
  return Object.assign(Object.assign({}, t), { firstCol: e, lastCol: n - 1, eventRange: {
    def: r.def,
    ui: Object.assign(Object.assign({}, r.ui), { durationEditable: !1 }),
    instance: r.instance,
    range: a
  }, isStart: t.isStart && a.start.valueOf() === s.start.valueOf(), isEnd: t.isEnd && a.end.valueOf() === s.end.valueOf() });
}
class fu extends ns {
  constructor() {
    super(...arguments), this.hiddenConsumes = !1, this.forceHidden = {};
  }
  addSegs(e) {
    const n = super.addSegs(e), { entriesByLevel: i } = this, r = (s) => !this.forceHidden[ye(s)];
    for (let s = 0; s < i.length; s += 1)
      i[s] = i[s].filter(r);
    return n;
  }
  handleInvalidInsertion(e, n, i) {
    const { entriesByLevel: r, forceHidden: s } = this, { touchingEntry: a, touchingLevel: l, touchingLateral: o } = e;
    if (this.hiddenConsumes && a) {
      const d = ye(a);
      if (!s[d])
        if (this.allowReslicing) {
          const c = Object.assign(Object.assign({}, a), { span: Un(a.span, n.span) }), h = ye(c);
          s[h] = !0, r[l][o] = c, this.splitEntry(a, n, i);
        } else
          s[d] = !0, i.push(a);
    }
    return super.handleInvalidInsertion(e, n, i);
  }
}
class Fs extends K {
  constructor() {
    super(...arguments), this.cellElRefs = new ee(), this.frameElRefs = new ee(), this.fgElRefs = new ee(), this.segHarnessRefs = new ee(), this.rootElRef = j(), this.state = {
      framePositions: null,
      maxContentHeight: null,
      eventInstanceHeights: {}
    }, this.handleResize = (e) => {
      e && this.updateSizing(!0);
    };
  }
  render() {
    let { props: e, state: n, context: i } = this, { options: r } = i, s = e.cells.length, a = nt(e.businessHourSegs, s), l = nt(e.bgEventSegs, s), o = nt(this.getHighlightSegs(), s), d = nt(this.getMirrorSegs(), s), { singleColPlacements: c, multiColPlacements: h, moreCnts: f, moreMarginTops: u } = cu($r(e.fgEventSegs, r.eventOrder), e.dayMaxEvents, e.dayMaxEventRows, r.eventOrderStrict, n.eventInstanceHeights, n.maxContentHeight, e.cells), v = (
      // TODO: messy way to compute this
      e.eventDrag && e.eventDrag.affectedInstances || e.eventResize && e.eventResize.affectedInstances || {}
    );
    return p(
      "tr",
      { ref: this.rootElRef, role: "row" },
      e.renderIntro && e.renderIntro(),
      e.cells.map((y, b) => {
        let E = this.renderFgSegs(b, e.forPrint ? c[b] : h[b], e.todayRange, v), C = this.renderFgSegs(b, hu(d[b], h), e.todayRange, {}, !!e.eventDrag, !!e.eventResize, !1);
        return p(au, { key: y.key, elRef: this.cellElRefs.createRef(y.key), innerElRef: this.frameElRefs.createRef(y.key), dateProfile: e.dateProfile, date: y.date, showDayNumber: e.showDayNumbers, showWeekNumber: e.showWeekNumbers && b === 0, forceDayTop: e.showWeekNumbers, todayRange: e.todayRange, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, extraRenderProps: y.extraRenderProps, extraDataAttrs: y.extraDataAttrs, extraClassNames: y.extraClassNames, extraDateSpan: y.extraDateSpan, moreCnt: f[b], moreMarginTop: u[b], singlePlacements: c[b], fgContentElRef: this.fgElRefs.createRef(y.key), fgContent: (
          // Fragment scopes the keys
          p(
            H,
            null,
            p(H, null, E),
            p(H, null, C)
          )
        ), bgContent: (
          // Fragment scopes the keys
          p(
            H,
            null,
            this.renderFillSegs(o[b], "highlight"),
            this.renderFillSegs(a[b], "non-business"),
            this.renderFillSegs(l[b], "bg-event")
          )
        ), minHeight: e.cellMinHeight });
      })
    );
  }
  componentDidMount() {
    this.updateSizing(!0), this.context.addResizeHandler(this.handleResize);
  }
  componentDidUpdate(e, n) {
    let i = this.props;
    this.updateSizing(!J(e, i));
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleResize);
  }
  getHighlightSegs() {
    let { props: e } = this;
    return e.eventDrag && e.eventDrag.segs.length ? e.eventDrag.segs : e.eventResize && e.eventResize.segs.length ? e.eventResize.segs : e.dateSelectionSegs;
  }
  getMirrorSegs() {
    let { props: e } = this;
    return e.eventResize && e.eventResize.segs.length ? e.eventResize.segs : [];
  }
  renderFgSegs(e, n, i, r, s, a, l) {
    let { context: o } = this, { eventSelection: d } = this.props, { framePositions: c } = this.state, h = this.props.cells.length === 1, f = s || a || l, u = [];
    if (c)
      for (let v of n) {
        let { seg: y } = v, { instanceId: b } = y.eventRange.instance, E = b + ":" + e, C = v.isVisible && !r[b], T = v.isAbsolute, A = "", O = "";
        T && (o.isRtl ? (O = 0, A = c.lefts[y.lastCol] - c.lefts[y.firstCol]) : (A = 0, O = c.rights[y.firstCol] - c.rights[y.lastCol])), u.push(p("div", { className: "fc-daygrid-event-harness" + (T ? " fc-daygrid-event-harness-abs" : ""), key: E, ref: f ? null : this.segHarnessRefs.createRef(E), style: {
          visibility: C ? "" : "hidden",
          marginTop: T ? "" : v.marginTop,
          top: T ? v.absoluteTop : "",
          left: A,
          right: O
        } }, Bs(y) ? p(Us, Object.assign({ seg: y, isDragging: s, isSelected: b === d, defaultDisplayEventEnd: h }, de(y, i))) : p(zs, Object.assign({ seg: y, isDragging: s, isResizing: a, isDateSelecting: l, isSelected: b === d, defaultDisplayEventEnd: h }, de(y, i)))));
      }
    return u;
  }
  renderFillSegs(e, n) {
    let { isRtl: i } = this.context, { todayRange: r } = this.props, { framePositions: s } = this.state, a = [];
    if (s)
      for (let l of e) {
        let o = i ? {
          right: 0,
          left: s.lefts[l.lastCol] - s.lefts[l.firstCol]
        } : {
          left: 0,
          right: s.rights[l.firstCol] - s.rights[l.lastCol]
        };
        a.push(p("div", { key: Xr(l.eventRange), className: "fc-daygrid-bg-harness", style: o }, n === "bg-event" ? p(Es, Object.assign({ seg: l }, de(l, r))) : _s(n)));
      }
    return p(H, {}, ...a);
  }
  updateSizing(e) {
    let { props: n, state: i, frameElRefs: r } = this;
    if (!n.forPrint && n.clientWidth !== null) {
      if (e) {
        let o = n.cells.map((d) => r.currentMap[d.key]);
        if (o.length) {
          let d = this.rootElRef.current, c = new Me(
            d,
            o,
            !0,
            // isHorizontal
            !1
          );
          (!i.framePositions || !i.framePositions.similarTo(c)) && this.setState({
            framePositions: new Me(
              d,
              o,
              !0,
              // isHorizontal
              !1
            )
          });
        }
      }
      const s = this.state.eventInstanceHeights, a = this.queryEventInstanceHeights(), l = n.dayMaxEvents === !0 || n.dayMaxEventRows === !0;
      this.safeSetState({
        // HACK to prevent oscillations of events being shown/hidden from max-event-rows
        // Essentially, once you compute an element's height, never null-out.
        // TODO: always display all events, as visibility:hidden?
        eventInstanceHeights: Object.assign(Object.assign({}, s), a),
        maxContentHeight: l ? this.computeMaxContentHeight() : null
      });
    }
  }
  queryEventInstanceHeights() {
    let e = this.segHarnessRefs.currentMap, n = {};
    for (let i in e) {
      let r = Math.round(e[i].getBoundingClientRect().height), s = i.split(":")[0];
      n[s] = Math.max(n[s] || 0, r);
    }
    return n;
  }
  computeMaxContentHeight() {
    let e = this.props.cells[0].key, n = this.cellElRefs.currentMap[e], i = this.fgElRefs.currentMap[e];
    return n.getBoundingClientRect().bottom - i.getBoundingClientRect().top;
  }
  getCellEls() {
    let e = this.cellElRefs.currentMap;
    return this.props.cells.map((n) => e[n.key]);
  }
}
Fs.addStateEquality({
  eventInstanceHeights: J
});
function hu(t, e) {
  if (!t.length)
    return [];
  let n = pu(e);
  return t.map((i) => ({
    seg: i,
    isVisible: !0,
    isAbsolute: !0,
    absoluteTop: n[i.eventRange.instance.instanceId],
    marginTop: 0
  }));
}
function pu(t) {
  let e = {};
  for (let n of t)
    for (let i of n)
      e[i.seg.eventRange.instance.instanceId] = i.absoluteTop;
  return e;
}
class gu extends K {
  constructor() {
    super(...arguments), this.splitBusinessHourSegs = D(tt), this.splitBgEventSegs = D(tt), this.splitFgEventSegs = D(tt), this.splitDateSelectionSegs = D(tt), this.splitEventDrag = D(Xi), this.splitEventResize = D(Xi), this.rowRefs = new ee();
  }
  render() {
    let { props: e, context: n } = this, i = e.cells.length, r = this.splitBusinessHourSegs(e.businessHourSegs, i), s = this.splitBgEventSegs(e.bgEventSegs, i), a = this.splitFgEventSegs(e.fgEventSegs, i), l = this.splitDateSelectionSegs(e.dateSelectionSegs, i), o = this.splitEventDrag(e.eventDrag, i), d = this.splitEventResize(e.eventResize, i), c = i >= 7 && e.clientWidth ? e.clientWidth / n.options.aspectRatio / 6 : null;
    return p(Ve, { unit: "day" }, (h, f) => p(H, null, e.cells.map((u, v) => p(Fs, {
      ref: this.rowRefs.createRef(v),
      key: u.length ? u[0].date.toISOString() : v,
      showDayNumbers: i > 1,
      showWeekNumbers: e.showWeekNumbers,
      todayRange: f,
      dateProfile: e.dateProfile,
      cells: u,
      renderIntro: e.renderRowIntro,
      businessHourSegs: r[v],
      eventSelection: e.eventSelection,
      bgEventSegs: s[v].filter(mu),
      fgEventSegs: a[v],
      dateSelectionSegs: l[v],
      eventDrag: o[v],
      eventResize: d[v],
      dayMaxEvents: e.dayMaxEvents,
      dayMaxEventRows: e.dayMaxEventRows,
      clientWidth: e.clientWidth,
      clientHeight: e.clientHeight,
      cellMinHeight: c,
      forPrint: e.forPrint
    }))));
  }
  componentDidMount() {
    const e = this.rowRefs.currentMap[0].getCellEls()[0];
    this.rootEl = e ? e.closest(".fc-daygrid-body") : null, this.rootEl && this.context.registerInteractiveComponent(this, {
      el: this.rootEl,
      isHitComboAllowed: this.props.isHitComboAllowed
    });
  }
  componentWillUnmount() {
    this.rootEl && (this.context.unregisterInteractiveComponent(this), this.rootEl = null);
  }
  // Hit System
  // ----------------------------------------------------------------------------------------------------
  prepareHits() {
    this.rowPositions = new Me(
      this.rootEl,
      this.rowRefs.collect().map((e) => e.getCellEls()[0]),
      // first cell el in each row. TODO: not optimal
      !1,
      !0
    ), this.colPositions = new Me(
      this.rootEl,
      this.rowRefs.currentMap[0].getCellEls(),
      // cell els in first row
      !0,
      // horizontal
      !1
    );
  }
  queryHit(e, n) {
    let { colPositions: i, rowPositions: r } = this, s = i.leftToIndex(e), a = r.topToIndex(n);
    if (a != null && s != null) {
      let l = this.props.cells[a][s];
      return {
        dateProfile: this.props.dateProfile,
        dateSpan: Object.assign({ range: this.getCellRange(a, s), allDay: !0 }, l.extraDateSpan),
        dayEl: this.getCellEl(a, s),
        rect: {
          left: i.lefts[s],
          right: i.rights[s],
          top: r.tops[a],
          bottom: r.bottoms[a]
        },
        layer: 0
      };
    }
    return null;
  }
  getCellEl(e, n) {
    return this.rowRefs.currentMap[e].getCellEls()[n];
  }
  getCellRange(e, n) {
    let i = this.props.cells[e][n].date, r = F(i, 1);
    return { start: i, end: r };
  }
}
function mu(t) {
  return t.eventRange.def.allDay;
}
class vu extends K {
  constructor() {
    super(...arguments), this.elRef = j(), this.needsScrollReset = !1;
  }
  render() {
    let { props: e } = this, { dayMaxEventRows: n, dayMaxEvents: i, expandRows: r } = e, s = i === !0 || n === !0;
    s && !r && (s = !1, n = null, i = null);
    let a = [
      "fc-daygrid-body",
      s ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
      r ? "" : "fc-daygrid-body-natural"
      // will height of one row depend on the others?
    ];
    return p(
      "div",
      { ref: this.elRef, className: a.join(" "), style: {
        // these props are important to give this wrapper correct dimensions for interactions
        // TODO: if we set it here, can we avoid giving to inner tables?
        width: e.clientWidth,
        minWidth: e.tableMinWidth
      } },
      p(
        "table",
        { role: "presentation", className: "fc-scrollgrid-sync-table", style: {
          width: e.clientWidth,
          minWidth: e.tableMinWidth,
          height: r ? e.clientHeight : ""
        } },
        e.colGroupNode,
        p(
          "tbody",
          { role: "presentation" },
          p(gu, { dateProfile: e.dateProfile, cells: e.cells, renderRowIntro: e.renderRowIntro, showWeekNumbers: e.showWeekNumbers, clientWidth: e.clientWidth, clientHeight: e.clientHeight, businessHourSegs: e.businessHourSegs, bgEventSegs: e.bgEventSegs, fgEventSegs: e.fgEventSegs, dateSelectionSegs: e.dateSelectionSegs, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, dayMaxEvents: i, dayMaxEventRows: n, forPrint: e.forPrint, isHitComboAllowed: e.isHitComboAllowed })
        )
      )
    );
  }
  componentDidMount() {
    this.requestScrollReset();
  }
  componentDidUpdate(e) {
    e.dateProfile !== this.props.dateProfile ? this.requestScrollReset() : this.flushScrollReset();
  }
  requestScrollReset() {
    this.needsScrollReset = !0, this.flushScrollReset();
  }
  flushScrollReset() {
    if (this.needsScrollReset && this.props.clientWidth) {
      const e = yu(this.elRef.current, this.props.dateProfile);
      if (e) {
        const n = e.closest(".fc-daygrid-body"), i = n.closest(".fc-scroller"), r = e.getBoundingClientRect().top - n.getBoundingClientRect().top;
        i.scrollTop = r ? r + 1 : 0;
      }
      this.needsScrollReset = !1;
    }
  }
}
function yu(t, e) {
  let n;
  return e.currentRangeUnit.match(/year|month/) && (n = t.querySelector(`[data-date="${fl(e.currentDate)}-01"]`)), n || (n = t.querySelector(`[data-date="${Tn(e.currentDate)}"]`)), n;
}
class bu extends us {
  constructor() {
    super(...arguments), this.forceDayIfListItem = !0;
  }
  sliceRange(e, n) {
    return n.sliceRange(e);
  }
}
class js extends K {
  constructor() {
    super(...arguments), this.slicer = new bu(), this.tableRef = j();
  }
  render() {
    let { props: e, context: n } = this;
    return p(vu, Object.assign({ ref: this.tableRef }, this.slicer.sliceProps(e, e.dateProfile, e.nextDayThreshold, n, e.dayTableModel), { dateProfile: e.dateProfile, cells: e.dayTableModel.cells, colGroupNode: e.colGroupNode, tableMinWidth: e.tableMinWidth, renderRowIntro: e.renderRowIntro, dayMaxEvents: e.dayMaxEvents, dayMaxEventRows: e.dayMaxEventRows, showWeekNumbers: e.showWeekNumbers, expandRows: e.expandRows, headerAlignElRef: e.headerAlignElRef, clientWidth: e.clientWidth, clientHeight: e.clientHeight, forPrint: e.forPrint }));
  }
}
class Eu extends Gr {
  // Computes the date range that will be rendered
  buildRenderRange(e, n, i) {
    let r = super.buildRenderRange(e, n, i), { props: s } = this;
    return _u({
      currentRange: r,
      snapToWeek: /^(year|month)$/.test(n),
      fixedWeekCount: s.fixedWeekCount,
      dateEnv: s.dateEnv
    });
  }
}
function _u(t) {
  let { dateEnv: e, currentRange: n } = t, { start: i, end: r } = n, s;
  if (t.snapToWeek && (i = e.startOfWeek(i), s = e.startOfWeek(r), s.valueOf() !== r.valueOf() && (r = Si(s, 1))), t.fixedWeekCount) {
    let a = e.startOfWeek(e.startOfMonth(F(n.end, -1))), l = Math.ceil(
      // could be partial weeks due to hiddenDays
      tl(a, r)
    );
    r = Si(r, 6 - l);
  }
  return { start: i, end: r };
}
class wu extends K {
  constructor() {
    super(...arguments), this.headerElRef = j();
  }
  renderSimpleLayout(e, n) {
    let { props: i, context: r } = this, s = [], a = _t(r.options);
    return e && s.push({
      type: "header",
      key: "header",
      isSticky: a,
      chunk: {
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }
    }), s.push({
      type: "body",
      key: "body",
      liquid: !0,
      chunk: { content: n }
    }), p(
      wt,
      { elClasses: ["fc-daygrid"], viewSpec: r.viewSpec },
      p(Gn, { liquid: !i.isHeightAuto && !i.forPrint, collapsibleWidth: i.forPrint, cols: [], sections: s })
    );
  }
  renderHScrollLayout(e, n, i, r) {
    let s = this.context.pluginHooks.scrollGridImpl;
    if (!s)
      throw new Error("No ScrollGrid implementation");
    let { props: a, context: l } = this, o = !a.forPrint && _t(l.options), d = !a.forPrint && ys(l.options), c = [];
    return e && c.push({
      type: "header",
      key: "header",
      isSticky: o,
      chunks: [{
        key: "main",
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }]
    }), c.push({
      type: "body",
      key: "body",
      liquid: !0,
      chunks: [{
        key: "main",
        content: n
      }]
    }), d && c.push({
      type: "footer",
      key: "footer",
      isSticky: !0,
      chunks: [{
        key: "main",
        content: un
      }]
    }), p(
      wt,
      { elClasses: ["fc-daygrid"], viewSpec: l.viewSpec },
      p(s, { liquid: !a.isHeightAuto && !a.forPrint, forPrint: a.forPrint, collapsibleWidth: a.forPrint, colGroups: [{ cols: [{ span: i, minWidth: r }] }], sections: c })
    );
  }
}
class Cu extends wu {
  constructor() {
    super(...arguments), this.buildDayTableModel = D(Su), this.headerRef = j(), this.tableRef = j();
  }
  render() {
    let { options: e, dateProfileGenerator: n } = this.context, { props: i } = this, r = this.buildDayTableModel(i.dateProfile, n), s = e.dayHeaders && p(os, { ref: this.headerRef, dateProfile: i.dateProfile, dates: r.headerDates, datesRepDistinctDays: r.rowCnt === 1 }), a = (l) => p(js, { ref: this.tableRef, dateProfile: i.dateProfile, dayTableModel: r, businessHours: i.businessHours, dateSelection: i.dateSelection, eventStore: i.eventStore, eventUiBases: i.eventUiBases, eventSelection: i.eventSelection, eventDrag: i.eventDrag, eventResize: i.eventResize, nextDayThreshold: e.nextDayThreshold, colGroupNode: l.tableColGroupNode, tableMinWidth: l.tableMinWidth, dayMaxEvents: e.dayMaxEvents, dayMaxEventRows: e.dayMaxEventRows, showWeekNumbers: e.weekNumbers, expandRows: !i.isHeightAuto, headerAlignElRef: this.headerElRef, clientWidth: l.clientWidth, clientHeight: l.clientHeight, forPrint: i.forPrint });
    return e.dayMinWidth ? this.renderHScrollLayout(s, a, r.colCnt, e.dayMinWidth) : this.renderSimpleLayout(s, a);
  }
}
function Su(t, e) {
  let n = new cs(t.renderRange, e);
  return new ds(n, /year|month|week/.test(t.currentRangeUnit));
}
var Du = se({
  name: "@fullcalendar/daygrid",
  initialView: "dayGridMonth",
  views: {
    dayGrid: {
      component: Cu,
      dateProfileGeneratorClass: Eu
    },
    dayGridDay: {
      type: "dayGrid",
      duration: { days: 1 }
    },
    dayGridWeek: {
      type: "dayGrid",
      duration: { weeks: 1 }
    },
    dayGridMonth: {
      type: "dayGrid",
      duration: { months: 1 },
      fixedWeekCount: !0
    },
    dayGridYear: {
      type: "dayGrid",
      duration: { years: 1 }
    }
  }
}), Au = '.fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:"\\00a0"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:"\\00a0-\\00a0"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}';
En(Au);
class Tu extends Ql {
  getKeyInfo() {
    return {
      allDay: {},
      timed: {}
    };
  }
  getKeysForDateSpan(e) {
    return e.allDay ? ["allDay"] : ["timed"];
  }
  getKeysForEventDef(e) {
    return e.allDay ? Do(e) ? ["timed", "allDay"] : ["allDay"] : ["timed"];
  }
}
const Ru = B({
  hour: "numeric",
  minute: "2-digit",
  omitZeroMinute: !0,
  meridiem: "short"
});
function Ws(t) {
  let e = [
    "fc-timegrid-slot",
    "fc-timegrid-slot-label",
    t.isLabeled ? "fc-scrollgrid-shrink" : "fc-timegrid-slot-minor"
  ];
  return p(re.Consumer, null, (n) => {
    if (!t.isLabeled)
      return p("td", { className: e.join(" "), "data-time": t.isoTimeStr });
    let { dateEnv: i, options: r, viewApi: s } = n, a = (
      // TODO: fully pre-parse
      r.slotLabelFormat == null ? Ru : Array.isArray(r.slotLabelFormat) ? B(r.slotLabelFormat[0]) : B(r.slotLabelFormat)
    ), l = {
      level: 0,
      time: t.time,
      date: i.toDate(t.date),
      view: s,
      text: i.format(t.date, a)
    };
    return p(q, { elTag: "td", elClasses: e, elAttrs: {
      "data-time": t.isoTimeStr
    }, renderProps: l, generatorName: "slotLabelContent", customGenerator: r.slotLabelContent, defaultGenerator: xu, classNameGenerator: r.slotLabelClassNames, didMount: r.slotLabelDidMount, willUnmount: r.slotLabelWillUnmount }, (o) => p(
      "div",
      { className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame" },
      p(o, { elTag: "div", elClasses: [
        "fc-timegrid-slot-label-cushion",
        "fc-scrollgrid-shrink-cushion"
      ] })
    ));
  });
}
function xu(t) {
  return t.text;
}
class ku extends I {
  render() {
    return this.props.slatMetas.map((e) => p(
      "tr",
      { key: e.key },
      p(Ws, Object.assign({}, e))
    ));
  }
}
const Mu = B({ week: "short" }), Iu = 5;
class Ou extends K {
  constructor() {
    super(...arguments), this.allDaySplitter = new Tu(), this.headerElRef = j(), this.rootElRef = j(), this.scrollerElRef = j(), this.state = {
      slatCoords: null
    }, this.handleScrollTopRequest = (e) => {
      let n = this.scrollerElRef.current;
      n && (n.scrollTop = e);
    }, this.renderHeadAxis = (e, n = "") => {
      let { options: i } = this.context, { dateProfile: r } = this.props, s = r.renderRange, l = Ce(s.start, s.end) === 1 ? bt(this.context, s.start, "week") : {};
      return i.weekNumbers && e === "day" ? p(ws, { elTag: "th", elClasses: [
        "fc-timegrid-axis",
        "fc-scrollgrid-shrink"
      ], elAttrs: {
        "aria-hidden": !0
      }, date: s.start, defaultFormat: Mu }, (o) => p(
        "div",
        { className: [
          "fc-timegrid-axis-frame",
          "fc-scrollgrid-shrink-frame",
          "fc-timegrid-axis-frame-liquid"
        ].join(" "), style: { height: n } },
        p(o, { elTag: "a", elClasses: [
          "fc-timegrid-axis-cushion",
          "fc-scrollgrid-shrink-cushion",
          "fc-scrollgrid-sync-inner"
        ], elAttrs: l })
      )) : p(
        "th",
        { "aria-hidden": !0, className: "fc-timegrid-axis" },
        p("div", { className: "fc-timegrid-axis-frame", style: { height: n } })
      );
    }, this.renderTableRowAxis = (e) => {
      let { options: n, viewApi: i } = this.context, r = {
        text: n.allDayText,
        view: i
      };
      return (
        // TODO: make reusable hook. used in list view too
        p(q, { elTag: "td", elClasses: [
          "fc-timegrid-axis",
          "fc-scrollgrid-shrink"
        ], elAttrs: {
          "aria-hidden": !0
        }, renderProps: r, generatorName: "allDayContent", customGenerator: n.allDayContent, defaultGenerator: Nu, classNameGenerator: n.allDayClassNames, didMount: n.allDayDidMount, willUnmount: n.allDayWillUnmount }, (s) => p(
          "div",
          { className: [
            "fc-timegrid-axis-frame",
            "fc-scrollgrid-shrink-frame",
            e == null ? " fc-timegrid-axis-frame-liquid" : ""
          ].join(" "), style: { height: e } },
          p(s, { elTag: "span", elClasses: [
            "fc-timegrid-axis-cushion",
            "fc-scrollgrid-shrink-cushion",
            "fc-scrollgrid-sync-inner"
          ] })
        ))
      );
    }, this.handleSlatCoords = (e) => {
      this.setState({ slatCoords: e });
    };
  }
  // rendering
  // ----------------------------------------------------------------------------------------------------
  renderSimpleLayout(e, n, i) {
    let { context: r, props: s } = this, a = [], l = _t(r.options);
    return e && a.push({
      type: "header",
      key: "header",
      isSticky: l,
      chunk: {
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }
    }), n && (a.push({
      type: "body",
      key: "all-day",
      chunk: { content: n }
    }), a.push({
      type: "body",
      key: "all-day-divider",
      outerContent: (
        // TODO: rename to cellContent so don't need to define <tr>?
        p(
          "tr",
          { role: "presentation", className: "fc-scrollgrid-section" },
          p("td", { className: "fc-timegrid-divider " + r.theme.getClass("tableCellShaded") })
        )
      )
    })), a.push({
      type: "body",
      key: "body",
      liquid: !0,
      expandRows: !!r.options.expandRows,
      chunk: {
        scrollerElRef: this.scrollerElRef,
        content: i
      }
    }), p(
      wt,
      { elRef: this.rootElRef, elClasses: ["fc-timegrid"], viewSpec: r.viewSpec },
      p(Gn, { liquid: !s.isHeightAuto && !s.forPrint, collapsibleWidth: s.forPrint, cols: [{ width: "shrink" }], sections: a })
    );
  }
  renderHScrollLayout(e, n, i, r, s, a, l) {
    let o = this.context.pluginHooks.scrollGridImpl;
    if (!o)
      throw new Error("No ScrollGrid implementation");
    let { context: d, props: c } = this, h = !c.forPrint && _t(d.options), f = !c.forPrint && ys(d.options), u = [];
    e && u.push({
      type: "header",
      key: "header",
      isSticky: h,
      syncRowHeights: !0,
      chunks: [
        {
          key: "axis",
          rowContent: (y) => p("tr", { role: "presentation" }, this.renderHeadAxis("day", y.rowSyncHeights[0]))
        },
        {
          key: "cols",
          elRef: this.headerElRef,
          tableClassName: "fc-col-header",
          rowContent: e
        }
      ]
    }), n && (u.push({
      type: "body",
      key: "all-day",
      syncRowHeights: !0,
      chunks: [
        {
          key: "axis",
          rowContent: (y) => p("tr", { role: "presentation" }, this.renderTableRowAxis(y.rowSyncHeights[0]))
        },
        {
          key: "cols",
          content: n
        }
      ]
    }), u.push({
      key: "all-day-divider",
      type: "body",
      outerContent: (
        // TODO: rename to cellContent so don't need to define <tr>?
        p(
          "tr",
          { role: "presentation", className: "fc-scrollgrid-section" },
          p("td", { colSpan: 2, className: "fc-timegrid-divider " + d.theme.getClass("tableCellShaded") })
        )
      )
    }));
    let v = d.options.nowIndicator;
    return u.push({
      type: "body",
      key: "body",
      liquid: !0,
      expandRows: !!d.options.expandRows,
      chunks: [
        {
          key: "axis",
          content: (y) => (
            // TODO: make this now-indicator arrow more DRY with TimeColsContent
            p(
              "div",
              { className: "fc-timegrid-axis-chunk" },
              p(
                "table",
                { "aria-hidden": !0, style: { height: y.expandRows ? y.clientHeight : "" } },
                y.tableColGroupNode,
                p(
                  "tbody",
                  null,
                  p(ku, { slatMetas: a })
                )
              ),
              p(
                "div",
                { className: "fc-timegrid-now-indicator-container" },
                p(Ve, {
                  unit: v ? "minute" : "day"
                  /* hacky */
                }, (b) => {
                  let E = v && l && l.safeComputeTop(b);
                  return typeof E == "number" ? p(qn, { elClasses: ["fc-timegrid-now-indicator-arrow"], elStyle: { top: E }, isAxis: !0, date: b }) : null;
                })
              )
            )
          )
        },
        {
          key: "cols",
          scrollerElRef: this.scrollerElRef,
          content: i
        }
      ]
    }), f && u.push({
      key: "footer",
      type: "footer",
      isSticky: !0,
      chunks: [
        {
          key: "axis",
          content: un
        },
        {
          key: "cols",
          content: un
        }
      ]
    }), p(
      wt,
      { elRef: this.rootElRef, elClasses: ["fc-timegrid"], viewSpec: d.viewSpec },
      p(o, { liquid: !c.isHeightAuto && !c.forPrint, forPrint: c.forPrint, collapsibleWidth: !1, colGroups: [
        { width: "shrink", cols: [{ width: "shrink" }] },
        { cols: [{ span: r, minWidth: s }] }
      ], sections: u })
    );
  }
  /* Dimensions
  ------------------------------------------------------------------------------------------------------------------*/
  getAllDayMaxEventProps() {
    let { dayMaxEvents: e, dayMaxEventRows: n } = this.context.options;
    return (e === !0 || n === !0) && (e = void 0, n = Iu), { dayMaxEvents: e, dayMaxEventRows: n };
  }
}
function Nu(t) {
  return t.text;
}
class Pu {
  constructor(e, n, i) {
    this.positions = e, this.dateProfile = n, this.slotDuration = i;
  }
  safeComputeTop(e) {
    let { dateProfile: n } = this;
    if (te(n.currentRange, e)) {
      let i = P(e), r = e.valueOf() - i.valueOf();
      if (r >= Z(n.slotMinTime) && r < Z(n.slotMaxTime))
        return this.computeTimeTop(k(r));
    }
    return null;
  }
  // Computes the top coordinate, relative to the bounds of the grid, of the given date.
  // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
  computeDateTop(e, n) {
    return n || (n = P(e)), this.computeTimeTop(k(e.valueOf() - n.valueOf()));
  }
  // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
  // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
  // Eventually allow computation with arbirary slat dates.
  computeTimeTop(e) {
    let { positions: n, dateProfile: i } = this, r = n.els.length, s = (e.milliseconds - Z(i.slotMinTime)) / Z(this.slotDuration), a, l;
    return s = Math.max(0, s), s = Math.min(r, s), a = Math.floor(s), a = Math.min(a, r - 1), l = s - a, n.tops[a] + n.getHeight(a) * l;
  }
}
class Hu extends I {
  render() {
    let { props: e, context: n } = this, { options: i } = n, { slatElRefs: r } = e;
    return p("tbody", null, e.slatMetas.map((s, a) => {
      let l = {
        time: s.time,
        date: n.dateEnv.toDate(s.date),
        view: n.viewApi
      };
      return p(
        "tr",
        { key: s.key, ref: r.createRef(s.key) },
        e.axis && p(Ws, Object.assign({}, s)),
        p(q, { elTag: "td", elClasses: [
          "fc-timegrid-slot",
          "fc-timegrid-slot-lane",
          !s.isLabeled && "fc-timegrid-slot-minor"
        ], elAttrs: {
          "data-time": s.isoTimeStr
        }, renderProps: l, generatorName: "slotLaneContent", customGenerator: i.slotLaneContent, classNameGenerator: i.slotLaneClassNames, didMount: i.slotLaneDidMount, willUnmount: i.slotLaneWillUnmount })
      );
    }));
  }
}
class Lu extends I {
  constructor() {
    super(...arguments), this.rootElRef = j(), this.slatElRefs = new ee();
  }
  render() {
    let { props: e, context: n } = this;
    return p(
      "div",
      { ref: this.rootElRef, className: "fc-timegrid-slots" },
      p(
        "table",
        { "aria-hidden": !0, className: n.theme.getClass("table"), style: {
          minWidth: e.tableMinWidth,
          width: e.clientWidth,
          height: e.minHeight
        } },
        e.tableColGroupNode,
        p(Hu, { slatElRefs: this.slatElRefs, axis: e.axis, slatMetas: e.slatMetas })
      )
    );
  }
  componentDidMount() {
    this.updateSizing();
  }
  componentDidUpdate() {
    this.updateSizing();
  }
  componentWillUnmount() {
    this.props.onCoords && this.props.onCoords(null);
  }
  updateSizing() {
    let { context: e, props: n } = this;
    n.onCoords && n.clientWidth !== null && this.rootElRef.current.offsetHeight && n.onCoords(new Pu(new Me(this.rootElRef.current, Bu(this.slatElRefs.currentMap, n.slatMetas), !1, !0), this.props.dateProfile, e.options.slotDuration));
  }
}
function Bu(t, e) {
  return e.map((n) => t[n.key]);
}
function Pe(t, e) {
  let n = [], i;
  for (i = 0; i < e; i += 1)
    n.push([]);
  if (t)
    for (i = 0; i < t.length; i += 1)
      n[t[i].col].push(t[i]);
  return n;
}
function Ji(t, e) {
  let n = [];
  if (t) {
    for (let i = 0; i < e; i += 1)
      n[i] = {
        affectedInstances: t.affectedInstances,
        isEvent: t.isEvent,
        segs: []
      };
    for (let i of t.segs)
      n[i.col].segs.push(i);
  } else
    for (let i = 0; i < e; i += 1)
      n[i] = null;
  return n;
}
class zu extends I {
  render() {
    let { props: e } = this;
    return p(Cs, { elClasses: ["fc-timegrid-more-link"], elStyle: {
      top: e.top,
      bottom: e.bottom
    }, allDayDate: null, moreCnt: e.hiddenSegs.length, allSegs: e.hiddenSegs, hiddenSegs: e.hiddenSegs, extraDateSpan: e.extraDateSpan, dateProfile: e.dateProfile, todayRange: e.todayRange, popoverContent: () => Gs(e.hiddenSegs, e), defaultGenerator: Uu, forceTimed: !0 }, (n) => p(n, { elTag: "div", elClasses: ["fc-timegrid-more-link-inner", "fc-sticky"] }));
  }
}
function Uu(t) {
  return t.shortText;
}
function Fu(t, e, n) {
  let i = new ns();
  e != null && (i.strictOrder = e), n != null && (i.maxStackCnt = n);
  let r = i.addSegs(t), s = Vo(r), a = ju(i);
  return a = Yu(a, 1), { segRects: qu(a), hiddenGroups: s };
}
function ju(t) {
  const { entriesByLevel: e } = t, n = Xn((i, r) => i + ":" + r, (i, r) => {
    let s = Gu(t, i, r), a = Ki(s, n), l = e[i][r];
    return [
      Object.assign(Object.assign({}, l), { nextLevelNodes: a[0] }),
      l.thickness + a[1]
      // the pressure builds
    ];
  });
  return Ki(e.length ? { level: 0, lateralStart: 0, lateralEnd: e[0].length } : null, n)[0];
}
function Ki(t, e) {
  if (!t)
    return [[], 0];
  let { level: n, lateralStart: i, lateralEnd: r } = t, s = i, a = [];
  for (; s < r; )
    a.push(e(n, s)), s += 1;
  return a.sort(Wu), [
    a.map(Vu),
    a[0][1]
    // first item's pressure
  ];
}
function Wu(t, e) {
  return e[1] - t[1];
}
function Vu(t) {
  return t[0];
}
function Gu(t, e, n) {
  let { levelCoords: i, entriesByLevel: r } = t, s = r[e][n], a = i[e] + s.thickness, l = i.length, o = e;
  for (; o < l && i[o] < a; o += 1)
    ;
  for (; o < l; o += 1) {
    let d = r[o], c, h = cn(d, s.span.start, on), f = h[0] + h[1], u = f;
    for (
      ;
      // loop through entries that horizontally intersect
      (c = d[u]) && // but not past the whole seg list
      c.span.start < s.span.end;
    )
      u += 1;
    if (f < u)
      return { level: o, lateralStart: f, lateralEnd: u };
  }
  return null;
}
function Yu(t, e) {
  const n = Xn((i, r, s) => ye(i), (i, r, s) => {
    let { nextLevelNodes: a, thickness: l } = i, o = l + s, d = l / o, c, h = [];
    if (!a.length)
      c = e;
    else
      for (let u of a)
        if (c === void 0) {
          let v = n(u, r, o);
          c = v[0], h.push(v[1]);
        } else {
          let v = n(u, c, 0);
          h.push(v[1]);
        }
    let f = (c - r) * d;
    return [c - f, Object.assign(Object.assign({}, i), { thickness: f, nextLevelNodes: h })];
  });
  return t.map((i) => n(i, 0, 0)[1]);
}
function qu(t) {
  let e = [];
  const n = Xn((r, s, a) => ye(r), (r, s, a) => {
    let l = Object.assign(Object.assign({}, r), {
      levelCoord: s,
      stackDepth: a,
      stackForward: 0
    });
    return e.push(l), l.stackForward = i(r.nextLevelNodes, s + r.thickness, a + 1) + 1;
  });
  function i(r, s, a) {
    let l = 0;
    for (let o of r)
      l = Math.max(n(o, s, a), l);
    return l;
  }
  return i(t, 0, 0), e;
}
function Xn(t, e) {
  const n = {};
  return (...i) => {
    let r = t(...i);
    return r in n ? n[r] : n[r] = e(...i);
  };
}
function er(t, e, n = null, i = 0) {
  let r = [];
  if (n)
    for (let s = 0; s < t.length; s += 1) {
      let a = t[s], l = n.computeDateTop(a.start, e), o = Math.max(
        l + (i || 0),
        // :(
        n.computeDateTop(a.end, e)
      );
      r.push({
        start: Math.round(l),
        end: Math.round(o)
        //
      });
    }
  return r;
}
function Qu(t, e, n, i) {
  let r = [], s = [];
  for (let d = 0; d < t.length; d += 1) {
    let c = e[d];
    c ? r.push({
      index: d,
      thickness: 1,
      span: c
    }) : s.push(t[d]);
  }
  let { segRects: a, hiddenGroups: l } = Fu(r, n, i), o = [];
  for (let d of a)
    o.push({
      seg: t[d.index],
      rect: d
    });
  for (let d of s)
    o.push({ seg: d, rect: null });
  return { segPlacements: o, hiddenGroups: l };
}
const $u = B({
  hour: "numeric",
  minute: "2-digit",
  meridiem: !1
});
class Vs extends I {
  render() {
    return p(bs, Object.assign({}, this.props, { elClasses: [
      "fc-timegrid-event",
      "fc-v-event",
      this.props.isShort && "fc-timegrid-event-short"
    ], defaultTimeFormat: $u }));
  }
}
class Zu extends I {
  constructor() {
    super(...arguments), this.sortEventSegs = D($r);
  }
  // TODO: memoize event-placement?
  render() {
    let { props: e, context: n } = this, { options: i } = n, r = i.selectMirror, s = (
      // yuck
      e.eventDrag && e.eventDrag.segs || e.eventResize && e.eventResize.segs || r && e.dateSelectionSegs || []
    ), a = (
      // TODO: messy way to compute this
      e.eventDrag && e.eventDrag.affectedInstances || e.eventResize && e.eventResize.affectedInstances || {}
    ), l = this.sortEventSegs(e.fgEventSegs, i.eventOrder);
    return p(Qn, { elTag: "td", elRef: e.elRef, elClasses: [
      "fc-timegrid-col",
      ...e.extraClassNames || []
    ], elAttrs: Object.assign({ role: "gridcell" }, e.extraDataAttrs), date: e.date, dateProfile: e.dateProfile, todayRange: e.todayRange, extraRenderProps: e.extraRenderProps }, (o) => p(
      "div",
      { className: "fc-timegrid-col-frame" },
      p(
        "div",
        { className: "fc-timegrid-col-bg" },
        this.renderFillSegs(e.businessHourSegs, "non-business"),
        this.renderFillSegs(e.bgEventSegs, "bg-event"),
        this.renderFillSegs(e.dateSelectionSegs, "highlight")
      ),
      p("div", { className: "fc-timegrid-col-events" }, this.renderFgSegs(l, a, !1, !1, !1)),
      p("div", { className: "fc-timegrid-col-events" }, this.renderFgSegs(s, {}, !!e.eventDrag, !!e.eventResize, !!r, "mirror")),
      p("div", { className: "fc-timegrid-now-indicator-container" }, this.renderNowIndicator(e.nowIndicatorSegs)),
      $n(i) && p(o, { elTag: "div", elClasses: ["fc-timegrid-col-misc"] })
    ));
  }
  renderFgSegs(e, n, i, r, s, a) {
    let { props: l } = this;
    return l.forPrint ? Gs(e, l) : this.renderPositionedFgSegs(e, n, i, r, s, a);
  }
  renderPositionedFgSegs(e, n, i, r, s, a) {
    let { eventMaxStack: l, eventShortHeight: o, eventOrderStrict: d, eventMinHeight: c } = this.context.options, { date: h, slatCoords: f, eventSelection: u, todayRange: v, nowDate: y } = this.props, b = i || r || s, E = er(e, h, f, c), { segPlacements: C, hiddenGroups: T } = Qu(e, E, d, l);
    return p(
      H,
      null,
      this.renderHiddenGroups(T, e),
      C.map((A) => {
        let { seg: O, rect: M } = A, N = O.eventRange.instance.instanceId, x = b || !!(!n[N] && M), Q = $t(M && M.span), ae = !b && M ? this.computeSegHStyle(M) : { left: 0, right: 0 }, qe = !!M && M.stackForward > 0, Qe = !!M && M.span.end - M.span.start < o;
        return p(
          "div",
          { className: "fc-timegrid-event-harness" + (qe ? " fc-timegrid-event-harness-inset" : ""), key: a || N, style: Object.assign(Object.assign({ visibility: x ? "" : "hidden" }, Q), ae) },
          p(Vs, Object.assign({ seg: O, isDragging: i, isResizing: r, isDateSelecting: s, isSelected: N === u, isShort: Qe }, de(O, v, y)))
        );
      })
    );
  }
  // will already have eventMinHeight applied because segInputs already had it
  renderHiddenGroups(e, n) {
    let { extraDateSpan: i, dateProfile: r, todayRange: s, nowDate: a, eventSelection: l, eventDrag: o, eventResize: d } = this.props;
    return p(H, null, e.map((c) => {
      let h = $t(c.span), f = Xu(c.entries, n);
      return p(zu, { key: Ir(Ss(f)), hiddenSegs: f, top: h.top, bottom: h.bottom, extraDateSpan: i, dateProfile: r, todayRange: s, nowDate: a, eventSelection: l, eventDrag: o, eventResize: d });
    }));
  }
  renderFillSegs(e, n) {
    let { props: i, context: r } = this, a = er(e, i.date, i.slatCoords, r.options.eventMinHeight).map((l, o) => {
      let d = e[o];
      return p("div", { key: Xr(d.eventRange), className: "fc-timegrid-bg-harness", style: $t(l) }, n === "bg-event" ? p(Es, Object.assign({ seg: d }, de(d, i.todayRange, i.nowDate))) : _s(n));
    });
    return p(H, null, a);
  }
  renderNowIndicator(e) {
    let { slatCoords: n, date: i } = this.props;
    return n ? e.map((r, s) => p(
      qn,
      {
        // key doesn't matter. will only ever be one
        key: s,
        elClasses: ["fc-timegrid-now-indicator-line"],
        elStyle: {
          top: n.computeDateTop(r.start, i)
        },
        isAxis: !1,
        date: i
      }
    )) : null;
  }
  computeSegHStyle(e) {
    let { isRtl: n, options: i } = this.context, r = i.slotEventOverlap, s = e.levelCoord, a = e.levelCoord + e.thickness, l, o;
    r && (a = Math.min(1, s + (a - s) * 2)), n ? (l = 1 - a, o = s) : (l = s, o = 1 - a);
    let d = {
      zIndex: e.stackDepth + 1,
      left: l * 100 + "%",
      right: o * 100 + "%"
    };
    return r && !e.stackForward && (d[n ? "marginLeft" : "marginRight"] = 10 * 2), d;
  }
}
function Gs(t, { todayRange: e, nowDate: n, eventSelection: i, eventDrag: r, eventResize: s }) {
  let a = (r ? r.affectedInstances : null) || (s ? s.affectedInstances : null) || {};
  return p(H, null, t.map((l) => {
    let o = l.eventRange.instance.instanceId;
    return p(
      "div",
      { key: o, style: { visibility: a[o] ? "hidden" : "" } },
      p(Vs, Object.assign({ seg: l, isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: o === i, isShort: !1 }, de(l, e, n)))
    );
  }));
}
function $t(t) {
  return t ? {
    top: t.start,
    bottom: -t.end
  } : { top: "", bottom: "" };
}
function Xu(t, e) {
  return t.map((n) => e[n.index]);
}
class Ju extends I {
  constructor() {
    super(...arguments), this.splitFgEventSegs = D(Pe), this.splitBgEventSegs = D(Pe), this.splitBusinessHourSegs = D(Pe), this.splitNowIndicatorSegs = D(Pe), this.splitDateSelectionSegs = D(Pe), this.splitEventDrag = D(Ji), this.splitEventResize = D(Ji), this.rootElRef = j(), this.cellElRefs = new ee();
  }
  render() {
    let { props: e, context: n } = this, i = n.options.nowIndicator && e.slatCoords && e.slatCoords.safeComputeTop(e.nowDate), r = e.cells.length, s = this.splitFgEventSegs(e.fgEventSegs, r), a = this.splitBgEventSegs(e.bgEventSegs, r), l = this.splitBusinessHourSegs(e.businessHourSegs, r), o = this.splitNowIndicatorSegs(e.nowIndicatorSegs, r), d = this.splitDateSelectionSegs(e.dateSelectionSegs, r), c = this.splitEventDrag(e.eventDrag, r), h = this.splitEventResize(e.eventResize, r);
    return p(
      "div",
      { className: "fc-timegrid-cols", ref: this.rootElRef },
      p(
        "table",
        { role: "presentation", style: {
          minWidth: e.tableMinWidth,
          width: e.clientWidth
        } },
        e.tableColGroupNode,
        p(
          "tbody",
          { role: "presentation" },
          p(
            "tr",
            { role: "row" },
            e.axis && p(
              "td",
              { "aria-hidden": !0, className: "fc-timegrid-col fc-timegrid-axis" },
              p(
                "div",
                { className: "fc-timegrid-col-frame" },
                p("div", { className: "fc-timegrid-now-indicator-container" }, typeof i == "number" && p(qn, { elClasses: ["fc-timegrid-now-indicator-arrow"], elStyle: { top: i }, isAxis: !0, date: e.nowDate }))
              )
            ),
            e.cells.map((f, u) => p(Zu, { key: f.key, elRef: this.cellElRefs.createRef(f.key), dateProfile: e.dateProfile, date: f.date, nowDate: e.nowDate, todayRange: e.todayRange, extraRenderProps: f.extraRenderProps, extraDataAttrs: f.extraDataAttrs, extraClassNames: f.extraClassNames, extraDateSpan: f.extraDateSpan, fgEventSegs: s[u], bgEventSegs: a[u], businessHourSegs: l[u], nowIndicatorSegs: o[u], dateSelectionSegs: d[u], eventDrag: c[u], eventResize: h[u], slatCoords: e.slatCoords, eventSelection: e.eventSelection, forPrint: e.forPrint }))
          )
        )
      )
    );
  }
  componentDidMount() {
    this.updateCoords();
  }
  componentDidUpdate() {
    this.updateCoords();
  }
  updateCoords() {
    let { props: e } = this;
    e.onColCoords && e.clientWidth !== null && e.onColCoords(new Me(
      this.rootElRef.current,
      Ku(this.cellElRefs.currentMap, e.cells),
      !0,
      // horizontal
      !1
    ));
  }
}
function Ku(t, e) {
  return e.map((n) => t[n.key]);
}
class ef extends K {
  constructor() {
    super(...arguments), this.processSlotOptions = D(tf), this.state = {
      slatCoords: null
    }, this.handleRootEl = (e) => {
      e ? this.context.registerInteractiveComponent(this, {
        el: e,
        isHitComboAllowed: this.props.isHitComboAllowed
      }) : this.context.unregisterInteractiveComponent(this);
    }, this.handleScrollRequest = (e) => {
      let { onScrollTopRequest: n } = this.props, { slatCoords: i } = this.state;
      if (n && i) {
        if (e.time) {
          let r = i.computeTimeTop(e.time);
          r = Math.ceil(r), r && (r += 1), n(r);
        }
        return !0;
      }
      return !1;
    }, this.handleColCoords = (e) => {
      this.colCoords = e;
    }, this.handleSlatCoords = (e) => {
      this.setState({ slatCoords: e }), this.props.onSlatCoords && this.props.onSlatCoords(e);
    };
  }
  render() {
    let { props: e, state: n } = this;
    return p(
      "div",
      { className: "fc-timegrid-body", ref: this.handleRootEl, style: {
        // these props are important to give this wrapper correct dimensions for interactions
        // TODO: if we set it here, can we avoid giving to inner tables?
        width: e.clientWidth,
        minWidth: e.tableMinWidth
      } },
      p(Lu, { axis: e.axis, dateProfile: e.dateProfile, slatMetas: e.slatMetas, clientWidth: e.clientWidth, minHeight: e.expandRows ? e.clientHeight : "", tableMinWidth: e.tableMinWidth, tableColGroupNode: e.axis ? e.tableColGroupNode : null, onCoords: this.handleSlatCoords }),
      p(Ju, { cells: e.cells, axis: e.axis, dateProfile: e.dateProfile, businessHourSegs: e.businessHourSegs, bgEventSegs: e.bgEventSegs, fgEventSegs: e.fgEventSegs, dateSelectionSegs: e.dateSelectionSegs, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, todayRange: e.todayRange, nowDate: e.nowDate, nowIndicatorSegs: e.nowIndicatorSegs, clientWidth: e.clientWidth, tableMinWidth: e.tableMinWidth, tableColGroupNode: e.tableColGroupNode, slatCoords: n.slatCoords, onColCoords: this.handleColCoords, forPrint: e.forPrint })
    );
  }
  componentDidMount() {
    this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
  }
  componentDidUpdate(e) {
    this.scrollResponder.update(e.dateProfile !== this.props.dateProfile);
  }
  componentWillUnmount() {
    this.scrollResponder.detach();
  }
  queryHit(e, n) {
    let { dateEnv: i, options: r } = this.context, { colCoords: s } = this, { dateProfile: a } = this.props, { slatCoords: l } = this.state, { snapDuration: o, snapsPerSlot: d } = this.processSlotOptions(this.props.slotDuration, r.snapDuration), c = s.leftToIndex(e), h = l.positions.topToIndex(n);
    if (c != null && h != null) {
      let f = this.props.cells[c], u = l.positions.tops[h], v = l.positions.getHeight(h), y = (n - u) / v, b = Math.floor(y * d), E = h * d + b, C = this.props.cells[c].date, T = nn(a.slotMinTime, qa(o, E)), A = i.add(C, T), O = i.add(A, o);
      return {
        dateProfile: a,
        dateSpan: Object.assign({ range: { start: A, end: O }, allDay: !1 }, f.extraDateSpan),
        dayEl: s.els[c],
        rect: {
          left: s.lefts[c],
          right: s.rights[c],
          top: u,
          bottom: u + v
        },
        layer: 0
      };
    }
    return null;
  }
}
function tf(t, e) {
  let n = e || t, i = Sn(t, n);
  return i === null && (n = t, i = 1), { snapDuration: n, snapsPerSlot: i };
}
class nf extends us {
  sliceRange(e, n) {
    let i = [];
    for (let r = 0; r < n.length; r += 1) {
      let s = _e(e, n[r]);
      s && i.push({
        start: s.start,
        end: s.end,
        isStart: s.start.valueOf() === e.start.valueOf(),
        isEnd: s.end.valueOf() === e.end.valueOf(),
        col: r
      });
    }
    return i;
  }
}
class rf extends K {
  constructor() {
    super(...arguments), this.buildDayRanges = D(sf), this.slicer = new nf(), this.timeColsRef = j();
  }
  render() {
    let { props: e, context: n } = this, { dateProfile: i, dayTableModel: r } = e, { nowIndicator: s, nextDayThreshold: a } = n.options, l = this.buildDayRanges(r, i, n.dateEnv);
    return p(Ve, { unit: s ? "minute" : "day" }, (o, d) => p(ef, Object.assign({ ref: this.timeColsRef }, this.slicer.sliceProps(e, i, null, n, l), { forPrint: e.forPrint, axis: e.axis, dateProfile: i, slatMetas: e.slatMetas, slotDuration: e.slotDuration, cells: r.cells[0], tableColGroupNode: e.tableColGroupNode, tableMinWidth: e.tableMinWidth, clientWidth: e.clientWidth, clientHeight: e.clientHeight, expandRows: e.expandRows, nowDate: o, nowIndicatorSegs: s && this.slicer.sliceNowDate(o, i, a, n, l), todayRange: d, onScrollTopRequest: e.onScrollTopRequest, onSlatCoords: e.onSlatCoords })));
  }
}
function sf(t, e, n) {
  let i = [];
  for (let r of t.headerDates)
    i.push({
      start: n.add(r, e.slotMinTime),
      end: n.add(r, e.slotMaxTime)
    });
  return i;
}
const tr = [
  { hours: 1 },
  { minutes: 30 },
  { minutes: 15 },
  { seconds: 30 },
  { seconds: 15 }
];
function af(t, e, n, i, r) {
  let s = /* @__PURE__ */ new Date(0), a = t, l = k(0), o = n || lf(i), d = [];
  for (; Z(a) < Z(e); ) {
    let c = r.add(s, a), h = Sn(l, o) !== null;
    d.push({
      date: c,
      time: a,
      key: c.toISOString(),
      isoTimeStr: hl(c),
      isLabeled: h
    }), a = nn(a, i), l = nn(l, i);
  }
  return d;
}
function lf(t) {
  let e, n, i;
  for (e = tr.length - 1; e >= 0; e -= 1)
    if (n = k(tr[e]), i = Sn(n, t), i !== null && i > 1)
      return n;
  return t;
}
class of extends Ou {
  constructor() {
    super(...arguments), this.buildTimeColsModel = D(cf), this.buildSlatMetas = D(af);
  }
  render() {
    let { options: e, dateEnv: n, dateProfileGenerator: i } = this.context, { props: r } = this, { dateProfile: s } = r, a = this.buildTimeColsModel(s, i), l = this.allDaySplitter.splitProps(r), o = this.buildSlatMetas(s.slotMinTime, s.slotMaxTime, e.slotLabelInterval, e.slotDuration, n), { dayMinWidth: d } = e, c = !d, h = d, f = e.dayHeaders && p(os, { dates: a.headerDates, dateProfile: s, datesRepDistinctDays: !0, renderIntro: c ? this.renderHeadAxis : null }), u = e.allDaySlot !== !1 && ((y) => p(js, Object.assign({}, l.allDay, { dateProfile: s, dayTableModel: a, nextDayThreshold: e.nextDayThreshold, tableMinWidth: y.tableMinWidth, colGroupNode: y.tableColGroupNode, renderRowIntro: c ? this.renderTableRowAxis : null, showWeekNumbers: !1, expandRows: !1, headerAlignElRef: this.headerElRef, clientWidth: y.clientWidth, clientHeight: y.clientHeight, forPrint: r.forPrint }, this.getAllDayMaxEventProps()))), v = (y) => p(rf, Object.assign({}, l.timed, { dayTableModel: a, dateProfile: s, axis: c, slotDuration: e.slotDuration, slatMetas: o, forPrint: r.forPrint, tableColGroupNode: y.tableColGroupNode, tableMinWidth: y.tableMinWidth, clientWidth: y.clientWidth, clientHeight: y.clientHeight, onSlatCoords: this.handleSlatCoords, expandRows: y.expandRows, onScrollTopRequest: this.handleScrollTopRequest }));
    return h ? this.renderHScrollLayout(f, u, v, a.colCnt, d, o, this.state.slatCoords) : this.renderSimpleLayout(f, u, v);
  }
}
function cf(t, e) {
  let n = new cs(t.renderRange, e);
  return new ds(n, !1);
}
const df = {
  allDaySlot: Boolean
};
var uf = se({
  name: "@fullcalendar/timegrid",
  initialView: "timeGridWeek",
  optionRefiners: df,
  views: {
    timeGrid: {
      component: of,
      usesMinMaxTime: !0,
      allDaySlot: !0,
      slotDuration: "00:30:00",
      slotEventOverlap: !0
      // a bad name. confused with overlap/constraint system
    },
    timeGridDay: {
      type: "timeGrid",
      duration: { days: 1 }
    },
    timeGridWeek: {
      type: "timeGrid",
      duration: { weeks: 1 }
    }
  }
});
jn.touchMouseIgnoreWait = 500;
let hn = 0, Ct = 0, pn = !1;
class Ys {
  constructor(e) {
    this.subjectEl = null, this.selector = "", this.handleSelector = "", this.shouldIgnoreMove = !1, this.shouldWatchScroll = !0, this.isDragging = !1, this.isTouchDragging = !1, this.wasTouchScroll = !1, this.handleMouseDown = (n) => {
      if (!this.shouldIgnoreMouse() && ff(n) && this.tryStart(n)) {
        let i = this.createEventFromMouse(n, !0);
        this.emitter.trigger("pointerdown", i), this.initScrollWatch(i), this.shouldIgnoreMove || document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("mouseup", this.handleMouseUp);
      }
    }, this.handleMouseMove = (n) => {
      let i = this.createEventFromMouse(n);
      this.recordCoords(i), this.emitter.trigger("pointermove", i);
    }, this.handleMouseUp = (n) => {
      document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), this.emitter.trigger("pointerup", this.createEventFromMouse(n)), this.cleanup();
    }, this.handleTouchStart = (n) => {
      if (this.tryStart(n)) {
        this.isTouchDragging = !0;
        let i = this.createEventFromTouch(n, !0);
        this.emitter.trigger("pointerdown", i), this.initScrollWatch(i);
        let r = n.target;
        this.shouldIgnoreMove || r.addEventListener("touchmove", this.handleTouchMove), r.addEventListener("touchend", this.handleTouchEnd), r.addEventListener("touchcancel", this.handleTouchEnd), window.addEventListener("scroll", this.handleTouchScroll, !0);
      }
    }, this.handleTouchMove = (n) => {
      let i = this.createEventFromTouch(n);
      this.recordCoords(i), this.emitter.trigger("pointermove", i);
    }, this.handleTouchEnd = (n) => {
      if (this.isDragging) {
        let i = n.target;
        i.removeEventListener("touchmove", this.handleTouchMove), i.removeEventListener("touchend", this.handleTouchEnd), i.removeEventListener("touchcancel", this.handleTouchEnd), window.removeEventListener("scroll", this.handleTouchScroll, !0), this.emitter.trigger("pointerup", this.createEventFromTouch(n)), this.cleanup(), this.isTouchDragging = !1, hf();
      }
    }, this.handleTouchScroll = () => {
      this.wasTouchScroll = !0;
    }, this.handleScroll = (n) => {
      if (!this.shouldIgnoreMove) {
        let i = window.pageXOffset - this.prevScrollX + this.prevPageX, r = window.pageYOffset - this.prevScrollY + this.prevPageY;
        this.emitter.trigger("pointermove", {
          origEvent: n,
          isTouch: this.isTouchDragging,
          subjectEl: this.subjectEl,
          pageX: i,
          pageY: r,
          deltaX: i - this.origPageX,
          deltaY: r - this.origPageY
        });
      }
    }, this.containerEl = e, this.emitter = new xt(), e.addEventListener("mousedown", this.handleMouseDown), e.addEventListener("touchstart", this.handleTouchStart, { passive: !0 }), pf();
  }
  destroy() {
    this.containerEl.removeEventListener("mousedown", this.handleMouseDown), this.containerEl.removeEventListener("touchstart", this.handleTouchStart, { passive: !0 }), gf();
  }
  tryStart(e) {
    let n = this.querySubjectEl(e), i = e.target;
    return n && (!this.handleSelector || U(i, this.handleSelector)) ? (this.subjectEl = n, this.isDragging = !0, this.wasTouchScroll = !1, !0) : !1;
  }
  cleanup() {
    pn = !1, this.isDragging = !1, this.subjectEl = null, this.destroyScrollWatch();
  }
  querySubjectEl(e) {
    return this.selector ? U(e.target, this.selector) : this.containerEl;
  }
  shouldIgnoreMouse() {
    return hn || this.isTouchDragging;
  }
  // can be called by user of this class, to cancel touch-based scrolling for the current drag
  cancelTouchScroll() {
    this.isDragging && (pn = !0);
  }
  // Scrolling that simulates pointermoves
  // ----------------------------------------------------------------------------------------------------
  initScrollWatch(e) {
    this.shouldWatchScroll && (this.recordCoords(e), window.addEventListener("scroll", this.handleScroll, !0));
  }
  recordCoords(e) {
    this.shouldWatchScroll && (this.prevPageX = e.pageX, this.prevPageY = e.pageY, this.prevScrollX = window.pageXOffset, this.prevScrollY = window.pageYOffset);
  }
  destroyScrollWatch() {
    this.shouldWatchScroll && window.removeEventListener("scroll", this.handleScroll, !0);
  }
  // Event Normalization
  // ----------------------------------------------------------------------------------------------------
  createEventFromMouse(e, n) {
    let i = 0, r = 0;
    return n ? (this.origPageX = e.pageX, this.origPageY = e.pageY) : (i = e.pageX - this.origPageX, r = e.pageY - this.origPageY), {
      origEvent: e,
      isTouch: !1,
      subjectEl: this.subjectEl,
      pageX: e.pageX,
      pageY: e.pageY,
      deltaX: i,
      deltaY: r
    };
  }
  createEventFromTouch(e, n) {
    let i = e.touches, r, s, a = 0, l = 0;
    return i && i.length ? (r = i[0].pageX, s = i[0].pageY) : (r = e.pageX, s = e.pageY), n ? (this.origPageX = r, this.origPageY = s) : (a = r - this.origPageX, l = s - this.origPageY), {
      origEvent: e,
      isTouch: !0,
      subjectEl: this.subjectEl,
      pageX: r,
      pageY: s,
      deltaX: a,
      deltaY: l
    };
  }
}
function ff(t) {
  return t.button === 0 && !t.ctrlKey;
}
function hf() {
  hn += 1, setTimeout(() => {
    hn -= 1;
  }, jn.touchMouseIgnoreWait);
}
function pf() {
  Ct += 1, Ct === 1 && window.addEventListener("touchmove", qs, { passive: !1 });
}
function gf() {
  Ct -= 1, Ct || window.removeEventListener("touchmove", qs, { passive: !1 });
}
function qs(t) {
  pn && t.preventDefault();
}
class mf {
  constructor() {
    this.isVisible = !1, this.sourceEl = null, this.mirrorEl = null, this.sourceElRect = null, this.parentNode = document.body, this.zIndex = 9999, this.revertDuration = 0;
  }
  start(e, n, i) {
    this.sourceEl = e, this.sourceElRect = this.sourceEl.getBoundingClientRect(), this.origScreenX = n - window.pageXOffset, this.origScreenY = i - window.pageYOffset, this.deltaX = 0, this.deltaY = 0, this.updateElPosition();
  }
  handleMove(e, n) {
    this.deltaX = e - window.pageXOffset - this.origScreenX, this.deltaY = n - window.pageYOffset - this.origScreenY, this.updateElPosition();
  }
  // can be called before start
  setIsVisible(e) {
    e ? this.isVisible || (this.mirrorEl && (this.mirrorEl.style.display = ""), this.isVisible = e, this.updateElPosition()) : this.isVisible && (this.mirrorEl && (this.mirrorEl.style.display = "none"), this.isVisible = e);
  }
  // always async
  stop(e, n) {
    let i = () => {
      this.cleanup(), n();
    };
    e && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
    (this.deltaX || this.deltaY) ? this.doRevertAnimation(i, this.revertDuration) : setTimeout(i, 0);
  }
  doRevertAnimation(e, n) {
    let i = this.mirrorEl, r = this.sourceEl.getBoundingClientRect();
    i.style.transition = "top " + n + "ms,left " + n + "ms", He(i, {
      left: r.left,
      top: r.top
    }), Ia(i, () => {
      i.style.transition = "", e();
    });
  }
  cleanup() {
    this.mirrorEl && (_n(this.mirrorEl), this.mirrorEl = null), this.sourceEl = null;
  }
  updateElPosition() {
    this.sourceEl && this.isVisible && He(this.getMirrorEl(), {
      left: this.sourceElRect.left + this.deltaX,
      top: this.sourceElRect.top + this.deltaY
    });
  }
  getMirrorEl() {
    let e = this.sourceElRect, n = this.mirrorEl;
    return n || (n = this.mirrorEl = this.sourceEl.cloneNode(!0), n.style.userSelect = "none", n.classList.add("fc-event-dragging"), He(n, {
      position: "fixed",
      zIndex: this.zIndex,
      visibility: "",
      boxSizing: "border-box",
      width: e.right - e.left,
      height: e.bottom - e.top,
      right: "auto",
      bottom: "auto",
      margin: 0
    }), this.parentNode.appendChild(n)), n;
  }
}
class Qs extends Ln {
  constructor(e, n) {
    super(), this.handleScroll = () => {
      this.scrollTop = this.scrollController.getScrollTop(), this.scrollLeft = this.scrollController.getScrollLeft(), this.handleScrollChange();
    }, this.scrollController = e, this.doesListening = n, this.scrollTop = this.origScrollTop = e.getScrollTop(), this.scrollLeft = this.origScrollLeft = e.getScrollLeft(), this.scrollWidth = e.getScrollWidth(), this.scrollHeight = e.getScrollHeight(), this.clientWidth = e.getClientWidth(), this.clientHeight = e.getClientHeight(), this.clientRect = this.computeClientRect(), this.doesListening && this.getEventTarget().addEventListener("scroll", this.handleScroll);
  }
  destroy() {
    this.doesListening && this.getEventTarget().removeEventListener("scroll", this.handleScroll);
  }
  getScrollTop() {
    return this.scrollTop;
  }
  getScrollLeft() {
    return this.scrollLeft;
  }
  setScrollTop(e) {
    this.scrollController.setScrollTop(e), this.doesListening || (this.scrollTop = Math.max(Math.min(e, this.getMaxScrollTop()), 0), this.handleScrollChange());
  }
  setScrollLeft(e) {
    this.scrollController.setScrollLeft(e), this.doesListening || (this.scrollLeft = Math.max(Math.min(e, this.getMaxScrollLeft()), 0), this.handleScrollChange());
  }
  getClientWidth() {
    return this.clientWidth;
  }
  getClientHeight() {
    return this.clientHeight;
  }
  getScrollWidth() {
    return this.scrollWidth;
  }
  getScrollHeight() {
    return this.scrollHeight;
  }
  handleScrollChange() {
  }
}
class $s extends Qs {
  constructor(e, n) {
    super(new ho(e), n);
  }
  getEventTarget() {
    return this.scrollController.el;
  }
  computeClientRect() {
    return lo(this.scrollController.el);
  }
}
class vf extends Qs {
  constructor(e) {
    super(new po(), e);
  }
  getEventTarget() {
    return window;
  }
  computeClientRect() {
    return {
      left: this.scrollLeft,
      right: this.scrollLeft + this.clientWidth,
      top: this.scrollTop,
      bottom: this.scrollTop + this.clientHeight
    };
  }
  // the window is the only scroll object that changes it's rectangle relative
  // to the document's topleft as it scrolls
  handleScrollChange() {
    this.clientRect = this.computeClientRect();
  }
}
const nr = typeof performance == "function" ? performance.now : Date.now;
class yf {
  constructor() {
    this.isEnabled = !0, this.scrollQuery = [window, ".fc-scroller"], this.edgeThreshold = 50, this.maxVelocity = 300, this.pointerScreenX = null, this.pointerScreenY = null, this.isAnimating = !1, this.scrollCaches = null, this.everMovedUp = !1, this.everMovedDown = !1, this.everMovedLeft = !1, this.everMovedRight = !1, this.animate = () => {
      if (this.isAnimating) {
        let e = this.computeBestEdge(this.pointerScreenX + window.pageXOffset, this.pointerScreenY + window.pageYOffset);
        if (e) {
          let n = nr();
          this.handleSide(e, (n - this.msSinceRequest) / 1e3), this.requestAnimation(n);
        } else
          this.isAnimating = !1;
      }
    };
  }
  start(e, n, i) {
    this.isEnabled && (this.scrollCaches = this.buildCaches(i), this.pointerScreenX = null, this.pointerScreenY = null, this.everMovedUp = !1, this.everMovedDown = !1, this.everMovedLeft = !1, this.everMovedRight = !1, this.handleMove(e, n));
  }
  handleMove(e, n) {
    if (this.isEnabled) {
      let i = e - window.pageXOffset, r = n - window.pageYOffset, s = this.pointerScreenY === null ? 0 : r - this.pointerScreenY, a = this.pointerScreenX === null ? 0 : i - this.pointerScreenX;
      s < 0 ? this.everMovedUp = !0 : s > 0 && (this.everMovedDown = !0), a < 0 ? this.everMovedLeft = !0 : a > 0 && (this.everMovedRight = !0), this.pointerScreenX = i, this.pointerScreenY = r, this.isAnimating || (this.isAnimating = !0, this.requestAnimation(nr()));
    }
  }
  stop() {
    if (this.isEnabled) {
      this.isAnimating = !1;
      for (let e of this.scrollCaches)
        e.destroy();
      this.scrollCaches = null;
    }
  }
  requestAnimation(e) {
    this.msSinceRequest = e, requestAnimationFrame(this.animate);
  }
  handleSide(e, n) {
    let { scrollCache: i } = e, { edgeThreshold: r } = this, s = r - e.distance, a = (
      // the closer to the edge, the faster we scroll
      s * s / (r * r) * // quadratic
      this.maxVelocity * n
    ), l = 1;
    switch (e.name) {
      case "left":
        l = -1;
      case "right":
        i.setScrollLeft(i.getScrollLeft() + a * l);
        break;
      case "top":
        l = -1;
      case "bottom":
        i.setScrollTop(i.getScrollTop() + a * l);
        break;
    }
  }
  // left/top are relative to document topleft
  computeBestEdge(e, n) {
    let { edgeThreshold: i } = this, r = null, s = this.scrollCaches || [];
    for (let a of s) {
      let l = a.clientRect, o = e - l.left, d = l.right - e, c = n - l.top, h = l.bottom - n;
      o >= 0 && d >= 0 && c >= 0 && h >= 0 && (c <= i && this.everMovedUp && a.canScrollUp() && (!r || r.distance > c) && (r = { scrollCache: a, name: "top", distance: c }), h <= i && this.everMovedDown && a.canScrollDown() && (!r || r.distance > h) && (r = { scrollCache: a, name: "bottom", distance: h }), o <= i && this.everMovedLeft && a.canScrollLeft() && (!r || r.distance > o) && (r = { scrollCache: a, name: "left", distance: o }), d <= i && this.everMovedRight && a.canScrollRight() && (!r || r.distance > d) && (r = { scrollCache: a, name: "right", distance: d }));
    }
    return r;
  }
  buildCaches(e) {
    return this.queryScrollEls(e).map((n) => n === window ? new vf(!1) : new $s(n, !1));
  }
  queryScrollEls(e) {
    let n = [];
    for (let i of this.scrollQuery)
      typeof i == "object" ? n.push(i) : n.push(...Array.prototype.slice.call(e.getRootNode().querySelectorAll(i)));
    return n;
  }
}
class Ge extends qo {
  constructor(e, n) {
    super(e), this.containerEl = e, this.delay = null, this.minDistance = 0, this.touchScrollAllowed = !0, this.mirrorNeedsRevert = !1, this.isInteracting = !1, this.isDragging = !1, this.isDelayEnded = !1, this.isDistanceSurpassed = !1, this.delayTimeoutId = null, this.onPointerDown = (r) => {
      this.isDragging || (this.isInteracting = !0, this.isDelayEnded = !1, this.isDistanceSurpassed = !1, Oa(document.body), Pa(document.body), r.isTouch || r.origEvent.preventDefault(), this.emitter.trigger("pointerdown", r), this.isInteracting && // not destroyed via pointerdown handler
      !this.pointer.shouldIgnoreMove && (this.mirror.setIsVisible(!1), this.mirror.start(r.subjectEl, r.pageX, r.pageY), this.startDelay(r), this.minDistance || this.handleDistanceSurpassed(r)));
    }, this.onPointerMove = (r) => {
      if (this.isInteracting) {
        if (this.emitter.trigger("pointermove", r), !this.isDistanceSurpassed) {
          let s = this.minDistance, a, { deltaX: l, deltaY: o } = r;
          a = l * l + o * o, a >= s * s && this.handleDistanceSurpassed(r);
        }
        this.isDragging && (r.origEvent.type !== "scroll" && (this.mirror.handleMove(r.pageX, r.pageY), this.autoScroller.handleMove(r.pageX, r.pageY)), this.emitter.trigger("dragmove", r));
      }
    }, this.onPointerUp = (r) => {
      this.isInteracting && (this.isInteracting = !1, Na(document.body), Ha(document.body), this.emitter.trigger("pointerup", r), this.isDragging && (this.autoScroller.stop(), this.tryStopDrag(r)), this.delayTimeoutId && (clearTimeout(this.delayTimeoutId), this.delayTimeoutId = null));
    };
    let i = this.pointer = new Ys(e);
    i.emitter.on("pointerdown", this.onPointerDown), i.emitter.on("pointermove", this.onPointerMove), i.emitter.on("pointerup", this.onPointerUp), n && (i.selector = n), this.mirror = new mf(), this.autoScroller = new yf();
  }
  destroy() {
    this.pointer.destroy(), this.onPointerUp({});
  }
  startDelay(e) {
    typeof this.delay == "number" ? this.delayTimeoutId = setTimeout(() => {
      this.delayTimeoutId = null, this.handleDelayEnd(e);
    }, this.delay) : this.handleDelayEnd(e);
  }
  handleDelayEnd(e) {
    this.isDelayEnded = !0, this.tryStartDrag(e);
  }
  handleDistanceSurpassed(e) {
    this.isDistanceSurpassed = !0, this.tryStartDrag(e);
  }
  tryStartDrag(e) {
    this.isDelayEnded && this.isDistanceSurpassed && (!this.pointer.wasTouchScroll || this.touchScrollAllowed) && (this.isDragging = !0, this.mirrorNeedsRevert = !1, this.autoScroller.start(e.pageX, e.pageY, this.containerEl), this.emitter.trigger("dragstart", e), this.touchScrollAllowed === !1 && this.pointer.cancelTouchScroll());
  }
  tryStopDrag(e) {
    this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, e));
  }
  stopDrag(e) {
    this.isDragging = !1, this.emitter.trigger("dragend", e);
  }
  // fill in the implementations...
  setIgnoreMove(e) {
    this.pointer.shouldIgnoreMove = e;
  }
  setMirrorIsVisible(e) {
    this.mirror.setIsVisible(e);
  }
  setMirrorNeedsRevert(e) {
    this.mirrorNeedsRevert = e;
  }
  setAutoScrollEnabled(e) {
    this.autoScroller.isEnabled = e;
  }
}
class bf {
  constructor(e) {
    this.origRect = Hn(e), this.scrollCaches = Wr(e).map((n) => new $s(n, !0));
  }
  destroy() {
    for (let e of this.scrollCaches)
      e.destroy();
  }
  computeLeft() {
    let e = this.origRect.left;
    for (let n of this.scrollCaches)
      e += n.origScrollLeft - n.getScrollLeft();
    return e;
  }
  computeTop() {
    let e = this.origRect.top;
    for (let n of this.scrollCaches)
      e += n.origScrollTop - n.getScrollTop();
    return e;
  }
  isWithinClipping(e, n) {
    let i = { left: e, top: n };
    for (let r of this.scrollCaches)
      if (!Ef(r.getEventTarget()) && !Wl(i, r.clientRect))
        return !1;
    return !0;
  }
}
function Ef(t) {
  let e = t.tagName;
  return e === "HTML" || e === "BODY";
}
class kt {
  constructor(e, n) {
    this.useSubjectCenter = !1, this.requireInitial = !0, this.initialHit = null, this.movingHit = null, this.finalHit = null, this.handlePointerDown = (i) => {
      let { dragging: r } = this;
      this.initialHit = null, this.movingHit = null, this.finalHit = null, this.prepareHits(), this.processFirstCoord(i), this.initialHit || !this.requireInitial ? (r.setIgnoreMove(!1), this.emitter.trigger("pointerdown", i)) : r.setIgnoreMove(!0);
    }, this.handleDragStart = (i) => {
      this.emitter.trigger("dragstart", i), this.handleMove(i, !0);
    }, this.handleDragMove = (i) => {
      this.emitter.trigger("dragmove", i), this.handleMove(i);
    }, this.handlePointerUp = (i) => {
      this.releaseHits(), this.emitter.trigger("pointerup", i);
    }, this.handleDragEnd = (i) => {
      this.movingHit && this.emitter.trigger("hitupdate", null, !0, i), this.finalHit = this.movingHit, this.movingHit = null, this.emitter.trigger("dragend", i);
    }, this.droppableStore = n, e.emitter.on("pointerdown", this.handlePointerDown), e.emitter.on("dragstart", this.handleDragStart), e.emitter.on("dragmove", this.handleDragMove), e.emitter.on("pointerup", this.handlePointerUp), e.emitter.on("dragend", this.handleDragEnd), this.dragging = e, this.emitter = new xt();
  }
  // sets initialHit
  // sets coordAdjust
  processFirstCoord(e) {
    let n = { left: e.pageX, top: e.pageY }, i = n, r = e.subjectEl, s;
    r instanceof HTMLElement && (s = Hn(r), i = Vl(i, s));
    let a = this.initialHit = this.queryHitForOffset(i.left, i.top);
    if (a) {
      if (this.useSubjectCenter && s) {
        let l = zr(s, a.rect);
        l && (i = Gl(l));
      }
      this.coordAdjust = Yl(i, n);
    } else
      this.coordAdjust = { left: 0, top: 0 };
  }
  handleMove(e, n) {
    let i = this.queryHitForOffset(e.pageX + this.coordAdjust.left, e.pageY + this.coordAdjust.top);
    (n || !Mt(this.movingHit, i)) && (this.movingHit = i, this.emitter.trigger("hitupdate", i, !1, e));
  }
  prepareHits() {
    this.offsetTrackers = ne(this.droppableStore, (e) => (e.component.prepareHits(), new bf(e.el)));
  }
  releaseHits() {
    let { offsetTrackers: e } = this;
    for (let n in e)
      e[n].destroy();
    this.offsetTrackers = {};
  }
  queryHitForOffset(e, n) {
    let { droppableStore: i, offsetTrackers: r } = this, s = null;
    for (let a in i) {
      let l = i[a].component, o = r[a];
      if (o && // wasn't destroyed mid-drag
      o.isWithinClipping(e, n)) {
        let d = o.computeLeft(), c = o.computeTop(), h = e - d, f = n - c, { origRect: u } = o, v = u.right - u.left, y = u.bottom - u.top;
        if (
          // must be within the element's bounds
          h >= 0 && h < v && f >= 0 && f < y
        ) {
          let b = l.queryHit(h, f, v, y);
          b && // make sure the hit is within activeRange, meaning it's not a dead cell
          Rt(b.dateProfile.activeRange, b.dateSpan.range) && (!s || b.layer > s.layer) && (b.componentId = a, b.context = l.context, b.rect.left += d, b.rect.right += d, b.rect.top += c, b.rect.bottom += c, s = b);
        }
      }
    }
    return s;
  }
}
function Mt(t, e) {
  return !t && !e ? !0 : !!t != !!e ? !1 : No(t.dateSpan, e.dateSpan);
}
function Zs(t, e) {
  let n = {};
  for (let i of e.pluginHooks.datePointTransforms)
    Object.assign(n, i(t, e));
  return Object.assign(n, _f(t, e.dateEnv)), n;
}
function _f(t, e) {
  return {
    date: e.toDate(t.range.start),
    dateStr: e.formatIso(t.range.start, { omitTime: t.allDay }),
    allDay: t.allDay
  };
}
class wf extends Oe {
  constructor(e) {
    super(e), this.handlePointerDown = (i) => {
      let { dragging: r } = this, s = i.origEvent.target;
      r.setIgnoreMove(!this.component.isValidDateDownEl(s));
    }, this.handleDragEnd = (i) => {
      let { component: r } = this, { pointer: s } = this.dragging;
      if (!s.wasTouchScroll) {
        let { initialHit: a, finalHit: l } = this.hitDragging;
        if (a && l && Mt(a, l)) {
          let { context: o } = r, d = Object.assign(Object.assign({}, Zs(a.dateSpan, o)), { dayEl: a.dayEl, jsEvent: i.origEvent, view: o.viewApi || o.calendarApi.view });
          o.emitter.trigger("dateClick", d);
        }
      }
    }, this.dragging = new Ge(e.el), this.dragging.autoScroller.isEnabled = !1;
    let n = this.hitDragging = new kt(this.dragging, Fn(e));
    n.emitter.on("pointerdown", this.handlePointerDown), n.emitter.on("dragend", this.handleDragEnd);
  }
  destroy() {
    this.dragging.destroy();
  }
}
class Cf extends Oe {
  constructor(e) {
    super(e), this.dragSelection = null, this.handlePointerDown = (a) => {
      let { component: l, dragging: o } = this, { options: d } = l.context, c = d.selectable && l.isValidDateDownEl(a.origEvent.target);
      o.setIgnoreMove(!c), o.delay = a.isTouch ? Sf(l) : null;
    }, this.handleDragStart = (a) => {
      this.component.context.calendarApi.unselect(a);
    }, this.handleHitUpdate = (a, l) => {
      let { context: o } = this.component, d = null, c = !1;
      if (a) {
        let h = this.hitDragging.initialHit;
        a.componentId === h.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(h, a) || (d = Df(h, a, o.pluginHooks.dateSelectionTransformers)), (!d || !cc(d, a.dateProfile, o)) && (c = !0, d = null);
      }
      d ? o.dispatch({ type: "SELECT_DATES", selection: d }) : l || o.dispatch({ type: "UNSELECT_DATES" }), c ? wn() : Cn(), l || (this.dragSelection = d);
    }, this.handlePointerUp = (a) => {
      this.dragSelection && (Yr(this.dragSelection, a, this.component.context), this.dragSelection = null);
    };
    let { component: n } = e, { options: i } = n.context, r = this.dragging = new Ge(e.el);
    r.touchScrollAllowed = !1, r.minDistance = i.selectMinDistance || 0, r.autoScroller.isEnabled = i.dragScroll;
    let s = this.hitDragging = new kt(this.dragging, Fn(e));
    s.emitter.on("pointerdown", this.handlePointerDown), s.emitter.on("dragstart", this.handleDragStart), s.emitter.on("hitupdate", this.handleHitUpdate), s.emitter.on("pointerup", this.handlePointerUp);
  }
  destroy() {
    this.dragging.destroy();
  }
}
function Sf(t) {
  let { options: e } = t.context, n = e.selectLongPressDelay;
  return n == null && (n = e.longPressDelay), n;
}
function Df(t, e, n) {
  let i = t.dateSpan, r = e.dateSpan, s = [
    i.range.start,
    i.range.end,
    r.range.start,
    r.range.end
  ];
  s.sort(Fa);
  let a = {};
  for (let l of n) {
    let o = l(t, e);
    if (o === !1)
      return null;
    o && Object.assign(a, o);
  }
  return a.range = { start: s[0], end: s[3] }, a.allDay = i.allDay, a;
}
class Ye extends Oe {
  constructor(e) {
    super(e), this.subjectEl = null, this.subjectSeg = null, this.isDragging = !1, this.eventRange = null, this.relevantEvents = null, this.receivingContext = null, this.validMutation = null, this.mutatedRelevantEvents = null, this.handlePointerDown = (a) => {
      let l = a.origEvent.target, { component: o, dragging: d } = this, { mirror: c } = d, { options: h } = o.context, f = o.context;
      this.subjectEl = a.subjectEl;
      let u = this.subjectSeg = Ie(a.subjectEl), y = (this.eventRange = u.eventRange).instance.instanceId;
      this.relevantEvents = Mn(f.getCurrentData().eventStore, y), d.minDistance = a.isTouch ? 0 : h.eventDragMinDistance, d.delay = // only do a touch delay if touch and this event hasn't been selected yet
      a.isTouch && y !== o.props.eventSelection ? Tf(o) : null, h.fixedMirrorParent ? c.parentNode = h.fixedMirrorParent : c.parentNode = U(l, ".fc"), c.revertDuration = h.dragRevertDuration;
      let b = o.isValidSegDownEl(l) && !U(l, ".fc-event-resizer");
      d.setIgnoreMove(!b), this.isDragging = b && a.subjectEl.classList.contains("fc-event-draggable");
    }, this.handleDragStart = (a) => {
      let l = this.component.context, o = this.eventRange, d = o.instance.instanceId;
      a.isTouch ? d !== this.component.props.eventSelection && l.dispatch({ type: "SELECT_EVENT", eventInstanceId: d }) : l.dispatch({ type: "UNSELECT_EVENT" }), this.isDragging && (l.calendarApi.unselect(a), l.emitter.trigger("eventDragStart", {
        el: this.subjectEl,
        event: new L(l, o.def, o.instance),
        jsEvent: a.origEvent,
        view: l.viewApi
      }));
    }, this.handleHitUpdate = (a, l) => {
      if (!this.isDragging)
        return;
      let o = this.relevantEvents, d = this.hitDragging.initialHit, c = this.component.context, h = null, f = null, u = null, v = !1, y = {
        affectedEvents: o,
        mutatedEvents: Y(),
        isEvent: !0
      };
      if (a) {
        h = a.context;
        let b = h.options;
        c === h || b.editable && b.droppable ? (f = Af(d, a, h.getCurrentData().pluginHooks.eventDragMutationMassagers), f && (u = zn(o, h.getCurrentData().eventUiBases, f, h), y.mutatedEvents = u, ps(y, a.dateProfile, h) || (v = !0, f = null, u = null, y.mutatedEvents = Y()))) : h = null;
      }
      this.displayDrag(h, y), v ? wn() : Cn(), l || (c === h && // TODO: write test for this
      Mt(d, a) && (f = null), this.dragging.setMirrorNeedsRevert(!f), this.dragging.setMirrorIsVisible(!a || !this.subjectEl.getRootNode().querySelector(".fc-event-mirror")), this.receivingContext = h, this.validMutation = f, this.mutatedRelevantEvents = u);
    }, this.handlePointerUp = () => {
      this.isDragging || this.cleanup();
    }, this.handleDragEnd = (a) => {
      if (this.isDragging) {
        let l = this.component.context, o = l.viewApi, { receivingContext: d, validMutation: c } = this, h = this.eventRange.def, f = this.eventRange.instance, u = new L(l, h, f), v = this.relevantEvents, y = this.mutatedRelevantEvents, { finalHit: b } = this.hitDragging;
        if (this.clearDrag(), l.emitter.trigger("eventDragStop", {
          el: this.subjectEl,
          event: u,
          jsEvent: a.origEvent,
          view: o
        }), c) {
          if (d === l) {
            let E = new L(l, y.defs[h.defId], f ? y.instances[f.instanceId] : null);
            l.dispatch({
              type: "MERGE_EVENTS",
              eventStore: y
            });
            let C = {
              oldEvent: u,
              event: E,
              relatedEvents: ve(y, l, f),
              revert() {
                l.dispatch({
                  type: "MERGE_EVENTS",
                  eventStore: v
                  // the pre-change data
                });
              }
            }, T = {};
            for (let A of l.getCurrentData().pluginHooks.eventDropTransformers)
              Object.assign(T, A(c, l));
            l.emitter.trigger("eventDrop", Object.assign(Object.assign(Object.assign({}, C), T), { el: a.subjectEl, delta: c.datesDelta, jsEvent: a.origEvent, view: o })), l.emitter.trigger("eventChange", C);
          } else if (d) {
            let E = {
              event: u,
              relatedEvents: ve(v, l, f),
              revert() {
                l.dispatch({
                  type: "MERGE_EVENTS",
                  eventStore: v
                });
              }
            };
            l.emitter.trigger("eventLeave", Object.assign(Object.assign({}, E), { draggedEl: a.subjectEl, view: o })), l.dispatch({
              type: "REMOVE_EVENTS",
              eventStore: v
            }), l.emitter.trigger("eventRemove", E);
            let C = y.defs[h.defId], T = y.instances[f.instanceId], A = new L(d, C, T);
            d.dispatch({
              type: "MERGE_EVENTS",
              eventStore: y
            });
            let O = {
              event: A,
              relatedEvents: ve(y, d, T),
              revert() {
                d.dispatch({
                  type: "REMOVE_EVENTS",
                  eventStore: y
                });
              }
            };
            d.emitter.trigger("eventAdd", O), a.isTouch && d.dispatch({
              type: "SELECT_EVENT",
              eventInstanceId: f.instanceId
            }), d.emitter.trigger("drop", Object.assign(Object.assign({}, Zs(b.dateSpan, d)), { draggedEl: a.subjectEl, jsEvent: a.origEvent, view: b.context.viewApi })), d.emitter.trigger("eventReceive", Object.assign(Object.assign({}, O), { draggedEl: a.subjectEl, view: b.context.viewApi }));
          }
        } else
          l.emitter.trigger("_noEventDrop");
      }
      this.cleanup();
    };
    let { component: n } = this, { options: i } = n.context, r = this.dragging = new Ge(e.el);
    r.pointer.selector = Ye.SELECTOR, r.touchScrollAllowed = !1, r.autoScroller.isEnabled = i.dragScroll;
    let s = this.hitDragging = new kt(this.dragging, dn);
    s.useSubjectCenter = e.useEventCenter, s.emitter.on("pointerdown", this.handlePointerDown), s.emitter.on("dragstart", this.handleDragStart), s.emitter.on("hitupdate", this.handleHitUpdate), s.emitter.on("pointerup", this.handlePointerUp), s.emitter.on("dragend", this.handleDragEnd);
  }
  destroy() {
    this.dragging.destroy();
  }
  // render a drag state on the next receivingCalendar
  displayDrag(e, n) {
    let i = this.component.context, r = this.receivingContext;
    r && r !== e && (r === i ? r.dispatch({
      type: "SET_EVENT_DRAG",
      state: {
        affectedEvents: n.affectedEvents,
        mutatedEvents: Y(),
        isEvent: !0
      }
    }) : r.dispatch({ type: "UNSET_EVENT_DRAG" })), e && e.dispatch({ type: "SET_EVENT_DRAG", state: n });
  }
  clearDrag() {
    let e = this.component.context, { receivingContext: n } = this;
    n && n.dispatch({ type: "UNSET_EVENT_DRAG" }), e !== n && e.dispatch({ type: "UNSET_EVENT_DRAG" });
  }
  cleanup() {
    this.subjectSeg = null, this.isDragging = !1, this.eventRange = null, this.relevantEvents = null, this.receivingContext = null, this.validMutation = null, this.mutatedRelevantEvents = null;
  }
}
Ye.SELECTOR = ".fc-event-draggable, .fc-event-resizable";
function Af(t, e, n) {
  let i = t.dateSpan, r = e.dateSpan, s = i.range.start, a = r.range.start, l = {};
  i.allDay !== r.allDay && (l.allDay = r.allDay, l.hasEnd = e.context.options.allDayMaintainDuration, r.allDay && (s = P(s)));
  let o = Ae(s, a, t.context.dateEnv, t.componentId === e.componentId ? t.largeUnit : null);
  o.milliseconds && (l.allDay = !1);
  let d = {
    datesDelta: o,
    standardProps: l
  };
  for (let c of n)
    c(d, t, e);
  return d;
}
function Tf(t) {
  let { options: e } = t.context, n = e.eventLongPressDelay;
  return n == null && (n = e.longPressDelay), n;
}
class Rf extends Oe {
  constructor(e) {
    super(e), this.draggingSegEl = null, this.draggingSeg = null, this.eventRange = null, this.relevantEvents = null, this.validMutation = null, this.mutatedRelevantEvents = null, this.handlePointerDown = (s) => {
      let { component: a } = this, l = this.querySegEl(s), o = Ie(l), d = this.eventRange = o.eventRange;
      this.dragging.minDistance = a.context.options.eventDragMinDistance, this.dragging.setIgnoreMove(!this.component.isValidSegDownEl(s.origEvent.target) || s.isTouch && this.component.props.eventSelection !== d.instance.instanceId);
    }, this.handleDragStart = (s) => {
      let { context: a } = this.component, l = this.eventRange;
      this.relevantEvents = Mn(a.getCurrentData().eventStore, this.eventRange.instance.instanceId);
      let o = this.querySegEl(s);
      this.draggingSegEl = o, this.draggingSeg = Ie(o), a.calendarApi.unselect(), a.emitter.trigger("eventResizeStart", {
        el: o,
        event: new L(a, l.def, l.instance),
        jsEvent: s.origEvent,
        view: a.viewApi
      });
    }, this.handleHitUpdate = (s, a, l) => {
      let { context: o } = this.component, d = this.relevantEvents, c = this.hitDragging.initialHit, h = this.eventRange.instance, f = null, u = null, v = !1, y = {
        affectedEvents: d,
        mutatedEvents: Y(),
        isEvent: !0
      };
      s && (s.componentId === c.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(c, s) || (f = xf(c, s, l.subjectEl.classList.contains("fc-event-resizer-start"), h.range))), f && (u = zn(d, o.getCurrentData().eventUiBases, f, o), y.mutatedEvents = u, ps(y, s.dateProfile, o) || (v = !0, f = null, u = null, y.mutatedEvents = null)), u ? o.dispatch({
        type: "SET_EVENT_RESIZE",
        state: y
      }) : o.dispatch({ type: "UNSET_EVENT_RESIZE" }), v ? wn() : Cn(), a || (f && Mt(c, s) && (f = null), this.validMutation = f, this.mutatedRelevantEvents = u);
    }, this.handleDragEnd = (s) => {
      let { context: a } = this.component, l = this.eventRange.def, o = this.eventRange.instance, d = new L(a, l, o), c = this.relevantEvents, h = this.mutatedRelevantEvents;
      if (a.emitter.trigger("eventResizeStop", {
        el: this.draggingSegEl,
        event: d,
        jsEvent: s.origEvent,
        view: a.viewApi
      }), this.validMutation) {
        let f = new L(a, h.defs[l.defId], o ? h.instances[o.instanceId] : null);
        a.dispatch({
          type: "MERGE_EVENTS",
          eventStore: h
        });
        let u = {
          oldEvent: d,
          event: f,
          relatedEvents: ve(h, a, o),
          revert() {
            a.dispatch({
              type: "MERGE_EVENTS",
              eventStore: c
              // the pre-change events
            });
          }
        };
        a.emitter.trigger("eventResize", Object.assign(Object.assign({}, u), { el: this.draggingSegEl, startDelta: this.validMutation.startDelta || k(0), endDelta: this.validMutation.endDelta || k(0), jsEvent: s.origEvent, view: a.viewApi })), a.emitter.trigger("eventChange", u);
      } else
        a.emitter.trigger("_noEventResize");
      this.draggingSeg = null, this.relevantEvents = null, this.validMutation = null;
    };
    let { component: n } = e, i = this.dragging = new Ge(e.el);
    i.pointer.selector = ".fc-event-resizer", i.touchScrollAllowed = !1, i.autoScroller.isEnabled = n.context.options.dragScroll;
    let r = this.hitDragging = new kt(this.dragging, Fn(e));
    r.emitter.on("pointerdown", this.handlePointerDown), r.emitter.on("dragstart", this.handleDragStart), r.emitter.on("hitupdate", this.handleHitUpdate), r.emitter.on("dragend", this.handleDragEnd);
  }
  destroy() {
    this.dragging.destroy();
  }
  querySegEl(e) {
    return U(e.subjectEl, ".fc-event");
  }
}
function xf(t, e, n, i) {
  let r = t.context.dateEnv, s = t.dateSpan.range.start, a = e.dateSpan.range.start, l = Ae(s, a, r, t.largeUnit);
  if (n) {
    if (r.add(i.start, l) < i.end)
      return { startDelta: l };
  } else if (r.add(i.end, l) > i.start)
    return { endDelta: l };
  return null;
}
class kf {
  constructor(e) {
    this.context = e, this.isRecentPointerDateSelect = !1, this.matchesCancel = !1, this.matchesEvent = !1, this.onSelect = (i) => {
      i.jsEvent && (this.isRecentPointerDateSelect = !0);
    }, this.onDocumentPointerDown = (i) => {
      let r = this.context.options.unselectCancel, s = Ar(i.origEvent);
      this.matchesCancel = !!U(s, r), this.matchesEvent = !!U(s, Ye.SELECTOR);
    }, this.onDocumentPointerUp = (i) => {
      let { context: r } = this, { documentPointer: s } = this, a = r.getCurrentData();
      if (!s.wasTouchScroll) {
        if (a.dateSelection && // an existing date selection?
        !this.isRecentPointerDateSelect) {
          let l = r.options.unselectAuto;
          l && (!l || !this.matchesCancel) && r.calendarApi.unselect(i);
        }
        a.eventSelection && // an existing event selected?
        !this.matchesEvent && r.dispatch({ type: "UNSELECT_EVENT" });
      }
      this.isRecentPointerDateSelect = !1;
    };
    let n = this.documentPointer = new Ys(document);
    n.shouldIgnoreMove = !0, n.shouldWatchScroll = !1, n.emitter.on("pointerdown", this.onDocumentPointerDown), n.emitter.on("pointerup", this.onDocumentPointerUp), e.emitter.on("select", this.onSelect);
  }
  destroy() {
    this.context.emitter.off("select", this.onSelect), this.documentPointer.destroy();
  }
}
const Mf = {
  fixedMirrorParent: m
}, If = {
  dateClick: m,
  eventDragStart: m,
  eventDragStop: m,
  eventDrop: m,
  eventResizeStart: m,
  eventResizeStop: m,
  eventResize: m,
  drop: m,
  eventReceive: m,
  eventLeave: m
};
jn.dataAttrPrefix = "";
var Of = se({
  name: "@fullcalendar/interaction",
  componentInteractions: [wf, Cf, Ye, Rf],
  calendarInteractions: [kf],
  elementDraggingImpl: Ge,
  optionRefiners: Mf,
  listenerRefiners: If
});
const Nf = ':host{display:block;height:100%;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-color-blue-100:#e0e6f9;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;--nylas-color-black:#000000;--nylas-color-grey-900:#2c2c2c;--nylas-color-grey-800:#4b4b4b;--nylas-color-grey-700:#6e6e6e;--nylas-color-grey-600:#8e8e8e;--nylas-color-grey-500:#b3b3b3;--nylas-color-grey-400:#cacaca;--nylas-color-grey-300:#e1e1e1;--nylas-color-grey-200:#eaeaea;--nylas-color-grey-100:#f5f5f5;--nylas-color-grey-50:#fbfcfe;--nylas-color-white:#ffffff;--nylas-color-red-900:#992222;--nylas-color-red-700:#cc4841;--nylas-color-red-500:#ff786a;--nylas-color-red-300:#ffa79e;--nylas-color-red-100:#ffc5bf;--nylas-color-red-50:#ffeae8;--nylas-color-blue-900:#213571;--nylas-color-blue-700:#314fa9;--nylas-color-blue-500:#4169e1;--nylas-color-blue-300:#bdccf9;--nylas-color-blue-100:#e0e6f9;--nylas-color-blue-50:#f6f8fd;--nylas-color-yellow-900:#7c6506;--nylas-color-yellow-700:#c29f09;--nylas-color-yellow-500:#f7c90b;--nylas-color-yellow-300:#f9de70;--nylas-color-yellow-100:#fceba9;--nylas-color-yellow-50:#fdf4ce;--nylas-color-green-900:#0e6b60;--nylas-color-green-700:#16a392;--nylas-color-green-500:#17c3b2;--nylas-color-green-300:#74dbd1;--nylas-color-green-100:#a2e7e0;--nylas-color-green-50:#d1f3f0;--nylas-color-purple-900:#643554;--nylas-color-purple-700:#954f7d;--nylas-color-purple-500:#c769a7;--nylas-color-purple-300:#dda5ca;--nylas-color-purple-100:#e0bdd6;--nylas-color-purple-50:#e9dde5;--nylas-color-sky-900:#20698f;--nylas-color-sky-700:#2b8fc2;--nylas-color-sky-500:#6dceff;--nylas-color-sky-300:#8fdaff;--nylas-color-sky-100:#b8e7ff;--nylas-color-sky-50:#d9f2ff}.nylas-event-calendar{height:inherit;padding:0 16px}.calendar-header{display:flex;justify-content:space-between;align-items:center}@media screen and (max-width: 768px){.calendar-header{flex-direction:column;align-items:flex-start;margin-bottom:16px}}.calendar-header .calendar-header__title{display:flex;align-items:center;gap:16px;font-family:var(--nylas-font-family);font-size:20px;font-weight:600;line-height:30px;text-align:left;text-underline-position:from-font;text-decoration-skip-ink:none}.calendar-header .calendar-header__title .calendar-header-prev-next{display:flex}.calendar-header .calendar-header__title .calendar-header-prev-next .chevron-right{transform:rotate(180deg)}.calendar-header .calendar-header__title .calendar-header-prev-next .button{display:flex;flex-direction:row;justify-content:center;align-items:center;height:3vh;width:3vh;min-width:3em;min-height:3em;cursor:pointer;border-radius:var(--nylas-border-radius-2x);background-color:transparent;color:var(--nylas-base-800);cursor:pointer;border:none}.calendar-header .calendar-header__title .calendar-header-prev-next .button:hover{background-color:var(--nylas-base-50)}.calendar-header .calendar-header__title .calendar-header-prev-next .button:active{background-color:var(--nylas-base-100)}.calendar-header .calendar-header__title .calendar-header-prev-next .button:disabled{background-color:transparent;color:var(--nylas-base-300);cursor:not-allowed}.calendar-header .calendar-header__current-calendar{padding:6px 12px;border-radius:var(--nylas-border-radius);border:1px solid var(--nylas-base-200)}@media screen and (max-width: 768px){.calendar-header .calendar-header__view-options{display:grid;grid-template-columns:1fr 1fr 1fr;width:-webkit-fill-available}}.calendar-header .calendar-header__view-options button{color:var(--nylas-base-800);background:var(--nylas-base-0)}.calendar-header .calendar-header__view-options button.selected{background-color:var(--nylas-color-blue-100);border-radius:4px}.calendar-header .calendar-header__view-options button:hover:not(.selected){background:var(--nylas-base-50)}.calendar-header h3{font-size:1.5rem;font-weight:600}button{padding:0.5rem 1rem;margin-right:0.5rem;border:none;background-color:#0073e6;color:white;border-radius:4px;cursor:pointer;font-size:1rem}button:hover{background-color:#005bb5}.calendar-container{border:1px solid #ddd;border-radius:4px;box-shadow:0 2px 5px rgba(0, 0, 0, 0.1);flex:1;display:flex;flex-direction:column;height:calc(100% - 16px);min-height:0;position:relative;overflow-y:auto;z-index:0;--fc-today-bg-color:var(--nylas-base-0);--fc-now-indicator-color:var(--nylas-error)}@media screen and (max-width: 768px){.calendar-container{height:calc(100% - 116px)}}.calendar-container.show-event{height:calc(100% - 456px - 80px - 16px)}@media screen and (max-width: 768px){.calendar-container.show-event{height:calc(100% - 116px + 16px)}}.calendar-container.hide{display:none}.calendar-container .fc .fc-view-harness{overflow-y:auto;}.calendar-container .fc .fc-view-harness .fc-col-header{position:sticky;top:0;background:#fff;box-shadow:0px 2px 5px rgba(0, 0, 0, 0.1)}.calendar-container .fc .fc-view-harness .custom-day-header{display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:Arial, sans-serif;font-size:14px;color:#1e3a8a;font-weight:bold;text-transform:uppercase}.calendar-container .fc .fc-view-harness .custom-day-header .day-name{color:var(--nylas-base-400);margin-bottom:4px;font-family:var(--nylas-font-family);font-size:14px;font-weight:400;line-height:20px;text-align:left;text-underline-position:from-font;text-decoration-skip-ink:none}.calendar-container .fc .fc-view-harness .custom-day-header .day-number{font-size:16px;background-color:var(--nylas-base-0);color:var(--nylas-base-800);padding:6px;border-radius:50%;font-family:var(--nylas-font-family);font-size:22px;font-weight:500;line-height:32px;text-align:left;text-underline-position:from-font;text-decoration-skip-ink:none;width:44px;display:inline-flex;justify-content:center;align-items:center}.calendar-container .fc .fc-view-harness .custom-day-header .day-number.today{background-color:var(--nylas-primary);color:var(--nylas-base-0)}.calendar-container .fc .fc-timegrid-now-indicator-line{border-width:1.5px 0 0}.calendar-container .fc .fc-day-today .fc-daygrid-day-top .fc-daygrid-day-number{background-color:var(--nylas-primary);color:var(--nylas-base-0);border-radius:50%;width:36px;height:36px;margin:8px 8px}.calendar-container .fc .fc-daygrid-day-top{flex-direction:row}.calendar-container .fc .fc-daygrid-day-top .fc-daygrid-day-number{display:inline-flex;justify-content:center;align-items:center;padding:16px;color:var(--nylas-base-400);font-family:var(--nylas-font-family);font-size:14px;font-weight:400;line-height:20px;text-align:left;text-underline-position:from-font;text-decoration-skip-ink:none}.calendar-container .fc .fc-v-event{border:none}.calendar-container .fc .fc-v-event .fc-event-main{border-radius:2px}.calendar-container .fc .fc-v-event.group-event .fc-event-main{background:var(--nylas-color-green-50);color:var(--nylas-color-green-900)}.calendar-container .fc .fc-v-event.group-event:not(.read-only):not(.no-participants){cursor:pointer}.calendar-container .fc .fc-v-event.regular-event .fc-event-main{background:var(--nylas-color-blue-300);color:var(--nylas-base-800)}.calendar-container .fc .fc-v-event.regular-event:not(.read-only):not(.no-participants){cursor:pointer}.calendar-container .fc .fc-v-event.read-only,.calendar-container .fc .fc-v-event.no-participants{opacity:0.5;cursor:not-allowed}.action-options{position:absolute;top:0;left:0;display:flex;justify-content:center;align-items:center;width:100%;height:100%;background:rgba(0, 0, 0, 0.6);z-index:4}@media screen and (max-width: 768px){.action-options{height:calc(100% - 96px)}}.action-options.update-options,.action-options.delete-options,.action-options.discard-changes{height:calc(100% + 80px);border-bottom-left-radius:var(--nylas-border-radius-2x);border-bottom-right-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.action-options.update-options,.action-options.delete-options,.action-options.discard-changes{height:calc(100% + 176px)}}.action-options .action-options__card{display:flex;flex-direction:column;justify-content:center;background:var(--nylas-base-0);border-radius:var(--nylas-border-radius-2x);min-width:240px}.action-options .action-options__card.discard-changes__card{min-width:320px}.action-options .action-options__card button-component#close-edit-options,.action-options .action-options__card button-component#close-update-options,.action-options .action-options__card button-component#close-delete-options,.action-options .action-options__card button-component#close-discard-changes,.action-options .action-options__card button-component#close-choose-participants-modal{display:flex;justify-content:flex-end;padding-top:8px}.action-options .action-options__card button-component#close-edit-options button,.action-options .action-options__card button-component#close-update-options button,.action-options .action-options__card button-component#close-delete-options button,.action-options .action-options__card button-component#close-discard-changes button,.action-options .action-options__card button-component#close-choose-participants-modal button{padding:0;height:auto;width:auto}.action-options .action-options__card button-component#close-edit-options button:hover,.action-options .action-options__card button-component#close-update-options button:hover,.action-options .action-options__card button-component#close-delete-options button:hover,.action-options .action-options__card button-component#close-discard-changes button:hover,.action-options .action-options__card button-component#close-choose-participants-modal button:hover{background-color:transparent !important}.action-options .action-options__card .action-options__header{display:flex;justify-content:space-between;align-items:center;padding-bottom:8px;border-bottom:1px solid var(--nylas-base-200)}.action-options .action-options__card .action-options__header h3{font-family:var(--nylas-font-family);font-size:18px;font-weight:500;line-height:30px;text-align:left;text-underline-position:from-font;text-decoration-skip-ink:none;color:var(--nylas-base-900);margin:0;padding:8px 16px 0}.action-options .action-options__card .action-options__content.choose-participants-modal__content{padding:24px;display:flex;flex-direction:column;gap:16px;width:400px;max-height:200px;overflow-y:auto}@media screen and (max-width: 768px){.action-options .action-options__card .action-options__content.choose-participants-modal__content{width:-webkit-fill-available;max-height:120px}}.action-options .action-options__card .action-options__content.discard-changes__content{padding:24px}.action-options .action-options__card .action-options__content.discard-changes__content h3{font-family:var(--nylas-font-family);font-size:20px;font-weight:500;line-height:30px;text-align:left;text-underline-position:from-font;text-decoration-skip-ink:none;color:var(--nylas-base-900);margin:0}.action-options .action-options__card .action-options__content ul{padding:0;list-style-type:none;color:var(--nylas-base-900);max-height:336px}.action-options .action-options__card .action-options__content ul li{padding:16px, 12px, 16px, 12px;color:var(--nylas-base-900);padding:12px 16px;text-decoration:none;display:block;font-family:var(--nylas-font-family);font-weight:400;font-size:14px;line-height:21px;letter-spacing:0px;text-align:left;cursor:pointer}.action-options .action-options__card .action-options__content ul li:hover,.action-options .action-options__card .action-options__content ul li:focus{background-color:var(--nylas-base-100)}.action-options .action-options__card .action-options__content ul li.disabled{cursor:not-allowed;opacity:0.5}.action-options .action-options__card .action-options__footer{display:flex;justify-content:flex-end;gap:16px;padding:16px;border-top:1px solid var(--nylas-base-200)}.event-details-container{position:absolute;bottom:-80px;left:0;width:100%;z-index:3;background:var(--nylas-base-0);box-shadow:4px -8px 12px -12px rgba(0, 0, 0, 0.5);border-bottom-left-radius:var(--nylas-border-radius-2x);border-bottom-right-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.event-details-container{bottom:-176px}}.event-details-container .event-details-header{margin-bottom:16px;display:flex;justify-content:space-between;align-items:center;padding:0 16px;border-bottom:1px solid var(--nylas-base-200)}.event-details-container .event-details-header div.event-details-header__actions{display:flex;align-items:center;gap:16px}.event-details-container .event-details-header div.event-details-header__actions button-component#close button{padding:0;height:auto}.event-details-container .event-details-header div.event-details-header__actions button-component#close button:hover{background-color:transparent !important}.event-details-container .event-details{max-height:440px;overflow-y:scroll;padding:0 16px;display:flex;flex-direction:column;gap:16px;margin-bottom:16px}.event-details-container .event-details.edit-event-details nylas-additional-participants{margin:16px 0}.event-details-container .event-details.edit-event-details nylas-additional-participants::part(nfc){border:none}.event-details-container .event-details.edit-event-details nylas-additional-participants::part(nadtnlpart__title){font-weight:400}.event-details-container .event-details.edit-event-details nylas-additional-participants::part(nadtnlpart__content){padding:16px 0}.event-details-container .event-details.edit-event-details nylas-additional-participants::part(nfc__header){padding:0;border-bottom:none}.event-details-container .event-details .event-details-form-inputs{display:flex;flex-direction:column;gap:16px}.event-details-container .event-details-footer{display:flex;justify-content:flex-end;gap:16px;padding:16px;border-top:1px solid var(--nylas-base-200)}.event-details-container .event-details-footer .event-details-footer__error{color:var(--nylas-error);font-family:var(--nylas-font-family);font-size:14px;font-weight:400;line-height:20px;text-align:left;text-underline-position:from-font}.event-details-container .event-details-footer .event-details-footer__helper-text{color:var(--nylas-base-800);font-family:var(--nylas-font-family);font-size:14px;font-weight:400;line-height:20px;text-align:left;text-underline-position:from-font}.event-details-container .event-details-footer .event-details-footer__actions{display:flex;gap:16px}', Pf = Nf;
var Hf = function(t, e, n, i) {
  var r = arguments.length, s = r < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, n) : i, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(t, e, n, i);
  else
    for (var l = t.length - 1; l >= 0; l--)
      (a = t[l]) && (s = (r < 3 ? a(s) : r > 3 ? a(e, n, s) : a(e, n)) || s);
  return r > 3 && s && Object.defineProperty(e, n, s), s;
}, Zt = function(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
};
R.extend(ir);
R.extend(rr);
const it = {
  day: "timeGridDay",
  week: "timeGridWeek",
  month: "dayGridMonth"
}, Lf = {
  timeGridDay: "day",
  timeGridWeek: "week",
  dayGridMonth: "month"
}, Bf = [
  { label: _.t("nylasEventCalendar.editOptions.import") || "Import", value: "import", langKey: "nylasEventCalendar.editOptions.import" },
  { label: _.t("nylasEventCalendar.editOptions.edit") || "Edit", value: "edit", langKey: "nylasEventCalendar.editOptions.edit" },
  { label: _.t("nylasEventCalendar.editOptions.deleteThis") || "Delete this event only", value: "delete-this", langKey: "nylasEventCalendar.editOptions.deleteThis" },
  { label: _.t("nylasEventCalendar.editOptions.deleteAll") || "Delete all events", value: "delete-all", langKey: "nylasEventCalendar.editOptions.deleteAll" }
], zf = [
  { label: _.t("nylasEventCalendar.updateOptions.updateThis") || "Update this event", value: "this", langKey: "nylasEventCalendar.updateOptions.updateThis" },
  {
    label: _.t("nylasEventCalendar.updateOptions.updateFuture") || "Update all future occurrences",
    value: "future",
    langKey: "nylasEventCalendar.updateOptions.updateFuture"
  },
  { label: _.t("nylasEventCalendar.updateOptions.updateAll") || "Update all events", value: "all", langKey: "nylasEventCalendar.updateOptions.updateAll" }
], Uf = [
  { label: _.t("nylasEventCalendar.deleteOptions.deleteThis") || "Delete this event", value: "this", langKey: "nylasEventCalendar.deleteOptions.deleteThis" },
  {
    label: _.t("nylasEventCalendar.deleteOptions.deleteFuture") || "Delete this and all future occurrences",
    value: "future",
    langKey: "nylasEventCalendar.deleteOptions.deleteFuture"
  },
  { label: _.t("nylasEventCalendar.deleteOptions.deleteAll") || "Delete all events", value: "all", langKey: "nylasEventCalendar.deleteOptions.deleteAll" }
], Xs = class {
  constructor(t) {
    gn(this, t), this.fetchMasterGroupEvent = V(this, "fetchMasterGroupEvent", 7), this.saveGroupEventChanges = V(this, "saveGroupEventChanges", 7), this.deleteGroupEvent = V(this, "deleteGroupEvent", 7), this.groupEventSelected = V(this, "groupEventSelected", 7), this.createGroupEvent = V(this, "createGroupEvent", 7), this.calendarViewChanged = V(this, "calendarViewChanged", 7), this.previosNextClicked = V(this, "previosNextClicked", 7), this.setCalendarViewDateRange = V(this, "setCalendarViewDateRange", 7), this.importGroupEvent = V(this, "importGroupEvent", 7), t.$hostElement$["s-ei"] ? this.internals = t.$hostElement$["s-ei"] : (this.internals = t.$hostElement$.attachInternals(), t.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.name = "page-name", this.selectedLanguage = void 0, this.groupEvents = void 0, this.currentUser = void 0, this.calendars = void 0, this.masterGroupEvents = void 0, this.isLoading = void 0, this.selectedView = "week", this.events = [], this.calendar = void 0, this.selectedEvent = null, this.selectedDateRangeString = "", this.showEditEventDetails = !1, this.showCreateEventDetails = !1, this.editOptionChoices = Bf, this.updateOptionChoices = zf, this.deleteOptionChoices = Uf, this.editOptions = this.editOptionChoices, this.showEditOptions = !1, this.updateOptions = this.updateOptionChoices, this.showUpdateOptions = !1, this.deleteOptions = this.deleteOptionChoices, this.showDeleteOptions = !1, this.unsavedChanges = !1, this.showConfirmDiscardUnsavedChangesModal = !1, this.createNewGroupEventTimeslot = null, this.formError = "", this.formErrors = {}, this.loadingOptions = {
      update: "",
      delete: "",
      create: ""
    }, this.showChooseParticipantsModal = !1, this.importParticipants = [], this.selectedImportParticipants = [];
  }
  elementNameChangedHandler(t) {
    z("nylas-page-name", "elementNameChangedHandler", t), this.host.setAttribute("name", t);
  }
  createCustomLocaleConfig(t) {
    return {
      code: t,
      buttonText: {
        today: _.t("today") || "today",
        month: _.t("timePeriod_month") || "month",
        week: _.t("timePeriod_week") || "week",
        day: _.t("timePeriod_day") || "day"
      },
      allDayText: _.t("allDay") || "all-day"
    };
  }
  selectedLanguageChangedHandler(t, e) {
    if (t !== e) {
      if (_.changeLanguage(t), this.calendar) {
        const n = this.createCustomLocaleConfig(t);
        this.calendar.setOption("locale", n);
      }
      this.updateOptionTranslations();
    }
  }
  updateOptionTranslations() {
    this.editOptionChoices = this.editOptionChoices.map((t) => ({
      ...t,
      label: _.t(t.langKey) || t.label
    })), this.updateOptionChoices = this.updateOptionChoices.map((t) => ({
      ...t,
      label: _.t(t.langKey) || t.label
    })), this.deleteOptionChoices = this.deleteOptionChoices.map((t) => ({
      ...t,
      label: _.t(t.langKey) || t.label
    })), this.editOptions = this.editOptions.map((t) => {
      var e;
      return {
        ...t,
        label: ((e = this.editOptionChoices.find((n) => n.value === t.value)) == null ? void 0 : e.label) || t.label
      };
    }), this.updateOptions = this.updateOptions.map((t) => {
      var e;
      return {
        ...t,
        label: ((e = this.updateOptionChoices.find((n) => n.value === t.value)) == null ? void 0 : e.label) || t.label
      };
    }), this.deleteOptions = this.deleteOptions.map((t) => {
      var e;
      return {
        ...t,
        label: ((e = this.deleteOptionChoices.find((n) => n.value === t.value)) == null ? void 0 : e.label) || t.label
      };
    });
  }
  groupEventsChangedHandler(t, e) {
    var n;
    t !== e && (this.events = t.filter((i) => i !== void 0).map((i) => {
      var s, a;
      const r = i.event;
      if (r != null && r.id) {
        const l = !!i.group_event_info && !!((s = i.group_event_info) != null && s.event_id), o = r.read_only, d = r.participants || [], c = ((a = i.group_event_info) == null ? void 0 : a.participants) || [], h = d.length <= 0 && c.length <= 0;
        return {
          title: r.title,
          start: R.unix(r.when.start_time).locale(this.selectedLanguage || "en").format("YYYY-MM-DDTHH:mm:ss"),
          end: R.unix(r.when.end_time).locale(this.selectedLanguage || "en").format("YYYY-MM-DDTHH:mm:ss"),
          calendar_id: r.calendar_id,
          id: r.id,
          classNames: [l ? "group-event" : "regular-event", o ? "read-only" : "", h ? "no-participants" : ""],
          editable: !1
        };
      }
    }), (n = this.calendar) == null || n.setOption("events", this.events));
  }
  connectedCallback() {
    z("nylas-connected-calendars", "connectedCallback");
  }
  disconnectedCallback() {
    z("nylas-connected-calendars", "disconnectedCallback");
  }
  componentWillLoad() {
    z("nylas-connected-calendars", "componentWillLoad");
  }
  componentDidLoad() {
    this.selectedView = "week";
    const t = {
      plugins: [Du, uf, Of],
      headerToolbar: !1,
      initialView: "timeGridWeek",
      events: this.events,
      editable: !0,
      selectable: !0,
      nowIndicator: !0,
      scrollTime: (/* @__PURE__ */ new Date()).getHours() + ":00:00",
      dayHeaderFormat: { weekday: "short", month: void 0, day: "2-digit", formatMatcher: "basic" },
      dayHeaderContent: (e) => e.view.type === "dayGridMonth" ? {
        html: `<div class="custom-day-header">
              <span class="day-name">${R(e.date).locale(this.selectedLanguage || "en").format("ddd")}</span>
            </div>`
      } : {
        html: `<div class="custom-day-header">
              <span class="day-name">${R(e.date).locale(this.selectedLanguage || "en").format("ddd")}</span>
              <span class="day-number ${e.isToday ? "today" : ""}">${R(e.date).locale(this.selectedLanguage || "en").format("D")}</span>
            </div>`
      },
      datesSet: (e) => {
        const n = R(e.start).locale(this.selectedLanguage || "en").format("MMMM").substring(0, 3), i = R(e.end).subtract(1, "day").locale(this.selectedLanguage || "en").format("MMMM").substring(0, 3), r = R(e.start).format("YYYY"), s = R(e.end).subtract(1, "day").format("YYYY");
        n === i && r === s ? this.selectedDateRangeString = `${n} ${r}` : r === s ? this.selectedDateRangeString = `${n} - ${i} ${r}` : this.selectedDateRangeString = `${n} ${r} - ${i} ${s}`;
      },
      eventClick: (e) => {
        var i, r;
        const n = (i = this.groupEvents) == null ? void 0 : i.find((s) => s.event.id === e.event._def.publicId);
        if (!(e.event.classNames.includes("read-only") || e.event.classNames.includes("no-participants")))
          if (this.showEditEventDetails = !1, this.unsavedChanges = !1, this.showEditOptions = !0, this.selectedEvent = n || null, n && n.group_event_info) {
            const s = n.event.master_event_id;
            this.groupEventSelected.emit(n), this.editOptions = this.editOptionChoices.filter((a) => a.value !== "import"), this.deleteOptions = [...this.deleteOptionChoices], this.updateOptions = [...this.updateOptionChoices], s || (this.editOptions = this.editOptions.filter((a) => a.value !== "delete-all"), this.deleteOptions = this.deleteOptions.filter((a) => a.value !== "all" && a.value !== "future")), s && !((r = this.masterGroupEvents) != null && r[s]) && this.fetchMasterGroupEvent.emit(n.event.master_event_id);
          } else
            this.editOptions = this.editOptionChoices.filter((s) => s.value === "import");
      },
      select: (e) => {
        new Date(e.start).getTime() < (/* @__PURE__ */ new Date()).getTime() || (this.createNewGroupEventTimeslot = {
          when: {
            start_time: new Date(e.start).getTime() / 1e3,
            end_time: new Date(e.end).getTime() / 1e3,
            start_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            end_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
          },
          recurrence: []
        }, this.showCreateEventDetails = !0);
      },
      eventDurationEditable: !0,
      height: "100%",
      contentHeight: "auto"
    };
    if (this.calendar = new eu(this.calendarEl, t), this.calendar.render(), this.selectedLanguage) {
      const e = this.createCustomLocaleConfig(this.selectedLanguage);
      this.calendar.setOption("locale", e), this.updateOptionTranslations();
    }
    this.setCalendarViewDateRange.emit({
      startTime: new Date(this.calendar.getCurrentData().viewApi.activeStart).getTime() / 1e3,
      endTime: new Date(this.calendar.getCurrentData().viewApi.activeEnd).getTime() / 1e3
    });
  }
  setView(t) {
    this.selectedView = t, this.calendar.changeView(it[t]);
    const e = new Date(this.calendar.getCurrentData().viewApi.activeStart).getTime() / 1e3, n = new Date(this.calendar.getCurrentData().viewApi.activeEnd).getTime() / 1e3;
    this.calendarViewChanged.emit({ startTime: e, endTime: n });
  }
  dayHeaderContent(t) {
    return t.view.type === "dayGridMonth" ? {
      html: `<div class="custom-day-header">
            <span class="day-name">${R(t.date).locale(this.selectedLanguage || "en").format("ddd")}</span>
          </div>`
    } : {
      html: `<div class="custom-day-header">
          <span class="day-name">${R(t.date).locale(this.selectedLanguage || "en").format("ddd")}</span>
          <span class="day-number ${t.isToday ? "today" : ""}">${R(t.date).locale(this.selectedLanguage || "en").format("D")}</span>
        </div>`
    };
  }
  handleEditOptionSelected(t, e) {
    if (t.preventDefault(), t.stopPropagation(), !this.isLoading) {
      if (e.value === "edit")
        this.showEditOptions = !1, this.showEditEventDetails = !0;
      else if ((e.value === "delete-this" || e.value === "delete-all" || e.value === "delete-future") && this.selectedEvent) {
        this.loadingOptions.delete = e.value;
        const n = e.value.split("-")[1];
        this.deleteGroupEvent.emit({ data: this.selectedEvent, action: n });
      } else if (e.value === "import" && this.selectedEvent) {
        const n = this.selectedEvent.event.participants || [], i = this.selectedEvent.event.organizer;
        this.showEditOptions = !1, this.showChooseParticipantsModal = !0, this.importParticipants = n.map((r) => ({
          label: r == null ? void 0 : r.email,
          value: r == null ? void 0 : r.email,
          disabled: (r == null ? void 0 : r.email) === (i == null ? void 0 : i.email),
          selected: (r == null ? void 0 : r.email) === (i == null ? void 0 : i.email)
        }));
      }
    }
  }
  handleImportGroupEvent() {
    var r, s, a, l;
    const t = (r = this.selectedEvent) == null ? void 0 : r.event.master_event_id, e = this.selectedImportParticipants, n = (s = this.selectedEvent) == null ? void 0 : s.event.organizer, i = {
      event_id: t || ((a = this.selectedEvent) == null ? void 0 : a.event.id) || "",
      calendar_id: ((l = this.selectedEvent) == null ? void 0 : l.event.calendar_id) || "",
      capacity: 10,
      participants: e.length > 0 ? e : [{ ...n, is_organizer: !0 }],
      organizer: n
    };
    this.showChooseParticipantsModal = !1, i.event_id && i.calendar_id && this.importGroupEvent.emit(i);
  }
  handlePrevNextClick(t) {
    const e = Lf[this.calendar.view.type];
    t === "prev" ? this.calendar.prev() : this.calendar.next();
    const n = new Date(this.calendar.getCurrentData().viewApi.activeStart).getTime() / 1e3, i = new Date(this.calendar.getCurrentData().viewApi.activeEnd).getTime() / 1e3;
    this.previosNextClicked.emit({ direction: t, view: e, currentViewRange: { startTime: n, endTime: i } });
  }
  handleUpdateGroupEvent(t, e) {
    t.preventDefault(), t.stopPropagation(), !this.isLoading && (this.loadingOptions.update = e.value, this.selectedEvent && this.internals.checkValidity() && this.saveGroupEventChanges.emit({ data: this.selectedEvent, action: e.value }));
  }
  handleDeleteGroupEvent(t, e) {
    t.preventDefault(), t.stopPropagation(), !this.isLoading && (this.loadingOptions.delete = e.value, this.selectedEvent && this.deleteGroupEvent.emit({ data: this.selectedEvent, action: e.value }));
  }
  async handleCreateGroupEvent(t) {
    t.preventDefault(), t.stopPropagation();
    const e = new FormData(this.formRef);
    if (!this.formRef.checkValidity()) {
      this.formError = "Please fix the form errors.", this.formErrors.form = "Please fix the form errors.";
      return;
    }
    const i = {};
    e.forEach((r, s) => {
      i[s] = r;
    }), await this.createGroupEvent.emit({
      title: i == null ? void 0 : i.title,
      description: i == null ? void 0 : i.description,
      location: i == null ? void 0 : i.location,
      eventTimeslot: JSON.parse(i == null ? void 0 : i["event-timeslot"]),
      eventCapacity: parseInt(i == null ? void 0 : i["event-capacity"]),
      conferencing: i != null && i.conferencing ? JSON.parse(i == null ? void 0 : i.conferencing.toString()) : void 0,
      participants: i != null && i.participants ? JSON.parse(i.participants) : []
    });
  }
  isLoadingChangedHandler(t, e) {
    t || (this.loadingOptions = {
      update: "",
      delete: "",
      create: ""
    }, this.showCreateEventDetails = !1, this.createNewGroupEventTimeslot = null, this.showEditOptions = !1, this.showUpdateOptions = !1, this.showDeleteOptions = !1, this.showEditEventDetails = !1, this.unsavedChanges = !1, this.showConfirmDiscardUnsavedChangesModal = !1, this.selectedEvent = null, this.selectedImportParticipants = [], this.importParticipants = [], this.showChooseParticipantsModal = !1, this.formError = "", this.formErrors = {});
  }
  valueChangedHandler(t) {
    var r, s, a, l;
    const { value: e, name: n } = t.detail, i = ["title", "description", "location", "event-timeslot", "participants", "event-capacity"];
    if ((this.showEditEventDetails || this.showCreateEventDetails) && i.includes(n))
      if (this.unsavedChanges = !0, this.formErrors[n] && delete this.formErrors[n], Object.keys(this.formErrors).length === 0)
        this.formError = "", this.internals.setValidity({});
      else {
        const o = Object.values(this.formErrors)[0];
        this.formError = o || "";
      }
    if (n === "event-timeslot") {
      const { recurrence: o } = JSON.parse(e), d = (a = (s = (r = this.selectedEvent) == null ? void 0 : r.group_event_info) == null ? void 0 : s.rrule) == null ? void 0 : a[0], c = o[0];
      if (d !== c) {
        this.updateOptionTranslations(), this.updateOptions = this.updateOptionChoices.filter((h) => h.value !== "this");
        return;
      }
      (l = this.selectedEvent) != null && l.group_event_info && (this.selectedEvent.group_event_info.rrule = o);
    }
    if (n === "event-capacity") {
      const o = parseInt(e);
      o < 1 || o > 500 || isNaN(o) ? (this.formErrors["event-capacity"] = _.t("fixFormErrors"), this.formError = _.t("fixFormErrors"), this.internals.setValidity({ customError: !0 }, this.formError)) : (this.formError = "", this.internals.setValidity({ customError: !1 }, ""));
    }
  }
  timeWindowFormErrorHandler(t) {
    var e;
    if (t.detail.key === "event-timeslot") {
      const n = ((e = t.detail) == null ? void 0 : e.uniqueIdentifier) || t.detail.key;
      if (t.detail.message)
        this.formErrors[n] = t.detail.message, this.formError = t.detail.message, this.internals.setValidity({ customError: !0 }, t.detail.message);
      else if (this.formErrors[n] && delete this.formErrors[n], Object.keys(this.formErrors).length === 0)
        this.formError = "", this.internals.setValidity({});
      else {
        const i = Object.values(this.formErrors)[0];
        this.formError = i || "";
      }
    }
  }
  dateTimeInputErrorHandler(t) {
    t.detail.key === "event-timeslot" && (t.detail.message ? (this.formErrors["date-time-input"] = t.detail.message, this.formError = t.detail.message) : (delete this.formErrors["date-time-input"], this.formError = ""));
  }
  saveGroupEventChangesErrorHandler(t) {
    this.loadingOptions.update = "", t.detail.error && (this.formError = t.detail.error);
  }
  selectedOptionsChangedHandler(t) {
    var i, r;
    const { value: e, name: n } = t.detail;
    n === "participants" && (this.selectedImportParticipants = ((r = (i = this.selectedEvent) == null ? void 0 : i.event.participants) == null ? void 0 : r.filter((s) => e.includes(s.email))) || []);
  }
  render() {
    var d, c, h, f, u, v, y, b, E, C, T, A, O, M, N, x, Q, ae, qe, Qe, Jn;
    const t = (c = (d = this.selectedConfiguration) == null ? void 0 : d.group_booking) == null ? void 0 : c.calendar_id, e = t ? (h = this.calendars) == null ? void 0 : h.find((w) => w.id === t) : null, n = _.t("timePeriod_day") || "day", i = _.t("timePeriod_week") || "week", r = _.t("timePeriod_month") || "month", s = (v = (u = (f = this.selectedEvent) == null ? void 0 : f.event) == null ? void 0 : u.when) == null ? void 0 : v.start_time, a = (E = (b = (y = this.selectedEvent) == null ? void 0 : y.event) == null ? void 0 : b.when) == null ? void 0 : E.start_timezone, l = s ? R(s * 1e3).tz(a) : null, o = l && l.isBefore(R().tz(a));
    return g(mn, null, g("div", { class: "nylas-event-calendar" }, g("div", { class: {
      "calendar-container": !0,
      "show-event": this.showEditEventDetails || this.showCreateEventDetails
    } }, g("div", { class: "calendar-header" }, g("div", { class: "calendar-header__title" }, g("div", { class: "calendar-header-prev-next" }, g("button", { onClick: () => this.handlePrevNextClick("prev"), class: { "chevron-left": !0, button: !0 } }, " ", g("chevron-icon", null)), g("button", { onClick: () => this.handlePrevNextClick("next"), class: { "chevron-right": !0, button: !0 } }, " ", g("chevron-icon", null))), g("span", null, this.selectedDateRangeString)), g("div", { class: "calendar-header__current-calendar" }, (e == null ? void 0 : e.name) || (e == null ? void 0 : e.id), "'s calendar"), g("div", { class: "calendar-header__view-options" }, g("button", { class: { selected: ((C = this.calendar) == null ? void 0 : C.view.type) === it.day }, onClick: () => this.setView("day") }, n.charAt(0).toUpperCase() + n.slice(1)), g("button", { class: { selected: ((T = this.calendar) == null ? void 0 : T.view.type) === it.week }, onClick: () => this.setView("week") }, i.charAt(0).toUpperCase() + i.slice(1)), g("button", { class: { selected: ((A = this.calendar) == null ? void 0 : A.view.type) === it.month }, onClick: () => this.setView("month") }, r.charAt(0).toUpperCase() + r.slice(1)))), g("div", { ref: (w) => this.calendarEl = w })), this.showEditEventDetails && ((O = this.selectedEvent) == null ? void 0 : O.group_event_info) && g("div", { class: "event-details-container" }, g("div", { class: "event-details-header" }, g("h3", null, _.t("nylasEventCalendar.editEventDetails.headerTitle")), g("div", { class: "event-details-header__actions" }, g("button-component", { tooltip: _.t("nylasEventCalendar.editEventDetails.closeButtonTooltip"), id: "close", disabled: this.isLoading, variant: "invisible", onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.unsavedChanges ? this.showConfirmDiscardUnsavedChangesModal = !0 : (this.showEditEventDetails = !1, this.unsavedChanges = !1, this.selectedEvent = null, this.formError = "");
    } }, g("close-icon", null)))), g("div", { class: {
      "event-details": !0,
      "edit-event-details": !0
    } }, g("nylas-event-title", { noTemplates: !0, name: "title", eventTitle: this.selectedEvent.event.title, exportparts: "net, net__title, net__input_group, net__input_wrapper, net__input" }), g("nylas-event-description", { name: "description", noTemplates: !0, eventDescription: this.selectedEvent.event.description, exportparts: "ned, ned__title, ned__input_group, ned__input_wrapper, ned__input" }), g("nylas-event-location", { name: "location", eventLocation: this.selectedEvent.event.location, eventConferencing: this.selectedEvent.event.conferencing, exportparts: "nel, nel__title, nel__input_group, nel__input_wrapper, nel__input, nel__conferencing" }), g("nylas-event-timeslot", { name: "event-timeslot", initialValue: {
      when: this.selectedEvent.event.when,
      recurrence: (N = (M = this.selectedEvent) == null ? void 0 : M.group_event_info) != null && N.rrule ? this.selectedEvent.group_event_info.rrule : []
    }, exportparts: "nets, nets__title, nets__input_group, nets__input_wrapper, nets__input, nets__timezone, nets__recurrence" }), g("nylas-event-capacity", { name: "event-capacity", capacity: (Q = (x = this.selectedEvent) == null ? void 0 : x.group_event_info) == null ? void 0 : Q.capacity, exportparts: "nec, nec__title, nec__input_group, nec__input_wrapper, nec__input" }), g("nylas-additional-participants", { name: "participants", eventParticipants: this.selectedEvent.group_event_info.participants, exportparts: "nadtnlpart, nadtnlpart__title, nadtnlpart__subtitle, nadtnlpart__content, nadtnlpart__input_group, nadtnlpart__input_wrapper, nadtnlpart__input, nadtnlpart__remove-participant" })), g("div", { class: "event-details-footer" }, g("div", { class: "event-details-footer__error" }, g("p", null, this.formError)), g("div", { class: "event-details-footer__helper-text" }, g("p", null, this.unsavedChanges && !this.isLoading ? _.t("nylasEventCalendar.unsavedChanges") : "")), g("div", { class: "event-details-footer__actions" }, g("button-component", { variant: "destructive", disabled: this.isLoading, onClick: (w) => {
      var $, Ne;
      w.preventDefault(), w.stopImmediatePropagation(), (Ne = ($ = this.selectedEvent) == null ? void 0 : $.event) != null && Ne.master_event_id ? this.showUpdateOptions = !0 : this.handleDeleteGroupEvent(w, { label: "Delete this event", value: "this" });
    } }, _.t("nylasEventCalendar.editEventDetails.deleteButton")), g("button-component", { variant: "basic", disabled: this.isLoading || this.formError !== "" || !!o, tooltip: o ? _.t("nylasEventCalendar.editEventDetails.pastEventTooltip") : "", onClick: (w) => {
      var $, Ne;
      w.preventDefault(), w.stopImmediatePropagation(), this.unsavedChanges && ((Ne = ($ = this.selectedEvent) == null ? void 0 : $.event) != null && Ne.master_event_id ? this.showUpdateOptions = !0 : this.handleUpdateGroupEvent(w, { label: "Update this event", value: "this" }));
    } }, _.t("nylasEventCalendar.editEventDetails.saveButton"))))), this.showCreateEventDetails && this.createNewGroupEventTimeslot && g("div", { class: "event-details-container" }, g("div", { class: "event-details-header" }, g("h3", null, _.t("nylasEventCalendar.createEventDetails.headerTitle")), g("div", { class: "event-details-header__actions" }, g("button-component", { tooltip: _.t("nylasEventCalendar.createEventDetails.closeButtonTooltip"), id: "close", variant: "invisible", disabled: this.isLoading, onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.unsavedChanges ? this.showConfirmDiscardUnsavedChangesModal = !0 : (this.showCreateEventDetails = !1, this.createNewGroupEventTimeslot = null, this.selectedEvent = null, this.unsavedChanges = !1);
    } }, g("close-icon", null)))), g("form", { ref: (w) => this.formRef = w }, g("div", { class: {
      "event-details": !0
    } }, g("nylas-event-info", null, g("div", { slot: "inputs", class: "event-details-form-inputs" }, g("nylas-event-title", { noTemplates: !0, eventTitle: "New group event", exportparts: "net, net__title, net__input_group, net__input_wrapper, net__input" }), g("nylas-event-description", { noTemplates: !0, hideAutoPopulateButton: !0, exportparts: "ned, ned__title, ned__input_group, ned__input_wrapper, ned__input" }), g("nylas-event-location", { userProvider: (ae = this.currentUser) == null ? void 0 : ae.provider, exportparts: "nel, nel__title, nel__input_group, nel__input_wrapper, nel__input, nel__conferencing" }), g("nylas-event-timeslot", { name: "event-timeslot", initialValue: this.createNewGroupEventTimeslot, exportparts: "nets, nets__title, nets__input_group, nets__input_wrapper, nets__input, nets__timezone, nets__recurrence" }), g("nylas-event-capacity", { name: "event-capacity", exportparts: "nec, nec__title, nec__input_group, nec__input_wrapper, nec__input" }))), g("nylas-additional-participants", { name: "participants", eventParticipants: [{ name: ((qe = this.currentUser) == null ? void 0 : qe.name) || ((Qe = this.currentUser) == null ? void 0 : Qe.email), email: ((Jn = this.currentUser) == null ? void 0 : Jn.email) || "", is_organizer: !0 }], exportparts: "nadtnlpart, nadtnlpart__title, nadtnlpart__subtitle, nadtnlpart__content, nadtnlpart__input_group, nadtnlpart__input_wrapper, nadtnlpart__input, nadtnlpart__remove-participant" })), g("div", { class: "event-details-footer" }, g("div", { class: "event-details-footer__error" }, g("p", null, this.formError)), g("div", { class: "event-details-footer__helper-text" }, g("p", null, this.unsavedChanges && !this.isLoading ? _.t("nylasEventCalendar.unsavedChanges") : "")), g("div", { class: "event-details-footer__actions" }, g("button-component", { variant: "basic", disabled: this.isLoading, onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.unsavedChanges ? this.showConfirmDiscardUnsavedChangesModal = !0 : (this.showCreateEventDetails = !1, this.createNewGroupEventTimeslot = null, this.selectedEvent = null, this.unsavedChanges = !1);
    } }, _.t("nylasEventCalendar.createEventDetails.cancelButton")), g("button-component", { variant: "primary", disabled: this.isLoading || this.formError !== "", isLoading: this.isLoading, onClick: (w) => {
      this.handleCreateGroupEvent(w);
    } }, _.t("nylasEventCalendar.createEventDetails.createButton")))))), this.showConfirmDiscardUnsavedChangesModal && g("div", { class: "discard-changes action-options", onClick: () => this.showUpdateOptions = !1 }, g("div", { class: "discard-changes__card action-options__card" }, g("button-component", { tooltip: "Close", id: "close-discard-changes", variant: "invisible", disabled: this.isLoading, onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.showConfirmDiscardUnsavedChangesModal = !1;
    } }, g("close-icon", null)), g("div", { class: "discard-changes__content action-options__content" }, g("h3", { slot: "card-title", part: "nfbf__title" }, _.t("nylasEventCalendar.discardChanges.headerTitle"))), g("div", { class: "discard-changes__footer action-options__footer" }, g("button-component", { variant: "basic", onClick: (w) => this.showConfirmDiscardUnsavedChangesModal = !1, part: "nfbf__button-outline nfbf__cancel-cta" }, _.t("nylasEventCalendar.discardChanges.cancelButton")), g("button-component", { variant: "destructive", onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.showConfirmDiscardUnsavedChangesModal = !1, this.unsavedChanges = !1, this.showEditEventDetails = !1, this.showCreateEventDetails = !1, this.selectedEvent = null, this.createNewGroupEventTimeslot = null, this.formError = "";
    }, part: "nfbf__button-outline nfbf__reschedule-cta" }, _.t("nylasEventCalendar.discardChanges.discardButton"))))), this.showEditOptions && g("div", { class: "edit-options action-options", onClick: () => this.showEditOptions = !1 }, g("div", { class: "edit-options__card action-options__card" }, g("div", { class: "edit-options__header action-options__header" }, g("h3", null, _.t("nylasEventCalendar.editOptions.headerTitle")), g("button-component", { tooltip: _.t("nylasEventCalendar.editOptions.closeButtonTooltip"), id: "close-edit-options", disabled: this.isLoading, variant: "invisible", onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.showEditOptions = !1;
    } }, g("close-icon", null))), g("div", { class: "edit-options__content action-options__content" }, g("ul", { tabindex: "-1", role: "listbox", "aria-label": this.name }, this.editOptions.map((w) => w.value.toString() ? g("li", { class: { disabled: !!this.isLoading }, tabindex: "0", key: w.value, id: w.value, onClick: ($) => this.handleEditOptionSelected($, w), role: "option" }, this.isLoading && this.loadingOptions.delete === w.value ? _.t("nylasEventCalendar.editOptions.deleting") : w.label) : null))))), this.showUpdateOptions && g("div", { class: "update-options action-options", onClick: () => this.showUpdateOptions = !1 }, g("div", { class: "update-options__card action-options__card" }, g("button-component", { tooltip: "Close", id: "close-update-options", variant: "invisible", disabled: this.isLoading, onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.showUpdateOptions = !1;
    } }, g("close-icon", null)), g("div", { class: "update-options__content action-options__content" }, g("ul", { tabindex: "-1", role: "listbox", "aria-label": this.name }, this.updateOptions.map((w) => w.value.toString() ? g("li", { class: { disabled: !!this.isLoading }, tabindex: "0", key: w.value, id: w.value, role: "option", onClick: ($) => this.handleUpdateGroupEvent($, w) }, this.isLoading && this.loadingOptions.update === w.value ? "Updating..." : w.label) : null))))), this.showDeleteOptions && g("div", { class: "delete-options action-options", onClick: () => this.showDeleteOptions = !1 }, g("div", { class: "delete-options__card action-options__card" }, g("button-component", { tooltip: _.t("nylasEventCalendar.deleteEvent.closeButtonTooltip"), id: "close-delete-options", variant: "invisible", disabled: this.isLoading, onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.showDeleteOptions = !1;
    } }, g("close-icon", null)), g("div", { class: "delete-options__content action-options__content" }, g("ul", { tabindex: "-1", role: "listbox", "aria-label": this.name }, this.deleteOptions.map((w) => w.value.toString() ? g("li", { class: { disabled: !!this.isLoading }, tabindex: "0", key: w.value, id: w.value, role: "option", onClick: ($) => this.handleDeleteGroupEvent($, w) }, this.isLoading && this.loadingOptions.delete === w.value ? _.t("nylasEventCalendar.deleteEvent.deleting") : w.label) : null))))), this.showChooseParticipantsModal && g("div", { class: "choose-participants-modal action-options" }, g("div", { class: "choose-participants-modal__card action-options__card" }, g("button-component", { tooltip: _.t("nylasEventCalendar.importEvent.closeButtonTooltip"), id: "close-choose-participants-modal", variant: "invisible", disabled: this.isLoading, onClick: (w) => {
      w.preventDefault(), w.stopImmediatePropagation(), this.showChooseParticipantsModal = !1;
    } }, g("close-icon", null)), g("div", { class: "choose-participants-modal__content action-options__content" }, g("multi-select-dropdown", { multipleOptionsSelectedLabel: _.t("multipleOptionsSelected"), name: "participants", label: _.t("nylasEventCalendar.importEvent.participantsLabel"), options: this.importParticipants }), g("button-component", { variant: "basic", onClick: () => this.handleImportGroupEvent() }, _.t("nylasEventCalendar.importEvent.importButton")))))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return vn(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedLanguage: ["selectedLanguageChangedHandler"],
      groupEvents: ["groupEventsChangedHandler"],
      isLoading: ["isLoadingChangedHandler"]
    };
  }
};
Hf([
  yn({
    name: "nylas-event-calendar",
    stateToProps: /* @__PURE__ */ new Map([
      ["schedulerConfig.selectedLanguage", "selectedLanguage"],
      ["schedulerConfig.groupEvents", "groupEvents"],
      ["schedulerConfig.masterGroupEvents", "masterGroupEvents"],
      ["schedulerConfig.currentUser", "currentUser"],
      ["schedulerConfig.calendars", "calendars"],
      ["schedulerConfig.isLoading", "isLoading"],
      ["schedulerConfig.selectedConfiguration", "selectedConfiguration"]
    ]),
    eventToProps: {
      groupEventSelected: async (t, e) => {
        const { detail: n } = t;
        e.schedulerConfigStore.state.selectedGroupEvent = n;
      },
      calendarViewChanged: async (t, e) => {
        var r;
        const { detail: n } = t;
        e.schedulerConfigStore.state.calendarViewDateRange = {
          start_time: n.startTime.toString(),
          end_time: n.endTime.toString()
        };
        const i = (r = e.schedulerConfigStore.state.selectedConfiguration) == null ? void 0 : r.id;
        if (i) {
          const [s, a] = await e.schedulerConfig.getGroupEvents(i);
          if (!s && a && a.message)
            return;
        }
      },
      previosNextClicked: async (t, e) => {
        var r;
        const { detail: n } = t;
        e.schedulerConfigStore.state.calendarViewDateRange = {
          start_time: n.currentViewRange.startTime.toString(),
          end_time: n.currentViewRange.endTime.toString()
        };
        const i = (r = e.schedulerConfigStore.state.selectedConfiguration) == null ? void 0 : r.id;
        if (i) {
          const [s, a] = await e.schedulerConfig.getGroupEvents(i);
          if (!s && a && a.message)
            return;
        }
      },
      saveGroupEventChanges: async (t, e) => {
        z("nylas-event-calendar", "saveGroupEventChanges", t.detail);
      },
      setCalendarViewDateRange: async (t, e) => {
        z("nylas-event-calendar", "setCalendarViewDateRange", t.detail), e.schedulerConfigStore.state.calendarViewDateRange = {
          start_time: t.detail.startTime.toString(),
          end_time: t.detail.endTime.toString()
        };
      },
      fetchMasterGroupEvent: async (t, e) => {
        z("nylas-event-calendar", "fetchMasterGroupEvent", t.detail);
        const [n, i] = await e.schedulerConfig.getMasterEventById(t.detail);
        !n && i && i.message;
      }
    },
    fireRegisterEvent: !0
  }),
  Zt("design:type", Function),
  Zt("design:paramtypes", []),
  Zt("design:returntype", void 0)
], Xs.prototype, "render", null);
Xs.style = Pf;
const Ff = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-color-blue-100:#e0e6f9;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;--nylas-color-black:#000000;--nylas-color-grey-900:#2c2c2c;--nylas-color-grey-800:#4b4b4b;--nylas-color-grey-700:#6e6e6e;--nylas-color-grey-600:#8e8e8e;--nylas-color-grey-500:#b3b3b3;--nylas-color-grey-400:#cacaca;--nylas-color-grey-300:#e1e1e1;--nylas-color-grey-200:#eaeaea;--nylas-color-grey-100:#f5f5f5;--nylas-color-grey-50:#fbfcfe;--nylas-color-white:#ffffff;--nylas-color-red-900:#992222;--nylas-color-red-700:#cc4841;--nylas-color-red-500:#ff786a;--nylas-color-red-300:#ffa79e;--nylas-color-red-100:#ffc5bf;--nylas-color-red-50:#ffeae8;--nylas-color-blue-900:#213571;--nylas-color-blue-700:#314fa9;--nylas-color-blue-500:#4169e1;--nylas-color-blue-300:#bdccf9;--nylas-color-blue-100:#e0e6f9;--nylas-color-blue-50:#f6f8fd;--nylas-color-yellow-900:#7c6506;--nylas-color-yellow-700:#c29f09;--nylas-color-yellow-500:#f7c90b;--nylas-color-yellow-300:#f9de70;--nylas-color-yellow-100:#fceba9;--nylas-color-yellow-50:#fdf4ce;--nylas-color-green-900:#0e6b60;--nylas-color-green-700:#16a392;--nylas-color-green-500:#17c3b2;--nylas-color-green-300:#74dbd1;--nylas-color-green-100:#a2e7e0;--nylas-color-green-50:#d1f3f0;--nylas-color-purple-900:#643554;--nylas-color-purple-700:#954f7d;--nylas-color-purple-500:#c769a7;--nylas-color-purple-300:#dda5ca;--nylas-color-purple-100:#e0bdd6;--nylas-color-purple-50:#e9dde5;--nylas-color-sky-900:#20698f;--nylas-color-sky-700:#2b8fc2;--nylas-color-sky-500:#6dceff;--nylas-color-sky-300:#8fdaff;--nylas-color-sky-100:#b8e7ff;--nylas-color-sky-50:#d9f2ff;width:inherit}.nylas-event-capacity{display:flex;flex-direction:column;gap:4px}.nylas-event-capacity label{display:flex;align-items:center;gap:4px;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-event-capacity label span.required{color:var(--nylas-error, #cc4841)}.nylas-event-capacity label span.label-icon{margin-left:4px}.nylas-event-capacity label span.label-icon tooltip-component{display:flex}.nylas-event-capacity label tooltip-component::part(tc__content){left:50px}.nylas-event-capacity__wrapper{display:flex;align-items:center;gap:0.5rem}.nylas-event-capacity__wrapper input-component{width:auto}.nylas-event-capacity__wrapper input-component::part(ic__input){border-width:1;border-radius:8px;border:1px solid var(--nylas-base-200);font-family:var(--nylas-font-family);font-size:16px;line-height:24px;width:80px}.nylas-event-capacity__wrapper input-component::part(ic__input--error){border:1px solid var(--nylas-error)}.nylas-event-capacity__wrapper input-component::part(ic__label--error){position:relative;margin-bottom:24px}.nylas-event-capacity__wrapper input-component::part(ic__error_message){position:absolute;top:54px;width:max-content}.nylas-event-capacity__wrapper span.attendees.error{margin-top:-24px}', jf = Ff;
var Wf = function(t, e, n, i) {
  var r = arguments.length, s = r < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, n) : i, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(t, e, n, i);
  else
    for (var l = t.length - 1; l >= 0; l--)
      (a = t[l]) && (s = (r < 3 ? a(s) : r > 3 ? a(e, n, s) : a(e, n)) || s);
  return r > 3 && s && Object.defineProperty(e, n, s), s;
}, Xt = function(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
};
const Js = class {
  constructor(t) {
    gn(this, t), this.valueChanged = V(this, "valueChanged", 7), t.$hostElement$["s-ei"] ? this.internals = t.$hostElement$["s-ei"] : (this.internals = t.$hostElement$.attachInternals(), t.$hostElement$["s-ei"] = this.internals), this.name = "event-capacity", this.capacity = void 0, this.selectedLanguage = void 0, this.selectedEventCapacity = void 0, this.error = "";
  }
  connectedCallback() {
    z("nylas-event-capacity", "connectedCallback");
  }
  disconnectedCallback() {
    z("nylas-event-capacity", "disconnectedCallback");
  }
  componentWillLoad() {
    z("nylas-event-capacity", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    z("nylas-event-capacity", "componentDidLoad"), this.selectedEventCapacity = this.capacity || 10, console.log("selectedEventCapacity", this.selectedEventCapacity), this.internals.setFormValue(this.selectedEventCapacity.toString(), this.name);
  }
  componentWillUpdate() {
    z("nylas-event-capacity", "componentWillUpdate");
  }
  componentDidUpdate() {
    z("nylas-event-capacity", "componentDidUpdate");
  }
  componentWillRender() {
    z("nylas-event-capacity", "componentWillRender");
  }
  componentDidRender() {
    z("nylas-event-capacity", "componentDidRender");
  }
  elementNameChangedHandler(t) {
    z("nylas-event-capacity", "elementNameChangedHandler", t), this.host.setAttribute("name", t);
  }
  selectedLanguageChangedHandler(t, e) {
    t !== e && _.changeLanguage(t);
  }
  async nylasFormInputChangeHandler(t) {
    const { name: e, value: n } = t.detail;
    if (e === "event-capacity") {
      const i = parseInt(n);
      if (i < 1 || i > 500 || isNaN(i)) {
        this.error = _.t("fixFormErrors"), this.internals.setValidity({ customError: !0 }, this.error), this.valueChanged.emit({ value: n.toString(), name: this.name });
        return;
      }
      this.error = "", this.internals.setValidity({ customError: !1 }, ""), this.selectedEventCapacity = parseInt(n), this.internals.setFormValue(n.toString(), this.name), this.valueChanged.emit({ value: n.toString(), name: this.name });
    }
  }
  render() {
    const t = typeof this.selectedEventCapacity < "u";
    return g(mn, { key: "196c809c4eb92a68f27e3c57784c1de830216abc" }, g("div", { key: "503845c128cc0387e2b3830d05ee2f111c0136da", class: "nylas-event-capacity", part: "necapacity" }, g("label", { key: "83059d682337edaee48a0056172cf06abfc6c571", htmlFor: "event-capacity" }, g("span", { key: "e38ab96339864cbf94d0b45a009d2c5e85f3d8cd" }, _.t("nylasEventCapacity.headerTitle"), g("span", { key: "325e2cdd6f545077c598e514334d65f2c187d133", class: "required" }, "*")), g("tooltip-component", { key: "2f845ee508a5d4d331c77d748070a85554251e29" }, g("info-icon", { key: "f80932c1102ddd5e3e78804298a1e0ee7de4b4de", slot: "tooltip-icon" }), g("span", { key: "c5bbb176f1b67ffd2639f1f95a2e5afec9319cd1", slot: "tooltip-content" }, _.t("nylasEventCapacity.tooltip.desc")))), t && g("div", { class: "nylas-event-capacity__wrapper" }, g("input-component", { name: "event-capacity", id: "event-capacity", type: "number", pattern: /^[0-9]*$/, patternError: _.t("invalidInputFormat", { field: "Event capacity" }), minValue: 1, maxValue: 500, required: !1, exportparts: "ic_input: necapacity__input-textfield", defaultValue: typeof this.selectedEventCapacity == "number" ? this.selectedEventCapacity.toString() : "10" }), g("span", { class: this.error ? "attendees error" : "attendees" }, _.t("nylasEventCapacity.attendees")))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return vn(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedLanguage: ["selectedLanguageChangedHandler"]
    };
  }
};
Wf([
  yn({
    name: "nylas-event-capacity",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedLanguage", "selectedLanguage"]]),
    eventToProps: {
      valueChanged: async (t, e) => {
        const { valueChanged: n } = t.detail;
        n && n(t);
      }
    },
    fireRegisterEvent: !0
  }),
  Xt("design:type", Function),
  Xt("design:paramtypes", []),
  Xt("design:returntype", void 0)
], Js.prototype, "render", null);
Js.style = jf;
const Vf = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-color-blue-100:#e0e6f9;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;--nylas-color-black:#000000;--nylas-color-grey-900:#2c2c2c;--nylas-color-grey-800:#4b4b4b;--nylas-color-grey-700:#6e6e6e;--nylas-color-grey-600:#8e8e8e;--nylas-color-grey-500:#b3b3b3;--nylas-color-grey-400:#cacaca;--nylas-color-grey-300:#e1e1e1;--nylas-color-grey-200:#eaeaea;--nylas-color-grey-100:#f5f5f5;--nylas-color-grey-50:#fbfcfe;--nylas-color-white:#ffffff;--nylas-color-red-900:#992222;--nylas-color-red-700:#cc4841;--nylas-color-red-500:#ff786a;--nylas-color-red-300:#ffa79e;--nylas-color-red-100:#ffc5bf;--nylas-color-red-50:#ffeae8;--nylas-color-blue-900:#213571;--nylas-color-blue-700:#314fa9;--nylas-color-blue-500:#4169e1;--nylas-color-blue-300:#bdccf9;--nylas-color-blue-100:#e0e6f9;--nylas-color-blue-50:#f6f8fd;--nylas-color-yellow-900:#7c6506;--nylas-color-yellow-700:#c29f09;--nylas-color-yellow-500:#f7c90b;--nylas-color-yellow-300:#f9de70;--nylas-color-yellow-100:#fceba9;--nylas-color-yellow-50:#fdf4ce;--nylas-color-green-900:#0e6b60;--nylas-color-green-700:#16a392;--nylas-color-green-500:#17c3b2;--nylas-color-green-300:#74dbd1;--nylas-color-green-100:#a2e7e0;--nylas-color-green-50:#d1f3f0;--nylas-color-purple-900:#643554;--nylas-color-purple-700:#954f7d;--nylas-color-purple-500:#c769a7;--nylas-color-purple-300:#dda5ca;--nylas-color-purple-100:#e0bdd6;--nylas-color-purple-50:#e9dde5;--nylas-color-sky-900:#20698f;--nylas-color-sky-700:#2b8fc2;--nylas-color-sky-500:#6dceff;--nylas-color-sky-300:#8fdaff;--nylas-color-sky-100:#b8e7ff;--nylas-color-sky-50:#d9f2ff;width:inherit}div.nylas-event-timeslot label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%}div.nylas-event-timeslot div.date-time-input div.date-time-picker{display:flex;gap:32px}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.date-time-picker{flex-direction:column;gap:16px}}div.nylas-event-timeslot div.date-time-input div.date-time-picker nylas-date-component{width:224px}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.date-time-picker nylas-date-component{width:100%}}div.nylas-event-timeslot div.date-time-input div.date-time-picker nylas-date-component:not(.error)::part(ic__date){border-color:var(--nylas-base-200)}div.nylas-event-timeslot div.date-time-input div.date-time-picker nylas-date-component::part(ic__date){height:50px}div.nylas-event-timeslot div.date-time-input div.date-time-picker div.time-range{display:flex;gap:8px;align-items:flex-start}div.nylas-event-timeslot div.date-time-input div.date-time-picker div.time-range span{margin:12px 0 0 6px;display:inline-flex;align-items:flex-start}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.date-time-picker div.time-range{display:grid;grid-template-columns:1fr 20px 1fr}div.nylas-event-timeslot div.date-time-input div.date-time-picker div.time-range nylas-time-window-picker::part(time-picker){width:-webkit-fill-available}div.nylas-event-timeslot div.date-time-input div.date-time-picker div.time-range nylas-time-window-picker::part(time-input){width:calc(100% - 8px)}}div.nylas-event-timeslot div.date-time-input div.date-time-picker select-dropdown{width:fit-content}div.nylas-event-timeslot div.date-time-input div.date-time-picker select-dropdown::part(sd_dropdown){position:relative}div.nylas-event-timeslot div.date-time-input div.date-time-picker select-dropdown::part(sd_dropdown-button){border:none;padding:14px;justify-content:flex-start}div.nylas-event-timeslot div.date-time-input div.date-time-picker select-dropdown::part(sd_dropdown-button):hover{border:none;outline:none;color:var(--nylas-primary)}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.date-time-picker select-dropdown{width:-webkit-fill-available}div.nylas-event-timeslot div.date-time-input div.date-time-picker select-dropdown::part(sd_dropdown-button-selected-label){max-width:fit-content}div.nylas-event-timeslot div.date-time-input div.date-time-picker select-dropdown::part(sd_dropdown-content){right:unset;width:unset}}div.nylas-event-timeslot div.date-time-input div.recurrence-options{margin:8px 0}div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown){position:relative}div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown-button){width:fit-content;padding:14px;border-color:var(--nylas-base-200)}div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown-button):hover{color:var(--nylas-primary)}div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown-content){width:fit-content}div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown-button-selected-label){max-width:100%;width:fit-content;font-size:16px}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown{width:-webkit-fill-available}div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown-button-selected-label){max-width:254px;width:fit-content}div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown-content){right:unset;width:unset}}@media screen and (max-width: 412px){div.nylas-event-timeslot div.date-time-input div.recurrence-options select-dropdown::part(sd_dropdown-button-selected-label){max-width:240px}}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.custom-recurrence-time-period,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-type,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-end{display:grid;align-items:center;gap:16px;grid-template-columns:128px 1fr;margin-bottom:8px}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.custom-recurrence-time-period select-dropdown::part(sd_dropdown-button),div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-type select-dropdown::part(sd_dropdown-button),div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-end select-dropdown::part(sd_dropdown-button){border-color:var(--nylas-base-200)}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.recurrence-options div.custom-recurrence-time-period,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-type,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-end{grid-template-columns:1fr;gap:4px;margin:16px 0}}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.custom-recurrence-time-period time-period-selector::part(id_dropdown-input),div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-type time-period-selector::part(id_dropdown-input),div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-end time-period-selector::part(id_dropdown-input){padding:16px}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.custom-recurrence-time-period time-period-selector input-dropdown:hover,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-type time-period-selector input-dropdown:hover,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.recurrence-end time-period-selector input-dropdown:hover{border:1px solid var(--nylas-primary);outline:1px solid transparent}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days{margin:16px 0;display:flex;gap:16px;align-items:center}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days div.buttons{display:flex;gap:8px;margin:8px 0}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days div.buttons button{border-radius:50%;border:none;height:24px;width:24px;color:var(--nylas-base-800);cursor:pointer}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days div.buttons button.selected{background-color:var(--nylas-primary);color:var(--nylas-base-0)}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days div.buttons button:hover{background-color:var(--nylas-base-500);color:var(--nylas-base-0)}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days div.buttons button:active{background-color:var(--nylas-base-600);color:var(--nylas-base-0)}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence-ends,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.month-recurrence{display:grid;align-items:center;gap:16px;grid-template-columns:128px 1fr}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence-ends,div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.month-recurrence{grid-template-columns:1fr;gap:4px;margin:16px 0}}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence-ends #custom-recurrence-end-type::part(sd_dropdown-button){padding:16px}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence{display:flex;gap:16px;align-items:baseline}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence{flex-direction:column;align-items:flex-start;gap:0}}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence div.custom-recurrence-end-after{display:flex;gap:8px;align-items:center}@media screen and (max-width: 768px){div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence div.custom-recurrence-end-after{flex-direction:column;align-items:flex-start}}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence div.custom-recurrence-end-after #recurrence-end-after::part(netimeslot__input-textfield),div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence div.custom-recurrence-end-after #recurrence-end-after::part(ic__input){border-color:var(--nylas-base-200)}div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.custom-recurrence nylas-date-component::part(ic__date){padding:0 16px;height:52px;border:1px solid var(--nylas-base-200)}', Gf = Vf;
var Yf = function(t, e, n, i) {
  var r = arguments.length, s = r < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, n) : i, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(t, e, n, i);
  else
    for (var l = t.length - 1; l >= 0; l--)
      (a = t[l]) && (s = (r < 3 ? a(s) : r > 3 ? a(e, n, s) : a(e, n)) || s);
  return r > 3 && s && Object.defineProperty(e, n, s), s;
}, Jt = function(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
};
R.extend(ta);
R.extend(ir);
R.extend(rr);
const qf = {
  day: "daily",
  week: "weekly",
  month: "monthly",
  year: "yearly"
}, Ks = class {
  constructor(t) {
    gn(this, t), this.valueChanged = V(this, "valueChanged", 7), this.timeWindowFormError = V(this, "timeWindowFormError", 7), this.dateTimeInputError = V(this, "dateTimeInputError", 7), t.$hostElement$["s-ei"] ? this.internals = t.$hostElement$["s-ei"] : (this.internals = t.$hostElement$.attachInternals(), t.$hostElement$["s-ei"] = this.internals), this.name = "event-timeslot", this.initialValue = void 0, this.selectedLanguage = void 0, this.currentUser = void 0, this.selectedDate = void 0, this.selectedStartTime = void 0, this.selectedEndTime = void 0, this.selectedTimezone = void 0, this.selectedRecurrenceType = void 0, this.timeRangeError = !1, this.selectedRrule = void 0, this.recurrenceOptions = [], this.repeatEveryInterval = 1, this.repeatEveryFrequency = "week", this.repeatOnDays = [], this.repeatMonthlySameDate = !0, this.repeatEndType = "never", this.repeatEndAfter = 1, this.repeatEndOn = void 0, this.monthRecurrenceOptions = [], this.endDate = void 0, this.hasDateTimeInputError = !1;
  }
  connectedCallback() {
    z("nylas-event-timeslot", "connectedCallback");
  }
  disconnectedCallback() {
    z("nylas-event-timeslot", "disconnectedCallback");
  }
  componentWillLoad() {
    z("nylas-event-timeslot", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    var t, e, n, i, r, s;
    if (z("nylas-event-timeslot", "componentDidLoad"), this.initialValue) {
      const { when: a, recurrence: l } = this.initialValue;
      if (a)
        this.selectedDate = R.unix(a.start_time).tz(a.start_timezone).format("YYYY-MM-DD"), this.selectedStartTime = R.unix(a.start_time).tz(a.start_timezone).format("hh:mma"), this.selectedEndTime = R.unix(a.end_time).tz(a.end_timezone).format("hh:mma"), this.selectedTimezone = a.start_timezone;
      else {
        this.selectedDate = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
        const o = this.getSuggestedTime();
        this.selectedStartTime = o.startTime, this.selectedEndTime = o.endTime, this.selectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      if (l && l.length > 0) {
        this.selectedRrule = l[0];
        const o = (e = (t = l[0]) == null ? void 0 : t.split(";")) == null ? void 0 : e.find((f) => f.includes("COUNT"));
        o && (this.repeatEndAfter = parseInt(o.split("=")[1]));
        const d = (i = (n = l[0]) == null ? void 0 : n.split(";")) == null ? void 0 : i.find((f) => f.includes("BYDAY"));
        d && (this.repeatOnDays = d.split("=")[1].split(","));
        const c = (s = (r = l[0]) == null ? void 0 : r.split(";")) == null ? void 0 : s.find((f) => f.includes("UNTIL"));
        if (c) {
          const f = R(c.split("=")[1], "YYYYMMDDTHHmmss").toDate();
          this.repeatEndOn = R(f).toISOString().split("T")[0], this.repeatEndType = "on";
        }
        const h = this.getRecurrenceTypeFromRrule(l[0]);
        this.selectedRecurrenceType = h || "none";
      } else
        this.selectedRecurrenceType = "none", this.selectedRrule = It(this.selectedDate, this.selectedRecurrenceType, void 0, void 0, this.selectedTimezone);
    } else {
      this.selectedDate = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
      const a = this.getSuggestedTime();
      this.selectedStartTime = a.startTime, this.selectedEndTime = a.endTime, this.selectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone, this.selectedRecurrenceType = "none", this.selectedRrule = It(this.selectedDate, this.selectedRecurrenceType, void 0, void 0, this.selectedTimezone);
    }
    this.recurrenceOptions = this.generateRecurrenceOptions(this.selectedDate, this.selectedTimezone), this.monthRecurrenceOptions = this.getMonthRecurrenceOptions(this.selectedDate, this.selectedTimezone), this.handleValueChanged(!0);
  }
  elementNameChangedHandler(t) {
    z("nylas-event-timeslot", "elementNameChangedHandler", t), this.host.setAttribute("name", t);
  }
  selectedLanguageChangedHandler(t, e) {
    t !== e && _.changeLanguage(t);
  }
  getOrdinalSuffix(t) {
    const e = ["th", "st", "nd", "rd"], n = t % 100;
    return t + (e[(n - 20) % 10] || e[n] || e[0]);
  }
  getRecurrenceTypeFromRrule(t) {
    if (t.includes("INTERVAL"))
      return "custom";
    if (t.includes("FREQ=DAILY"))
      return "daily";
    if (t.includes("FREQ=WEEKLY"))
      return "weekly";
    if (t.includes("FREQ=MONTHLY"))
      return "monthly";
    if (t.includes("FREQ=YEARLY"))
      return "yearly";
  }
  generateRecurrenceOptions(t, e) {
    const n = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], i = R.tz(t, e), r = n[i.day()], s = i.date(), a = Math.ceil(s / 7);
    return [
      { label: _.t("nylasEventTimeslot.recurrenceOptions.none"), value: "none" },
      { label: _.t("nylasEventTimeslot.recurrenceOptions.daily"), value: "daily" },
      { label: _.t("nylasEventTimeslot.recurrenceOptions.weekly", { dayOfWeek: r }), value: "weekly" },
      { label: _.t("nylasEventTimeslot.recurrenceOptions.monthly", { dayOfMonth: `${this.getOrdinalSuffix(a)} ${r}` }), value: "monthly" },
      {
        label: _.t("nylasEventTimeslot.recurrenceOptions.yearly", { dateOfMonth: `${i.format("MMMM D")}` }),
        value: "yearly"
      },
      { label: _.t("nylasEventTimeslot.recurrenceOptions.custom"), value: "custom" }
    ];
  }
  getMonthRecurrenceOptions(t, e) {
    const n = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], i = R.tz(t, e), r = n[i.day()], s = i.date(), a = Math.ceil(s / 7);
    return [
      { label: _.t("nylasEventTimeslot.recurrenceOptions.monthOnDay", { date: s }), value: "monthly-same-date" },
      { label: _.t("nylasEventTimeslot.recurrenceOptions.monthly", { dayOfMonth: `${this.getOrdinalSuffix(a)} ${r}` }), value: "monthly" }
    ];
  }
  getSuggestedTime() {
    const t = R(), n = t.minute() <= 30 ? 30 : 60, i = t.set("minute", n).set("second", 0), r = i.add(30, "minute");
    return {
      startTime: i.format("hh:mma"),
      endTime: r.format("hh:mma")
    };
  }
  getTimezoneLabelHTML(t) {
    const e = ea(t);
    return g("span", { class: "timezone-label", style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "-webkit-fill-available"
    } }, Ot[t], " ", g("span", { class: "timezone-offset", style: {
      fontSize: "14px",
      fontWeight: "400",
      color: "var(--nylas-base-500)"
    } }, e));
  }
  isStartTimeAfterEndTime(t, e) {
    const n = R(t, "hh:mma"), i = R(e, "hh:mma");
    return n.isAfter(i);
  }
  isStartTimeEqualToEndTime(t, e) {
    const n = R(t, "hh:mma"), i = R(e, "hh:mma");
    return n.isSame(i);
  }
  isStartTimeBeforeCurrentDate(t, e, n) {
    return R.tz(`${t} ${e}`, "YYYY-MM-DD hh:mma", n).isBefore(R());
  }
  validateDateTimeInput(t, e, n) {
    const r = R.tz(`${t} ${e}`, "YYYY-MM-DD hh:mma", n).isBefore(R());
    return {
      isValid: !r,
      errorMessage: r ? _.t("nylasEventTimeslot.errors.startTimeBeforeCurrentDate") : ""
    };
  }
  getStartAndEndTimes() {
    const t = R.tz(`${this.selectedDate} ${this.selectedStartTime}`, "YYYY-MM-DD hh:mma", this.selectedTimezone).toDate(), e = R.tz(`${this.selectedDate} ${this.selectedEndTime}`, "YYYY-MM-DD hh:mma", this.selectedTimezone).toDate();
    return {
      start_time: Math.round(t.getTime() / 1e3),
      end_time: Math.round(e.getTime() / 1e3)
    };
  }
  getCustomOptions() {
    return this.selectedRecurrenceType !== "custom" ? void 0 : {
      frequency: qf[this.repeatEveryFrequency],
      interval: this.repeatEveryInterval,
      daysOfWeek: this.repeatEveryFrequency === "week" ? this.repeatOnDays : void 0,
      monthlySameDate: this.repeatEveryFrequency === "month" ? this.repeatMonthlySameDate : void 0,
      end: {
        type: this.repeatEndType,
        count: this.repeatEndType === "after" ? this.repeatEndAfter : void 0,
        date: this.repeatEndType === "on" ? this.repeatEndOn : void 0
      }
    };
  }
  handleValueChanged(t = !1) {
    const e = this.getCustomOptions();
    this.selectedRrule = It(this.selectedDate, this.selectedRecurrenceType, this.repeatEndOn, e, this.selectedTimezone);
    const { start_time: n, end_time: i } = this.getStartAndEndTimes(), r = {
      when: {
        start_time: n,
        end_time: i,
        start_timezone: this.selectedTimezone,
        end_timezone: this.selectedTimezone
      },
      recurrence: this.selectedRrule ? [this.selectedRrule] : []
    };
    this.internals.setFormValue(JSON.stringify(r), this.name), t || this.valueChanged.emit({
      value: JSON.stringify(r),
      name: this.name
    });
  }
  setTime(t) {
    const { key: e, value: n } = t.detail;
    e === "event-timeslot-start-time" ? this.selectedStartTime = n : e === "event-timeslot-end-time" && (this.selectedEndTime = n);
    const i = this.isStartTimeAfterEndTime(this.selectedStartTime, this.selectedEndTime), r = this.isStartTimeEqualToEndTime(this.selectedStartTime, this.selectedEndTime), s = this.validateDateTimeInput(this.selectedDate, this.selectedStartTime, this.selectedTimezone), a = !s.isValid;
    this.timeRangeError = i || r || a;
    let l = "";
    i ? l = _.t("nylasEventTimeslot.errors.invalidTimeRange") : r ? l = _.t("nylasEventTimeslot.errors.startTimeSameAsEndTime") : a ? l = s.errorMessage : l = "", this.timeWindowFormError.emit({
      key: this.name,
      message: l,
      uniqueIdentifier: "time-range"
    }), !l && this.handleValueChanged();
  }
  nylasFormDropdownChangedHandler(t) {
    const { name: e, value: n } = t.detail;
    if (e === "timezone") {
      this.selectedTimezone = n;
      const i = R(this.selectedDate), r = this.validateDateTimeInput(i.format("YYYY-MM-DD"), this.selectedStartTime, this.selectedTimezone);
      if (this.hasDateTimeInputError = !r.isValid, this.dateTimeInputError.emit({
        key: this.name,
        message: r.errorMessage
      }), !r.isValid)
        return;
    } else
      e === "recurrence-type" ? this.selectedRecurrenceType = n : e === "month-recurrence-type" ? this.repeatMonthlySameDate = n === "monthly-same-date" : e === "custom-recurrence-end-type" && (this.repeatEndType = n);
    this.handleValueChanged();
  }
  nylasFormInputChangedHandler(t) {
    var i;
    const { name: e, value: n } = t.detail;
    if (e === "date-time-input") {
      const r = R(n), s = this.validateDateTimeInput(r.format("YYYY-MM-DD"), this.selectedStartTime, this.selectedTimezone);
      if (this.hasDateTimeInputError = !s.isValid, this.dateTimeInputError.emit({
        key: this.name,
        message: s.errorMessage
      }), !s.isValid)
        return;
      this.selectedDate = r.format("YYYY-MM-DD"), this.recurrenceOptions = this.generateRecurrenceOptions(this.selectedDate, this.selectedTimezone), this.monthRecurrenceOptions = this.getMonthRecurrenceOptions(this.selectedDate, this.selectedTimezone);
    } else if (e === "recurrence-end-date" || e === "custom-recurrence-end-date") {
      const r = ((i = t.detail) == null ? void 0 : i.error) || "";
      this.timeWindowFormError.emit({
        key: this.name,
        message: r,
        uniqueIdentifier: e
      }), this.repeatEndOn = n;
    } else if (e === "recurrence-end-after") {
      const r = parseInt(n);
      if (r < 1 || isNaN(r)) {
        this.timeWindowFormError.emit({
          key: this.name,
          message: _.t("fixFormErrors")
        });
        return;
      }
      this.repeatEndAfter = r;
    }
    this.handleValueChanged();
  }
  timePeriodChangedHandler(t) {
    const { number: e, period: n } = t.detail;
    this.repeatEveryInterval = e, this.repeatEveryFrequency = n, n === "month" && (this.monthRecurrenceOptions = this.getMonthRecurrenceOptions(this.selectedDate, this.selectedTimezone)), this.handleValueChanged();
  }
  render() {
    var o;
    const t = ((o = this.currentUser) == null ? void 0 : o.provider) === "icloud", e = this.recurrenceOptions.find((d) => d.value === this.selectedRecurrenceType), n = Object.keys(Ot).map((d) => ({
      labelHTML: this.getTimezoneLabelHTML(d),
      label: Ot[d],
      value: d
    })), i = n.find((d) => d.value === this.selectedTimezone), r = [
      { label: _.t("nylasEventTimeslot.customRecurrence.endsOptions.never"), value: "never" },
      { label: _.t("nylasEventTimeslot.customRecurrence.endsOptions.on"), value: "on" },
      { label: _.t("nylasEventTimeslot.customRecurrence.endsOptions.after"), value: "after" }
    ], s = R(this.selectedDate).add(1, "year").toISOString().split("T")[0], a = this.repeatEveryFrequency === "week" ? 4 : this.repeatEveryFrequency === "month" ? 12 : 5;
    this.repeatEndOn = this.repeatEndOn || s, this.repeatEndAfter = this.repeatEndAfter || a;
    const l = R().tz(this.selectedTimezone);
    return g(mn, { key: "061acbe54b62dde5fd3bec70046c6d22aa546801" }, g("div", { key: "a795cf697475720331f5d631e6a6593839448c27", class: "nylas-event-timeslot", part: "netimeslot" }, g("label", { key: "22df92126f1bb3fb5b9c726b685f4699a38fc8cc", htmlFor: "date-time-input" }, _.t("nylasEventTimeslot.dateTimeLabel")), g("div", { key: "a2b6a273394adeba0a2d950fd6214842d8329568", class: "date-time-input", part: "netimeslot__date-time-input" }, g("div", { key: "7bee55b1bfb7c60342b8846ec67c2d5f41c5c02d", class: "date-time-picker", part: "netimeslot__date-time-picker" }, g("nylas-date-component", { key: "45b144b4da4a637e86d956cd466dceae6374f4d1", minDate: R().tz(this.selectedTimezone).toISOString().split("T")[0], name: "date-time-input", defaultValue: this.selectedDate, id: "date-time-input", class: { error: this.hasDateTimeInputError }, required: !0, hasError: this.hasDateTimeInputError }), g("div", { key: "1f8b73ca3ab113e9a10bb7558d2b7b2587b44dc4", class: "time-range", part: "netimeslot__time-range" }, g("nylas-time-window-picker", { id: "event-timeslot-start-time", hasError: this.timeRangeError, time: this.selectedStartTime, language: this.selectedLanguage, name: "event-timeslot-start-time", key: "event-timeslot-start-time", exportparts: "time-picker: nap__time-picker-container, time-input: nap__time-picker-input, times: nap__time-picker-times" }), g("span", { key: "f0c7245b018e25633be8f6a88c3f9c7af6ef7d45" }, "–"), g("nylas-time-window-picker", { id: "event-timeslot-end-time", hasError: this.timeRangeError, time: this.selectedEndTime, language: this.selectedLanguage, name: "event-timeslot-end-time", key: "event-timeslot-end-time", minimumStartTime: this.selectedStartTime, exportparts: "time-picker: nap__time-picker-container, time-input: nap__time-picker-input, times: nap__time-picker-times" })), (i == null ? void 0 : i.label) && g("select-dropdown", { searchPlaceholder: _.t("search"), name: "timezone", exportparts: "sd_dropdown: nap__timezone-container, sd_dropdown-button: nap__timezone-button, sd_dropdown-content: nap__timezone-dropdown-content", options: n, withChevron: !1, defaultSelectedOption: i }, g("span", { slot: "select-icon" }, g("globe-icon", { width: "20", height: "20" })))), !t && g("div", { class: "recurrence-options", part: "netimeslot__recurrence-options" }, e && (e == null ? void 0 : e.label) && g("div", { class: "recurrence-type", part: "netimeslot__recurrence-type" }, g("label", { htmlFor: "recurrence-type" }, _.t("nylasEventTimeslot.recurrenceLabel")), g("select-dropdown", { withSearch: !1, id: "recurrence-type", name: "recurrence-type", options: this.recurrenceOptions, defaultSelectedOption: e, exportparts: "sd_dropdown: netimeslot__dropdown, sd_dropdown-button: netimeslot__dropdown-button, sd_dropdown-content: netimeslot__dropdown-content" })), this.selectedRecurrenceType !== "custom" && this.selectedRecurrenceType !== "none" && g("div", { class: "recurrence-end", part: "netimeslot__recurrence-end" }, g("label", null, _.t("nylasEventTimeslot.endDate")), g("nylas-date-component", { name: "recurrence-end-date", minDate: l.toISOString().split("T")[0], defaultValue: this.repeatEndOn || s, id: "recurrence-end-date", required: !0 })), this.selectedRecurrenceType === "custom" && g("div", { class: "custom-recurrence-time-period", part: "netimeslot__custom-recurrence" }, g("label", { htmlFor: "" }, _.t("nylasEventTimeslot.customRecurrence.repeatEvery")), g("time-period-selector", { id: "custom-recurrence-time-period", exportparts: "tps__number-dropdown: netimeslot__number-dropdown, tps__number-dropdown-button: netimeslot__number-dropdown-button, tps__number-dropdown-content: netimeslot__number-dropdown-content, tps__period-dropdown: netimeslot__period-dropdown, tps__period-dropdown-button: netimeslot__period-dropdown-button, tps__period-dropdown-content: netimeslot__period-dropdown-content", timePeriods: [
      { value: "day", label: _.t("timePeriod", { context: "day" }) },
      { value: "week", label: _.t("timePeriod", { context: "week" }) },
      { value: "month", label: _.t("timePeriod", { context: "month" }) },
      { value: "year", label: _.t("timePeriod", { context: "year" }) }
    ], defaultSelectedNumber: this.repeatEveryInterval, defaultSelectedPeriod: this.repeatEveryFrequency })), g("div", { class: "repeat-on" }, this.selectedRecurrenceType === "custom" && this.repeatEveryFrequency === "week" && g("div", { class: "days" }, g("label", null, _.t("nylasEventTimeslot.customRecurrence.repeatOn")), g("div", { class: "buttons" }, [
      { label: "S", value: "SU", title: "Sunday" },
      { label: "M", value: "MO", title: "Monday" },
      { label: "T", value: "TU", title: "Tuesday" },
      { label: "W", value: "WE", title: "Wednesday" },
      { label: "T", value: "TH", title: "Thursday" },
      { label: "F", value: "FR", title: "Friday" },
      { label: "S", value: "SA", title: "Saturday" }
    ].map((d) => g("button", { class: { selected: this.repeatOnDays.includes(d.value) }, title: d.title, onClick: () => {
      this.repeatOnDays = this.repeatOnDays.includes(d.value) ? this.repeatOnDays.filter((c) => c !== d.value) : [...this.repeatOnDays, d.value], this.handleValueChanged();
    } }, d.label)))), this.selectedRecurrenceType === "custom" && this.repeatEveryFrequency === "month" && g("div", { class: "month-recurrence" }, g("span", null), g("select-dropdown", { withSearch: !1, id: "month-recurrence-type", name: "month-recurrence-type", options: this.monthRecurrenceOptions, defaultSelectedOption: this.repeatMonthlySameDate ? this.monthRecurrenceOptions[0] : this.monthRecurrenceOptions[1], exportparts: "sd_dropdown: netimeslot__dropdown, sd_dropdown-button: netimeslot__dropdown-button, sd_dropdown-content: netimeslot__dropdown-content" })), g("div", { class: "custom-recurrence" }, this.selectedRecurrenceType === "custom" && g("div", { class: "custom-recurrence-ends" }, g("label", { htmlFor: "recurrence-type" }, _.t("nylasEventTimeslot.customRecurrence.ends")), g("select-dropdown", { withSearch: !1, id: "custom-recurrence-end-type", name: "custom-recurrence-end-type", options: r, defaultSelectedOption: r.find((d) => d.value === this.repeatEndType), exportparts: "sd_dropdown: netimeslot__dropdown, sd_dropdown-button: netimeslot__dropdown-button, sd_dropdown-content: netimeslot__dropdown-content" })), this.selectedRecurrenceType === "custom" && this.repeatEndType === "on" && g("div", null, g("nylas-date-component", { name: "custom-recurrence-end-date", minDate: l.toISOString().split("T")[0], defaultValue: this.repeatEndOn || s, id: "custom-recurrence-end-date", required: !0 })), this.selectedRecurrenceType === "custom" && this.repeatEndType === "after" && g("div", { class: "custom-recurrence-end-after" }, g("input-component", { name: "recurrence-end-after", id: "recurrence-end-after", type: "number", minValue: 1, defaultValue: a.toString(), exportparts: "ic_input: netimeslot__input-textfield" }), g("span", null, _.t("nylasEventTimeslot.customRecurrence.occurrences")))))))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return vn(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedLanguage: ["selectedLanguageChangedHandler"]
    };
  }
};
Yf([
  yn({
    name: "nylas-event-timeslot",
    stateToProps: /* @__PURE__ */ new Map([
      ["schedulerConfig.selectedLanguage", "selectedLanguage"],
      ["schedulerConfig.currentUser", "currentUser"]
    ]),
    eventToProps: {
      valueChanged: async (t, e) => {
        z("nylas-event-timeslot", "valueChanged", t.detail);
      }
    },
    fireRegisterEvent: !0
  }),
  Jt("design:type", Function),
  Jt("design:paramtypes", []),
  Jt("design:returntype", void 0)
], Ks.prototype, "render", null);
Ks.style = Gf;
export {
  Xs as nylas_event_calendar,
  Js as nylas_event_capacity,
  Ks as nylas_event_timeslot
};
